
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("c2Y7c", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::79927e3c1c348660896b3e18285ccee2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c544d8771767dee$var$_react = $8c544d8771767dee$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $8c544d8771767dee$var$_iconNew = $8c544d8771767dee$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $8c544d8771767dee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/question-circle
 * Usage guidance:
 * Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c544d8771767dee$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $8c544d8771767dee$var$_react.default.createElement($8c544d8771767dee$var$_iconNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$8c544d8771767dee$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $8c544d8771767dee$var$_default = module.exports.default = $8c544d8771767dee$var$QuestionCircleIcon;

});

parcelRegister("ggmdV", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $b6812553d1a566be$export$68f3db7f6af48bcb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::932d47dd87f3f2976aabd1b4699b27b4>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $hBUvp = parcelRequire("hBUvp");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $b6812553d1a566be$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673"/>
</svg>
`;
const $b6812553d1a566be$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135"/>
</svg>
`;
function $b6812553d1a566be$export$68f3db7f6af48bcb({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hBUvp.IconWrapper), {
        svg: $b6812553d1a566be$var$svg,
        customThemeSvg: $b6812553d1a566be$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$b6812553d1a566be$export$68f3db7f6af48bcb.displayName = "ConfluenceIcon";

});
parcelRegister("hBUvp", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $a8aac4f7cefd259f$export$be58b4326e23250f);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $5T6N9 = parcelRequire("5T6N9");

var $4XxmM = parcelRequire("4XxmM");
const $a8aac4f7cefd259f$var$styles = {
    root: "_3iDTPbvbI6",
    TEMP_assets: "_0C0F9q1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $a8aac4f7cefd259f$var$cloudLightAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jyBRVV _0C0F9q1qiM",
    inverse: "_36J4jyCl79 _0C0F9qt28M",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $a8aac4f7cefd259f$var$cloudDarkAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jynrF4 _0C0F9qMlgR",
    inverse: "_36J4jyt28M _0C0F9qCl79",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $a8aac4f7cefd259f$var$dataCenterLightAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM",
    neutral: "_36J4jyBRVV _0C0F9q1qiM _0g0wFMBRVV",
    inverse: "_36J4jyt28M _0C0F9qRvDB _0g0wFMt28M",
    legacy: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $a8aac4f7cefd259f$var$dataCenterDarkAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR",
    neutral: "_36J4jynrF4 _0C0F9qMlgR _0g0wFMnrF4",
    inverse: "_36J4jyMmzW _0C0F9qt28M _0g0wFMMmzW",
    legacy: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR"
};
const $a8aac4f7cefd259f$var$rovoDarkAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6nrF4 _05MzPYnrF4 _0Yajk0nrF4 _40KAGSnrF4",
    inverse: "_2PY8Z6RvDB _05MzPYRvDB _0Yajk0RvDB _40KAGSRvDB",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
};
const $a8aac4f7cefd259f$var$rovoLightAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6BRVV _05MzPYBRVV _0Yajk0BRVV _40KAGSBRVV",
    inverse: "_2PY8Z6t28M _05MzPYt28M _0Yajk0t28M _40KAGSt28M",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $a8aac4f7cefd259f$var$sizeMap = {
    xxsmall: "_0jFU0Vey7F",
    xsmall: "_0jFU0VSPN1",
    small: "_0jFU0VoWWg",
    medium: "_0jFU0VUofl",
    large: "_0jFU0VUF4f",
    xlarge: "_0jFU0VpJKa",
    '12': "_0jFU0VxpxF",
    '16': "_0jFU0Vey7F",
    '20': "_0jFU0VSPN1",
    '24': "_0jFU0VoWWg",
    '32': "_0jFU0VUofl"
};
function $a8aac4f7cefd259f$export$be58b4326e23250f({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $4XxmM.useThemeObserver)();
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $gJ6nT.default)([
            $a8aac4f7cefd259f$var$styles.root,
            $a8aac4f7cefd259f$var$sizeMap[size],
            colorMode === 'dark' ? $a8aac4f7cefd259f$var$dataCenterDarkAppearanceMap[appearance] : $a8aac4f7cefd259f$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $a8aac4f7cefd259f$var$rovoDarkAppearanceMap[appearance] : $a8aac4f7cefd259f$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $a8aac4f7cefd259f$var$cloudDarkAppearanceMap[appearance] : $a8aac4f7cefd259f$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $5T6N9.fg)('assets-platform-branding') || (0, $5T6N9.fg)('assets-platform-branding-v2')) && $a8aac4f7cefd259f$var$styles.TEMP_assets
        ])
    });
}
$a8aac4f7cefd259f$export$be58b4326e23250f.displayName = "IconWrapper";

});
parcelRegister("4XxmM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "useThemeObserver", () => $58b743975db5767c$export$3dd7971102e44fa8);
$parcel$export(module.exports, "default", () => $58b743975db5767c$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");

var $2dFEX = parcelRequire("2dFEX");

var $ju1ig = parcelRequire("ju1ig");
const $58b743975db5767c$export$3dd7971102e44fa8 = ()=>{
    const [theme, setTheme] = (0, $fsvuC.useState)((0, $2dFEX.getGlobalTheme)());
    (0, $fsvuC.useEffect)(()=>{
        const observer = new (0, $ju1ig.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $58b743975db5767c$export$2e2bcd8739ae039 = $58b743975db5767c$export$3dd7971102e44fa8;

});



parcelRegister("6tIMZ", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $f388f01be679e1b0$export$c4b5b1f965d8b3eb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c0e4bfbb3ca87324a6e97db845b2ae2c>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $hBUvp = parcelRequire("hBUvp");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $f388f01be679e1b0$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>
</svg>
`;
const $f388f01be679e1b0$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>
</svg>
`;
function $f388f01be679e1b0$export$c4b5b1f965d8b3eb({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hBUvp.IconWrapper), {
        svg: $f388f01be679e1b0$var$svg,
        customThemeSvg: $f388f01be679e1b0$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$f388f01be679e1b0$export$c4b5b1f965d8b3eb.displayName = "JiraIcon";

});

parcelRegister("2PNUx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $88cd0d3eac5c55a5$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $eALNX = parcelRequire("eALNX");
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $88cd0d3eac5c55a5$var$ModalWrapper = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $eALNX.default), {
        ...props,
        isFullScreen: false,
        ref: ref
    });
});
$88cd0d3eac5c55a5$var$ModalWrapper.displayName = 'ModalWrapper';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$88cd0d3eac5c55a5$export$2e2bcd8739ae039 = $88cd0d3eac5c55a5$var$ModalWrapper;

});
parcelRegister("eALNX", function(module, exports) {
$parcel$export(module.exports, "default", () => $709207ee6a47cb04$export$2e2bcd8739ae039);
/* modal-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $kyAKM = parcelRequire("kyAKM");

var $121xR = parcelRequire("121xR");

var $fkuHa = parcelRequire("fkuHa");

var $6Wg69 = parcelRequire("6Wg69");

var $iqo7S = parcelRequire("iqo7S");

var $9gFl0 = parcelRequire("9gFl0");

var $k9FWI = parcelRequire("k9FWI");

var $5xVTY = parcelRequire("5xVTY");

var $equX1 = parcelRequire("equX1");

var $h4ylU = parcelRequire("h4ylU");

var $3s1nE = parcelRequire("3s1nE");

var $7IVZh = parcelRequire("7IVZh");

var $35OYy = parcelRequire("35OYy");

var $5T6N9 = parcelRequire("5T6N9");

var $5OOYg = parcelRequire("5OOYg");

var $k0iCs = parcelRequire("k0iCs");

var $QrsDO = parcelRequire("QrsDO");

var $hiGNn = parcelRequire("hiGNn");

var $hUfXA = parcelRequire("hUfXA");

var $gslXa = parcelRequire("gslXa");

var $1ZFxP = parcelRequire("1ZFxP");

var $7psUz = parcelRequire("7psUz");

var $2qiHl = parcelRequire("2qiHl");

var $bUmWJ = parcelRequire("bUmWJ");

var $4iZn0 = parcelRequire("4iZn0");

var $khDrE = parcelRequire("khDrE");

var $kRIRZ = parcelRequire("kRIRZ");

var $6xFCE = parcelRequire("6xFCE");

var $7jbx2 = parcelRequire("7jbx2");
const $709207ee6a47cb04$var$fillScreenStyles = null; /**
                                * Styles applied to the <dialog> wrapper, NOT the visual modal surface.
                                */ 
const $709207ee6a47cb04$var$dialogStyles = {
    'body-scroll': "_4bt5LAYvD1 _2WAcuGYvD1 _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _4fJ90yfI2J _1tgHQuIZbP _3GDW4sfI2J _4ntsTKIZbP",
    'viewport-scroll': "_1qyfxmyhct _39xV02qUim _0jFU0VWP8C",
    'full-screen': ""
}; // Visual styles for modal content inside native <dialog>.
// Uses cssMap (not css) to avoid triggering no-nested-styles lint rule.
const $709207ee6a47cb04$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current'; /**
                                                                                                         * Styles applied to the visual modal surface.
                                                                                                         */ 
const $709207ee6a47cb04$var$surfaceStyles = {
    root: "_3iDTPbQ4SZ _0aFT5vbt8w _0KLXruoI2d _45TjwHoI2d _1pp6NdIZbP _3Sk04SOLYo _1s1YRNOLYo _3gkMN6OLYo _1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _2l47gTGk8v",
    borderRadius: "_0bjKvDdnbC _0YcdZAyzSk"
};
const $709207ee6a47cb04$var$topLayerScrollModeStyles = {
    'full-screen': "_39xV02qUim _0jFU0VWP8C _1mT5xdy1CL _2I62gzPgdg _3iC0zdPgdg _2WAcuGIZbP _0xWutCdqJc",
    'viewport-scroll': "_0jFU0VWP8C _4fJ90yfI2J _1tgHQuIZbP _3GDW4sfI2J _4ntsTKIZbP _3ShBvMBY1A _3GZDR8k2yd _14gTsZ5dtV _28xGbQw4ra",
    'body-scroll': "_39xV02qUim _0jFU0VWP8C _3GZDR8k2yd _14gTsZ5dtV _28xGbQw4ra"
};
const $709207ee6a47cb04$var$topLayerAutoHeightStyles = null;
const $709207ee6a47cb04$var$allowlistElements = (element, callback)=>{
    // Allow focus outside modal when AUI dialog is visible
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- legacy FocusLock allowlist
    if (document.querySelector('.aui-blanket:not([hidden])')) return false;
     // Optional callback to let consumers exclude elements from focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
}; // Analytics-wrapped close handler. Extracted so both rendering paths build it
// identically.
function $709207ee6a47cb04$var$useModalCloseHandler(providedOnClose) {
    return (0, $fkuHa.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $iqo7S.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
}
function $709207ee6a47cb04$var$getScrollMode({ shouldScrollInViewport: shouldScrollInViewport, isFullScreen: isFullScreen }) {
    if (isFullScreen) return 'full-screen';
    if (shouldScrollInViewport) return 'viewport-scroll';
    return 'body-scroll';
}
function $709207ee6a47cb04$var$isWidthName(value) {
    return (0, $6xFCE.width).values.includes(value);
}
function $709207ee6a47cb04$var$getTopLayerSurfaceWidth(input) {
    if (!input) return 'auto';
    if (typeof input === 'number') return `${input}px`;
    if ($709207ee6a47cb04$var$isWidthName(input)) return `${(0, $6xFCE.width).widths[input]}px`;
    if (input.endsWith('%')) // Percentage widths need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-width
    // (100vw - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vw), so a raw percentage would produce a wider modal.
    // Transform e.g. '42%' → 'calc(42 * (100vw - 120px) / 100)' to match legacy.
    return `calc(${parseFloat(input)} * (100vw - 120px) / 100)`;
    return input;
}
function $709207ee6a47cb04$var$getTopLayerSurfaceHeight(input) {
    if (!input) // Although this value would ordinarily fill the viewport height,
    // there is also a `max-height: max-content` applied to keep it constrained.
    // But we need to provide the modal with a fixed height (non-keyword, non-percentage)
    // in order for child elements with 100% height to work correctly.
    return 'calc(100vh - 120px)';
    if (typeof input === 'number') return `${input}px`;
    if (input.endsWith('%')) // Percentage heights need special handling in the top layer.
    // In legacy, the percentage resolved against the Positioner's max-height
    // (100vh - 120px). In the top layer, the <dialog>'s containing block is the
    // viewport (100vh), so a raw percentage would produce a taller modal.
    // Transform e.g. '42%' → 'calc(42 * (100vh - 120px) / 100)' to match legacy.
    return `calc(${parseFloat(input)} * (100vh - 120px) / 100)`;
    return input;
}
function $709207ee6a47cb04$var$getDismissedBy({ shouldCloseOnEscapePress: shouldCloseOnEscapePress, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick }) {
    if (shouldCloseOnEscapePress && shouldCloseOnOverlayClick) return 'escape-and-outside-click';
    if (shouldCloseOnEscapePress) return 'escape';
     // Backdrop clicks only: `Dialog` asks on both, and `onDialogAsk` ignores Escape.
    if (shouldCloseOnOverlayClick) return 'escape-and-outside-click';
    return 'none';
} /**
   * Top-layer rendering path (platform-dst-top-layer).
   *
   * Replaces Portal, FocusLock, ScrollLock, Blanket, Positioner, and z-index
   * management with native <dialog> via @atlaskit/top-layer/dialog.
   *
   * Key decisions:
   * - Animation: CSS transitions via @starting-style / allow-discrete.
   * - Close gating: matches legacy while open. Dialog asks on Escape and backdrop
   *   clicks (the consumer may refuse any number of times). During the exit they
   *   do not call `onClose` again.
   * - A close that Dialog did not ask about (e.g. `<form method="dialog">`): not
   *   supported. Dialog shows the modal again, and `onClose` does not run.
   * - onClose event param: undefined - consumers should use close reason.
   * - Focus restoration: native <dialog> behavior replaces react-focus-lock's
   *   returnFocus (see accessibility-criteria.md).
   *
   * Every hook here runs unconditionally: this component only mounts on the
   * top-layer path, so it never shares a hook sequence with the legacy path.
   */ 
function $709207ee6a47cb04$var$ModalWrapperTopLayer(props) {
    const { autoFocus: autoFocus, UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, onClose: providedOnClose, onStackChange: onStackChange = (0, $iqo7S.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width = 'medium', onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen = false } = props;
    (0, $7psUz.default)({
        onStackChange: onStackChange
    });
    const onCloseHandler = $709207ee6a47cb04$var$useModalCloseHandler(providedOnClose);
    const { isExiting: isExiting, onFinish: onExitFinish } = (0, $3s1nE.useExitingPersistence)(); // Native <dialog> always restores focus on close - no opt-out via shouldReturnFocus.
    const defaultTestId = testId || 'modal-dialog';
    const id = (0, $k9FWI.useId)();
    const titleId = `modal-dialog-title-${id}`; // Content container ref - used for onOpenComplete/onCloseComplete callbacks.
    const contentRef = (0, $fsvuC.useRef)(null); // Cache last content element for onCloseComplete after children unmount
    // (with reduced motion, contentRef clears before onExitFinish fires).
    const lastContentElRef = (0, $fsvuC.useRef)(null);
    if (contentRef.current) lastContentElRef.current = contentRef.current;
     // Native <dialog> ref - needed for ExitingPersistence to call dialog.close().
    const dialogRef = (0, $fsvuC.useRef)(null);
    const hasProvidedOnClose = Boolean(providedOnClose);
    const modalDialogContext = (0, $fsvuC.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onCloseHandler,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen ?? false
        }), [
        defaultTestId,
        titleId,
        onCloseHandler,
        hasProvidedOnClose,
        isFullScreen
    ]); // Pass a synthetic event to satisfy the KeyboardOrMouseEvent contract. Dialog calls this
    // for an allowed Escape or backdrop click.
    const onDialogClose = (0, $fsvuC.useCallback)(({ reason: reason })=>{
        onCloseHandler((0, $hiGNn.createCloseEvent)({
            reason: reason
        }));
    }, [
        onCloseHandler
    ]); /**
                         * Dialog asks on an allowed Escape or backdrop click. Ignoring an Escape ask refuses it:
                         * Dialog still cancels the Escape `keydown`, so nothing else closes.
                         */ 
    const onDialogAsk = (0, $fsvuC.useCallback)(({ reason: reason })=>{
        if (reason === 'escape' && !shouldCloseOnEscapePress) return;
        onDialogClose({
            reason: reason
        });
    }, [
        onDialogClose,
        shouldCloseOnEscapePress
    ]); // Unlike legacy, Escape and backdrop clicks during the exit do not call `onClose` again.
    // See `@atlaskit/top-layer` notes: `decisions/dialog-close-flow.md`.
    // Dialog could not reopen after a close it did not ask about (its parent layer is closed), so
    // the `<dialog>` is already gone. End the exit.
    (0, $fsvuC.useEffect)(()=>{
        if (isExiting && !dialogRef.current) onExitFinish?.();
    }, [
        isExiting,
        onExitFinish
    ]); // ExitingPersistence: isExiting → isOpen={false} → Dialog exit animation →
    // onExitFinish → onCloseComplete + unmount.
    const handleDialogExitFinish = (0, $fsvuC.useCallback)(()=>{
        const el = contentRef.current ?? lastContentElRef.current;
        if (onCloseComplete && el) onCloseComplete(el);
        lastContentElRef.current = null;
        onExitFinish?.();
    }, [
        onExitFinish,
        onCloseComplete
    ]);
    const handleDialogEnterFinish = (0, $fsvuC.useCallback)(()=>{
        if (onOpenComplete && contentRef.current) onOpenComplete(contentRef.current, true);
    }, [
        onOpenComplete
    ]); // Honor `shouldReturnFocus={ref}` on unmount.
    // Native <dialog>.close() restores focus to the trigger that opened it,
    // but the consumer asked for focus to go to a specific element instead.
    // Run this in an unmount cleanup so it fires after dialog.close()
    // (which fires in the Dialog's effect cleanup).
    const shouldReturnFocusRef = (0, $fsvuC.useRef)(shouldReturnFocus);
    shouldReturnFocusRef.current = shouldReturnFocus;
    (0, $fsvuC.useEffect)(()=>{
        return ()=>{
            const target = shouldReturnFocusRef.current;
            if (typeof target === 'object' && target.current) target.current.focus();
        };
    }, []); // Focus a ref-targeted element after mount (when autoFocus is a ref).
    // When true, native <dialog>.showModal() handles focus automatically.
    (0, $9gFl0.default)(typeof autoFocus === 'object' ? autoFocus : undefined, typeof autoFocus === 'object' && !UNSAFE__disableInitialAutoFocus); // Chrome cross-origin iframe DnD workaround (crbug.com/362301053)
    (0, $fsvuC.useEffect)(()=>{
        return (0, $k0iCs.combine)((0, $bUmWJ.disableDraggingToCrossOriginIFramesForElement)(), (0, $khDrE.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $4iZn0.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    const scrollMode = $709207ee6a47cb04$var$getScrollMode({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $hUfXA.Dialog), {
        ref: dialogRef,
        onClose: onDialogAsk,
        dismissedBy: $709207ee6a47cb04$var$getDismissedBy({
            shouldCloseOnEscapePress: shouldCloseOnEscapePress,
            shouldCloseOnOverlayClick: shouldCloseOnOverlayClick
        }),
        onExitFinish: handleDialogExitFinish,
        shouldAnimate: !isFullScreen,
        isOpen: !isExiting,
        onEnterFinish: handleDialogEnterFinish,
        shouldHideBackdrop: isBlanketHidden,
        ...label ? {
            label: label
        } : {
            labelledBy: titleId
        },
        testId: defaultTestId,
        xcss: $709207ee6a47cb04$var$dialogStyles[scrollMode],
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $gslXa.DialogScrollLock), {
                isOpen: true
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                ref: contentRef,
                style: {
                    '--modal-dialog-height': $709207ee6a47cb04$var$getTopLayerSurfaceHeight(height),
                    '--modal-dialog-width': $709207ee6a47cb04$var$getTopLayerSurfaceWidth(width)
                },
                className: (0, $gJ6nT.default)([
                    $709207ee6a47cb04$var$surfaceStyles.root,
                    !isFullScreen && $709207ee6a47cb04$var$surfaceStyles.borderRadius,
                    $709207ee6a47cb04$var$topLayerScrollModeStyles[scrollMode],
                    !height && !isFullScreen && "_0Wik48W9qI"
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $1ZFxP.ModalContext).Provider, {
                    value: modalDialogContext,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kRIRZ.ScrollContext).Provider, {
                        value: shouldScrollInViewport,
                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $35OYy.default), {
                            children: children
                        })
                    })
                })
            })
        ]
    });
}
$709207ee6a47cb04$var$ModalWrapperTopLayer.displayName = "ModalWrapperTopLayer";
/**
 * Legacy rendering path (Portal + FocusLock + ScrollLock + Blanket).
 *
 * Every hook here runs unconditionally: this component only mounts on the
 * legacy path, so it never shares a hook sequence with the top-layer path.
 */ const $709207ee6a47cb04$var$ModalWrapperLegacy = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const { autoFocus: autoFocus, UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus = false, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $iqo7S.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const calculatedStackIndex = (0, $7psUz.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0; // If no ref is provided, autofocus on first element
    const autoFocusLock = !UNSAFE__disableInitialAutoFocus && !(typeof autoFocus === 'object');
    const onCloseHandler = $709207ee6a47cb04$var$useModalCloseHandler(providedOnClose);
    const onBlanketClicked = (0, $fsvuC.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]); // Stable callback to avoid re-renders when focusLockAllowlist is not provided.
    const allowListCallback = (0, $fsvuC.useCallback)((element)=>$709207ee6a47cb04$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]); // Prevent background scroll (top-layer path uses DialogScrollLock instead).
    (0, $2qiHl.default)(); // Register with the open layer observer. On the top-layer path the Dialog
    // primitive does this itself, which is why it lives in this legacy-only
    // component rather than the shared dispatcher.
    (0, $equX1.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Always open — modal is conditionally rendered when visible.
        isOpen: true,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $iqo7S.default)
    });
    const modalDialogWithBlanket = /*#__PURE__*/ (0, $5chsV.jsx)((0, $6Wg69.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $7jbx2.default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            hasProvidedOnClose: Boolean(providedOnClose),
            isFullScreen: isFullScreen,
            UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift,
            ref: ref,
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $35OYy.default), {
                children: children
            })
        })
    });
    let returnFocus = true;
    let onDeactivation = (0, $iqo7S.default);
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            shouldReturnFocus.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5xVTY.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5OOYg.default), {
            zIndex: (0, $QrsDO.layers).modal(),
            children: !UNSAFE_shouldDisableMotionUplift && (0, $5T6N9.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $h4ylU.default), {
                enteringAnimation: "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
                exitingAnimation: "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
                children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    "aria-hidden": !isForeground,
                    className: (0, $gJ6nT.default)([
                        "_39xV02qUim _0jFU0VWP8C _1mT5xdy1CL _2I62gzPgdg _3iC0zdPgdg _2WAcuGIZbP _0xWutCdqJc"
                    ]),
                    children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $kyAKM.default), {
                        autoFocus: autoFocusLock,
                        returnFocus: returnFocus,
                        onDeactivation: onDeactivation,
                        whiteList: allowListCallback,
                        children: [
                            /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($121xR))), {}),
                            shouldScrollInViewport ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $121xR.TouchScrollable), {
                                children: modalDialogWithBlanket
                            }) : modalDialogWithBlanket
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $7IVZh.default), {
                children: (fadeInProps)=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
                        ...fadeInProps,
                        className: (0, $gJ6nT.default)([
                            "_39xV02qUim _0jFU0VWP8C _1mT5xdy1CL _2I62gzPgdg _3iC0zdPgdg _2WAcuGIZbP _0xWutCdqJc",
                            fadeInProps.className
                        ]),
                        "aria-hidden": !isForeground,
                        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $kyAKM.default), {
                            autoFocus: autoFocusLock,
                            returnFocus: returnFocus,
                            onDeactivation: onDeactivation,
                            whiteList: allowListCallback,
                            children: [
                                /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($121xR))), {}),
                                shouldScrollInViewport ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $121xR.TouchScrollable), {
                                    children: modalDialogWithBlanket
                                }) : modalDialogWithBlanket
                            ]
                        })
                    })
            })
        })
    });
}); // Choose the rendering implementation at the component boundary rather than
// gating hooks inside a single component. Each implementation owns its own
// hooks unconditionally, so a runtime feature-flag change swaps component types
// (a clean remount) instead of changing the hook order of a mounted component.
const $709207ee6a47cb04$var$InternalModalWrapper = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    if ((0, $5T6N9.fg)('platform-dst-top-layer')) // TODO: the top-layer path does not forward the external `ref` (parity
    // with the pre-refactor behavior, where the top-layer branch never
    // consumed it). The public type still advertises `RefAttributes`, so a
    // consumer ref silently no-ops here. Follow up by forwarding `ref` to a
    // sensible element (for example the content `div`) once ref parity is
    // intentionally desired.
    return /*#__PURE__*/ (0, $5chsV.jsx)($709207ee6a47cb04$var$ModalWrapperTopLayer, {
        ...props
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)($709207ee6a47cb04$var$ModalWrapperLegacy, {
        ref: ref,
        ...props
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $709207ee6a47cb04$export$2e2bcd8739ae039 = $709207ee6a47cb04$var$InternalModalWrapper;

});
parcelRegister("6Wg69", function(module, exports) {
$parcel$export(module.exports, "default", () => $57dd49a1413c0fd0$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $fkuHa = parcelRequire("fkuHa");

var $iqo7S = parcelRequire("iqo7S");
const $57dd49a1413c0fd0$var$packageName = "platform-pkg";
const $57dd49a1413c0fd0$var$packageVersion = "0.0.0-use.local";
const $57dd49a1413c0fd0$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $57dd49a1413c0fd0$var$packageName,
    packageVersion: $57dd49a1413c0fd0$var$packageVersion
};
const $57dd49a1413c0fd0$var$baseStyles = null;
const $57dd49a1413c0fd0$var$shouldAllowClickThroughStyles = null;
const $57dd49a1413c0fd0$var$invisibleStyles = null; /**
                               * __Blanket__
                               *
                               * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
                               *
                               * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
                               */ 
const $57dd49a1413c0fd0$var$Blanket = /*#__PURE__*/ (0, $fsvuC.memo)(/*#__PURE__*/ (0, $fsvuC.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $iqo7S.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $fsvuC.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $fkuHa.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$57dd49a1413c0fd0$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $fsvuC.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $fsvuC.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $gJ6nT.default)([
            "_49OCfRdnbC _1mT5xdy1CL _42Yu6BN779 _0KLXruA5lS _2WAcuGIZbP _1pp6NdIZbP",
            shouldAllowClickThrough && "_1pp6NdYbGa",
            !isTinted && "_0KLXruyL8i"
        ]),
        children: children
    });
}));
$57dd49a1413c0fd0$var$Blanket.displayName = 'Blanket';
var $57dd49a1413c0fd0$export$2e2bcd8739ae039 = $57dd49a1413c0fd0$var$Blanket;

});

parcelRegister("5xVTY", function(module, exports) {
$parcel$export(module.exports, "Layering", () => $a9f37339e1339247$export$7c885f891c940977);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $2W1pO = parcelRequire("2W1pO");

var $fWAWL = parcelRequire("fWAWL");

var $kQW6b = parcelRequire("kQW6b");

var $7SXb3 = parcelRequire("7SXb3");
const $a9f37339e1339247$var$LevelProvider = ({ children: children, currentLevel: currentLevel, node: levelNode })=>{
    (0, $fsvuC.useEffect)(()=>{
        const levelNodeSafe = levelNode.current;
        const parentNode = levelNodeSafe.parent;
        parentNode?.addChild(levelNodeSafe);
        return ()=>{
            parentNode?.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fWAWL.LevelContext).Provider, {
        value: currentLevel,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kQW6b.LevelNodeContext).Provider, {
            value: levelNode,
            children: children
        })
    });
};
$a9f37339e1339247$var$LevelProvider.displayName = "LevelProvider";
const $a9f37339e1339247$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $fsvuC.useContext)((0, $fWAWL.LevelContext));
    const parentNode = (0, $fsvuC.useContext)((0, $kQW6b.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const newNode = (0, $fsvuC.useRef)(new (0, $2W1pO.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: children
    });
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, $5chsV.jsx)($a9f37339e1339247$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode,
        children: children
    });
    return isNested ? content : /*#__PURE__*/ (0, $5chsV.jsx)((0, $7SXb3.RootNodeContext).Provider, {
        value: newNode,
        children: content
    });
};
$a9f37339e1339247$export$7c885f891c940977.displayName = "Layering";

});
parcelRegister("2W1pO", function(module, exports) {
$parcel$export(module.exports, "LayerNode", () => $a77bc2c4eca16ab4$export$da4f61fd78d35243);
class $a77bc2c4eca16ab4$export$da4f61fd78d35243 {
    constructor(id, parent){
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    addChild(node) {
        this.childNodes.push(node);
    }
    removeChild(node) {
        this.childNodes = this.childNodes.filter((child)=>child.id !== node.id);
    }
    getLevel() {
        if (!this.parent) return 1;
        return this.parent.getLevel() + 1;
    }
    getHeight() {
        if (this.childNodes.length === 0) return 1;
        return Math.max(...this.childNodes.map((child)=>child.getHeight())) + 1;
    }
}
$a77bc2c4eca16ab4$export$da4f61fd78d35243.displayName = "LayerNode";

});

parcelRegister("fWAWL", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $0271dfc67134ce9b$export$650d12d3c2ddb8fc);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fsvuC = parcelRequire("fsvuC");
const $0271dfc67134ce9b$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $fsvuC.createContext)(0);

});

parcelRegister("kQW6b", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", () => $1f787a02f1b12ae7$export$18f4d8b5b3a77f59);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fsvuC = parcelRequire("fsvuC");
const $1f787a02f1b12ae7$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $fsvuC.createContext)({
    current: null
});

});

parcelRegister("7SXb3", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", () => $aa77905676753acb$export$fa973f110e8f6ca8);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fsvuC = parcelRequire("fsvuC");
const $aa77905676753acb$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $fsvuC.createContext)({
    current: null
});

});


parcelRegister("hiGNn", function(module, exports) {
$parcel$export(module.exports, "createCloseEvent", () => $1bbb3481e01b1177$export$330cd73b9da5838b);
function $1bbb3481e01b1177$export$330cd73b9da5838b({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        bubbles: true
    });
    return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
}

});

parcelRegister("hUfXA", function(module, exports) {
$parcel$export(module.exports, "Dialog", () => $10754d8614df5370$export$3ddf2d174ce01153);
/* dialog-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $80czl = parcelRequire("80czl");

var $4twf9 = parcelRequire("4twf9");

var $dqdTY = parcelRequire("dqdTY");

var $1cXpO = parcelRequire("1cXpO");

var $86OVn = parcelRequire("86OVn");

var $6OnfV = parcelRequire("6OnfV");

var $x9Y7k = parcelRequire("x9Y7k");

var $6wSlU = parcelRequire("6wSlU");

var $iQVNb = parcelRequire("iQVNb");

var $5Byvi = parcelRequire("5Byvi");

var $bWEeg = parcelRequire("bWEeg");
/**
 * **Surface reset**, including `color` (the UA `dialog` rule sets `CanvasText`).
 *
 * KEEP IN SYNC with `surfaceResetStyles` in `popover/popover.tsx`.
 */ const $10754d8614df5370$var$surfaceResetStyles = {
    root: "_16fQCjIZbP _22xN0BzUZr _31O5bFzUZr _3npKLMzUZr _1W8Jgq7p2s _1sv16BdnbC _37eVqOYbGa _0D9ajdy7kJ"
};
const $10754d8614df5370$var$dialogStyles = {
    root: "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _1EqgXlYbGa _1rY2tZYbGa _1uleA0Pgdg _1q5MkmPgdg _0SwjAoPgdg _22YA6yPgdg _4DVkoZIZbP _3sidotIZbP _0HFSp6YbGa _3NthtFzUZr _1hzzDPzUZr _3n2izOYbGa _2bmTl7YbGa _1Wet47YbGa _4eTLRPYbGa _2Q5CZ97dHp _3hz6pUy1CL _00JIZJdnbC _4bqM9MyL8i _0sSBqpvLZJ",
    motion: "_1kOSYtHCFx _3Z9K0wLrT7 _4f1LA5ThaV _3Y6bKpZSoF _0LqqFdYbGa _2Iz54kxlqh",
    enter: "_2fBhte18fs",
    exit: "_2fBhte9ddd"
};
const $10754d8614df5370$var$backdropStyles = {
    root: "_3OBRCTA5lS",
    hidden: "_3OBRCTyL8i",
    enter: "_3PXcY4o0Nz",
    exit: "_3PXcY4nJl0"
};
function $10754d8614df5370$var$isEscapeAllowed({ dismissedBy: dismissedBy }) {
    return dismissedBy === 'escape' || dismissedBy === 'escape-and-outside-click';
}
function $10754d8614df5370$var$isBackdropClickAllowed({ dismissedBy: dismissedBy }) {
    return dismissedBy === 'escape-and-outside-click';
}
// Whether every `<dialog>` and `[popover]` that contains the node is open. Crosses shadow roots.
function $10754d8614df5370$var$isEveryAncestorLayerOpen({ node: node }) {
    const parent = node.parentNode instanceof ShadowRoot ? node.parentNode.host : node.parentElement;
    if (!parent) return true;
    if (parent instanceof HTMLElement && (parent instanceof HTMLDialogElement || parent.hasAttribute('popover')) && !(0, $6OnfV.isNativeElementOpen)({
        element: parent
    })) return false;
    return $10754d8614df5370$var$isEveryAncestorLayerOpen({
        node: parent
    });
}
/**
 * Safety net for a close that `Dialog` did not ask about (for example `dialog.close()` or a
 * `<form method="dialog">` submit). Consumers should not close the native dialog. `isOpen` is the
 * source of truth, so show the dialog again.
 *
 * Skipped inside a closed layer: an open modal there is invisible but still makes the page inert.
 *
 * Returns `true` when this call showed the dialog again.
 */ function $10754d8614df5370$var$reopenAfterUnaskedClose({ dialog: dialog }) {
    if (dialog.open || !$10754d8614df5370$var$isEveryAncestorLayerOpen({
        node: dialog
    })) return false;
    try {
        dialog.showModal();
    } catch  {
        return false;
    }
    return dialog.open;
}
const $10754d8614df5370$export$3ddf2d174ce01153 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(function Dialog({ children: children, isOpen: isOpen, onClose: onClose, dismissedBy: dismissedBy = 'escape-and-outside-click', onEnterFinish: onEnterFinish, onExitFinish: onExitFinish, shouldAnimate: shouldAnimate = false, xcss: consumerXcss, enteringAnimationXcss: enteringAnimationXcss, exitingAnimationXcss: exitingAnimationXcss, style: style, testId: testId, id: providedId, label: label, labelledBy: labelledBy, shouldHideBackdrop: shouldHideBackdrop }, ref) {
    const generatedId = (0, $fsvuC.useId)();
    const dialogId = providedId ?? generatedId;
    const ownRef = (0, $fsvuC.useRef)(null);
    const combinedRef = (0, $1cXpO.default)([
        ownRef,
        ref
    ]);
    const dismissedByRef = (0, $fsvuC.useRef)(dismissedBy);
    const onCloseRef = (0, $fsvuC.useRef)(onClose);
    const isOpenRef = (0, $fsvuC.useRef)(isOpen);
    // Keep native event handlers stable while ensuring they read the latest committed props.
    (0, $86OVn.useLayoutEffect)(()=>{
        dismissedByRef.current = dismissedBy;
        onCloseRef.current = onClose;
        isOpenRef.current = isOpen;
    }, [
        dismissedBy,
        onClose,
        isOpen
    ]);
    const { phase: phase, isMounted: isMounted, onBeforeToggle: onBeforeToggle, onToggle: onToggle } = (0, $x9Y7k.useAnimatedVisibility)({
        isOpen: isOpen,
        shouldAnimate: shouldAnimate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    });
    // Bind the lifecycle listeners before the `isOpen` effect below calls `showModal()` or
    // `close()`: `beforetoggle` fires synchronously during those calls.
    (0, $86OVn.useLayoutEffect)(()=>{
        if (!isMounted) return;
        const dialog = ownRef.current;
        if (!dialog) return;
        return (0, $dqdTY.bindAll)(dialog, [
            {
                type: 'beforetoggle',
                listener: onBeforeToggle
            },
            {
                type: 'toggle',
                listener (event) {
                    // The consumer unmounted the dialog in `onClose`. Do not schedule
                    // `onExitFinish` after unmount.
                    if (!dialog.isConnected) return;
                    // Safety net: something closed the native dialog while `isOpen` is `true`, so
                    // show it again. Runs before `onToggle`, so the exit never settles.
                    if (event.newState === 'closed' && isOpenRef.current && $10754d8614df5370$var$reopenAfterUnaskedClose({
                        dialog: dialog
                    })) return;
                    onToggle(event);
                }
            }
        ]);
    }, [
        isMounted,
        onBeforeToggle,
        onToggle
    ]);
    // Native `<dialog>.showModal()` traps focus but wraps through `<body>` at the boundary
    // (A → B → C → body → A). `useFocusWrap` handles Tab and wraps directly (A → B → C → A), as in
    // the WAI-ARIA APG pattern. `phase` keeps the listener during the exit animation (WCAG 2.4.3 Focus
    // Order regression guard).
    (0, $6wSlU.useFocusWrap)({
        elementRef: ownRef,
        role: 'dialog',
        phase: phase
    });
    // Show or close the native dialog to match `isOpen`.
    (0, $86OVn.useLayoutEffect)(()=>{
        const dialog = ownRef.current;
        if (!dialog) return;
        if (isOpen) {
            if (!dialog.open) dialog.showModal();
            return ()=>{
                if (dialog.open) dialog.close();
            };
        }
        if (dialog.open) dialog.close();
    }, [
        isOpen
    ]);
    // Standard path: Escape.
    const handleEscape = (0, $fsvuC.useCallback)(()=>{
        if (!$10754d8614df5370$var$isEscapeAllowed({
            dismissedBy: dismissedByRef.current
        })) return;
        // Commit the consumer's `isOpen` answer before the keydown ends.
        (0, $80czl.flushSync)(()=>{
            onCloseRef.current({
                reason: 'escape'
            });
        });
    }, []);
    (0, $bWEeg.useEscapeKeydown)({
        dialogRef: ownRef,
        isMounted: isMounted,
        onEscape: handleEscape
    });
    // Standard path: backdrop click.
    const handleBackdropClick = (0, $fsvuC.useCallback)(()=>{
        if (!$10754d8614df5370$var$isBackdropClickAllowed({
            dismissedBy: dismissedByRef.current
        })) return;
        // Commit the consumer's `isOpen` answer before the click ends.
        (0, $80czl.flushSync)(()=>{
            onCloseRef.current({
                reason: 'overlay-click'
            });
        });
    }, []);
    (0, $iQVNb.useBackdropClick)({
        dialogRef: ownRef,
        isMounted: isMounted,
        onBackdropClick: handleBackdropClick
    });
    // Fallback: only in browsers without `closedby`.
    (0, $5Byvi.useCancelFallback)({
        dialogRef: ownRef,
        isMounted: isMounted
    });
    // After the exit, render nothing, so no empty `role="dialog"` element stays in the accessibility
    // tree. The next open mounts a new `<dialog>`, and the effects above run again for it.
    if (!isMounted) return null;
    const shouldAnimateBackdrop = !shouldHideBackdrop && shouldAnimate;
    return /*#__PURE__*/ (0, $5chsV.jsx)("dialog", {
        ref: combinedRef,
        id: dialogId,
        // No `aria-modal`: `showModal()` already tells assistive technology that the dialog is
        // modal (NVDA, JAWS and VoiceOver read it from the platform accessibility API). With
        // `aria-modal`, a dialog opened with `show()` would also appear modal.
        "aria-label": label,
        "aria-labelledby": label ? undefined : labelledBy,
        style: style,
        // The browser never closes the dialog for a user action. `Dialog` handles Escape and
        // backdrop clicks itself. Always `none` (no feature check), so the server and the client
        // render the same markup.
        closedby: "none",
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $gJ6nT.default)([
            // Dialog styles
            $10754d8614df5370$var$dialogStyles.root,
            $10754d8614df5370$var$surfaceResetStyles.root,
            shouldAnimate && phase === 'entering' && $10754d8614df5370$var$dialogStyles.enter,
            shouldAnimate && phase === 'exiting' && $10754d8614df5370$var$dialogStyles.exit,
            shouldAnimate && $10754d8614df5370$var$dialogStyles.motion,
            shouldHideBackdrop ? $10754d8614df5370$var$backdropStyles.hidden : $10754d8614df5370$var$backdropStyles.root,
            shouldAnimateBackdrop && phase === 'entering' && $10754d8614df5370$var$backdropStyles.enter,
            shouldAnimateBackdrop && phase === 'exiting' && $10754d8614df5370$var$backdropStyles.exit,
            (0, $4twf9.cx)(consumerXcss, shouldAnimate && phase === 'entering' && enteringAnimationXcss, shouldAnimate && phase === 'exiting' && exitingAnimationXcss)
        ]),
        children: children
    });
});

});
parcelRegister("iQVNb", function(module, exports) {
$parcel$export(module.exports, "useBackdropClick", () => $2406e37320c4a843$export$a18054e824c0afa5);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");
function $2406e37320c4a843$export$a18054e824c0afa5({ dialogRef: dialogRef, isMounted: isMounted, onBackdropClick: onBackdropClick }) {
    (0, $fsvuC.useEffect)(()=>{
        const dialog = dialogRef.current;
        if (!isMounted || !dialog) return;
        /**
		 * Matches native dialog light dismiss: the `pointerdown` and `pointerup` targets must match.
		 * A `click` alone is not enough, as it fires on the common ancestor of both targets.
		 * https://html.spec.whatwg.org/multipage/interactive-elements.html#dialog-light-dismiss
		 */ let isBackdropPress = false;
        return (0, $dqdTY.bindAll)(dialog, [
            {
                type: 'pointerdown',
                listener (event) {
                    // Primary button only. `!button`: jsdom has no `PointerEvent`, so `button` is undefined.
                    isBackdropPress = event.target === dialog && !event.button;
                }
            },
            {
                type: 'pointerup',
                listener (event) {
                    isBackdropPress = isBackdropPress && event.target === dialog;
                }
            },
            {
                type: 'pointercancel',
                listener () {
                    isBackdropPress = false;
                }
            },
            {
                type: 'click',
                listener (event) {
                    // Each press is used once.
                    const wasBackdropPress = isBackdropPress;
                    isBackdropPress = false;
                    if (!wasBackdropPress || event.target !== dialog || !dialog.open) return;
                    onBackdropClick();
                }
            }
        ]);
    }, [
        dialogRef,
        isMounted,
        onBackdropClick
    ]);
}

});

parcelRegister("5Byvi", function(module, exports) {
$parcel$export(module.exports, "useCancelFallback", () => $1690b796ea87e8f1$export$91a60beba8b292ad);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");
/**
 * Whether the browser supports the `closedby` attribute on `<dialog>`.
 *
 * Read on the client only (in an effect), so it never changes the server markup.
 */ function $1690b796ea87e8f1$var$isClosedBySupported() {
    // eslint-disable-next-line compat/compat -- every browser in the browser policy has `<dialog>`
    return 'closedBy' in HTMLDialogElement.prototype;
}
function $1690b796ea87e8f1$export$91a60beba8b292ad({ dialogRef: dialogRef, isMounted: isMounted }) {
    (0, $fsvuC.useEffect)(()=>{
        const dialog = dialogRef.current;
        if (!isMounted || !dialog || $1690b796ea87e8f1$var$isClosedBySupported()) return;
        // Native `cancel` does not bubble, so a nested dialog's `cancel` does not reach this listener.
        return (0, $dqdTY.bind)(dialog, {
            type: 'cancel',
            listener (event) {
                event.preventDefault();
            }
        });
    }, [
        dialogRef,
        isMounted
    ]);
}

});

parcelRegister("bWEeg", function(module, exports) {
$parcel$export(module.exports, "useEscapeKeydown", () => $891f9cd8aff98fc0$export$3a72a57244d6e765);

var $dqdTY = parcelRequire("dqdTY");

var $86OVn = parcelRequire("86OVn");

var $l4c9y = parcelRequire("l4c9y");

var $2pMZ7 = parcelRequire("2pMZ7");

var $llZLy = parcelRequire("llZLy");

var $1u09E = parcelRequire("1u09E");


var $fYeZR = parcelRequire("fYeZR");

var $aiB2I = parcelRequire("aiB2I");
function $891f9cd8aff98fc0$export$3a72a57244d6e765({ dialogRef: dialogRef, isMounted: isMounted, onEscape: onEscape }) {
    (0, $fYeZR.useStartOpenOrderTracking)();
    // A layout effect, so the dialog is marked and listening as soon as it opens, even from a timer
    // outside a React event.
    (0, $86OVn.useLayoutEffect)(()=>{
        const dialog = dialogRef.current;
        if (!isMounted || !dialog) return;
        let shouldOwnEscapeRequest = false;
        return (0, $l4c9y.combine)(// `closedby="none"` hides the dialog from other layers' checks. Mark it.
        (0, $aiB2I.setAttribute)({
            element: dialog,
            name: (0, $f55c6207107d404d$export$e9d791a989444609),
            value: ''
        }), // Target and phase matter. See the listener order in `claim-escape`.
        (0, $dqdTY.bindAll)(window, [
            {
                // Capture: decide while every layer is still open. An inner layer may close on this
                // keydown before the bubble listener runs.
                type: 'keydown',
                listener (event) {
                    if (event.key === 'Escape') shouldOwnEscapeRequest = dialog.open && !(0, $llZLy.hasEscapeOwnerAbove)({
                        element: dialog,
                        isLayer: true
                    });
                },
                options: {
                    capture: true
                }
            },
            {
                // Bubble: inner handlers run first.
                type: 'keydown',
                listener (event) {
                    // `defaultPrevented`: an inner handler took this Escape, so one press undoes one thing (as
                    // with a native `<dialog>`). Legacy ModalDialog closes anyway; the flag changes that.
                    if (!(0, $1u09E.isEscapeToHandle)({
                        event: event
                    }) || !shouldOwnEscapeRequest || !dialog.open) return;
                    // `claimEscape()` stops the browser's close request. It would skip this `closedby="none"`
                    // dialog and close the next close watcher (for example a parent `auto` popover), or fire
                    // `cancel` without `closedby` support. A held key asks once.
                    if (!(0, $2pMZ7.claimEscape)({
                        event: event
                    })) return;
                    onEscape();
                }
            }
        ]));
    }, [
        dialogRef,
        isMounted,
        onEscape
    ]);
}

});
parcelRegister("2pMZ7", function(module, exports) {
$parcel$export(module.exports, "claimEscape", () => $c94481465a3f4588$export$7bfc69962e56136);
/**
 * **Listener order**
 *
 * One Escape `keydown` reaches the listeners in this order:
 *
 * 1. `Dialog`, `window` capture: decides if the Escape is its own while every layer is still open.
 * 2. `useCloseOnUnclaimedEscape` with a `targetRef`: on that element, so only while focus is in it.
 * 3. React handlers, on the React root (bubble).
 * 4. `useManualLightDismiss` and `useCloseOnUnclaimedEscape` without a `targetRef`: on `document`
 *    (bubble), in bind order. React binds child effects first.
 * 5. `Dialog`, `window` bubble: closes the dialog.
 * 6. The browser, unless a listener called `preventDefault()`: closes the topmost close watcher (an
 *    open `auto` or `hint` popover, or a `<dialog>` that closes on Escape). A `Dialog` has
 *    `closedby="none"`, so it is skipped.
 *
 * The open layers decide which layer takes Escape, not focus. But the `keydown` starts at the
 * focused element, so a handler on its path can take the Escape first, and step 2 hears it only
 * while focus is inside its element.
 *
 * Rules:
 *
 * - A listener that takes an Escape calls `claimEscape()`, and every listener checks
 *   `isEscapeToHandle()` first. So later listeners and the browser leave their layers open.
 * - An owner claims the Escape even when it declines to close.
 * - `defaultPrevented` only shows earlier listeners. A listener that runs before a layer above it
 *   must find that layer itself, with `hasEscapeOwnerAbove`:
 *   - `Dialog` asks in step 1, because the browser (step 6) closes `auto` and `hint` popovers.
 *   - A page surface on an element (step 2) runs before `manual` popovers (step 4), so it counts
 *     them too.
 *   - `document` listeners (step 4) run in bind order, not open order, so `manual` popovers and
 *     page surfaces there also ask.
 * - `hasEscapeOwnerAbove` orders owners: the later open is above, but a descendant is always above
 *   its ancestors. A marked page surface ranks just above its nearest containing layer.
 * - `stopPropagation()` before `document` (for example in a React handler) skips steps 4 and 5, not
 *   step 6: the browser closes the topmost `auto` or `hint` popover, and a `Dialog` stays open.
 *
 * Check these rules before moving a listener to another target or phase. For example, a `Dialog`
 * listener on `document` could run before a `manual` popover inside it, and close the dialog
 * instead of the popover.
 */ /**
 * Takes this Escape for a layer. `preventDefault()` stops ancestor layers and the browser from also
 * closing, so one press acts on one layer, as with a native close watcher. This is true even when
 * the layer stays open.
 *
 * Returns `true` when the layer should ask to close. Returns `false` for a held-key repeat: the
 * layer still takes the Escape, but asks to close once per key press.
 */ function $c94481465a3f4588$export$7bfc69962e56136({ event: event }) {
    event.preventDefault();
    return !event.repeat;
}

});

parcelRegister("llZLy", function(module, exports) {
$parcel$export(module.exports, "hasEscapeOwnerAbove", () => $55bd1e8a17f6fe39$export$34d7e67eba469e06);

var $k8we0 = parcelRequire("k8we0");

var $9qwFB = parcelRequire("9qwFB");

var $kmoLI = parcelRequire("kmoLI");

/**
 * The stack position of an Escape owner. Higher is above.
 *
 * - A layer ranks by its open order. No open order means it opened before tracking started, so it
 *   ranks `0`, below every later layer.
 * - A page surface is not in the top layer, so it has no open order. It ranks just above its
 *   nearest containing layer, and below every layer that opened after that one. Outside every
 *   layer, it ranks below every layer.
 */ function $55bd1e8a17f6fe39$var$getRank({ element: element, layers: layers, isLayer: isLayer }) {
    if (isLayer) return (0, $kmoLI.openOrderTracker).getOpenOrder({
        element: element
    }) ?? 0;
    const containingLayer = (0, $k8we0.getNearestContainingLayer)({
        element: element,
        layers: layers
    });
    if (!containingLayer) return Number.NEGATIVE_INFINITY;
    return ((0, $kmoLI.openOrderTracker).getOpenOrder({
        element: containingLayer
    }) ?? 0) + 0.5;
}
/**
 * `true` when `candidate` is above `element`, as with native close watchers: the later open is
 * above.
 *
 * A descendant is always above its ancestors. This fixes the open order when React opens the child
 * first (child effects run first), or when the ancestor opens again.
 *
 * A page surface ranks just above its nearest containing layer (see `getRank`). This prevents a
 * cycle where an older manual popover waits for a newer one, the newer one waits for a page surface
 * inside it, and that surface waits for the older popover.
 */ function $55bd1e8a17f6fe39$var$isCandidateAbove({ element: element, isElementLayer: isElementLayer, candidate: candidate, layers: layers }) {
    if (element === candidate || candidate.contains(element)) return false;
    if (element.contains(candidate)) return true;
    return $55bd1e8a17f6fe39$var$getRank({
        element: candidate,
        layers: layers,
        isLayer: layers.includes(candidate)
    }) > $55bd1e8a17f6fe39$var$getRank({
        element: element,
        layers: layers,
        isLayer: isElementLayer
    });
}
function $55bd1e8a17f6fe39$export$34d7e67eba469e06({ element: element, isLayer: isLayer = false }) {
    const { ownerDocument: ownerDocument } = element;
    const layers = (0, $9qwFB.getOpenLayersTakingEscape)({
        within: ownerDocument
    });
    // The hook can attach before its popover opens. Compare it anyway.
    if (isLayer && !layers.includes(element)) layers.push(element);
    const surfaces = Array.from(ownerDocument.querySelectorAll(`[${(0, $ff07b2b5c98781b6$export$890961b3d10b17dc)}]`));
    return [
        ...layers,
        ...surfaces
    ].some((candidate)=>$55bd1e8a17f6fe39$var$isCandidateAbove({
            element: element,
            isElementLayer: isLayer,
            candidate: candidate,
            layers: layers
        }));
}

});
parcelRegister("k8we0", function(module, exports) {
$parcel$export(module.exports, "getNearestContainingLayer", () => $78ea82ae94048056$export$a866a64ce12fcfe5);
/**
 * The deepest layer in `layers` that contains `element` (not `element` itself), or `null`.
 */ function $78ea82ae94048056$export$a866a64ce12fcfe5({ element: element, layers: layers }) {
    const containingLayers = layers.filter((layer)=>layer !== element && layer.contains(element));
    // The deepest containing layer contains no other containing layer.
    return containingLayers.find((layer)=>!containingLayers.some((otherLayer)=>otherLayer !== layer && layer.contains(otherLayer))) ?? null;
}

});

parcelRegister("9qwFB", function(module, exports) {
$parcel$export(module.exports, "getOpenLayersTakingEscape", () => $d953a6664df06e52$export$f07656e15ea7b8be);

var $52Fmn = parcelRequire("52Fmn");
function $d953a6664df06e52$export$f07656e15ea7b8be({ within: within }) {
    return Array.from(within.querySelectorAll('dialog, [popover]')).filter((element)=>(0, $52Fmn.isOpenLayerTakingEscape)({
            element: element
        }));
}

});
parcelRegister("52Fmn", function(module, exports) {
$parcel$export(module.exports, "isOpenLayerTakingEscape", () => $91f34deca449b592$export$53614d3ce6b06e6);

var $6OnfV = parcelRequire("6OnfV");

var $aRngQ = parcelRequire("aRngQ");

/**
 * `true` when an open `<dialog>` takes Escape, as the browser decides:
 *
 * - A `Dialog` has `closedby="none"` but takes Escape itself, so it marks itself with
 *   `manualEscapeLayerAttribute` while open.
 * - With `closedby` support, `closedBy` is the computed state: `"closerequest"` for a modal dialog
 *   without the attribute, `"none"` for a non-modal one. `closedby="none"` does not take Escape
 *   even when modal: the browser sends the close request past it.
 * - Without `closedby` support (Safari 27), only a modal dialog closes on Escape.
 *
 * A dialog that does not take Escape is part of the layer around it. Counting it would stop that
 * layer from closing.
 */ function $91f34deca449b592$var$isDialogTakingEscape({ element: element }) {
    if (!element.open) return false;
    if (element.hasAttribute((0, $f55c6207107d404d$export$e9d791a989444609))) return true;
    if (!('closedBy' in element)) return (0, $aRngQ.isModalDialog)({
        element: element
    });
    return element.closedBy !== 'none';
}
function $91f34deca449b592$export$53614d3ce6b06e6({ element: element }) {
    if (element instanceof HTMLDialogElement) return $91f34deca449b592$var$isDialogTakingEscape({
        element: element
    });
    if (!(0, $6OnfV.isNativeElementOpen)({
        element: element
    })) return false;
    if (element.popover === 'auto' || element.popover === 'hint') return true;
    return element.hasAttribute((0, $f55c6207107d404d$export$e9d791a989444609));
}

});
parcelRegister("aRngQ", function(module, exports) {
$parcel$export(module.exports, "isModalDialog", () => $0c049f72740dc902$export$cebb092bf393cc5);
/**
 * `true` for an open modal `<dialog>`.
 */ function $0c049f72740dc902$export$cebb092bf393cc5({ element: element }) {
    if (!element.open) return false;
    // Some DOM implementations throw on `:modal`.
    try {
        return element.matches(':modal');
    } catch  {
        return false;
    }
}

});

/**
 * Marks an open layer that takes Escape itself where the browser would not: a `manual` popover
 * with `useManualLightDismiss`, or a `Dialog` (`closedby="none"`), while it listens for Escape.
 *
 * A string, so it works across copies of `@atlaskit/top-layer`.
 *
 * An attribute, not a registry: the DOM is the record of open layers. The browser opens and closes
 * layers without our code (light dismiss, Escape), and layers from other code or older copies do
 * not register, so a registry would miss them. The mark only adds what the DOM cannot show, and it
 * goes away with its element.
 */ const $f55c6207107d404d$export$e9d791a989444609 = 'data-top-layer-takes-escape';



parcelRegister("kmoLI", function(module, exports) {
$parcel$export(module.exports, "openOrderTracker", () => $995729dec813f780$export$859fb18bafe6a3cf);

var $dqdTY = parcelRequire("dqdTY");
function $995729dec813f780$var$createOpenOrderTracker() {
    // A `WeakMap`, so a removed element is not kept alive.
    const openOrders = new WeakMap();
    let lastOpenOrder = 0;
    let isTracking = false;
    function record({ element: element }) {
        lastOpenOrder += 1;
        openOrders.set(element, lastOpenOrder);
    }
    return {
        start () {
            if (isTracking) return;
            isTracking = true;
            /**
			 * - Never unbound: it must see every open for the life of the page.
			 * - `beforetoggle`, not `toggle`: `beforetoggle` fires synchronously on open. `toggle` is
			 *   task-queued, and in Chrome it can arrive after an Escape that follows the open.
			 * - Capture: `beforetoggle` does not bubble, and an inner `stopPropagation()` cannot hide
			 *   an open from a capture listener on `document`.
			 */ // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- open order is tracked for the whole document
            (0, $dqdTY.bind)(document, {
                type: 'beforetoggle',
                listener (event) {
                    if (event.newState !== 'open' || !(event.target instanceof Element)) return;
                    // An element that opens again gets a new, higher order.
                    record({
                        element: event.target
                    });
                },
                options: {
                    capture: true
                }
            });
        },
        getOpenOrder ({ element: element }) {
            return openOrders.get(element) ?? null;
        },
        ensureOpenOrder ({ element: element }) {
            if (openOrders.has(element)) return;
            record({
                element: element
            });
        }
    };
}
const $995729dec813f780$export$859fb18bafe6a3cf = $995729dec813f780$var$createOpenOrderTracker();

});

/**
 * Marks the surface element of an open page surface while `useCloseOnUnclaimedEscape` listens for
 * Escape on `document`. A `manual` popover around the surface also listens on `document`, in bind
 * order. The mark lets the popover leave the Escape to the surface, whatever the bind order.
 *
 * A string, so it works across copies of `@atlaskit/top-layer`.
 */ const $ff07b2b5c98781b6$export$890961b3d10b17dc = 'data-top-layer-surface-takes-escape';


parcelRegister("1u09E", function(module, exports) {
$parcel$export(module.exports, "isEscapeToHandle", () => $2fe5051168ec2d54$export$da0a8943df86d627);
/**
 * `true` for an Escape keydown that a layer should act on.
 */ function $2fe5051168ec2d54$export$da0a8943df86d627({ event: event }) {
    if (event.key !== 'Escape') return false;
    // Something else already handled this Escape.
    if (event.defaultPrevented) return false;
    /**
	 * The user is typing with an IME (input method editor), such as for Japanese or Chinese text.
	 * While a composition is open, Escape cancels the composition, so it must not also close a layer.
	 *
	 * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/isComposing
	 */ if (event.isComposing) return false;
    return true;
}

});

parcelRegister("fYeZR", function(module, exports) {
$parcel$export(module.exports, "useStartOpenOrderTracking", () => $eaaa6e421d3048c9$export$67e00e6e0682a61c);

var $fsvuC = parcelRequire("fsvuC");

var $kmoLI = parcelRequire("kmoLI");
function $eaaa6e421d3048c9$export$67e00e6e0682a61c() {
    /**
	 * **Why `useInsertionEffect`**
	 *
	 * - It must run before any popover or dialog in this commit opens. `Popover` and `Dialog` open
	 *   in layout effects, and React runs child effects first, so our own `useLayoutEffect` can run
	 *   after a child layer has opened. React runs every insertion effect of a commit before any
	 *   layout effect.
	 * - Not during render: render also runs on the server, and binding a `document` listener there
	 *   breaks SSR in a DOM test environment. Effects never run on the server.
	 */ (0, $fsvuC.useInsertionEffect)(()=>{
        (0, $kmoLI.openOrderTracker).start();
    }, []);
}

});

parcelRegister("aiB2I", function(module, exports) {
$parcel$export(module.exports, "setAttribute", () => $f11e962faea8d63c$export$9fec4d97f1922e0b);
/**
 * Sets an attribute on an element and returns a cleanup function that removes it.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     setAttribute({ element, name: 'data-example', value: '' }),
 *     bind(window, { type: 'keydown', listener: onKeyDown }),
 *   );
 * }, []);
 * ```
 */ function $f11e962faea8d63c$export$9fec4d97f1922e0b({ element: element, name: name, value: value }) {
    element.setAttribute(name, value);
    return function cleanup() {
        element.removeAttribute(name);
    };
}

});



parcelRegister("gslXa", function(module, exports) {
$parcel$export(module.exports, "DialogScrollLock", () => $ac05adc3203babb6$export$e458030908e2d723);

var $jilfX = parcelRequire("jilfX");

var $86OVn = parcelRequire("86OVn");
function $ac05adc3203babb6$export$e458030908e2d723({ isOpen: isOpen }) {
    (0, $86OVn.useLayoutEffect)(()=>{
        if (!isOpen) return;
        const body = (0, $jilfX.getDocument)()?.body;
        if (!body) return;
        const previousOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
        return ()=>{
            body.style.overflow = previousOverflow;
        };
    }, [
        isOpen
    ]);
    return null;
}
$ac05adc3203babb6$export$e458030908e2d723.displayName = "DialogScrollLock";

});

parcelRegister("1ZFxP", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $002b4a480ea456be$export$ab57792b9b6974a6);

var $fsvuC = parcelRequire("fsvuC");
const $002b4a480ea456be$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});

parcelRegister("7psUz", function(module, exports) {
$parcel$export(module.exports, "default", () => $d810bad9e314b3c9$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");

var $aeFN5 = parcelRequire("aeFN5");

var $822dj = parcelRequire("822dj");

var $fW8Y9 = parcelRequire("fW8Y9");

var $3s1nE = parcelRequire("3s1nE");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $d810bad9e314b3c9$var$modalStackRegister = [];
function $d810bad9e314b3c9$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $3s1nE.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $fW8Y9.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $822dj.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $aeFN5.default)(()=>{
        const newStackIndex = $d810bad9e314b3c9$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $fsvuC.useEffect)(()=>{
        const currentStackIndex = $d810bad9e314b3c9$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $d810bad9e314b3c9$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $d810bad9e314b3c9$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $d810bad9e314b3c9$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $fsvuC.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $d810bad9e314b3c9$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $d810bad9e314b3c9$var$modalStackRegister.splice(currentStackIndex, 1);
                $d810bad9e314b3c9$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("aeFN5", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b821c3d216f305e$export$2e2bcd8739ae039);

var $c0C2m = parcelRequire("c0C2m");
function $4b821c3d216f305e$export$2e2bcd8739ae039(callback) {
    const ref = (0, $c0C2m.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("c0C2m", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd4c5e884937eee2$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
const $bd4c5e884937eee2$var$uniqueReferencedValue = {};
function $bd4c5e884937eee2$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $fsvuC.useRef)($bd4c5e884937eee2$var$uniqueReferencedValue);
    if (ref.current === $bd4c5e884937eee2$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("822dj", function(module, exports) {
$parcel$export(module.exports, "default", () => $828f49d1b366e5c4$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
function $828f49d1b366e5c4$export$2e2bcd8739ae039(value) {
    const ref = (0, $fsvuC.useRef)();
    (0, $fsvuC.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("fW8Y9", function(module, exports) {
$parcel$export(module.exports, "default", () => $dce55cf7686947a1$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
function $dce55cf7686947a1$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $fsvuC.useState)(initialState);
    const valueRef = (0, $fsvuC.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("2qiHl", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfc59d17946bae14$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $bfc59d17946bae14$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $bfc59d17946bae14$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $fsvuC.useState)(0);
    (0, $fsvuC.useLayoutEffect)(()=>{
        setScrollTopOffset($bfc59d17946bae14$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $fsvuC.useCallback)(()=>{
        if ($bfc59d17946bae14$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $fsvuC.useEffect)(()=>{
        return (0, $dqdTY.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("bUmWJ", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $3c35fe54f090f27e$export$ec28e97c7d8b1b35);

var $dqdTY = parcelRequire("dqdTY");

var $gKvs9 = parcelRequire("gKvs9");

var $k0iCs = parcelRequire("k0iCs");

var $9Awdx = parcelRequire("9Awdx");
function $3c35fe54f090f27e$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $dqdTY.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $gKvs9.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $k0iCs.combine)(unbindEvents, unbindMonitor);
}
function $3c35fe54f090f27e$var$watchForInteractionStart({ start: start }) {
    return (0, $dqdTY.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $3c35fe54f090f27e$var$api = (0, $9Awdx.makeFixForAdapter)({
    watchForInteractionStart: $3c35fe54f090f27e$var$watchForInteractionStart,
    watchForInteractionEnd: $3c35fe54f090f27e$var$watchForInteractionEnd
});
function $3c35fe54f090f27e$export$ec28e97c7d8b1b35() {
    return $3c35fe54f090f27e$var$api.registerUsage();
}

});
parcelRegister("9Awdx", function(module, exports) {
$parcel$export(module.exports, "makeFixForAdapter", () => $09bb9bbf1bedf9dd$export$a74bff2507e6126b);

var $k0iCs = parcelRequire("k0iCs");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $09bb9bbf1bedf9dd$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $09bb9bbf1bedf9dd$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch  {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $09bb9bbf1bedf9dd$var$isIframeOnAnotherDomain(iframe) {
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
	 */ if (iframe.srcdoc) return false;
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
	 */ if (iframe.src.startsWith('data:')) return false;
    return !$09bb9bbf1bedf9dd$var$hasSameOrigin(window.location.href, iframe.src);
}
const $09bb9bbf1bedf9dd$var$registry = new Map();
function $09bb9bbf1bedf9dd$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($09bb9bbf1bedf9dd$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $09bb9bbf1bedf9dd$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $09bb9bbf1bedf9dd$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $09bb9bbf1bedf9dd$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $09bb9bbf1bedf9dd$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $k0iCs.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $09bb9bbf1bedf9dd$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $09bb9bbf1bedf9dd$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            registrationCount--;
            if (registrationCount !== 0) return;
            stopWatchingInteractionStart?.();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("4iZn0", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $f1d73a376dd08a20$export$27d79116d3a4e7d5);

var $itCQV = parcelRequire("itCQV");

var $9Awdx = parcelRequire("9Awdx");
function $f1d73a376dd08a20$var$watchForInteractionStart({ start: start }) {
    return (0, $itCQV.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $f1d73a376dd08a20$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $itCQV.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $f1d73a376dd08a20$var$api = (0, $9Awdx.makeFixForAdapter)({
    watchForInteractionStart: $f1d73a376dd08a20$var$watchForInteractionStart,
    watchForInteractionEnd: $f1d73a376dd08a20$var$watchForInteractionEnd
});
function $f1d73a376dd08a20$export$27d79116d3a4e7d5() {
    return $f1d73a376dd08a20$var$api.registerUsage();
}

});

parcelRegister("khDrE", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $8c9659177a13a0a7$export$9c0606fcefb5d1e2);

var $dqdTY = parcelRequire("dqdTY");

var $gAMtd = parcelRequire("gAMtd");

var $k0iCs = parcelRequire("k0iCs");

var $9Awdx = parcelRequire("9Awdx");
function $8c9659177a13a0a7$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $dqdTY.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
					 * The pdnd `onDragStart()` fires in the frame after "dragstart"
					 * So we are delaying our isDragging check to give a chance
					 * for `onDragStart()` to set the value correctly.
					 *
					 * Note: could not use "pointercancel" as it is not
					 * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
					 */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $gAMtd.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $k0iCs.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $8c9659177a13a0a7$var$watchForInteractionStart({ start: start }) {
    return (0, $dqdTY.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $8c9659177a13a0a7$var$api = (0, $9Awdx.makeFixForAdapter)({
    watchForInteractionStart: $8c9659177a13a0a7$var$watchForInteractionStart,
    watchForInteractionEnd: $8c9659177a13a0a7$var$watchForInteractionEnd
});
function $8c9659177a13a0a7$export$9c0606fcefb5d1e2() {
    return $8c9659177a13a0a7$var$api.registerUsage();
}

});

parcelRegister("kRIRZ", function(module, exports) {
$parcel$export(module.exports, "ScrollContext", () => $84ef07ff3f29a27b$export$dece24112a937f92);

var $fsvuC = parcelRequire("fsvuC");
const $84ef07ff3f29a27b$export$dece24112a937f92 = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});

parcelRegister("6xFCE", function(module, exports) {
$parcel$export(module.exports, "width", () => $6a5e4548a4310f80$export$7e3df82ee760448c);
const $6a5e4548a4310f80$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};

});

parcelRegister("7jbx2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5df5f10513a7eb5d$export$2e2bcd8739ae039);
/* modal-dialog.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $2YOL2 = parcelRequire("2YOL2");

var $1cXpO = parcelRequire("1cXpO");

var $9gFl0 = parcelRequire("9gFl0");

var $k9FWI = parcelRequire("k9FWI");

var $04q6D = parcelRequire("04q6D");

var $1wCqK = parcelRequire("1wCqK");

var $h4ylU = parcelRequire("h4ylU");

var $7IVZh = parcelRequire("7IVZh");

var $5T6N9 = parcelRequire("5T6N9");

var $k0iCs = parcelRequire("k0iCs");

var $1ZFxP = parcelRequire("1ZFxP");

var $jJW8S = parcelRequire("jJW8S");

var $bUmWJ = parcelRequire("bUmWJ");

var $4iZn0 = parcelRequire("4iZn0");

var $khDrE = parcelRequire("khDrE");

var $kRIRZ = parcelRequire("kRIRZ");

var $4eozk = parcelRequire("4eozk");

var $ghIs9 = parcelRequire("ghIs9");

var $bqISS = parcelRequire("bqISS");
const $5df5f10513a7eb5d$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $5df5f10513a7eb5d$var$dialogStyles = {
    root: "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _3iDTPbQ4SZ _39xV02N91d _1EqgXlqUim _0jFU0VN91d _4kiQYAdnbC _0NUa3rWP8C _0aFT5vbt8w _0KLXruoI2d _1UtDYzy7kJ _45TjwHoI2d _1pp6NdIZbP _3Sk04SOLYo _1s1YRNOLYo _3gkMN6OLYo _1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _3e11vU6wH8 _0hSAgbHZdu _28xGbQOLYo _2l47gTGk8v _2gkHrTOLYo _0iOkeGOLYo _4APJLd5dtV",
    borderRadius: "_0YcdZAyzSk",
    motion: "_0NUa3rOLYo _1EqgXlOLYo _3iDTPbQ4SZ _3GZDR8B2PM _3AHHrTN91d",
    rootMotion: "_2gkHrTIZbP _0iOkeGIZbP",
    fullscreen: "_3GZDR8N91d"
};
const $5df5f10513a7eb5d$var$viewportScrollStyles = null;
const $5df5f10513a7eb5d$var$bodyScrollStyles = null;
const $5df5f10513a7eb5d$var$ModalDialog = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus = false, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId, isFullScreen: isFullScreen = false, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const id = (0, $k9FWI.useId)();
    const titleId = `modal-dialog-title-${id}`;
    const defaultTestId = testId || 'modal-dialog';
    (0, $fsvuC.useEffect)(()=>// Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        (0, $k0iCs.combine)((0, $bUmWJ.disableDraggingToCrossOriginIFramesForElement)(), (0, $khDrE.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $4iZn0.disableDraggingToCrossOriginIFramesForExternal)()), []);
    (0, $9gFl0.default)(autoFocus, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object' && !UNSAFE__disableInitialAutoFocus);
    const [motionRef, onMotionFinish] = (0, $jJW8S.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $fsvuC.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        }), [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $04q6D.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $1wCqK.useLayering)();
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bqISS.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $1ZFxP.ModalContext).Provider, {
            value: modalDialogContext,
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kRIRZ.ScrollContext).Provider, {
                value: shouldScrollInViewport,
                children: !UNSAFE_shouldDisableMotionUplift && (0, $5T6N9.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $h4ylU.default), {
                    enteringAnimation: "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)",
                    exitingAnimation: "var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)",
                    onFinish: onMotionFinish,
                    xcss: (0, $2YOL2.cx)($5df5f10513a7eb5d$var$dialogStyles.motion, isFullScreen && $5df5f10513a7eb5d$var$dialogStyles.fullscreen),
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--modal-dialog-width': (0, $ghIs9.dialogWidth)(width),
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--modal-dialog-height': (0, $4eozk.dialogHeight)(height)
                    },
                    children: /*#__PURE__*/ (0, $5chsV.jsx)("section", {
                        "aria-label": label,
                        ref: (0, $1cXpO.default)([
                            motionRef,
                            ref
                        ]),
                        style: {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            '--modal-dialog-width': (0, $ghIs9.dialogWidth)(width),
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            '--modal-dialog-height': (0, $4eozk.dialogHeight)(height)
                        },
                        role: "dialog",
                        "aria-labelledby": label ? undefined : titleId,
                        "data-testid": defaultTestId,
                        "data-modal-stack": stackIndex,
                        tabIndex: -1,
                        "aria-modal": true,
                        "data-ds--level": currentLevel,
                        className: (0, $gJ6nT.default)([
                            $5df5f10513a7eb5d$var$dialogStyles.root,
                            $5df5f10513a7eb5d$var$dialogStyles.rootMotion,
                            !isFullScreen && $5df5f10513a7eb5d$var$dialogStyles.borderRadius,
                            shouldScrollInViewport ? "_4kiQYAWP8C _0NUa3rYbGa _0z5aewk2yd" : "_0OpL60k2yd _0LO9FMOLYo"
                        ]),
                        children: children
                    })
                }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $7IVZh.default /**
                           * We don't want a 'slide in' for the full screen modals.
                           */ ), {
                    entranceDirection: isFullScreen ? undefined : 'bottom',
                    onFinish: onMotionFinish,
                    children: (bottomFadeInProps)=>/*#__PURE__*/ (0, $5chsV.jsx)("section", {
                            ...bottomFadeInProps,
                            "aria-label": label,
                            ref: (0, $1cXpO.default)([
                                bottomFadeInProps.ref,
                                motionRef,
                                ref
                            ]),
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-width': (0, $ghIs9.dialogWidth)(width),
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-height': (0, $4eozk.dialogHeight)(height)
                            },
                            className: (0, $gJ6nT.default)([
                                $5df5f10513a7eb5d$var$dialogStyles.root,
                                !isFullScreen && $5df5f10513a7eb5d$var$dialogStyles.borderRadius,
                                shouldScrollInViewport ? "_4kiQYAWP8C _0NUa3rYbGa _0z5aewk2yd" : "_0OpL60k2yd _0LO9FMOLYo",
                                bottomFadeInProps.className
                            ]),
                            role: "dialog",
                            "aria-labelledby": label ? undefined : titleId,
                            "data-testid": defaultTestId,
                            "data-modal-stack": stackIndex,
                            tabIndex: -1,
                            "aria-modal": true,
                            "data-ds--level": currentLevel,
                            children: children
                        })
                })
            })
        })
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc, @atlaskit/volt-strict-mode/no-multiple-exports
var $5df5f10513a7eb5d$export$2e2bcd8739ae039 = $5df5f10513a7eb5d$var$ModalDialog;

});
parcelRegister("04q6D", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $b45f43d674b89d1d$export$4a4bf067ea9e7886);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $1wCqK = parcelRequire("1wCqK");
const $b45f43d674b89d1d$var$ESCAPE = 'Escape';
function $b45f43d674b89d1d$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled, isEnabled: isEnabled = true }) {
    const escapePressed = (0, $fsvuC.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = (0, $1wCqK.useLayering)({
        isEnabled: isEnabled
    });
    const onKeyDown = (0, $fsvuC.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $b45f43d674b89d1d$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $fsvuC.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $fsvuC.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $dqdTY.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        isEnabled,
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("1wCqK", function(module, exports) {
$parcel$export(module.exports, "useLayering", () => $e23fb5a67b95d356$export$c8b4d54e03dee6ed);

var $fsvuC = parcelRequire("fsvuC");

var $fWAWL = parcelRequire("fWAWL");

var $kQW6b = parcelRequire("kQW6b");

var $7SXb3 = parcelRequire("7SXb3");
function $e23fb5a67b95d356$export$c8b4d54e03dee6ed({ isEnabled: isEnabled = true } = {}) {
    const levelFromContext = (0, $fsvuC.useContext)((0, $fWAWL.LevelContext));
    const currentLevel = isEnabled ? levelFromContext : 0;
    const layerNode = (0, $fsvuC.useContext)((0, $kQW6b.LevelNodeContext));
    const rootNode = (0, $fsvuC.useContext)((0, $7SXb3.RootNodeContext));
    const isLayerDisabled = (0, $fsvuC.useCallback)(()=>{
        if (!isEnabled) return false;
        // This is an impossible case, added for type safety
        if (!layerNode?.current || !rootNode?.current) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        isEnabled,
        layerNode,
        rootNode
    ]);
    const getTopLevel = (0, $fsvuC.useCallback)(()=>{
        if (!isEnabled) return null;
        return rootNode?.current ? rootNode.current.getHeight() : null;
    }, [
        isEnabled,
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});


parcelRegister("jJW8S", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2e277adc9b0df57$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
function $a2e277adc9b0df57$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $fsvuC.useRef)(null);
    const onMotionFinish = (0, $fsvuC.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("4eozk", function(module, exports) {
$parcel$export(module.exports, "dialogHeight", () => $3e4c705e2f9ac889$export$ceba93bf0bdd16f2);
const $3e4c705e2f9ac889$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("ghIs9", function(module, exports) {
$parcel$export(module.exports, "dialogWidth", () => $c98ea5cd1edb53dc$export$a3da89b899389ed8);

var $6xFCE = parcelRequire("6xFCE");
const $c98ea5cd1edb53dc$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = (0, $6xFCE.width).values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${(0, $6xFCE.width).widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("bqISS", function(module, exports) {
$parcel$export(module.exports, "default", () => $73e26e707b56bdaa$export$2e2bcd8739ae039);
/* positioner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");


var $fC2o6 = parcelRequire("fC2o6");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
const $73e26e707b56bdaa$var$positionerStyles = null;
const $73e26e707b56bdaa$var$stackStyles = {
    stackTransition: "_1kOSYtC67X _39Ohv4YbGa _1SdfoHYbGa",
    stackTransform: "_1VJPcamUxd",
    stackIdle: "_1VJPcaYbGa"
};
// Hardcoded pixels are based off a 60px base gutter
const $73e26e707b56bdaa$var$scrollStyles = {
    viewport: "_0jFU0VIZbP _1mT5xdRAKS _3ns3u9fI2J _3lqkkiIZbP _0Y3dgaYbGa",
    body: "_28xGbQw4ra _0Wik48UMig _2fj8asWVPG _0m5YQyahDP _4pesVsdnbC _3GyDTtdnbC _2gkHrTIZbP _0iOkeGIZbP _0Y3dgaYbGa",
    fullScreen: ""
};
function $73e26e707b56bdaa$var$getScrollBehavior({ isFullScreen: isFullScreen, shouldScrollInViewport: shouldScrollInViewport }) {
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
const $73e26e707b56bdaa$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId, isFullScreen: isFullScreen } = props;
    const scrollBehavior = $73e26e707b56bdaa$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        style: {
            '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: `${(0, $fC2o6.durations).medium}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $ef43174c6184897f$export$c07234257a03d5e9)
        },
        "data-testid": testId && `${testId}--positioner`,
        className: (0, $gJ6nT.default)([
            "_3iDTPbQ4SZ _39xV02N91d _1EqgXlN91d _0jFU0VN91d _1mT5xdy1CL _42Yu6BFIQA _0aFT5vbt8w _2I62gzdnbC _3iC0zddnbC",
            $73e26e707b56bdaa$var$stackStyles.stackTransition,
            stackIndex > 0 ? $73e26e707b56bdaa$var$stackStyles.stackTransform : $73e26e707b56bdaa$var$stackStyles.stackIdle,
            $73e26e707b56bdaa$var$scrollStyles[scrollBehavior]
        ]),
        children: children
    });
};
$73e26e707b56bdaa$var$Positioner.displayName = "Positioner";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$73e26e707b56bdaa$export$2e2bcd8739ae039 = $73e26e707b56bdaa$var$Positioner;

});
const $ef43174c6184897f$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $ef43174c6184897f$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $ef43174c6184897f$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $ef43174c6184897f$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
const $ef43174c6184897f$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
const $ef43174c6184897f$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
const $ef43174c6184897f$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';





parcelRegister("fLAte", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $0536e05eec42599f$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $c4Atc = parcelRequire("c4Atc");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $0536e05eec42599f$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $c4Atc.default), {
        appear: true,
        children: //Checking if children are undefined to prevent potential runtime errors in React 17
        props.children ?? null
    });
};
$0536e05eec42599f$var$ModalTransition.displayName = "ModalTransition";
var $0536e05eec42599f$export$2e2bcd8739ae039 = $0536e05eec42599f$var$ModalTransition;

});

parcelRegister("brBog", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c542095348fb4f31$export$2e2bcd8739ae039);
/* modal-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");
parcelRequire("fsvuC");

var $8C8EQ = parcelRequire("8C8EQ");

var $87Orm = parcelRequire("87Orm");

var $1hBzr = parcelRequire("1hBzr");
const $c542095348fb4f31$var$styles = {
    header: "_2Y7lL4NHnM _3iDTPbQ4SZ _1mT5xdRAKS _0hPCNLDIqT _37wbyuI7V3 _0rIjykLl21 _0xmtko5zaO _46hvQmNHnM",
    flex: "_0aFT5vf5Xk _39xV02N91d",
    titleContainer: "_4ouGXIdnbC"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $c542095348fb4f31$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId, hasCloseButton: hasCloseButton = false, closeButtonLabel: closeButtonLabel } = props;
    const { hasProvidedOnClose: hasProvidedOnClose, onClose: onClose, testId: modalTestId } = (0, $1hBzr.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
    // Only show if an onClose was provided for the modal dialog
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        className: (0, $gJ6nT.default)([
            $c542095348fb4f31$var$styles.header
        ]),
        children: shouldShowCloseButton ? /*#__PURE__*/ (0, $5chsV.jsxs)((0, $8C8EQ.Flex), {
            gap: "space.200",
            justifyContent: "space-between",
            xcss: $c542095348fb4f31$var$styles.flex,
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $8C8EQ.Flex), {
                    justifyContent: "end",
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $87Orm.CloseButton), {
                        label: closeButtonLabel,
                        onClick: onClose,
                        testId: modalTestId
                    })
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $8C8EQ.Flex), {
                    justifyContent: "start",
                    alignItems: "center",
                    xcss: $c542095348fb4f31$var$styles.titleContainer,
                    children: children
                })
            ]
        }) : children
    });
};
$c542095348fb4f31$var$ModalHeader.displayName = "ModalHeader";
var $c542095348fb4f31$export$2e2bcd8739ae039 = $c542095348fb4f31$var$ModalHeader;

});
parcelRegister("87Orm", function(module, exports) {
$parcel$export(module.exports, "CloseButton", () => $192f9e93e3641e80$export$de65de8213222d10);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $8gTjU = parcelRequire("8gTjU");

var $irYrv = parcelRequire("irYrv");
const $192f9e93e3641e80$export$de65de8213222d10 = ({ label: label, onBlur: onBlur, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $8gTjU.default), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($irYrv))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });
$192f9e93e3641e80$export$de65de8213222d10.displayName = "CloseButton";

});

parcelRegister("1hBzr", function(module, exports) {
$parcel$export(module.exports, "useModal", () => $e7bd4172f3620e1a$export$33ffd74ebf07f060);

var $fsvuC = parcelRequire("fsvuC");

var $1ZFxP = parcelRequire("1ZFxP");
const $e7bd4172f3620e1a$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $fsvuC.useContext)((0, $1ZFxP.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});


parcelRegister("clYgZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $46a62a56a1fa6f14$export$2e2bcd8739ae039);
/* modal-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $6Pb6R = parcelRequire("6Pb6R");

var $gD3tC = parcelRequire("gD3tC");

var $1hBzr = parcelRequire("1hBzr");
const $46a62a56a1fa6f14$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
const $46a62a56a1fa6f14$var$iconStyles = null;
const $46a62a56a1fa6f14$var$titleStyles = null;
const $46a62a56a1fa6f14$var$textStyles = null;
const $46a62a56a1fa6f14$var$truncatedTextStyles = null;
const $46a62a56a1fa6f14$var$TitleIcon = ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($6Pb6R))) : (0, (/*@__PURE__*/$parcel$interopDefault($gD3tC)));
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        className: (0, $gJ6nT.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _1UtDYzOLYo _4ya3eEOLYo _2l4i3rOLYo _1kk5TkOLYo _3iugoSOLYo _26BoRwOLYo"
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)(Icon, {
            label: appearance,
            color: $46a62a56a1fa6f14$var$iconColor[appearance],
            spacing: "spacious"
        })
    });
};
$46a62a56a1fa6f14$var$TitleIcon.displayName = "TitleIcon";
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $46a62a56a1fa6f14$var$ModalTitle = (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $1hBzr.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $5chsV.jsxs)("h1", {
        "data-testid": testId,
        className: (0, $gJ6nT.default)([
            "_2mHwu82ADO _2sNsIgWSk4 _3iDTPbQ4SZ _4ouGXIdnbC _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg"
        ]),
        children: [
            appearance && /*#__PURE__*/ (0, $5chsV.jsx)($46a62a56a1fa6f14$var$TitleIcon, {
                appearance: appearance
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                id: titleId,
                "data-testid": testId && `${testId}-text`,
                className: (0, $gJ6nT.default)([
                    "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _2sNsIgWSk4 _4ouGXIdnbC _1T2N03wPeg",
                    !isMultiline && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7"
                ]),
                children: children
            })
        ]
    });
};
$46a62a56a1fa6f14$var$ModalTitle.displayName = "ModalTitle";
var $46a62a56a1fa6f14$export$2e2bcd8739ae039 = $46a62a56a1fa6f14$var$ModalTitle;

});

parcelRegister("dJ6LB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $5d1f805737ad19a1$export$2e2bcd8739ae039);
/* modal-body.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");
parcelRequire("fsvuC");

var $121xR = parcelRequire("121xR");

var $1hBzr = parcelRequire("1hBzr");

var $kh3Pn = parcelRequire("kh3Pn");

var $lESkY = parcelRequire("lESkY");
const $5d1f805737ad19a1$var$styles = {
    root: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _2sNsIgmnOE",
    paddingBlock: "_4c065UFQfX",
    paddingInline: "_2Y7lL4NHnM"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $5d1f805737ad19a1$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId, hasInlinePadding: hasInlinePadding = true } = props;
    const { testId: modalTestId } = (0, $1hBzr.useModal)();
    const shouldScrollInViewport = (0, $lESkY.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        className: (0, $gJ6nT.default)([
            $5d1f805737ad19a1$var$styles.root,
            hasInlinePadding && $5d1f805737ad19a1$var$styles.paddingInline
        ]),
        children: children
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $121xR.TouchScrollable), {
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kh3Pn.default), {
            testId: userDefinedTestId || modalTestId,
            children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                "data-testid": testId,
                className: (0, $gJ6nT.default)([
                    $5d1f805737ad19a1$var$styles.root,
                    /**
       * Adding block padding for scroll keylines, which are only shown when the scrolling
       * is on the container.
       */ $5d1f805737ad19a1$var$styles.paddingBlock,
                    hasInlinePadding && $5d1f805737ad19a1$var$styles.paddingInline
                ]),
                children: children
            })
        })
    });
};
$5d1f805737ad19a1$var$ModalBody.displayName = "ModalBody";
var $5d1f805737ad19a1$export$2e2bcd8739ae039 = $5d1f805737ad19a1$var$ModalBody;

});
parcelRegister("kh3Pn", function(module, exports) {
$parcel$export(module.exports, "default", () => $96504a49d43e3727$export$2e2bcd8739ae039);
/* scroll-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $hMOFt = parcelRequire("hMOFt");

var $2YOL2 = parcelRequire("2YOL2");

var $1cXpO = parcelRequire("1cXpO");

var $iqo7S = parcelRequire("iqo7S");

var $aeFN5 = parcelRequire("aeFN5");

var $cjchk = parcelRequire("cjchk");
const $96504a49d43e3727$var$keylineColor = "var(--ds-border, #0B120E24)";
const $96504a49d43e3727$var$styles = {
    base: "_1ma2CfOLYo _3iDTPbOLYo _0aFT5vOLYo _2O5Vij7dHp _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _4bt5LAnQyn _2WAcuGIZbP _3GZDR8ZqHV _2aYxTvIZbP",
    topKeyline: "_1v3aPqOeNX",
    bottomKeyline: "_2R4pr3OeNX"
};
const $96504a49d43e3727$var$keylineHeight = 1;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $96504a49d43e3727$var$ScrollContainer = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ testId: testId, children: children }, ref)=>{
    const scrollableRef = (0, $fsvuC.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, $fsvuC.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $fsvuC.useState)(false);
    const [showContentFocus, setContentFocus] = (0, $fsvuC.useState)(false);
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $fsvuC.useEffect)(()=>{
        const schedule = (0, $hMOFt.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, $aeFN5.default)((0, $hMOFt.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $96504a49d43e3727$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $96504a49d43e3727$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $fsvuC.useEffect)(()=>{
        const target = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, $dqdTY.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $dqdTY.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $iqo7S.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $cjchk.Focusable), {
        as: "div",
        isInset: true,
        // tabindex is allowed here so that keyboard users can scroll content
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && `${testId}--scrollable`,
        ref: (0, $1cXpO.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $2YOL2.cx)($96504a49d43e3727$var$styles.base, showTopKeyline && $96504a49d43e3727$var$styles.topKeyline, showBottomKeyline && $96504a49d43e3727$var$styles.bottomKeyline),
        children: children
    });
});
$96504a49d43e3727$var$ScrollContainer.displayName = 'ScrollContainer';
var $96504a49d43e3727$export$2e2bcd8739ae039 = $96504a49d43e3727$var$ScrollContainer;

});

parcelRegister("lESkY", function(module, exports) {
$parcel$export(module.exports, "default", () => $35da66a23acb9cb9$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");

var $kRIRZ = parcelRequire("kRIRZ");
function $35da66a23acb9cb9$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $fsvuC.useContext)((0, $kRIRZ.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("e6Xis", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $7c017ee66964f1ae$export$2e2bcd8739ae039);
/* modal-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $1hBzr = parcelRequire("1hBzr");
const $7c017ee66964f1ae$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $7c017ee66964f1ae$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $1hBzr.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        className: (0, $gJ6nT.default)([
            "_2mHwu82ADO _2Y7lL4NHnM _3iDTPbQ4SZ _1mT5xdRAKS _0hPCNLDIqT _37wbyuz9WS _43nrzTLl21 _0xmtkoNHnM _46hvQm5zaO"
        ]),
        children: children
    });
};
$7c017ee66964f1ae$var$ModalFooter.displayName = "ModalFooter";
var $7c017ee66964f1ae$export$2e2bcd8739ae039 = $7c017ee66964f1ae$var$ModalFooter;

});

parcelRegister("2jeEB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::403d648a4ec6dc7540968c496b0b831a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ae8b91677446cef$var$_react = $1ae8b91677446cef$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $1ae8b91677446cef$var$_iconNew = $1ae8b91677446cef$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $1ae8b91677446cef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/dashboard
 * Usage guidance:
 * Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1ae8b91677446cef$var$DashboardIcon = (props)=>/*#__PURE__*/ $1ae8b91677446cef$var$_react.default.createElement($1ae8b91677446cef$var$_iconNew.default, Object.assign({
        name: "DashboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$1ae8b91677446cef$var$DashboardIcon.displayName = 'DashboardIcon';
var $1ae8b91677446cef$var$_default = module.exports.default = $1ae8b91677446cef$var$DashboardIcon;

});

parcelRegister("hdkV2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07ce97dc138cd4f55e8a1bb0a6f266b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c883e0a5a45fe2e5$var$_react = $c883e0a5a45fe2e5$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $c883e0a5a45fe2e5$var$_iconNew = $c883e0a5a45fe2e5$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $c883e0a5a45fe2e5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/add
 * Usage guidance:
 * Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c883e0a5a45fe2e5$var$AddIcon = (props)=>/*#__PURE__*/ $c883e0a5a45fe2e5$var$_react.default.createElement($c883e0a5a45fe2e5$var$_iconNew.default, Object.assign({
        name: "AddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.75 1.5v5.75h5.75v1.5H8.75v5.75h-1.5V8.75H1.5v-1.5h5.75V1.5z"/>`
    }, props));
$c883e0a5a45fe2e5$var$AddIcon.displayName = 'AddIcon';
var $c883e0a5a45fe2e5$var$_default = module.exports.default = $c883e0a5a45fe2e5$var$AddIcon;

});

parcelRegister("3Zxrq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d485ff62f9140a59decb65646f9f10e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e81025b4c9c517f$var$_react = $2e81025b4c9c517f$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $2e81025b4c9c517f$var$_iconNew = $2e81025b4c9c517f$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $2e81025b4c9c517f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/arrow-left
 * Usage guidance:
 * Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e81025b4c9c517f$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $2e81025b4c9c517f$var$_react.default.createElement($2e81025b4c9c517f$var$_iconNew.default, Object.assign({
        name: "ArrowLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$2e81025b4c9c517f$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $2e81025b4c9c517f$var$_default = module.exports.default = $2e81025b4c9c517f$var$ArrowLeftIcon;

});

parcelRegister("6UDJ1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::790216e1b1c39b618aa630400c4ea535>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5086c9a0e8e3ee15$var$_react = $5086c9a0e8e3ee15$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $5086c9a0e8e3ee15$var$_iconNew = $5086c9a0e8e3ee15$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $5086c9a0e8e3ee15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/check-circle
 * Usage guidance:
 * Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5086c9a0e8e3ee15$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $5086c9a0e8e3ee15$var$_react.default.createElement($5086c9a0e8e3ee15$var$_iconNew.default, Object.assign({
        name: "CheckCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$5086c9a0e8e3ee15$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $5086c9a0e8e3ee15$var$_default = module.exports.default = $5086c9a0e8e3ee15$var$CheckCircleIcon;

});

parcelRegister("cklu4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::289e45520b45682e3c0f255c5bc3a3e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f98049692c988c8$var$_react = $8f98049692c988c8$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $8f98049692c988c8$var$_iconNew = $8f98049692c988c8$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $8f98049692c988c8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CreditCard".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/credit-card
 * Usage guidance:
 * Multi purpose - Known uses: billing in Admin, invoices in PPC, payments.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f98049692c988c8$var$CreditCardIcon = (props)=>/*#__PURE__*/ $8f98049692c988c8$var$_react.default.createElement($8f98049692c988c8$var$_iconNew.default, Object.assign({
        name: "CreditCardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1.5h13V4a.5.5 0 0 0-.5-.5zM14.5 7h-13v5a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5zM9 9.5h4V11H9z" clip-rule="evenodd"/>`
    }, props));
$8f98049692c988c8$var$CreditCardIcon.displayName = 'CreditCardIcon';
var $8f98049692c988c8$var$_default = module.exports.default = $8f98049692c988c8$var$CreditCardIcon;

});

parcelRegister("gUoEG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::23550e9a9f6f237ba15b0b9afdf2850e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4f5004c159be631$var$_react = $c4f5004c159be631$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $c4f5004c159be631$var$_iconNew = $c4f5004c159be631$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $c4f5004c159be631$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cross-circle
 * Usage guidance:
 * Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4f5004c159be631$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $c4f5004c159be631$var$_react.default.createElement($c4f5004c159be631$var$_iconNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 6.94L5.03 3.97 3.97 5.03 6.94 8l-2.97 2.97 1.06 1.06L8 9.06l2.97 2.97 1.06-1.06L9.06 8l2.97-2.97-1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$c4f5004c159be631$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $c4f5004c159be631$var$_default = module.exports.default = $c4f5004c159be631$var$CrossCircleIcon;

});

parcelRegister("fE6ce", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdb9e6baa42be79f49a55523cb2c1b4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b63f65e16945ca81$var$_react = $b63f65e16945ca81$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $b63f65e16945ca81$var$_iconNew = $b63f65e16945ca81$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $b63f65e16945ca81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/show-more-horizontal
 * Usage guidance:
 * Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b63f65e16945ca81$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $b63f65e16945ca81$var$_react.default.createElement($b63f65e16945ca81$var$_iconNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$b63f65e16945ca81$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $b63f65e16945ca81$var$_default = module.exports.default = $b63f65e16945ca81$var$ShowMoreHorizontalIcon;

});

parcelRegister("kwWcS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f9c38bfa054ce139eb4eb1d828621cdf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef23f26dd3fb839f$var$_react = $ef23f26dd3fb839f$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $ef23f26dd3fb839f$var$_iconNew = $ef23f26dd3fb839f$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $ef23f26dd3fb839f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Clock".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/clock
 * Usage guidance:
 * Known uses: recent, time input, sprint time remaining, overdue task work type status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef23f26dd3fb839f$var$ClockIcon = (props)=>/*#__PURE__*/ $ef23f26dd3fb839f$var$_react.default.createElement($ef23f26dd3fb839f$var$_iconNew.default, Object.assign({
        name: "ClockIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M8.75 3.25v4.389l2.219 1.775-.938 1.172-2.5-2-.281-.226V3.25zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$ef23f26dd3fb839f$var$ClockIcon.displayName = 'ClockIcon';
var $ef23f26dd3fb839f$var$_default = module.exports.default = $ef23f26dd3fb839f$var$ClockIcon;

});

parcelRegister("edN4B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::455ddf841838a21b0f783ea6448b0f9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a5a858860203907a$var$_react = $a5a858860203907a$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $a5a858860203907a$var$_iconNew = $a5a858860203907a$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $a5a858860203907a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/search
 * Usage guidance:
 * Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a5a858860203907a$var$SearchIcon = (props)=>/*#__PURE__*/ $a5a858860203907a$var$_react.default.createElement($a5a858860203907a$var$_iconNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$a5a858860203907a$var$SearchIcon.displayName = 'SearchIcon';
var $a5a858860203907a$var$_default = module.exports.default = $a5a858860203907a$var$SearchIcon;

});

parcelRegister("hQpu3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bfb96ac8121d6e86aa07f23b47de6511>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfdb0f8e3cbcf032$var$_react = $cfdb0f8e3cbcf032$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $cfdb0f8e3cbcf032$var$_iconNew = $cfdb0f8e3cbcf032$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $cfdb0f8e3cbcf032$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/settings
 * Usage guidance:
 * Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfdb0f8e3cbcf032$var$SettingsIcon = (props)=>/*#__PURE__*/ $cfdb0f8e3cbcf032$var$_react.default.createElement($cfdb0f8e3cbcf032$var$_iconNew.default, Object.assign({
        name: "SettingsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$cfdb0f8e3cbcf032$var$SettingsIcon.displayName = 'SettingsIcon';
var $cfdb0f8e3cbcf032$var$_default = module.exports.default = $cfdb0f8e3cbcf032$var$SettingsIcon;

});

parcelRegister("jbwic", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a56ed314940e96507f3d40e0a0c01e78>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df78180ad2d43de2$var$_react = $df78180ad2d43de2$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $df78180ad2d43de2$var$_iconNew = $df78180ad2d43de2$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $df78180ad2d43de2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Filter".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/filter
 * Usage guidance:
 * Single purpose - Reserved for filterting data or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $df78180ad2d43de2$var$FilterIcon = (props)=>/*#__PURE__*/ $df78180ad2d43de2$var$_react.default.createElement($df78180ad2d43de2$var$_iconNew.default, Object.assign({
        name: "FilterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 12v1.5H5V12zm2-4.75v1.5H3v-1.5zm2-4.75V4H1V2.5z"/>`
    }, props));
$df78180ad2d43de2$var$FilterIcon.displayName = 'FilterIcon';
var $df78180ad2d43de2$var$_default = module.exports.default = $df78180ad2d43de2$var$FilterIcon;

});

parcelRegister("byNe2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7bd0b1f6d8e717040c997f247b7acc7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $86a90dd3b1529e2e$var$_react = $86a90dd3b1529e2e$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $86a90dd3b1529e2e$var$_iconNew = $86a90dd3b1529e2e$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $86a90dd3b1529e2e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/notification
 * Usage guidance:
 * Single purpose - Reserved for notifications within global app navigation and within app screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $86a90dd3b1529e2e$var$NotificationIcon = (props)=>/*#__PURE__*/ $86a90dd3b1529e2e$var$_react.default.createElement($86a90dd3b1529e2e$var$_iconNew.default, Object.assign({
        name: "NotificationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6.42 13.5a1.748 1.748 0 0 0 3.16 0zM4.5 8.636c0 .215-.06.426-.175.608L2.603 12h10.795l-1.723-2.756a1.15 1.15 0 0 1-.175-.608V5a3.5 3.5 0 0 0-7 0zm8.5-.1 1.788 2.86a1.375 1.375 0 0 1-1.166 2.104h-2.46a3.25 3.25 0 0 1-6.324 0h-2.46a1.375 1.375 0 0 1-1.166-2.104L3 8.537V5a5 5 0 0 1 10 0z"/>`
    }, props));
$86a90dd3b1529e2e$var$NotificationIcon.displayName = 'NotificationIcon';
var $86a90dd3b1529e2e$var$_default = module.exports.default = $86a90dd3b1529e2e$var$NotificationIcon;

});

parcelRegister("9sBmE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1823cfe9afabe77ba419bd26f71a4aac>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e33b660ecc29b11$var$_react = $6e33b660ecc29b11$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $6e33b660ecc29b11$var$_iconNew = $6e33b660ecc29b11$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $6e33b660ecc29b11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person-avatar
 * Usage guidance:
 * Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e33b660ecc29b11$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $6e33b660ecc29b11$var$_react.default.createElement($6e33b660ecc29b11$var$_iconNew.default, Object.assign({
        name: "PersonAvatarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$6e33b660ecc29b11$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $6e33b660ecc29b11$var$_default = module.exports.default = $6e33b660ecc29b11$var$PersonAvatarIcon;

});

parcelRegister("anXxY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a375ef61b97315ae7ff25123b3ed791c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $78fa3e2291bb332c$var$_react = $78fa3e2291bb332c$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $78fa3e2291bb332c$var$_iconNew = $78fa3e2291bb332c$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $78fa3e2291bb332c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/release
 * Usage guidance:
 * Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $78fa3e2291bb332c$var$ReleaseIcon = (props)=>/*#__PURE__*/ $78fa3e2291bb332c$var$_react.default.createElement($78fa3e2291bb332c$var$_iconNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$78fa3e2291bb332c$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $78fa3e2291bb332c$var$_default = module.exports.default = $78fa3e2291bb332c$var$ReleaseIcon;

});

parcelRegister("dM6XP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::508bd9728f54ab48d8a573901bb484ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a07528f1ca291773$var$_react = $a07528f1ca291773$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $a07528f1ca291773$var$_iconNew = $a07528f1ca291773$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $a07528f1ca291773$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogIn".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/log-in
 * Usage guidance:
 * Single purpose - Reserved for log in.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a07528f1ca291773$var$LogInIcon = (props)=>/*#__PURE__*/ $a07528f1ca291773$var$_react.default.createElement($a07528f1ca291773$var$_iconNew.default, Object.assign({
        name: "LogInIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5H8V1h5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8v-1.5h5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5M7.44 7.25 5.22 5.03l1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$a07528f1ca291773$var$LogInIcon.displayName = 'LogInIcon';
var $a07528f1ca291773$var$_default = module.exports.default = $a07528f1ca291773$var$LogInIcon;

});

parcelRegister("4w7e7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53379c98771562c0fa194d02f1725934>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $349fc1aa9434e318$var$_react = $349fc1aa9434e318$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $349fc1aa9434e318$var$_iconNew = $349fc1aa9434e318$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $349fc1aa9434e318$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/star-unstarred
 * Usage guidance:
 * Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $349fc1aa9434e318$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $349fc1aa9434e318$var$_react.default.createElement($349fc1aa9434e318$var$_iconNew.default, Object.assign({
        name: "StarUnstarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/>`
    }, props));
$349fc1aa9434e318$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $349fc1aa9434e318$var$_default = module.exports.default = $349fc1aa9434e318$var$StarUnstarredIcon;

});

parcelRegister("fvWrV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e1c792fe94266e0516d7c57a92d4d2b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4b7171f8f564573$var$_react = $b4b7171f8f564573$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $b4b7171f8f564573$var$_iconNew = $b4b7171f8f564573$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $b4b7171f8f564573$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FullscreenEnter".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/fullscreen-enter
 * Usage guidance:
 * Single purpose - Reserved for full screen videos or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4b7171f8f564573$var$FullscreenEnterIcon = (props)=>/*#__PURE__*/ $b4b7171f8f564573$var$_react.default.createElement($b4b7171f8f564573$var$_iconNew.default, Object.assign({
        name: "FullscreenEnterIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 2.5h-3V1h3a2 2 0 0 1 2 2v3h-1.5V3a.5.5 0 0 0-.5-.5m-10 0a.5.5 0 0 0-.5.5v3H1V3a2 2 0 0 1 2-2h3v1.5zM2.5 10v3a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2v-3zm11 3v-3H15v3a2 2 0 0 1-2 2h-3v-1.5h3a.5.5 0 0 0 .5-.5" clip-rule="evenodd"/>`
    }, props));
$b4b7171f8f564573$var$FullscreenEnterIcon.displayName = 'FullscreenEnterIcon';
var $b4b7171f8f564573$var$_default = module.exports.default = $b4b7171f8f564573$var$FullscreenEnterIcon;

});

parcelRegister("4Cn0v", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::891f8b0b0e6811694a02696ff381b7b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35cc8ec74e5ac2a4$var$_react = $35cc8ec74e5ac2a4$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $35cc8ec74e5ac2a4$var$_iconNew = $35cc8ec74e5ac2a4$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $35cc8ec74e5ac2a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/app-switcher
 * Usage guidance:
 * Single purpose - Reserved for app switcher in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35cc8ec74e5ac2a4$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $35cc8ec74e5ac2a4$var$_react.default.createElement($35cc8ec74e5ac2a4$var$_iconNew.default, Object.assign({
        name: "AppSwitcherIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm-8-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zM7 5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$35cc8ec74e5ac2a4$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $35cc8ec74e5ac2a4$var$_default = module.exports.default = $35cc8ec74e5ac2a4$var$AppSwitcherIcon;

});

parcelRegister("gI1yN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44bfe3fda6843e57916c639848bc7fcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c2a1f73d851ba605$var$_react = $c2a1f73d851ba605$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $c2a1f73d851ba605$var$_iconNew = $c2a1f73d851ba605$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $c2a1f73d851ba605$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/person
 * Usage guidance:
 * Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c2a1f73d851ba605$var$PersonIcon = (props)=>/*#__PURE__*/ $c2a1f73d851ba605$var$_react.default.createElement($c2a1f73d851ba605$var$_iconNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$c2a1f73d851ba605$var$PersonIcon.displayName = 'PersonIcon';
var $c2a1f73d851ba605$var$_default = module.exports.default = $c2a1f73d851ba605$var$PersonIcon;

});

parcelRegister("26iws", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc8c5bcc855f6883f121e0d08f8186bb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $187a827dde894ab9$var$_react = $187a827dde894ab9$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $187a827dde894ab9$var$_iconNew = $187a827dde894ab9$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $187a827dde894ab9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/roadmap
 * Usage guidance:
 * Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $187a827dde894ab9$var$RoadmapIcon = (props)=>/*#__PURE__*/ $187a827dde894ab9$var$_react.default.createElement($187a827dde894ab9$var$_iconNew.default, Object.assign({
        name: "RoadmapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$187a827dde894ab9$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $187a827dde894ab9$var$_default = module.exports.default = $187a827dde894ab9$var$RoadmapIcon;

});

parcelRegister("hQOf7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e090651e87a4c0aa5c0215d940612c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfee4430572b27d7$var$_react = $cfee4430572b27d7$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $cfee4430572b27d7$var$_iconNew = $cfee4430572b27d7$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $cfee4430572b27d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/teams
 * Usage guidance:
 * Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfee4430572b27d7$var$TeamsIcon = (props)=>/*#__PURE__*/ $cfee4430572b27d7$var$_react.default.createElement($cfee4430572b27d7$var$_iconNew.default, Object.assign({
        name: "TeamsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$cfee4430572b27d7$var$TeamsIcon.displayName = 'TeamsIcon';
var $cfee4430572b27d7$var$_default = module.exports.default = $cfee4430572b27d7$var$TeamsIcon;

});

parcelRegister("gjVYm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1078ad25bb88c0aacc625e83cbe31eaf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be1b63d5576e92d7$var$_react = $be1b63d5576e92d7$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $be1b63d5576e92d7$var$_iconNew = $be1b63d5576e92d7$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $be1b63d5576e92d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/ai-agent
 * Usage guidance:
 * Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be1b63d5576e92d7$var$AiAgentIcon = (props)=>/*#__PURE__*/ $be1b63d5576e92d7$var$_react.default.createElement($be1b63d5576e92d7$var$_iconNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$be1b63d5576e92d7$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $be1b63d5576e92d7$var$_default = module.exports.default = $be1b63d5576e92d7$var$AiAgentIcon;

});

parcelRegister("fm5Zq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5d9d22b41ee491811e82fedd8cf80d9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2dd8e865dde220e$var$_react = $b2dd8e865dde220e$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $b2dd8e865dde220e$var$_iconNew = $b2dd8e865dde220e$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $b2dd8e865dde220e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Apps".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/apps
 * Usage guidance:
 * Single purpose - Reserved for adding or viewing apps.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2dd8e865dde220e$var$AppsIcon = (props)=>/*#__PURE__*/ $b2dd8e865dde220e$var$_react.default.createElement($b2dd8e865dde220e$var$_iconNew.default, Object.assign({
        name: "AppsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm7.25-2v2.25H15v1.5h-2.25V15h-1.5v-2.25H9v-1.5h2.25V9zM5.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm0-8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$b2dd8e865dde220e$var$AppsIcon.displayName = 'AppsIcon';
var $b2dd8e865dde220e$var$_default = module.exports.default = $b2dd8e865dde220e$var$AppsIcon;

});

parcelRegister("9JQ5n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98f19b4ce1cb01bc604b2707417d4c9a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7170b82ebff4624b$var$_react = $7170b82ebff4624b$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $7170b82ebff4624b$var$_iconNew = $7170b82ebff4624b$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $7170b82ebff4624b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrendUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/chart-trend-up
 * Usage guidance:
 * Known uses: Upward trending data; Trend charts; Reports in Jira; Sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7170b82ebff4624b$var$ChartTrendUpIcon = (props)=>/*#__PURE__*/ $7170b82ebff4624b$var$_react.default.createElement($7170b82ebff4624b$var$_iconNew.default, Object.assign({
        name: "ChartTrendUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M15 7.5h-1.5V5.56L9.78 9.28a.75.75 0 0 1-1.06 0L7.25 7.81l-2.22 2.22-1.06-1.06 2.75-2.75.056-.052a.75.75 0 0 1 1.004.052l1.47 1.47 3.19-3.19H10.5V3h3.75a.75.75 0 0 1 .75.75z"/>`
    }, props));
$7170b82ebff4624b$var$ChartTrendUpIcon.displayName = 'ChartTrendUpIcon';
var $7170b82ebff4624b$var$_default = module.exports.default = $7170b82ebff4624b$var$ChartTrendUpIcon;

});

parcelRegister("2TESP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0f3b83dd529b07788ee27a881ae63826>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $21c06e6bae0ffe89$var$_react = $21c06e6bae0ffe89$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $21c06e6bae0ffe89$var$_iconNew = $21c06e6bae0ffe89$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $21c06e6bae0ffe89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Devices".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/devices
 * Usage guidance:
 * Known usages: 'Asset' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $21c06e6bae0ffe89$var$DevicesIcon = (props)=>/*#__PURE__*/ $21c06e6bae0ffe89$var$_react.default.createElement($21c06e6bae0ffe89$var$_iconNew.default, Object.assign({
        name: "DevicesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a.5.5 0 0 0-.5-.5h-2.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5zM13 3a.5.5 0 0 0-.5-.5h-9A.5.5 0 0 0 3 3v7h5v1.5H1.5v.5a.5.5 0 0 0 .5.5h6V14H2a2 2 0 0 1-2-2v-1.25l.004-.077A.75.75 0 0 1 .75 10h.75V3a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1.5H13zm3 11a2 2 0 0 1-2 2h-2.5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2z"/>`
    }, props));
$21c06e6bae0ffe89$var$DevicesIcon.displayName = 'DevicesIcon';
var $21c06e6bae0ffe89$var$_default = module.exports.default = $21c06e6bae0ffe89$var$DevicesIcon;

});

parcelRegister("dpfDo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d79300678d2a12fe66aec1aaa52c9d3a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c29bcd4b676c882$var$_react = $9c29bcd4b676c882$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $9c29bcd4b676c882$var$_iconNew = $9c29bcd4b676c882$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $9c29bcd4b676c882$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/goal
 * Usage guidance:
 * Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c29bcd4b676c882$var$GoalIcon = (props)=>/*#__PURE__*/ $9c29bcd4b676c882$var$_react.default.createElement($9c29bcd4b676c882$var$_iconNew.default, Object.assign({
        name: "GoalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$9c29bcd4b676c882$var$GoalIcon.displayName = 'GoalIcon';
var $9c29bcd4b676c882$var$_default = module.exports.default = $9c29bcd4b676c882$var$GoalIcon;

});

parcelRegister("h4F8m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4635c4898bffdbedd4e5aefaeceb12e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6e2b7b9c97f35ed$var$_react = $c6e2b7b9c97f35ed$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $c6e2b7b9c97f35ed$var$_iconNew = $c6e2b7b9c97f35ed$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $c6e2b7b9c97f35ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Headphones".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/headphones
 * Usage guidance:
 * Known uses: music, audio.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c6e2b7b9c97f35ed$var$HeadphonesIcon = (props)=>/*#__PURE__*/ $c6e2b7b9c97f35ed$var$_react.default.createElement($c6e2b7b9c97f35ed$var$_iconNew.default, Object.assign({
        name: "HeadphonesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 7a5.5 5.5 0 1 0-11 0v5H1V7a7 7 0 0 1 14 0v5h-1.5z"/><path fill="currentcolor" d="M4.5 10a1 1 0 0 0-2 0v1.92c0 .87.71 1.58 1.58 1.58.23 0 .42-.19.42-.42zM6 13.08A1.92 1.92 0 0 1 4.08 15 3.08 3.08 0 0 1 1 11.92V10a2.5 2.5 0 0 1 5 0zm7.5-1.16V10a1 1 0 1 0-2 0v3.08c0 .23.19.42.42.42.87 0 1.58-.71 1.58-1.58m1.5 0A3.08 3.08 0 0 1 11.92 15 1.92 1.92 0 0 1 10 13.08V10a2.5 2.5 0 0 1 5 0z"/>`
    }, props));
$c6e2b7b9c97f35ed$var$HeadphonesIcon.displayName = 'HeadphonesIcon';
var $c6e2b7b9c97f35ed$var$_default = module.exports.default = $c6e2b7b9c97f35ed$var$HeadphonesIcon;

});

parcelRegister("3JqUG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8426d0f71b15f9c5b7a2d1d52ee1c968>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b7a73796932bf92$var$_react = $2b7a73796932bf92$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $2b7a73796932bf92$var$_iconNew = $2b7a73796932bf92$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $2b7a73796932bf92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Operations".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/operations
 * Usage guidance:
 * Single purpose - Reserved for IT Operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2b7a73796932bf92$var$OperationsIcon = (props)=>/*#__PURE__*/ $2b7a73796932bf92$var$_react.default.createElement($2b7a73796932bf92$var$_iconNew.default, Object.assign({
        name: "OperationsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.036 2.904A6.501 6.501 0 1 0 8 14.5V16a8 8 0 1 1 5.657-13.657l.53.53L8.28 8.78 7.22 7.72l2.304-2.305A3.001 3.001 0 1 0 8 11v1.5a4.5 4.5 0 1 1 2.608-8.168z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M14.58 4.862a.75.75 0 0 1 .959.454l.008.025a.75.75 0 1 1-1.414.499l-.007-.02a.75.75 0 0 1 .454-.958m-2.798 2.573a.75.75 0 0 1 .713.786l-.001.015-.001.014a.75.75 0 1 1-1.498-.083v-.01l.001-.01a.75.75 0 0 1 .786-.712m3.497.184a.75.75 0 0 1 .71.787v.026a.75.75 0 1 1-1.498-.081V8.33a.75.75 0 0 1 .788-.711m-4.205 2.656a.75.75 0 0 1-.052 1.06l-.022.019a.75.75 0 1 1-1-1.118l.015-.013a.75.75 0 0 1 1.059.052m3.799.16a.75.75 0 0 1 .355.999l-.011.023a.75.75 0 0 1-1.353-.649l.01-.019a.75.75 0 0 1 .999-.355m-1.457 2.442a.75.75 0 0 1-.053 1.06l-.02.017a.75.75 0 0 1-1.001-1.117l.015-.014a.75.75 0 0 1 1.06.054m-2.278 1.703a.75.75 0 0 1-.454.959l-.025.008a.75.75 0 0 1-.499-1.414l.02-.007a.75.75 0 0 1 .958.454" clip-rule="evenodd"/>`
    }, props));
$2b7a73796932bf92$var$OperationsIcon.displayName = 'OperationsIcon';
var $2b7a73796932bf92$var$_default = module.exports.default = $2b7a73796932bf92$var$OperationsIcon;

});

parcelRegister("4dsZm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e9008592011ce9e8020afead221c92f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $311edce1d06bde81$var$_react = $311edce1d06bde81$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $311edce1d06bde81$var$_iconNew = $311edce1d06bde81$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $311edce1d06bde81$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Project".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/project
 * Usage guidance:
 * Single purpose - Reserved for projects in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $311edce1d06bde81$var$ProjectIcon = (props)=>/*#__PURE__*/ $311edce1d06bde81$var$_react.default.createElement($311edce1d06bde81$var$_iconNew.default, Object.assign({
        name: "ProjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.482a.5.5 0 0 0-.354.146L7.78 5.03a.75.75 0 0 1-.53.22H3.018a.5.5 0 0 0-.354.146l-.353.354 1.72 1.72a.75.75 0 0 1 0 1.06l-2.25 2.25L.72 9.72 2.44 8 .72 6.28a.75.75 0 0 1 0-1.06l.884-.884a2 2 0 0 1 1.414-.586h3.921l2.165-2.164A2 2 0 0 1 10.518 1H13a2 2 0 0 1 2 2v2.482a2 2 0 0 1-.586 1.414L12.25 9.061v3.921a2 2 0 0 1-.586 1.415l-.884.883a.75.75 0 0 1-1.06 0L8 13.56l-1.72 1.72-1.06-1.06 2.25-2.25a.75.75 0 0 1 1.06 0l1.72 1.72.354-.354a.5.5 0 0 0 .146-.354V8.75a.75.75 0 0 1 .22-.53l2.384-2.384a.5.5 0 0 0 .146-.354zm-6.72 7.28-5 5-1.06-1.06 5-5z" clip-rule="evenodd"/><path fill="currentcolor" d="M12.5 4.625a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$311edce1d06bde81$var$ProjectIcon.displayName = 'ProjectIcon';
var $311edce1d06bde81$var$_default = module.exports.default = $311edce1d06bde81$var$ProjectIcon;

});

parcelRegister("a6ln2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4c19cab1662745293e5bf052395df909>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75ab0aac6ccc960d$var$_react = $75ab0aac6ccc960d$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $75ab0aac6ccc960d$var$_iconNew = $75ab0aac6ccc960d$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $75ab0aac6ccc960d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RovoChat".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/rovo-chat
 * Usage guidance:
 * Reserved for branded Rovo chat experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75ab0aac6ccc960d$var$RovoChatIcon = (props)=>/*#__PURE__*/ $75ab0aac6ccc960d$var$_react.default.createElement($75ab0aac6ccc960d$var$_iconNew.default, Object.assign({
        name: "RovoChatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M0 3.125A2.625 2.625 0 0 1 2.625.5H8V2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125V8.5H16v2.875A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25z"/><path fill="currentcolor" d="M12.616.509a.75.75 0 0 1 .59.484l.613 1.687 1.688.615A.75.75 0 0 1 16 4l-.009.116a.75.75 0 0 1-.484.59l-1.688.613-.614 1.688a.75.75 0 0 1-.589.484L12.5 7.5a.75.75 0 0 1-.705-.493l-.615-1.688-1.687-.614a.75.75 0 0 1-.484-.589L9 4a.75.75 0 0 1 .493-.705l1.687-.615.615-1.687a.75.75 0 0 1 .589-.484L12.5.5z"/>`
    }, props));
$75ab0aac6ccc960d$var$RovoChatIcon.displayName = 'RovoChatIcon';
var $75ab0aac6ccc960d$var$_default = module.exports.default = $75ab0aac6ccc960d$var$RovoChatIcon;

});

parcelRegister("dVPyc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b4f1367f1cd984cea139cd322f85553>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a248961e7e2b5da4$var$_react = $a248961e7e2b5da4$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $a248961e7e2b5da4$var$_iconNew = $a248961e7e2b5da4$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $a248961e7e2b5da4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sidebar-collapse
 * Usage guidance:
 * Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a248961e7e2b5da4$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $a248961e7e2b5da4$var$_react.default.createElement($a248961e7e2b5da4$var$_iconNew.default, Object.assign({
        name: "SidebarCollapseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$a248961e7e2b5da4$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $a248961e7e2b5da4$var$_default = module.exports.default = $a248961e7e2b5da4$var$SidebarCollapseIcon;

});

parcelRegister("9s66L", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a887af9d6920f2ef0ce00494c960319>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6e1b778a989d06b8$var$_react = $6e1b778a989d06b8$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $6e1b778a989d06b8$var$_iconNew = $6e1b778a989d06b8$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $6e1b778a989d06b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarExpand".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/sidebar-expand
 * Usage guidance:
 * Single purpose - Reserved for expanding the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6e1b778a989d06b8$var$SidebarExpandIcon = (props)=>/*#__PURE__*/ $6e1b778a989d06b8$var$_react.default.createElement($6e1b778a989d06b8$var$_iconNew.default, Object.assign({
        name: "SidebarExpandIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14 2.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-2v-11zm-3.5 0v11H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5zM16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zM8.03 7.47l-2.5-2.5-1.06 1.06L6.44 8 4.47 9.97l1.06 1.06 2.5-2.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$6e1b778a989d06b8$var$SidebarExpandIcon.displayName = 'SidebarExpandIcon';
var $6e1b778a989d06b8$var$_default = module.exports.default = $6e1b778a989d06b8$var$SidebarExpandIcon;

});

parcelRegister("3CdLT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4c39bfa2c8ba34f67b9a83cec6525e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a1f9a69daf3e12c$var$_react = $2a1f9a69daf3e12c$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $2a1f9a69daf3e12c$var$_iconNew = $2a1f9a69daf3e12c$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $2a1f9a69daf3e12c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Support".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/support
 * Usage guidance:
 * Reserved for representing help support.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2a1f9a69daf3e12c$var$SupportIcon = (props)=>/*#__PURE__*/ $2a1f9a69daf3e12c$var$_react.default.createElement($2a1f9a69daf3e12c$var$_iconNew.default, Object.assign({
        name: "SupportIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.964 2.904 5.752 4.69a4 4 0 0 1 4.497 0l1.787-1.787a6.5 6.5 0 0 0-8.072 0m9.132 1.06L11.31 5.752a4 4 0 0 1 0 4.497l1.787 1.787a6.5 6.5 0 0 0 0-8.072m-1.06 9.132-1.787-1.787a4 4 0 0 1-4.497 0l-1.788 1.787a6.5 6.5 0 0 0 8.072 0m-9.132-1.06 1.787-1.787a4 4 0 0 1 0-4.497L2.904 3.964a6.5 6.5 0 0 0 0 8.072m-.56-9.693a8 8 0 1 1 11.313 11.314A8 8 0 0 1 2.343 2.343m7.424 3.89a2.5 2.5 0 1 0-3.536 3.535 2.5 2.5 0 0 0 3.536-3.536" clip-rule="evenodd"/>`
    }, props));
$2a1f9a69daf3e12c$var$SupportIcon.displayName = 'SupportIcon';
var $2a1f9a69daf3e12c$var$_default = module.exports.default = $2a1f9a69daf3e12c$var$SupportIcon;

});

parcelRegister("9rPba", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $39d600e8f37393ad$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $7NMaP = parcelRequire("7NMaP");

var $3DD8L = parcelRequire("3DD8L");

var $kNsW1 = parcelRequire("kNsW1");
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in `children`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $39d600e8f37393ad$var$Badge = /*#__PURE__*/ (0, $fsvuC.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    // Map old appearance names to new ones
    const newAppearance = (0, $7NMaP.appearanceMapping)[appearance];
    // Pre-format the value using the backward-compatible formatter (supports negative numbers)
    // then pass max={false} to BadgeNew so it doesn't apply its own (clamping) formatting.
    const formattedValue = typeof children === 'number' && typeof max === 'number' ? (0, $kNsW1.formatValueWithNegativeSupport)(children, max) : children;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $3DD8L.default), {
        appearance: newAppearance,
        max: false,
        style: style,
        testId: testId,
        children: formattedValue
    });
});
var $39d600e8f37393ad$export$2e2bcd8739ae039 = $39d600e8f37393ad$var$Badge;

});
parcelRegister("7NMaP", function(module, exports) {
$parcel$export(module.exports, "appearanceMapping", () => $c0d8deac4f106eff$export$d21bba0569254935);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $c0d8deac4f106eff$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral',
    informationBold: 'informationBold',
    successBold: 'successBold',
    dangerBold: 'dangerBold',
    warningBold: 'warningBold',
    discoveryBold: 'discoveryBold'
};

});

parcelRegister("3DD8L", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd52951ebe7a542b$export$2e2bcd8739ae039);
/* badge-new.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $kBK9z = parcelRequire("kBK9z");

var $4XxmM = parcelRequire("4XxmM");

var $1vHp0 = parcelRequire("1vHp0");
// Nested selectors with data attributes are required for theme switching
const $dd52951ebe7a542b$var$stylesNew = {
    root: "_0bjKvDcjp5 _2Y7lL41Y8M _4c065UdnbC _3iDTPbccYA _24h04i2Njc _4ouGXINHnM _37wbyuDIqT _3YEZNOdnbC _3L9DPXBY1A",
    success: "_1UtDYzM9Wa _0KLXruQuCm",
    danger: "_1UtDYzOZ2O _0KLXruJXmd",
    warning: "_1UtDYzVRW9 _0KLXru2bwY",
    information: "_1UtDYzdx2f _0KLXru9V7L",
    discovery: "_1UtDYzAGgF _0KLXruZB9y",
    neutral: "_1UtDYzy7kJ _0KLXruG6qS",
    inverse: "_0KLXrulfZc _1UtDYzy7kJ",
    informationBold: "_1UtDYzdx2f _0KLXruJVoT",
    successBold: "_1UtDYzM9Wa _0KLXruX1bq",
    dangerBold: "_1UtDYzOZ2O _0KLXrug6EK",
    warningBold: "_1UtDYzVRW9 _0KLXruKLKE",
    warningBoldDark: "_1UtDYzVRW9 _0KLXruDh4Z",
    discoveryBold: "_1UtDYzAGgF _0KLXruXfaS"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ const $dd52951ebe7a542b$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && max ? (0, $1vHp0.formatValue)(children, max) : children;
}; /**
    * __BadgeNew__
    *
    * New visual refresh implementation of Badge component for the labelling system.
    *
    * Uses new appearance naming convention:
    * - success (green)
    * - danger (red)
    * - neutral (gray)
    * - information (blue)
    * - inverse (inverted colors)
    * - warning (orange/yellow)
    * - discovery (purple)
    * - informationBold (bold blue, color.background.information.subtle)
    * - successBold (bold green, color.background.success.subtle)
    * - dangerBold (bold red, color.background.danger.subtle)
    * - warningBold (bold warning, color.background.warning.bold)
    * - discoveryBold (bold purple, color.background.discovery.subtle)
    */ 
const $dd52951ebe7a542b$var$BadgeNew = /*#__PURE__*/ (0, $fsvuC.memo)(function BadgeNew({ appearance: appearance = 'neutral', children: children = 0, max: max = 99, style: style, testId: testId }) {
    const { colorMode: colorMode } = (0, $4XxmM.useThemeObserver)(); // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    const resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        "data-testid": testId,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        className: (0, $gJ6nT.default)([
            $dd52951ebe7a542b$var$stylesNew.root,
            $dd52951ebe7a542b$var$stylesNew[resolvedAppearance]
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kBK9z.Text), {
            size: "small",
            align: "center",
            color: "inherit",
            children: $dd52951ebe7a542b$var$badgeValueWithNegativeNumberSupported(children, max)
        })
    });
});
var $dd52951ebe7a542b$export$2e2bcd8739ae039 = $dd52951ebe7a542b$var$BadgeNew;

});
parcelRegister("1vHp0", function(module, exports) {
$parcel$export(module.exports, "formatValue", () => $318c717d7b0013f8$export$7c4d25c0c3217d8c);
function $318c717d7b0013f8$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $318c717d7b0013f8$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $318c717d7b0013f8$var$getSafeValue(value);
    const safeMax = $318c717d7b0013f8$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("kNsW1", function(module, exports) {
$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $2a21524396bc6ec7$export$4b844743568d5983);
function $2a21524396bc6ec7$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $2a21524396bc6ec7$export$4b844743568d5983(value, max) {
    const safeValue = $2a21524396bc6ec7$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $2a21524396bc6ec7$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("9Tueh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25fc5e06165a31c1790a9d0782b9d836>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7340b303ffea4c0c$var$_react = $7340b303ffea4c0c$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $7340b303ffea4c0c$var$_iconNew = $7340b303ffea4c0c$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $7340b303ffea4c0c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Plan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/plan
 * Usage guidance:
 * Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7340b303ffea4c0c$var$PlanIcon = (props)=>/*#__PURE__*/ $7340b303ffea4c0c$var$_react.default.createElement($7340b303ffea4c0c$var$_iconNew.default, Object.assign({
        name: "PlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 12.75a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.5 0a2.75 2.75 0 0 1-5.394.75H5.625a3.125 3.125 0 1 1 0-6.25h4.75a1.625 1.625 0 1 0 0-3.25H5.394A2.749 2.749 0 0 1 0 3.25a2.75 2.75 0 0 1 5.394-.75h4.981a3.125 3.125 0 1 1 0 6.25h-4.75a1.625 1.625 0 0 0 0 3.25h4.981a2.749 2.749 0 0 1 5.394.75M1.5 3.25a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0"/>`
    }, props));
$7340b303ffea4c0c$var$PlanIcon.displayName = 'PlanIcon';
var $7340b303ffea4c0c$var$_default = module.exports.default = $7340b303ffea4c0c$var$PlanIcon;

});

parcelRegister("jw6Xp", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ae16317377fd108$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3554c5febd836a4b5be9a51b32c1bf4>>
 * @codegenCommand yarn build tokens
 */ const $8ae16317377fd108$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.button.hovered': '--ds-button-hovered',
    'motion.button.pressed': '--ds-button-pressed',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.form.message.enter': '--ds-form-message-enter',
    'motion.form.message.exit': '--ds-form-message-exit',
    'motion.iconography.enter.cycle.up': '--ds-iconography-enter-cycle-up',
    'motion.iconography.enter.fade': '--ds-iconography-enter-fade',
    'motion.iconography.exit.cycle.up': '--ds-iconography-exit-cycle-up',
    'motion.iconography.exit.fade': '--ds-iconography-exit-fade',
    'motion.input': '--ds-input',
    'motion.input.selection': '--ds-input-selection',
    'motion.input.toggle': '--ds-input-toggle',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.grid.column.in': '--ds-keyframe-grid-column-in',
    'motion.keyframe.grid.column.out': '--ds-keyframe-grid-column-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.label.enter': '--ds-label-enter',
    'motion.label.exit': '--ds-label-exit',
    'motion.listitem.hovered': '--ds-listitem-hovered',
    'motion.listitem.pressed': '--ds-listitem-pressed',
    'motion.listitem.selected': '--ds-listitem-selected',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.panel.content.enter': '--ds-panel-content-enter',
    'motion.panel.content.exit': '--ds-panel-content-exit',
    'motion.panel.enter': '--ds-panel-enter',
    'motion.panel.enter.left': '--ds-panel-enter-left',
    'motion.panel.enter.right': '--ds-panel-enter-right',
    'motion.panel.exit': '--ds-panel-exit',
    'motion.panel.exit.left': '--ds-panel-exit-left',
    'motion.panel.exit.right': '--ds-panel-exit-right',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.sidenav.enter.left': '--ds-sidenav-enter-left',
    'motion.sidenav.enter.right': '--ds-sidenav-enter-right',
    'motion.sidenav.exit.left': '--ds-sidenav-exit-left',
    'motion.sidenav.exit.right': '--ds-sidenav-exit-right',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'motion.tab': '--ds-tab',
    'motion.tab.indicator.enter.left': '--ds-tab-indicator-enter-left',
    'motion.tab.indicator.enter.right': '--ds-tab-indicator-enter-right',
    'motion.tab.indicator.exit.left': '--ds-tab-indicator-exit-left',
    'motion.tab.indicator.exit.right': '--ds-tab-indicator-exit-right',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.code.added.highlight': '--ds-background-code-added-highlight',
    'color.background.code.added.line': '--ds-background-code-added-line',
    'color.background.code.default': '--ds-background-code-default',
    'color.background.code.gutter': '--ds-background-code-gutter',
    'color.background.code.highlight': '--ds-background-code-highlight',
    'color.background.code.removed.highlight': '--ds-background-code-removed-highlight',
    'color.background.code.removed.line': '--ds-background-code-removed-line',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.subtle': '--ds-background-danger-subtle',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.subtle': '--ds-background-warning-subtle',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.subtle': '--ds-background-success-subtle',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.subtle': '--ds-background-discovery-subtle',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.subtle': '--ds-background-information-subtle',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.lime.subtle': '--ds-border-accent-lime-subtle',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.red.subtle': '--ds-border-accent-red-subtle',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.orange.subtle': '--ds-border-accent-orange-subtle',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.yellow.subtle': '--ds-border-accent-yellow-subtle',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.green.subtle': '--ds-border-accent-green-subtle',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.teal.subtle': '--ds-border-accent-teal-subtle',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.blue.subtle': '--ds-border-accent-blue-subtle',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.purple.subtle': '--ds-border-accent-purple-subtle',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.magenta.subtle': '--ds-border-accent-magenta-subtle',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.accent.gray.subtle': '--ds-border-accent-gray-subtle',
    'color.border.code': '--ds-border-code',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.input.search': '--ds-border-input-search',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.danger.subtle': '--ds-border-danger-subtle',
    'color.border.warning': '--ds-border-warning',
    'color.border.warning.subtle': '--ds-border-warning-subtle',
    'color.border.success': '--ds-border-success',
    'color.border.success.subtle': '--ds-border-success-subtle',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.discovery.subtle': '--ds-border-discovery-subtle',
    'color.border.information': '--ds-border-information',
    'color.border.information.subtle': '--ds-border-information-subtle',
    'color.border.bold': '--ds-border-bold',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.code.accent.1': '--ds-text-code-accent-1',
    'color.text.code.accent.2': '--ds-text-code-accent-2',
    'color.text.code.comments': '--ds-text-code-comments',
    'color.text.code.default': '--ds-text-code-default',
    'color.text.code.functions': '--ds-text-code-functions',
    'color.text.code.gutter': '--ds-text-code-gutter',
    'color.text.code.keywords': '--ds-text-code-keywords',
    'color.text.code.numbers': '--ds-text-code-numbers',
    'color.text.code.operators': '--ds-text-code-operators',
    'color.text.code.strings': '--ds-text-code-strings',
    'color.text.code.tags': '--ds-text-code-tags',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'color.rovo.background.brand.bold': '--ds-rovo-background-brand-bold',
    'color.rovo.background.brand.bold.hovered': '--ds-rovo-background-brand-bold-hovered',
    'color.rovo.background.brand.bold.pressed': '--ds-rovo-background-brand-bold-pressed',
    'color.rovo.border.lime': '--ds-rovo-border-lime',
    'color.rovo.border.saffron': '--ds-rovo-border-saffron',
    'color.rovo.border.blue': '--ds-rovo-border-blue',
    'color.rovo.border.purple': '--ds-rovo-border-purple',
    'color.rovo.icon.lime': '--ds-rovo-icon-lime',
    'color.rovo.icon.saffron': '--ds-rovo-icon-saffron',
    'color.rovo.icon.blue': '--ds-rovo-icon-blue',
    'color.rovo.icon.purple': '--ds-rovo-icon-purple',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.container': '--ds-surface-container',
    'elevation.surface.container.hovered': '--ds-surface-container-hovered',
    'elevation.surface.container.pressed': '--ds-surface-container-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.rovo.surface.overlay': '--ds-rovo-surface-overlay',
    'elevation.rovo.surface.overlay.hovered': '--ds-rovo-surface-overlay-hovered',
    'elevation.rovo.surface.overlay.pressed': '--ds-rovo-surface-overlay-pressed',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.gap.large': '--ds-space-gap-large',
    'space.gap.medium': '--ds-space-gap-medium',
    'space.gap.small': '--ds-space-gap-small',
    'space.gap.xlarge': '--ds-space-gap-xlarge',
    'space.gap.xsmall': '--ds-space-gap-xsmall',
    'space.gap.xxlarge': '--ds-space-gap-xxlarge',
    'space.gap.xxsmall': '--ds-space-gap-xxsmall',
    'space.inset.3xlarge': '--ds-space-inset-3xlarge',
    'space.inset.large': '--ds-space-inset-large',
    'space.inset.medium': '--ds-space-inset-medium',
    'space.inset.small': '--ds-space-inset-small',
    'space.inset.xlarge': '--ds-space-inset-xlarge',
    'space.inset.xsmall': '--ds-space-inset-xsmall',
    'space.inset.xxlarge': '--ds-space-inset-xxlarge',
    'space.inset.xxsmall': '--ds-space-inset-xxsmall',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $8ae16317377fd108$export$2e2bcd8739ae039 = $8ae16317377fd108$var$tokens;

});

parcelRegister("3m2dq", function(module, exports) {
$parcel$export(module.exports, "default", () => $39c4201daa6fcfb9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $2YOL2 = parcelRequire("2YOL2");

var $5hZWH = parcelRequire("5hZWH");

var $fpjto = parcelRequire("fpjto");
const $39c4201daa6fcfb9$var$styles = {
    base: "_0bjKvDcjp5 _0WKd3G4z3T",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCYyL8i _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rkyL8i _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9Ds4Fm _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGis4Fm _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCYs4Fm _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rks4Fm _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9DyL8i _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGiyL8i _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCYyL8i _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rkyL8i _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9Ds4Fm _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGis4Fm _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiyL8i _1mT5xdRAKS _2I62gzVQEB"
};
const $39c4201daa6fcfb9$var$iconStyles = null;
const $39c4201daa6fcfb9$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $5chsV.jsxs)((0, $5hZWH.Anchor), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $2YOL2.cx)($39c4201daa6fcfb9$var$styles.base, appearance === 'default' && $39c4201daa6fcfb9$var$styles.defaultAppearance, appearance === 'subtle' && $39c4201daa6fcfb9$var$styles.subtleAppearance, appearance === 'inverse' && $39c4201daa6fcfb9$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $39c4201daa6fcfb9$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fpjto.Box), {
                as: "span",
                xcss: $39c4201daa6fcfb9$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $5chsV.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gJ6nT.default)([
                            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                        ]),
                        children: /*#__PURE__*/ (0, $5chsV.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
$39c4201daa6fcfb9$var$LinkWithoutRef.displayName = "LinkWithoutRef";
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $39c4201daa6fcfb9$var$Link = /*#__PURE__*/ (0, $fsvuC.forwardRef)($39c4201daa6fcfb9$var$LinkWithoutRef);
var $39c4201daa6fcfb9$export$2e2bcd8739ae039 = $39c4201daa6fcfb9$var$Link;

});
parcelRegister("5hZWH", function(module, exports) {
$parcel$export(module.exports, "Anchor", () => $ece26180e12650ee$export$b688253958b8dfe7);
/* anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $4twf9 = parcelRequire("4twf9");

var $l9kus = parcelRequire("l9kus");

var $fkuHa = parcelRequire("fkuHa");

var $8bI31 = parcelRequire("8bI31");

var $iqo7S = parcelRequire("iqo7S");

var $k9FWI = parcelRequire("k9FWI");

var $6Pi1A = parcelRequire("6Pi1A");

var $01oqo = parcelRequire("01oqo");

var $cjchk = parcelRequire("cjchk");
const $ece26180e12650ee$var$styles = {
    root: "_00uqCYyL8i _3xtjKN0Rl6 _0H9qDF6wH8 _24h04i2Njc",
    position: "_1mT5xdRAKS"
};
const $ece26180e12650ee$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $ece26180e12650ee$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/; /**
                                                              * __Anchor__
                                                              *
                                                              * A primitive for building custom anchor links.
                                                              *
                                                              * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
                                                              * - [Code](https://atlassian.design/components/primitives/anchor/code)
                                                              * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
                                                              */ 
const $ece26180e12650ee$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $iqo7S.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $fsvuC.useContext)((0, $6Pi1A.default));
    const handleClick = (0, $fsvuC.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $k9FWI.useId)();
    const onClick = (0, $fkuHa.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $8bI31.useRouterLink)();
    const isExternal = typeof href === 'string' && $ece26180e12650ee$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $ece26180e12650ee$var$IS_NON_HTTP_BASED.test(href); /**
                                                                                    * Renders a router link if:
                                                                                    *
                                                                                    * - a link component is set in the app provider
                                                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
                                                                                    */ 
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $l9kus.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $cjchk.Focusable // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
    ), {
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $4twf9.cx)($ece26180e12650ee$var$styles.root, $ece26180e12650ee$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $5chsV.jsx)((0, $01oqo.default), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
$ece26180e12650ee$var$AnchorNoRef.displayName = "AnchorNoRef";
const $ece26180e12650ee$export$b688253958b8dfe7 = /*#__PURE__*/ (0, $fsvuC.forwardRef)($ece26180e12650ee$var$AnchorNoRef);

});
parcelRegister("8bI31", function(module, exports) {
$parcel$export(module.exports, "useRouterLink", () => $81a36a85a0cf89f0$export$6d558eab13290f59);

var $fsvuC = parcelRequire("fsvuC");

var $9iOsX = parcelRequire("9iOsX");
const $81a36a85a0cf89f0$export$6d558eab13290f59 = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $fsvuC.useContext)((0, $9iOsX.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};

});
parcelRegister("9iOsX", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $2cd4169c140ede87$export$2931e0ee690eee88);
$parcel$export(module.exports, "default", () => $2cd4169c140ede87$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
const $2cd4169c140ede87$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $fsvuC.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $2cd4169c140ede87$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)($2cd4169c140ede87$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
$2cd4169c140ede87$var$RouterLinkProvider.displayName = "RouterLinkProvider";
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$2cd4169c140ede87$export$2e2bcd8739ae039 = $2cd4169c140ede87$var$RouterLinkProvider;

});




parcelRegister("1Lbfi", function(module, exports) {
$parcel$export(module.exports, "default", () => $89e416510f6f2bf2$export$2e2bcd8739ae039);
/* banner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $fpjto = parcelRequire("fpjto");

var $9EEzo = parcelRequire("9EEzo");
const $89e416510f6f2bf2$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
const $89e416510f6f2bf2$var$inlineStyles = {
    root: "_4ouGXIdnbC"
};
const $89e416510f6f2bf2$var$textStyles = {
    root: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1UtDYzH6EN _1kk5Tkf7mX _39HuIbz8Lp _1ANEUSLRg7 _0luBOgyL8i _0uGipIyL8i _0DlTgXyL8i _1Oh6lcyL8i _1KbF3ryL8i _2h5UOz0Rl6 _2LQVB40Rl6 _27PHXJ0Rl6 _38ddKy0Rl6 _1R2oCZ0Rl6 _3W2WEt6wH8 _4BW6TR6wH8 _2IWu1s6wH8 _4i4dA66wH8 _06nYrP6wH8 _0gKGie98eZ _1EjoPe98eZ _1BrKNs98eZ _1E1xWz98eZ _3bFj0T98eZ"
};
const $89e416510f6f2bf2$var$backgroundColors = {
    warning: 'color.background.warning.bold',
    error: 'color.background.danger.bold',
    announcement: 'color.background.neutral.bold'
};
const $89e416510f6f2bf2$var$tokenBackgroundColors = {
    warning: "var(--ds-background-warning-bold, #FBC828)",
    error: "var(--ds-background-danger-bold, #C9372C)",
    announcement: "var(--ds-background-neutral-bold, #292A2E)"
};
const $89e416510f6f2bf2$var$tokenTextColors = {
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    announcement: "var(--ds-text-inverse, #FFFFFF)"
};
const $89e416510f6f2bf2$var$containerStyles = {
    root: "_0jFU0VDuDI _0hPCNLDIqT _3iDTPbQ4SZ"
};
const $89e416510f6f2bf2$var$iconWrapperStyles = {
    root: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV029DVM _0jFU0V9DVM _3YEZNOdnbC"
};
/**
 * __Banner__
 *
 * A banner displays a prominent message at the top of the screen.
 *
 * - [Examples](https://atlassian.design/components/banner/examples)
 * - [Code](https://atlassian.design/components/banner/code)
 * - [Usage](https://atlassian.design/components/banner/usage)
 */ const $89e416510f6f2bf2$var$Banner = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
    const appearanceType = appearance in $89e416510f6f2bf2$var$backgroundColors ? appearance : 'warning';
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fpjto.Box), {
        xcss: $89e416510f6f2bf2$var$containerStyles.root,
        backgroundColor: $89e416510f6f2bf2$var$backgroundColors[appearanceType],
        padding: "space.150",
        testId: testId,
        ref: ref,
        role: "alert",
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $9EEzo.Inline), {
            space: "space.050",
            alignBlock: "center",
            alignInline: "start",
            xcss: $89e416510f6f2bf2$var$inlineStyles.root,
            children: [
                icon ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $fpjto.Box), {
                    as: "span",
                    xcss: $89e416510f6f2bf2$var$iconWrapperStyles.root,
                    style: {
                        fill: $89e416510f6f2bf2$var$tokenBackgroundColors[appearanceType],
                        color: $89e416510f6f2bf2$var$tokenTextColors[appearanceType]
                    },
                    children: icon
                }) : null,
                /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                    style: {
                        [$89e416510f6f2bf2$var$CSS_VAR_TEXT_COLOR]: $89e416510f6f2bf2$var$tokenTextColors[appearanceType]
                    },
                    className: (0, $gJ6nT.default)([
                        $89e416510f6f2bf2$var$textStyles.root
                    ]),
                    children: children
                })
            ]
        })
    });
});
var $89e416510f6f2bf2$export$2e2bcd8739ae039 = $89e416510f6f2bf2$var$Banner;

});

parcelRegister("aXiOe", function(module, exports) {
$parcel$export(module.exports, "default", () => $57032e7307d9cb6c$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $fkuHa = parcelRequire("fkuHa");

var $iqo7S = parcelRequire("iqo7S");

var $5xVTY = parcelRequire("5xVTY");

var $04q6D = parcelRequire("04q6D");

var $1wCqK = parcelRequire("1wCqK");

var $5T6N9 = parcelRequire("5T6N9");

var $lzKbd = parcelRequire("lzKbd");

var $jWyYj = parcelRequire("jWyYj");

var $b5Ymx = parcelRequire("b5Ymx");

var $biQSs = parcelRequire("biQSs");

var $cTyZ4 = parcelRequire("cTyZ4");
const $57032e7307d9cb6c$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $57032e7307d9cb6c$var$checkIsChildOfPortal(node.parentElement);
};
// Close manager for layering
const $57032e7307d9cb6c$var$CloseManager = ({ handleEscapeClose: handleEscapeClose, handleClick: handleClick })=>{
    (0, $04q6D.useCloseOnEscapePress)({
        onClose: handleEscapeClose
    });
    const { isLayerDisabled: isLayerDisabled } = (0, $1wCqK.useLayering)();
    (0, $fsvuC.useEffect)(()=>{
        return (0, $dqdTY.bind)(window, {
            type: 'click',
            listener: (e)=>{
                if (isLayerDisabled()) return;
                handleClick(e);
            },
            options: {
                capture: true
            }
        });
    }, [
        handleClick,
        isLayerDisabled
    ]);
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {});
};
$57032e7307d9cb6c$var$CloseManager.displayName = "CloseManager";
const $57032e7307d9cb6c$var$InlineDialog = /*#__PURE__*/ (0, $fsvuC.memo)(function InlineDialog(props) {
    if ((0, $5T6N9.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $cTyZ4.default), {
        ...props
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)($57032e7307d9cb6c$var$InlineDialogLegacy, {
        ...props
    });
});
function $57032e7307d9cb6c$var$InlineDialogLegacy({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $iqo7S.default), onContentClick: onContentClick = (0, $iqo7S.default), onContentFocus: onContentFocus = (0, $iqo7S.default), onClose: providedOnClose = (0, $iqo7S.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children, fallbackPlacements: fallbackPlacements }) {
    const containerRef = (0, $fsvuC.useRef)(null);
    const triggerRef = (0, $fsvuC.useRef)(null);
    const onClose = (0, $fkuHa.usePlatformLeafEventHandler)({
        fn: (event)=>providedOnClose(event),
        action: 'closed',
        componentName: 'inlineDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $fsvuC.useRef)(onClose);
    (0, $fsvuC.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $fsvuC.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isOpen) {
            onCloseRef.current?.({
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($57032e7307d9cb6c$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
            isOpen: false,
            event: event
        });
    }, [
        isOpen
    ]);
    const handleClick = (0, $fsvuC.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        if (containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        containerRef,
        triggerRef
    ]);
    /**
   * Auto-flip is enabled by default in `@atlaskit/popper` and
   * the `InlineDialog` API does not allow disabling it.
   *
   * We only need to override it if there are `fallbackPlacements` specified.
   */ const modifiers = (0, $fsvuC.useMemo)(()=>fallbackPlacements ? [
            {
                name: 'flip',
                options: {
                    fallbackPlacements: fallbackPlacements
                }
            }
        ] : [], [
        fallbackPlacements
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $lzKbd.Popper), {
        placement: placement,
        strategy: strategy,
        modifiers: modifiers,
        children: ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $biQSs.Container), {
                onBlur: onContentBlur,
                onFocus: onContentFocus,
                onClick: onContentClick,
                ref: (node)=>{
                    if (node) {
                        containerRef.current = node;
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                    }
                },
                style: style,
                testId: testId,
                children: typeof content === 'function' ? content() : content
            })
    }) : null;
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jWyYj.Manager), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $b5Ymx.Reference), {
                children: ({ ref: ref })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
                        ref: (node)=>{
                            // Resolve to the first element child of the div in `children`
                            const firstElementChild = node?.firstElementChild || null;
                            triggerRef.current = firstElementChild;
                            if (typeof ref === 'function') ref(firstElementChild);
                            else ref.current = firstElementChild;
                        },
                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment, {
                            children: children
                        })
                    })
            }),
            isOpen ? /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5xVTY.Layering), {
                isDisabled: false,
                children: [
                    popper,
                    /*#__PURE__*/ (0, $5chsV.jsx)($57032e7307d9cb6c$var$CloseManager, {
                        handleEscapeClose: handleCloseRequest,
                        handleClick: handleClick
                    })
                ]
            }) : popper
        ]
    });
}
$57032e7307d9cb6c$var$InlineDialogLegacy.displayName = "InlineDialogLegacy";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$57032e7307d9cb6c$export$2e2bcd8739ae039 = $57032e7307d9cb6c$var$InlineDialog;

});
parcelRegister("biQSs", function(module, exports) {
$parcel$export(module.exports, "Container", () => $f40fb2ddaccd7ae6$export$42a852a2b6b56249);
/* inline-dialog-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $f40fb2ddaccd7ae6$var$containerStyles = null;
const $f40fb2ddaccd7ae6$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        className: (0, $gJ6nT.default)([
            "_0bjKvDzXzM _24h04iyL8i _1EqgXlhPwX _0NUa3rhPwX _42Yu6BPvK5 _0KLXruoI2d _2OUyjtGk8v _1UtDYzy7kJ _0xmtko5zaO _46hvQm5zaO _03SyCPNHnM _0LQT5ENHnM _1zr6Dc98eZ _0htemXYbGa _067LceT6kp"
        ]),
        children: typeof children === 'function' ? children() : children
    });
});

});

parcelRegister("cTyZ4", function(module, exports) {
$parcel$export(module.exports, "default", () => $be2cccb0777ed022$export$2e2bcd8739ae039);
/* inline-dialog-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $fkuHa = parcelRequire("fkuHa");

var $iqo7S = parcelRequire("iqo7S");

var $bkfvF = parcelRequire("bkfvF");

var $iR2qO = parcelRequire("iR2qO");

var $l1dgd = parcelRequire("l1dgd");

var $6AVCN = parcelRequire("6AVCN");

var $7DQ7q = parcelRequire("7DQ7q");

var $74Lna = parcelRequire("74Lna");
const $be2cccb0777ed022$var$displayContentsStyles = {
    root: "_3iDTPbcK7c"
};
const $be2cccb0777ed022$var$styles = {
    container: "_0bjKvDzXzM _24h04iyL8i _1EqgXlhPwX _0NUa3rhPwX _0KLXruoI2d _2OUyjtGk8v _0xmtko5zaO _46hvQm5zaO _03SyCPNHnM _0LQT5ENHnM"
};
function $be2cccb0777ed022$var$getTriggerElement(trigger) {
    if (!trigger) return null;
    if (trigger instanceof HTMLButtonElement) return trigger;
    return trigger.querySelector('button');
} /**
   * Applies ARIA attributes to the child trigger element via an effect,
   * keeping them in sync with popup state.
   */ 
function $be2cccb0777ed022$var$TriggerWrapper({ children: children, triggerRef: triggerRef, ariaAttributes: ariaAttributes }) {
    (0, $fsvuC.useEffect)(()=>{
        const trigger = $be2cccb0777ed022$var$getTriggerElement(triggerRef.current);
        if (!trigger) return;
         // Apply each attribute. When a value is `undefined` (e.g.
        // `aria-controls` while the popover host is not in the DOM),
        // remove the attribute so the trigger does not retain a stale
        // reference from a previous open.
        Object.entries(ariaAttributes).forEach(([key, value])=>{
            if (value === undefined) {
                trigger.removeAttribute(key);
                return;
            }
            trigger.setAttribute(key, String(value));
        });
    }, [
        ariaAttributes,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: (node)=>{
            if (!node) {
                triggerRef.current = null;
                return;
            } // CSS-in-JS may inject <style> elements into this wrapper; they are not trigger elements.
            const triggerElement = Array.from(node.children).find((child)=>child instanceof HTMLElement && !(child instanceof HTMLStyleElement));
            triggerRef.current = triggerElement ?? null;
        },
        className: (0, $gJ6nT.default)([
            $be2cccb0777ed022$var$displayContentsStyles.root
        ]),
        children: children
    });
}
$be2cccb0777ed022$var$TriggerWrapper.displayName = "TriggerWrapper";
/**
 * Top-layer implementation of InlineDialog.
 *
 * Replaces the legacy rendering pipeline (Popper.js + Portal + @atlaskit/layering)
 * with the native Popover API + CSS Anchor Positioning via @atlaskit/top-layer.
 *
 * Gated behind the `platform-dst-top-layer` feature flag.
 */ const $be2cccb0777ed022$var$InlineDialogTopLayer = /*#__PURE__*/ (0, $fsvuC.memo)(function InlineDialogTopLayer({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $iqo7S.default), onContentClick: onContentClick = (0, $iqo7S.default), onContentFocus: onContentFocus = (0, $iqo7S.default), onClose: providedOnClose = (0, $iqo7S.default), placement: placement = 'bottom-start', testId: testId, content: content, children: children, // No-op props.
// These props are accepted for API compatibility but have no effect
// in the top-layer path. Each is documented with why it is unnecessary.
// top-layer: CSS Anchor Positioning replaces Popper strategy. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
strategy: _strategy, // top-layer: Popper.js fallbackPlacements not applicable. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
fallbackPlacements: _fallbackPlacements }) {
    const triggerRef = (0, $fsvuC.useRef)(null);
    const popoverRef = (0, $fsvuC.useRef)(null);
    const popoverId = (0, $74Lna.usePopoverId)();
    const onClose = (0, $fkuHa.usePlatformLeafEventHandler)({
        fn: (event)=>providedOnClose(event),
        action: 'closed',
        componentName: 'inlineDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    }); // Placement conversion.
    const topLayerPlacement = (0, $fsvuC.useMemo)(()=>(0, $iR2qO.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]); // `isOpen` is included so the anchor positioning effect re-runs when
    // the Popover host element is unmounted/remounted across open cycles.
    (0, $7DQ7q.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen
    }); // onClose bridge.
    // Translates top-layer's { reason } into the legacy onClose({ isOpen, event }) shape.
    // Focus restoration is handled automatically by the Popover based on the content role
    // (role="dialog" -> auto-restore).
    const handleOnClose = (0, $fsvuC.useCallback)(({ reason: reason })=>{
        const syntheticEvent = (0, $l1dgd.createPopoverCloseEvent)({
            reason: reason
        });
        onClose({
            isOpen: false,
            event: syntheticEvent
        });
    }, [
        onClose
    ]);
    const ariaAttributes = (0, $bkfvF.getAriaForTrigger)({
        role: 'dialog',
        isOpen: isOpen,
        popoverId: popoverId
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)($be2cccb0777ed022$var$TriggerWrapper, {
                triggerRef: triggerRef,
                ariaAttributes: ariaAttributes,
                children: children
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $6AVCN.Popover), {
                ref: popoverRef,
                id: popoverId,
                role: "dialog",
                // Acceptable given this component is intent-to-deprecate.
                label: "Inline dialog",
                isOpen: isOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId,
                children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    role: "presentation",
                    onBlur: onContentBlur,
                    onClick: onContentClick,
                    onFocus: onContentFocus,
                    className: (0, $gJ6nT.default)([
                        $be2cccb0777ed022$var$styles.container
                    ]),
                    children: typeof content === 'function' ? content() : content
                })
            })
        ]
    });
});
var $be2cccb0777ed022$export$2e2bcd8739ae039 = $be2cccb0777ed022$var$InlineDialogTopLayer;

});
parcelRegister("bkfvF", function(module, exports) {
$parcel$export(module.exports, "getAriaForTrigger", () => $8bd410f79aabc474$export$9dd1d61dd4d4755);
/**
 * The `aria-haspopup` value for each role in `TAriaForTriggerRole`: the popup type that the
 * trigger announces. ARIA has no `alertdialog` value, so `alertdialog` uses `'dialog'`.
 *
 * `true` is not a value. The function returns only the explicit tokens, never
 * `aria-haspopup="true"`.
 */ const $8bd410f79aabc474$var$roleToAriaHasPopup = {
    dialog: 'dialog',
    alertdialog: 'dialog',
    menu: 'menu',
    listbox: 'listbox',
    tree: 'tree',
    grid: 'grid'
};
function $8bd410f79aabc474$export$9dd1d61dd4d4755({ role: role, isOpen: isOpen, popoverId: popoverId }) {
    // `aria-controls` is `undefined` while closed: the popover element is not in the DOM after its
    // exit animation, so the `id` would point to nothing.
    return {
        'aria-haspopup': role ? $8bd410f79aabc474$var$roleToAriaHasPopup[role] : undefined,
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}

});

parcelRegister("l1dgd", function(module, exports) {
$parcel$export(module.exports, "createPopoverCloseEvent", () => $9ff0072eb955a3d0$export$27b4de066896ac63);
function $9ff0072eb955a3d0$export$27b4de066896ac63({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        code: 'Escape',
        bubbles: true
    });
    if (reason === 'light-dismiss') return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
    return new Event('close');
}

});



parcelRegister("49mAA", function(module, exports) {
$parcel$export(module.exports, "PopoverContent", () => $290f4a9a7cb45f2f$export$d7e1f420b25549ff);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $5T6N9 = parcelRequire("5T6N9");

var $gF0mf = parcelRequire("gF0mf");

var $6gJBg = parcelRequire("6gJBg");
/**
 * __PopoverContent__
 *
 * A `PopoverContent` is the element that is shown as a popover.
 */ const $290f4a9a7cb45f2f$var$renderPopoverContent = (Component, { children: children, placement: placement, motion: motion, isVisible: isVisible, shouldDismissOnClickOutside: shouldDismissOnClickOutside, dismiss: dismiss, back: back, testId: testId, offset: offset, strategy: strategy, ...actionProps })=>{
    if ('next' in actionProps && actionProps.next) return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        placement: placement,
        motion: motion,
        isVisible: isVisible,
        shouldDismissOnClickOutside: shouldDismissOnClickOutside,
        dismiss: dismiss,
        back: back,
        testId: testId,
        offset: offset,
        strategy: strategy,
        next: actionProps.next,
        children: children
    });
    if ('done' in actionProps && actionProps.done) return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        placement: placement,
        motion: motion,
        isVisible: isVisible,
        shouldDismissOnClickOutside: shouldDismissOnClickOutside,
        dismiss: dismiss,
        back: back,
        testId: testId,
        offset: offset,
        strategy: strategy,
        done: actionProps.done,
        children: children
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        placement: placement,
        motion: motion,
        isVisible: isVisible,
        shouldDismissOnClickOutside: shouldDismissOnClickOutside,
        dismiss: dismiss,
        back: back,
        testId: testId,
        offset: offset,
        strategy: strategy,
        children: children
    });
};
const $290f4a9a7cb45f2f$export$d7e1f420b25549ff = (props)=>(0, $5T6N9.fg)('platform-dst-top-layer-spotlight') ? $290f4a9a7cb45f2f$var$renderPopoverContent((0, $6gJBg.PopoverContent), props) : $290f4a9a7cb45f2f$var$renderPopoverContent((0, $gF0mf.PopoverContent), props);

});
parcelRegister("gF0mf", function(module, exports) {
$parcel$export(module.exports, "PopoverContent", () => $a2ed9fd1a7db1b30$export$d7e1f420b25549ff);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $1cXpO = parcelRequire("1cXpO");

var $h4ylU = parcelRequire("h4ylU");

var $5T6N9 = parcelRequire("5T6N9");

var $lzKbd = parcelRequire("lzKbd");

var $hFyni = parcelRequire("hFyni");

var $7eTUC = parcelRequire("7eTUC");

var $6V481 = parcelRequire("6V481");

var $6TJPz = parcelRequire("6TJPz");

var $2HNJM = parcelRequire("2HNJM");
const $a2ed9fd1a7db1b30$var$styles = {
    root: "_42Yu6BkKjW"
};
/**
 * The `transform: rotate(45deg);` styles used to rotate the `Caret` component result in the corners of
 * the caret extending beyond the bounding box (by roughly 2px). So, apply an offset to ensure
 * the caret points to the very edge of the target element.
 *
 * Note: `@atlaskit/popper` maps the offset to the placement, so we only need to define `[0, 2]` and
 * the offset will get correctly rotated depending on the placement.
 */ const $a2ed9fd1a7db1b30$var$defaultOffset = [
    0,
    2
];
/**
 * The Spotlight card can be positioned in many different configurations, but the caret should always point to
 * the center of the target element. `@atlaskit/popper` uses `'top' | 'right' | 'bottom' | 'left'` values for
 * this center alignment along the respective face. So we translate between the Spotlight position, and the
 * Popper position using this map.
 */ const $a2ed9fd1a7db1b30$var$popperPlacementMap = {
    'top-start': 'top',
    'top-center': 'top',
    'top-end': 'top',
    'bottom-start': 'bottom',
    'bottom-center': 'bottom',
    'bottom-end': 'bottom',
    'right-start': 'right',
    'right-end': 'right',
    'left-start': 'left',
    'left-end': 'left'
};
const $a2ed9fd1a7db1b30$var$DefaultMotion = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $h4ylU.default), {
        enteringAnimation: "var(--ds-spotlight-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
        exitingAnimation: "var(--ds-spotlight-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
        children: children
    });
$a2ed9fd1a7db1b30$var$DefaultMotion.displayName = "DefaultMotion";
const $a2ed9fd1a7db1b30$export$d7e1f420b25549ff = (props)=>{
    const { children: children, placement: placement, motion: motion = $a2ed9fd1a7db1b30$var$DefaultMotion, isVisible: isVisible = true, shouldDismissOnClickOutside: shouldDismissOnClickOutside = true, dismiss: dismiss, back: back, testId: testId, offset: offset = $a2ed9fd1a7db1b30$var$defaultOffset, strategy: strategy } = props;
    /**
   * A user should only be able to pass a `done` or a `next`. Not both.
   * The type is set up as a discriminant union. So, we need a typeguard
   * here to destructure it properly.
   */ const done = 'done' in props ? props.done : undefined;
    const next = 'next' in props ? props.next : undefined;
    const updateRef = (0, $fsvuC.useRef)(()=>new Promise(()=>undefined));
    const ref = (0, $fsvuC.useRef)(null);
    const { heading: heading, popoverContent: popoverContent, card: card, primaryAction: primaryAction, secondaryAction: secondaryAction } = (0, $fsvuC.useContext)((0, $hFyni.SpotlightContext));
    const focusWithin = (0, $7eTUC.useFocusWithin)(popoverContent.ref);
    (0, $fsvuC.useEffect)(()=>{
        popoverContent.setRef(ref);
    }, [
        ref,
        popoverContent
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!done && !next) return;
        if (done) {
            primaryAction.setAction(done);
            return;
        } else if (next) {
            primaryAction.setAction(next);
            return;
        }
    }, [
        done,
        next,
        primaryAction
    ]);
    (0, $fsvuC.useEffect)(()=>{
        popoverContent.setDismiss(dismiss);
    }, [
        dismiss,
        popoverContent
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!back) return;
        secondaryAction.setAction(back);
    }, [
        back,
        secondaryAction
    ]);
    (0, $fsvuC.useLayoutEffect)(()=>{
        card.setPlacement(placement);
        if (motion) card.setMotion(()=>motion);
    }, [
        placement,
        card,
        motion
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (updateRef.current) popoverContent.setUpdate(()=>updateRef.current);
    }, [
        popoverContent
    ]);
    (0, $6TJPz.useOnEscape)((event)=>{
        if (!focusWithin) return;
        popoverContent.dismiss.current(event);
    });
    (0, $6V481.useOnClickOutside)((event)=>{
        if (!shouldDismissOnClickOutside) return;
        popoverContent.dismiss.current(event);
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $lzKbd.Popper), {
        offset: offset,
        strategy: strategy,
        placement: $a2ed9fd1a7db1b30$var$popperPlacementMap[placement],
        children: ({ ref: localRef, style: style, update: update })=>{
            if (!isVisible && !(0, $5T6N9.fg)('platform-dst-motion-uplift-spotlight')) return;
            updateRef.current = update;
            return (0, $5T6N9.fg)('platform-dst-motion-uplift-spotlight') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $2HNJM.ConditionalExitingPersistence), {
                children: isVisible && /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    role: "dialog",
                    "data-testid": testId,
                    "aria-labelledby": heading.id,
                    ref: (0, $1cXpO.default)([
                        ref,
                        localRef
                    ]),
                    style: style,
                    className: (0, $gJ6nT.default)([
                        $a2ed9fd1a7db1b30$var$styles.root
                    ]),
                    children: children
                })
            }) : /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                role: "dialog",
                "data-testid": testId,
                "aria-labelledby": heading.id,
                ref: (0, $1cXpO.default)([
                    ref,
                    localRef
                ]),
                style: style,
                className: (0, $gJ6nT.default)([
                    $a2ed9fd1a7db1b30$var$styles.root
                ]),
                children: children
            });
        }
    });
};
$a2ed9fd1a7db1b30$export$d7e1f420b25549ff.displayName = "PopoverContent";

});
parcelRegister("hFyni", function(module, exports) {
$parcel$export(module.exports, "SpotlightContext", () => $c08138dc8af3a65e$export$7b5aa0f5b37a336d);
$parcel$export(module.exports, "SpotlightContextProvider", () => $c08138dc8af3a65e$export$ad26233dae620a42);
/* context.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
const $c08138dc8af3a65e$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $fsvuC.createContext)({
    card: {
        ref: null,
        setRef: ()=>undefined,
        placement: 'bottom-end',
        setPlacement: ()=>undefined,
        motion: undefined,
        setMotion: ()=>undefined
    },
    heading: {
        id: '',
        setId: ()=>undefined
    },
    popoverContent: {
        ref: undefined,
        setRef: ()=>undefined,
        positionArea: undefined,
        setPositionArea: ()=>undefined,
        update: ()=>new Promise(()=>null),
        setUpdate: ()=>new Promise(()=>null),
        dismiss: {
            current: ()=>undefined
        },
        setDismiss: ()=>undefined
    },
    target: {
        ref: {
            current: null
        },
        setRef: ()=>undefined
    },
    primaryAction: {
        action: {
            current: ()=>undefined
        },
        setAction: ()=>undefined
    },
    secondaryAction: {
        action: {
            current: ()=>undefined
        },
        setAction: ()=>undefined
    }
});
const $c08138dc8af3a65e$export$ad26233dae620a42 = ({ children: children, targetRef: targetRef })=>{
    const id = (0, $fsvuC.useId)();
    const defaultTargetRef = (0, $fsvuC.useRef)(null);
    const [motion, setMotion] = (0, $fsvuC.useState)();
    const [placement, setPlacement] = (0, $fsvuC.useState)('bottom-end');
    const [headingId, setHeadingId] = (0, $fsvuC.useState)(`${id}-heading`);
    const [update, setUpdate] = (0, $fsvuC.useState)(()=>async ()=>undefined);
    const [popoverRef, setPopoverRef] = (0, $fsvuC.useState)();
    const [positionArea, setPositionArea] = (0, $fsvuC.useState)();
    const [cardRef, setCardRef] = (0, $fsvuC.useState)(null);
    const [internalTargetRef, setInternalTargetRef] = (0, $fsvuC.useState)(defaultTargetRef);
    // `targetRef` (the prop) takes precedence when provided. Its identity is
    // allowed to change over time; downstream consumers that depend on
    // `target.ref` identity (e.g. `useAnchoredPopover`'s effect deps) will
    // re-run accordingly.
    const effectiveTargetRef = targetRef ?? internalTargetRef;
    const dismissRef = (0, $fsvuC.useRef)(()=>undefined);
    const setDismiss = (dismissFn)=>{
        dismissRef.current = dismissFn;
    };
    const secondaryActionRef = (0, $fsvuC.useRef)(()=>undefined);
    const setSecondaryAction = (actionFn)=>{
        secondaryActionRef.current = actionFn;
    };
    const primaryActionRef = (0, $fsvuC.useRef)(()=>undefined);
    const setPrimaryAction = (actionFn)=>{
        primaryActionRef.current = actionFn;
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)($c08138dc8af3a65e$export$7b5aa0f5b37a336d.Provider, {
        value: {
            card: {
                ref: cardRef,
                setRef: setCardRef,
                placement: placement,
                setPlacement: setPlacement,
                motion: motion,
                setMotion: setMotion
            },
            heading: {
                id: headingId,
                setId: setHeadingId
            },
            popoverContent: {
                ref: popoverRef,
                setRef: setPopoverRef,
                positionArea: positionArea,
                setPositionArea: setPositionArea,
                update: update,
                setUpdate: setUpdate,
                dismiss: dismissRef,
                setDismiss: setDismiss
            },
            target: {
                ref: effectiveTargetRef,
                setRef: setInternalTargetRef
            },
            primaryAction: {
                action: primaryActionRef,
                setAction: setPrimaryAction
            },
            secondaryAction: {
                action: secondaryActionRef,
                setAction: setSecondaryAction
            }
        },
        children: children
    });
};
$c08138dc8af3a65e$export$ad26233dae620a42.displayName = "SpotlightContextProvider";

});

parcelRegister("7eTUC", function(module, exports) {
$parcel$export(module.exports, "useFocusWithin", () => $ac6ed50423fc1e37$export$420e68273165f4ec);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $jilfX = parcelRequire("jilfX");
const $ac6ed50423fc1e37$export$420e68273165f4ec = (ref)=>{
    const [active, setActive] = (0, $fsvuC.useState)(null);
    const updateFocusedElement = (0, $fsvuC.useCallback)(()=>{
        const doc = (0, $jilfX.getDocument)();
        const activeElement = doc?.activeElement || null;
        if (!ref || !ref.current) {
            setActive(null);
            return;
        }
        if (!activeElement) {
            setActive(null);
            return;
        }
        // Check if the focused element is within the ref element
        if (!ref.current.contains(activeElement)) {
            setActive(null);
            return;
        }
        setActive(activeElement);
    }, [
        ref
    ]);
    (0, $fsvuC.useEffect)(()=>{
        const doc = (0, $jilfX.getDocument)();
        if (!doc) return;
        updateFocusedElement();
        const unbindFocusIn = (0, $dqdTY.bind)(doc, {
            type: 'focusin',
            listener: updateFocusedElement
        });
        return ()=>{
            unbindFocusIn();
        };
    }, [
        updateFocusedElement
    ]);
    return active;
};

});

parcelRegister("6V481", function(module, exports) {
$parcel$export(module.exports, "useOnClickOutside", () => $9500cca9e4e3ba2d$export$9afc64c180e82dc4);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $jilfX = parcelRequire("jilfX");

var $hFyni = parcelRequire("hFyni");
const $9500cca9e4e3ba2d$export$9afc64c180e82dc4 = (onClickOutside)=>{
    const { card: card } = (0, $fsvuC.useContext)((0, $hFyni.SpotlightContext));
    const ref = card.ref;
    (0, $fsvuC.useEffect)(()=>{
        const doc = (0, $jilfX.getDocument)();
        if (!doc) return;
        const unbindMouseUp = (0, $dqdTY.bind)(doc, {
            type: 'mouseup',
            listener: (event)=>{
                if (!ref || !ref.current) return;
                const target = event.target instanceof Node ? event.target : null;
                if (ref.current.contains(target)) return;
                onClickOutside(event);
            }
        });
        return ()=>{
            unbindMouseUp();
        };
    }, [
        onClickOutside,
        ref
    ]);
};

});

parcelRegister("6TJPz", function(module, exports) {
$parcel$export(module.exports, "useOnEscape", () => $0a26e5f9d149cf11$export$795d56022f0285ed);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $jilfX = parcelRequire("jilfX");
const $0a26e5f9d149cf11$var$onKeyDown = (event, { onEscape: onEscape })=>{
    switch(event.key){
        case 'Escape':
            onEscape();
            break;
        default:
            break;
    }
};
const $0a26e5f9d149cf11$export$795d56022f0285ed = (onEscape)=>{
    (0, $fsvuC.useEffect)(()=>{
        const doc = (0, $jilfX.getDocument)();
        if (!doc) return;
        const unbindFocusIn = (0, $dqdTY.bind)(doc, {
            type: 'keydown',
            listener: (event)=>$0a26e5f9d149cf11$var$onKeyDown(event, {
                    onEscape: ()=>onEscape(event)
                })
        });
        return ()=>{
            unbindFocusIn();
        };
    }, [
        onEscape
    ]);
};

});

parcelRegister("2HNJM", function(module, exports) {
$parcel$export(module.exports, "ConditionalExitingPersistence", () => $70153031af43ce52$export$4c013c06aa0aee51);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $c4Atc = parcelRequire("c4Atc");

var $hFyni = parcelRequire("hFyni");
const $70153031af43ce52$export$4c013c06aa0aee51 = ({ children: children })=>{
    const { card: card } = (0, $fsvuC.useContext)((0, $hFyni.SpotlightContext));
    if (card.motion) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $c4Atc.default), {
        children: children
    });
    return children;
};
$70153031af43ce52$export$4c013c06aa0aee51.displayName = "ConditionalExitingPersistence";

});


parcelRegister("6gJBg", function(module, exports) {
$parcel$export(module.exports, "PopoverContent", () => $da76b45a62fd4b13$export$d7e1f420b25549ff);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $h4ylU = parcelRequire("h4ylU");

var $l1dgd = parcelRequire("l1dgd");

var $6AVCN = parcelRequire("6AVCN");

var $7DQ7q = parcelRequire("7DQ7q");

var $k8DTj = parcelRequire("k8DTj");

var $hFyni = parcelRequire("hFyni");

var $eEUuF = parcelRequire("eEUuF");

var $fKofq = parcelRequire("fKofq");
const $da76b45a62fd4b13$var$noopUpdate = ()=>Promise.resolve();
const $da76b45a62fd4b13$var$DefaultMotion = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $h4ylU.default), {
        enteringAnimation: "var(--ds-spotlight-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
        exitingAnimation: "var(--ds-spotlight-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
        children: children
    });
$da76b45a62fd4b13$var$DefaultMotion.displayName = "DefaultMotion";
const $da76b45a62fd4b13$export$d7e1f420b25549ff = (props)=>{
    /**
   * This composes the low-level `@atlaskit/top-layer` `Popover` primitive directly
   * (rather than `@atlaskit/popup` or a higher-level wrapper) for two reasons:
   *
   * 1. Spotlight has bespoke positioning, dismiss, and motion requirements that
   *    are coupled to the surrounding `SpotlightContext` (heading id, card
   *    placement, primary/secondary actions, etc.). Building on the primitive
   *    keeps that wiring local to spotlight without leaking into a shared popup.
   * 2. Spotlight's public API exposes a `dismiss(event)` callback that takes a
   *    `KeyboardEvent` / `MouseEvent`, while the top-layer primitive surfaces a
   *    structured `{ reason }`. Bridging that contract here (via
   *    `createPopoverCloseEvent`) preserves backwards compatibility for existing
   *    consumers as we migrate behind the `platform-dst-top-layer-spotlight` gate.
   */ const { children: children, placement: placement, motion: motion = $da76b45a62fd4b13$var$DefaultMotion, isVisible: isVisible = true, shouldDismissOnClickOutside: shouldDismissOnClickOutside = true, dismiss: dismiss, back: back, testId: testId, offset: offset } = props;
    const done = 'done' in props ? props.done : undefined;
    const next = 'next' in props ? props.next : undefined;
    const popoverRef = (0, $fsvuC.useRef)(null);
    const { heading: heading, popoverContent: popoverContent, card: card, primaryAction: primaryAction, secondaryAction: secondaryAction, target: target } = (0, $fsvuC.useContext)((0, $hFyni.SpotlightContext));
    (0, $7DQ7q.useAnchoredPopover)({
        anchorRef: target.ref,
        popoverRef: popoverRef,
        placement: (0, $fKofq.getPlacementWithOffset)({
            placement: placement,
            offset: offset
        }),
        isOpen: isVisible
    });
    (0, $k8DTj.useManualLightDismiss)({
        popoverRef: popoverRef,
        isOpen: isVisible,
        onClose: ({ reason: reason })=>{
            if (reason === 'light-dismiss' && !shouldDismissOnClickOutside) return;
            // `createPopoverCloseEvent` is typed as `KeyboardEvent | MouseEvent | Event`
            // for forward-compatibility, but only `escape` / `light-dismiss` are
            // possible here, so the result is always a Keyboard/MouseEvent.
            dismiss((0, $l1dgd.createPopoverCloseEvent)({
                reason: reason
            }));
        }
    });
    (0, $fsvuC.useEffect)(()=>{
        popoverContent.setRef(popoverRef);
        popoverContent.setUpdate(()=>$da76b45a62fd4b13$var$noopUpdate);
    }, [
        popoverContent
    ]);
    const positionArea = (0, $eEUuF.usePositionArea)(popoverRef);
    (0, $fsvuC.useEffect)(()=>{
        popoverContent.setPositionArea(positionArea);
    }, [
        popoverContent,
        positionArea
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!done && !next) return;
        if (done) {
            primaryAction.setAction(done);
            return;
        } else if (next) {
            primaryAction.setAction(next);
            return;
        }
    }, [
        done,
        next,
        primaryAction
    ]);
    (0, $fsvuC.useEffect)(()=>{
        popoverContent.setDismiss(dismiss);
    }, [
        dismiss,
        popoverContent
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!back) return;
        secondaryAction.setAction(back);
    }, [
        back,
        secondaryAction
    ]);
    (0, $fsvuC.useLayoutEffect)(()=>{
        card.setPlacement(placement);
        if (motion) card.setMotion(()=>motion);
    }, [
        placement,
        card,
        motion
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6AVCN.Popover), {
        ref: popoverRef,
        isOpen: isVisible,
        mode: "manual",
        role: "dialog",
        labelledBy: heading.id,
        testId: testId,
        children: children
    });
};
$da76b45a62fd4b13$export$d7e1f420b25549ff.displayName = "PopoverContent";

});
parcelRegister("k8DTj", function(module, exports) {
$parcel$export(module.exports, "useManualLightDismiss", () => $0906d1d42b90d582$export$798a205e5e823858);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $l9kus = parcelRequire("l9kus");

var $l4c9y = parcelRequire("l4c9y");

var $2pMZ7 = parcelRequire("2pMZ7");

var $llZLy = parcelRequire("llZLy");

var $1u09E = parcelRequire("1u09E");


var $kmoLI = parcelRequire("kmoLI");

var $fYeZR = parcelRequire("fYeZR");

var $aiB2I = parcelRequire("aiB2I");

var $7jX8p = parcelRequire("7jX8p");

var $iz4Yl = parcelRequire("iz4Yl");
function $0906d1d42b90d582$export$798a205e5e823858({ popoverRef: popoverRef, mode: mode = 'popover', additionalInsideElementRefs: additionalInsideElementRefs, isOpen: isOpen, onClose: onClose }) {
    // Latest callback, so the listeners do not re-bind each render.
    const onCloseRef = (0, $fsvuC.useRef)(onClose);
    onCloseRef.current = onClose;
    const isPopover = mode === 'popover';
    (0, $fYeZR.useStartOpenOrderTracking)();
    (0, $iz4Yl.useOutsidePress)({
        elementRef: popoverRef,
        additionalInsideElementRefs: additionalInsideElementRefs,
        isOpen: isOpen,
        onOutsidePress: ()=>onCloseRef.current({
                reason: 'light-dismiss'
            })
    });
    // Page surface: Escape closes it only while no owner is above it.
    (0, $7jX8p.useCloseOnUnclaimedEscape)({
        isEnabled: isOpen && !isPopover,
        onClose: ()=>onCloseRef.current({
                reason: 'escape'
            }),
        surfaceRef: popoverRef
    });
    // A passive effect, not a layout effect, so SSR in a DOM test environment does not warn. Until it
    // runs, the popover is not marked or listening.
    (0, $fsvuC.useEffect)(()=>{
        if (!isOpen || !isPopover) return;
        const popover = popoverRef.current;
        // Other layers find layers by `[popover]`, and the open order comes from `beforetoggle`. A plain
        // element has neither.
        (0, $l9kus.default)(!popover || popover.hasAttribute('popover'), "useManualLightDismiss: `popoverRef` must be a `[popover]` element. Use `mode: 'page-surface'` for an element that is not in the top layer.");
        // The open order lives outside the hook, so an effect re-run keeps it. A popover that opened
        // before tracking started is ordered from now.
        if (popover) (0, $kmoLI.openOrderTracker).ensureOpenOrder({
            element: popover
        });
        return (0, $l4c9y.combine)(// Mark it as a layer that takes Escape, for other layers' checks.
        popover ? (0, $aiB2I.setAttribute)({
            element: popover,
            name: (0, $f55c6207107d404d$export$e9d791a989444609),
            value: ''
        }) : undefined, // Target and phase matter. See the listener order in `claim-escape`.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- Escape reaches the popover from anywhere on the page
        (0, $dqdTY.bind)(document, {
            type: 'keydown',
            listener (event) {
                if (!(0, $1u09E.isEscapeToHandle)({
                    event: event
                })) return;
                const element = popoverRef.current;
                // Not attached: no place in the stack. Nothing dismisses, and the Escape goes on to the
                // next layer.
                if (!element) return;
                if ((0, $llZLy.hasEscapeOwnerAbove)({
                    element: element,
                    isLayer: true
                })) return;
                // Take the Escape even if `onClose` keeps the popover open, as a native close watcher
                // does: an ancestor `Dialog` sees `defaultPrevented`, and the browser sends no close
                // request to an ancestor auto popover. A held-key repeat is taken but does not call
                // `onClose`.
                if (!(0, $2pMZ7.claimEscape)({
                    event: event
                })) return;
                onCloseRef.current({
                    reason: 'escape'
                });
            }
        }));
    }, [
        isOpen,
        isPopover,
        popoverRef
    ]);
}

});
parcelRegister("7jX8p", function(module, exports) {
$parcel$export(module.exports, "useCloseOnUnclaimedEscape", () => $eb39e6e9c230073f$export$30d0a7083b150871);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $l4c9y = parcelRequire("l4c9y");

var $2pMZ7 = parcelRequire("2pMZ7");

var $k8we0 = parcelRequire("k8we0");

var $9qwFB = parcelRequire("9qwFB");

var $llZLy = parcelRequire("llZLy");

var $1u09E = parcelRequire("1u09E");


var $fYeZR = parcelRequire("fYeZR");

var $aiB2I = parcelRequire("aiB2I");
/**
 * `true` when `surface` is inside an open layer that takes Escape.
 */ function $eb39e6e9c230073f$var$isInsideOpenLayer({ surface: surface }) {
    return (0, $k8we0.getNearestContainingLayer)({
        element: surface,
        layers: (0, $9qwFB.getOpenLayersTakingEscape)({
            within: surface.ownerDocument
        })
    }) !== null;
}
/**
 * `true` when the document has an open layer that takes Escape, or a marked page surface.
 */ function $eb39e6e9c230073f$var$hasAnyEscapeOwner({ ownerDocument: ownerDocument }) {
    return (0, $9qwFB.getOpenLayersTakingEscape)({
        within: ownerDocument
    }).length > 0 || ownerDocument.querySelector(`[${(0, $ff07b2b5c98781b6$export$890961b3d10b17dc)}]`) !== null;
}
/**
 * `true` when an Escape owner is above the surface. With no surface element, the surface is the
 * whole page, so every owner is inside it, and above it.
 */ function $eb39e6e9c230073f$var$hasEscapeOwnerAboveSurface({ surface: surface, target: target }) {
    if (surface) return (0, $llZLy.hasEscapeOwnerAbove)({
        element: surface
    });
    return $eb39e6e9c230073f$var$hasAnyEscapeOwner({
        ownerDocument: target instanceof Document ? target : target.ownerDocument
    });
}
function $eb39e6e9c230073f$export$30d0a7083b150871({ isEnabled: isEnabled, onClose: onClose, shouldClose: shouldClose, targetRef: targetRef, surfaceRef: surfaceRef }) {
    // Latest callbacks, so the listener does not re-bind each render.
    const onCloseRef = (0, $fsvuC.useRef)(onClose);
    onCloseRef.current = onClose;
    const shouldCloseRef = (0, $fsvuC.useRef)(shouldClose);
    shouldCloseRef.current = shouldClose;
    (0, $fYeZR.useStartOpenOrderTracking)();
    (0, $fsvuC.useEffect)(()=>{
        if (!isEnabled) return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- page surfaces listen on the document by default
        const target = targetRef ? targetRef.current : document;
        if (!target) return;
        // A manual popover around the surface also listens on `document` and may run first. The mark
        // tells it to leave the Escape to this surface. On an element target this listener runs first
        // anyway.
        const surfaceToMark = target instanceof HTMLElement ? null : surfaceRef?.current ?? null;
        return (0, $l4c9y.combine)(surfaceToMark ? (0, $aiB2I.setAttribute)({
            element: surfaceToMark,
            name: (0, $ff07b2b5c98781b6$export$890961b3d10b17dc),
            value: ''
        }) : undefined, // Target and phase matter. See the listener order in `claim-escape`.
        (0, $dqdTY.bind)(target, {
            type: 'keydown',
            listener (event) {
                if (!(0, $1u09E.isEscapeToHandle)({
                    event: event
                })) return;
                const surface = surfaceRef?.current ?? (target instanceof HTMLElement ? target : null);
                if ($eb39e6e9c230073f$var$hasEscapeOwnerAboveSurface({
                    surface: surface,
                    target: target
                })) return;
                const isInsideLayer = surface !== null && $eb39e6e9c230073f$var$isInsideOpenLayer({
                    surface: surface
                });
                // `shouldClose` runs before `claimEscape()`, so it sees the event as not yet claimed.
                const shouldCloseSurface = !event.repeat && (!shouldCloseRef.current || shouldCloseRef.current({
                    event: event
                }));
                // Take the Escape even on a veto or repeat, so the layer around the surface stays open.
                if (isInsideLayer) (0, $2pMZ7.claimEscape)({
                    event: event
                });
                if (!shouldCloseSurface) return;
                onCloseRef.current({
                    event: event
                });
            }
        }));
    }, [
        isEnabled,
        surfaceRef,
        targetRef
    ]);
}

});

parcelRegister("iz4Yl", function(module, exports) {
$parcel$export(module.exports, "useOutsidePress", () => $0042a513b0bfc96c$export$8e766307d54318cb);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");
function $0042a513b0bfc96c$var$isInside({ ref: ref, target: target }) {
    return Boolean(ref.current?.contains(target));
}
function $0042a513b0bfc96c$export$8e766307d54318cb({ elementRef: elementRef, additionalInsideElementRefs: additionalInsideElementRefs, isOpen: isOpen, onOutsidePress: onOutsidePress }) {
    const onOutsidePressRef = (0, $fsvuC.useRef)(onOutsidePress);
    onOutsidePressRef.current = onOutsidePress;
    // Read at event time, so a new (inline) array does not re-bind the listeners mid-press.
    const additionalInsideElementRefsRef = (0, $fsvuC.useRef)(additionalInsideElementRefs);
    additionalInsideElementRefsRef.current = additionalInsideElementRefs;
    (0, $fsvuC.useEffect)(()=>{
        if (!isOpen) return;
        function isOutside({ target: target }) {
            // Without the element, nothing is outside it.
            if (!(target instanceof Node) || !elementRef.current) return false;
            return !($0042a513b0bfc96c$var$isInside({
                ref: elementRef,
                target: target
            }) || additionalInsideElementRefsRef.current?.some((ref)=>$0042a513b0bfc96c$var$isInside({
                    ref: ref,
                    target: target
                })));
        }
        /**
		 * Whether the current press started outside. The press that opened the popover came before
		 * the listeners were bound, so it cannot dismiss.
		 */ const press = {
            isStartedOutside: false
        };
        return (0, $dqdTY.bindAll)(// eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- light dismiss listens on the whole document
        document, [
            {
                type: 'pointerdown',
                listener (event) {
                    press.isStartedOutside = isOutside({
                        target: event.target
                    });
                }
            },
            {
                // As native light dismiss: dismiss when a press that started outside ends outside.
                type: 'pointerup',
                listener (event) {
                    const isStartedOutside = press.isStartedOutside;
                    press.isStartedOutside = false;
                    if (!isStartedOutside || !isOutside({
                        target: event.target
                    })) return;
                    onOutsidePressRef.current();
                }
            },
            {
                // A touch scroll or a native drag ends the press with no `pointerup`.
                type: 'pointercancel',
                listener () {
                    press.isStartedOutside = false;
                }
            }
        ], // Capture, so `stopPropagation()` on the target does not stop the dismiss.
        {
            capture: true
        });
    }, [
        isOpen,
        elementRef
    ]);
}

});


parcelRegister("eEUuF", function(module, exports) {
$parcel$export(module.exports, "usePositionArea", () => $fe7c56ad68eb46d9$export$c25d226a9f6a64fa);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");
const $fe7c56ad68eb46d9$export$c25d226a9f6a64fa = (ref)=>{
    const [positionArea, setPositionArea] = (0, $fsvuC.useState)(undefined);
    (0, $fsvuC.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const readPositionArea = ()=>{
            try {
                return el.computedStyleMap().get('position-area')?.toString();
            } catch  {
                // Some old browsers do not support computedStyleMap, so fall back to getPropertyValue
                return window.getComputedStyle(el).getPropertyValue('position-area').trim();
            }
        };
        const read = ()=>{
            const positionArea = readPositionArea();
            setPositionArea(positionArea);
        };
        read();
        /**
		 * requestAnimationFrame ensures that initial renders are in a different position
		 * to the supplied prop value (e.g. the viewport is too small so the position is
		 * recalculated) are rendered correctly.
		 */ const rafId = window.requestAnimationFrame(read);
        // Check if the viewport resizes
        const unbindResize = (0, $dqdTY.bind)(window, {
            type: 'resize',
            listener: read,
            options: {
                passive: true
            }
        });
        // Check if the viewport scrolls
        const unbindScroll = (0, $dqdTY.bind)(window, {
            type: 'scroll',
            listener: read,
            options: {
                passive: true,
                capture: true
            }
        });
        return ()=>{
            window.cancelAnimationFrame(rafId);
            unbindResize();
            unbindScroll();
        };
    }, [
        ref
    ]);
    return positionArea;
};

});

parcelRegister("fKofq", function(module, exports) {
$parcel$export(module.exports, "getPlacementWithOffset", () => $bfcec560f3b578ba$export$ca1bb198c4ca0115);

var $dbKiv = parcelRequire("dbKiv");
const $bfcec560f3b578ba$var$DEFAULT_GAP = "var(--ds-space-050, 4px)";
function $bfcec560f3b578ba$var$normalizeOffsetMember({ value: value }) {
    return value ?? 0;
}
function $bfcec560f3b578ba$var$addCssLength({ base: base, delta: delta }) {
    if (delta === 0) return base;
    if (typeof base === 'number') return base + delta;
    const operator = delta > 0 ? '+' : '-';
    return `calc(${base} ${operator} ${Math.abs(delta)}px)`;
}
function $bfcec560f3b578ba$var$toSignedCrossAxisShiftValue({ crossAxisShift: crossAxisShift }) {
    const baseValue = crossAxisShift.value ?? 0;
    if (crossAxisShift.direction === 'forwards') return baseValue;
    if (typeof baseValue === 'number') return -baseValue;
    return `calc(-1 * ${baseValue})`;
}
function $bfcec560f3b578ba$var$getCrossAxisShiftWithOffset({ baseCrossAxisShift: baseCrossAxisShift, along: along }) {
    if (!baseCrossAxisShift) {
        if (along === 0) return undefined;
        return {
            value: along,
            direction: 'forwards'
        };
    }
    if (along === 0) return baseCrossAxisShift;
    // Collapse sign into the CSS length so additive composition works even
    // when the existing shift is already expressed as a `calc(...)` string.
    return {
        value: $bfcec560f3b578ba$var$addCssLength({
            base: $bfcec560f3b578ba$var$toSignedCrossAxisShiftValue({
                crossAxisShift: baseCrossAxisShift
            }),
            delta: along
        }),
        direction: 'forwards'
    };
}
function $bfcec560f3b578ba$export$ca1bb198c4ca0115({ placement: placement, offset: offset }) {
    const basePlacement = (0, $dbKiv.placementMap)[placement];
    if (!offset) return basePlacement;
    const [alongRaw, awayRaw] = offset;
    const along = $bfcec560f3b578ba$var$normalizeOffsetMember({
        value: alongRaw
    });
    const away = $bfcec560f3b578ba$var$normalizeOffsetMember({
        value: awayRaw
    });
    if (along === 0 && away === 0) return basePlacement;
    const gap = $bfcec560f3b578ba$var$addCssLength({
        base: basePlacement.offset?.gap ?? $bfcec560f3b578ba$var$DEFAULT_GAP,
        delta: away
    });
    const crossAxisShift = $bfcec560f3b578ba$var$getCrossAxisShiftWithOffset({
        baseCrossAxisShift: basePlacement.offset?.crossAxisShift,
        along: along
    });
    return {
        ...basePlacement,
        offset: {
            ...basePlacement.offset,
            gap: gap,
            ...crossAxisShift ? {
                crossAxisShift: crossAxisShift
            } : {}
        }
    };
}

});
parcelRegister("dbKiv", function(module, exports) {
$parcel$export(module.exports, "placementMap", () => $1f0d45d6567e7382$export$168f55451c1c934);
const $1f0d45d6567e7382$var$GAP = "var(--ds-space-050, 4px)";
/**
 * Cross-axis shift toward target centre on block-axis placements (CSS anchor path).
 */ const $1f0d45d6567e7382$var$INLINE_TARGET_CENTER_SHIFT = 'calc(anchor-size(width) / 2 - 28px)';
/**
 * Cross-axis shift toward target centre on inline-axis placements (CSS anchor path).
 */ const $1f0d45d6567e7382$var$BLOCK_TARGET_CENTER_SHIFT = 'calc(anchor-size(height) / 2 - 22px)';
const $1f0d45d6567e7382$export$168f55451c1c934 = {
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'end',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: $1f0d45d6567e7382$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP
        }
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'start',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: $1f0d45d6567e7382$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'forwards'
            }
        }
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'end',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: $1f0d45d6567e7382$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP
        }
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'start',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: $1f0d45d6567e7382$var$INLINE_TARGET_CENTER_SHIFT,
                direction: 'forwards'
            }
        }
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'end',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: $1f0d45d6567e7382$var$BLOCK_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'start',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: `calc(${$1f0d45d6567e7382$var$BLOCK_TARGET_CENTER_SHIFT} - 4px)`,
                direction: 'forwards'
            }
        }
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'end',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: $1f0d45d6567e7382$var$BLOCK_TARGET_CENTER_SHIFT,
                direction: 'backwards'
            }
        }
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'start',
        offset: {
            gap: $1f0d45d6567e7382$var$GAP,
            crossAxisShift: {
                value: `calc(${$1f0d45d6567e7382$var$BLOCK_TARGET_CENTER_SHIFT} - 4px)`,
                direction: 'forwards'
            }
        }
    }
};

});




parcelRegister("2LKzh", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $ca4a571221645036$export$129a32eedafa97c5);
/* popup.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $k9FWI = parcelRequire("k9FWI");

var $5xVTY = parcelRequire("5xVTY");

var $equX1 = parcelRequire("equX1");

var $c4Atc = parcelRequire("c4Atc");

var $5T6N9 = parcelRequire("5T6N9");

var $jWyYj = parcelRequire("jWyYj");

var $b5Ymx = parcelRequire("b5Ymx");

var $5OOYg = parcelRequire("5OOYg");

var $fpjto = parcelRequire("fpjto");

var $F5ohn = parcelRequire("F5ohn");

var $9DqUR = parcelRequire("9DqUR");

var $Y749c = parcelRequire("Y749c");

var $aBy9a = parcelRequire("aBy9a");

var $kwVox = parcelRequire("kwVox");
const $ca4a571221645036$var$defaultLayer = 400;
const $ca4a571221645036$var$wrapperStyles = {
    root: "_1mT5xdRAKS"
};
const $ca4a571221645036$var$PopupLegacy = (props)=>{
    const { xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus = false, zIndex: zIndex = $ca4a571221645036$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport } = props;
    const [triggerRef, setTriggerRef] = (0, $fsvuC.useState)(null);
    const getMergedTriggerRef = (0, $aBy9a.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $kwVox.useGetMemoizedMergedTriggerRefNew)();
    const generatedId = (0, $k9FWI.useId)();
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $Y749c.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const id = providedId || generatedId;
    const handleOpenLayerObserverCloseSignal = (0, $fsvuC.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $equX1.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    // `xcss` is part of Popup's public API and is forwarded as-is to
    // the internal PopperWrapper, which rebuilds the inner styles. We
    // re-bind via a property accessor on a stable object so the
    // design-system css-prop lint rule's identifier-shape check no
    // longer flags it (avoiding a ratcheted lint suppression here).
    const xcssPassthrough = {
        value: xcss
    };
    const renderPopperWrapper = /*#__PURE__*/ (0, $5chsV.jsx)((0, $5xVTY.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $F5ohn.default), {
            xcss: xcssPassthrough.value,
            appearance: appearance,
            content: content,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: PopupContainer,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: UNSAFE__disableInitialAutoFocus ? false : autoFocus,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
            shouldFitContainer: shouldFitContainer,
            shouldDisableFocusLock: shouldDisableFocusLock,
            shouldReturnFocus: shouldReturnFocus,
            triggerRef: triggerRef,
            zIndex: zIndex,
            strategy: shouldFitContainer ? 'absolute' : strategy,
            role: role,
            label: label,
            titleId: titleId,
            modifiers: modifiers,
            shouldFitViewport: shouldFitViewport
        })
    });
    const popupContent = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $jWyYj.Manager), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $b5Ymx.Reference), {
                children: ({ ref: ref })=>{
                    return trigger({
                        ref: !(0, $5T6N9.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
                        'aria-controls': isOpen ? id : undefined,
                        'aria-expanded': isOpen,
                        'aria-haspopup': role === 'dialog' && (0, $5T6N9.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
                    });
                }
            }),
            !(0, $5T6N9.fg)('platform-dst-motion-uplift-popup') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $5chsV.jsx)((0, $5OOYg.default), {
                zIndex: zIndex,
                children: renderPopperWrapper
            })),
            (0, $5T6N9.fg)('platform-dst-motion-uplift-popup') && /*#__PURE__*/ (0, $5chsV.jsx)((0, $c4Atc.default), {
                appear: true,
                children: isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ (0, $5chsV.jsx)((0, $5OOYg.default), {
                    zIndex: zIndex,
                    children: renderPopperWrapper
                }))
            })
        ]
    });
    if (shouldFitContainer) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fpjto.Box), {
        xcss: $ca4a571221645036$var$wrapperStyles.root,
        children: popupContent
    });
    return popupContent;
};
$ca4a571221645036$var$PopupLegacy.displayName = "PopupLegacy";
const $ca4a571221645036$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $fsvuC.memo)((props)=>{
    // Choose the rendering implementation at the component boundary rather than
    // gating hooks inside a single component. Each implementation owns its own
    // hooks unconditionally, so a runtime feature-flag change swaps component
    // types (a clean remount) instead of changing the hook order of a mounted
    // component.
    if ((0, $5T6N9.fg)('platform-dst-top-layer')) // Pass the original props object to preserve the discriminated union
    // (shouldFitContainer: true vs false) that is lost after destructuring.
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $9DqUR.PopupTopLayer), {
        ...props
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)($ca4a571221645036$var$PopupLegacy, {
        ...props
    });
});

});
parcelRegister("F5ohn", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd8044c9121890e0$export$2e2bcd8739ae039);
/* popper-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $1wCqK = parcelRequire("1wCqK");

var $h4ylU = parcelRequire("h4ylU");

var $35OYy = parcelRequire("35OYy");

var $5T6N9 = parcelRequire("5T6N9");

var $lzKbd = parcelRequire("lzKbd");

var $5KmTR = parcelRequire("5KmTR");

var $1cU0M = parcelRequire("1cU0M");

var $gSTTn = parcelRequire("gSTTn");
const $dd8044c9121890e0$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $dd8044c9121890e0$var$fullWidthStyles = null;
const $dd8044c9121890e0$var$wrapperStyles = {
    root: "_0bjKvD8fU6 _3iDTPbvLZJ _24h04i2Njc _42Yu6B3fRC _0KLXruoI2d _2OUyjtGk8v _1UtDYzy7kJ _45TjwHoI2d _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
    fullWidth: "_39xV02N91d",
    motion: "_0NUa3rOLYo _3iDTPbQ4SZ"
};
const $dd8044c9121890e0$var$scrollableStyles = null;
const $dd8044c9121890e0$var$blanketStyles = null;
const $dd8044c9121890e0$var$modalStyles = null;
const $dd8044c9121890e0$var$focusRingStyles = {
    root: "_1ubuxonXvL _34b3D2vc3e _1NDpvb6wH8 _2wtOC9vc3e _3e11vU6wH8 _0hSAgbHZdu"
};
const $dd8044c9121890e0$var$placementMap = {
    top: {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    bottom: {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    left: {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    right: {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight4px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
};
const $dd8044c9121890e0$var$DefaultPopupComponent = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, className: className, isReferenceHidden: _isReferenceHidden, shouldFitViewport: shouldFitViewport, ...htmlAttributes } = props;
    return /*#__PURE__*/ (0, $5chsV.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gJ6nT.default)([
            $dd8044c9121890e0$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_0Tuepk1Y8M _0NUa3rEtrx _1mT5xdy1CL _2I62gz1Y8M",
            (!shouldRenderToParent || shouldFitViewport) && "_4bt5LAIZbP _2WAcuGIZbP",
            shouldFitContainer && "_39xV02N91d",
            className
        ]),
        ...htmlAttributes,
        ref: !(0, $5T6N9.fg)('platform-dst-motion-uplift-popup') ? ref : undefined,
        children: children
    });
});
function $dd8044c9121890e0$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', popupComponent: PopupContainer = $dd8044c9121890e0$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default', zIndex: zIndex }) {
    const [popupRef, setPopupRef] = (0, $fsvuC.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $fsvuC.useState)(null); // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    const shouldDisableFocusTrap = role !== 'dialog';
    (0, $gSTTn.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $1cU0M.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    const { currentLevel: currentLevel } = (0, $1wCqK.useLayering)();
    const mergedModifiers = (0, $fsvuC.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            },
            ...modifiers || []
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $lzKbd.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport,
        children: ({ ref: ref, style: style, placement: placement, update: update, isReferenceHidden: isReferenceHidden })=>{
            const popupContainer = /*#__PURE__*/ (0, $5chsV.jsx)(PopupContainer // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            , {
                className: (0, $gJ6nT.default)([
                    xcss,
                    // @ts-expect-error: `ax` is not typed correctly
                    !initialFocusRef && (0, $5T6N9.fg)('platform-design-system-apply-popup-wrapper-focus') && $dd8044c9121890e0$var$focusRingStyles.root
                ]),
                appearance: appearance,
                id: id,
                "data-ds--level": currentLevel,
                "data-placement": placement,
                "data-testid": testId,
                role: role,
                "aria-label": label,
                "aria-labelledby": titleId,
                ref: !(0, $5T6N9.fg)('platform-dst-motion-uplift-popup') ? (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                } : undefined,
                style: (0, $5T6N9.fg)('platform-dst-motion-uplift-popup') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
                // first on the browser address bar when using keyboard
                tabIndex: autoFocus ? 0 : undefined,
                shouldRenderToParent: shouldRenderToParent,
                shouldFitContainer: shouldFitContainer,
                shouldFitViewport: shouldFitViewport,
                isReferenceHidden: isReferenceHidden,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5KmTR.RepositionOnUpdate), {
                    update: update,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $35OYy.default), {
                        children: content({
                            update: update,
                            isOpen: isOpen,
                            onClose: onClose,
                            setInitialFocusRef: setInitialFocusRef
                        })
                    })
                })
            });
            const isAutoPlacement = placement === 'auto' || placement === 'auto-start' || placement === 'auto-end';
            const container = /*#__PURE__*/ (0, $5chsV.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            , {
                style: {
                    ...style,
                    zIndex: zIndex
                },
                // first on the browser address bar when using keyboard
                ref: (node)=>{
                    if (node) {
                        if (typeof ref === 'function') ref(node);
                        else ref.current = node;
                        setPopupRef(node);
                    }
                },
                "data-testid": `${testId}--container`,
                className: (0, $gJ6nT.default)([
                    shouldFitContainer && $dd8044c9121890e0$var$wrapperStyles.fullWidth
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $h4ylU.default), {
                    enteringAnimation: !isAutoPlacement ? $dd8044c9121890e0$var$placementMap[placement].enter : undefined,
                    exitingAnimation: !isAutoPlacement ? $dd8044c9121890e0$var$placementMap[placement].exit : undefined,
                    xcss: $dd8044c9121890e0$var$wrapperStyles.motion,
                    children: popupContainer
                })
            });
            return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
                children: [
                    (0, $5T6N9.fg)('platform-dst-motion-uplift-popup') ? container : popupContainer,
                    appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                        className: (0, $gJ6nT.default)([
                            "_49OCfRdnbC _1mT5xdy1CL _0KLXruA5lS"
                        ])
                    })
                ]
            });
        }
    });
}
$dd8044c9121890e0$var$PopperWrapper.displayName = "PopperWrapper";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$dd8044c9121890e0$export$2e2bcd8739ae039 = $dd8044c9121890e0$var$PopperWrapper;

});
parcelRegister("5KmTR", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", () => $e11da18b18460ba6$export$51eddd7655ca235a);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
const $e11da18b18460ba6$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $fsvuC.useRef)(true);
    (0, $fsvuC.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update.
        // Guard against `update` being undefined: on Safari the Popper instance may
        // not be fully initialised when this layout effect fires, in which case the
        // render-prop `update` is undefined and calling it throws
        // `TypeError: e.update is not a function`.
        if (typeof update === 'function') update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Fragment), {
        children: children
    });
};
$e11da18b18460ba6$export$51eddd7655ca235a.displayName = "RepositionOnUpdate";

});

parcelRegister("1cU0M", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", () => $6f3acc7de4dd2e1f$export$92dae2778ae88f9d);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $iqo7S = parcelRequire("iqo7S");

var $1wCqK = parcelRequire("1wCqK");

var $5T6N9 = parcelRequire("5T6N9");

var $41wRV = parcelRequire("41wRV");

var $dzYm2 = parcelRequire("dzYm2");
const $6f3acc7de4dd2e1f$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $1wCqK.useLayering)();
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $dzYm2.useAnimationFrame)();
    const mouseDownTarget = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $iqo7S.default;
        const closePopup = (event)=>{
            if (shouldIgnoreCloseEvent?.(event)) return;
            if (onClose) {
                let currentLevel = null;
                if (event.target instanceof HTMLElement) currentLevel = event.target.closest(`[data-ds--level]`)?.getAttribute('data-ds--level') ?? null;
                currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $5T6N9.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(()=>{
                triggerRef?.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if (target instanceof HTMLElement) {
                const layeredElement = target.closest?.(`[data-ds--level]`);
                if (layeredElement) {
                    const closeType = layeredElement.getAttribute('data-ds--close--type');
                    if (closeType === 'single' && isLayerDisabled()) // if the close type is single, we won't close other disabled layers when clicking outside
                    return;
                    const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                    if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // Don't close this popup when the click landed inside a higher-level layer
                    // (e.g. a Drawer or Modal that portals to <body>). Such nodes are not DOM
                    // descendants of popupRef, so the contains() checks below would wrongly
                    // classify them as "outside" clicks and close the popup prematurely.
                    return;
                }
            }
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            const didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $41wRV.isInteractiveElement)(document.activeElement) && (0, $5T6N9.fg)('platform_dst_popup-disable-focuslock')) triggerRef?.focus();
            }
        };
        const onMouseDown = (event)=>{
            /**
			 * Tracking the target of the mouse down event.
			 * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
			 * moves the mouse outside the popup before releasing the mouse button.
			 *
			 * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
			 * so they try to cancel their click by moving their mouse away from what they had moused down on.
			 *
			 * Blanket uses the same technique.
			 */ mouseDownTarget.current = event.target;
        };
        const onKeyDown = (event)=>{
            const key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $5T6N9.fg)('platform_dst_nested_escape')) {
                const eventTarget = event.target instanceof HTMLElement ? event.target : null;
                const layeredAncestor = eventTarget?.closest?.('[data-ds--level]');
                const levelStr = layeredAncestor?.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $5T6N9.fg)('platform_dst_popup-disable-focuslock')) {
                const { shiftKey: shiftKey } = event;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(()=>{
                        const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef?.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && document.activeElement?.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(()=>{
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        let unbind = (0, $iqo7S.default);
        if ((0, $5T6N9.fg)('popup-onclose-fix')) setTimeout(()=>{
            unbind = (0, $dqdTY.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $dqdTY.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $iqo7S.default);
        unbindBlur = (0, $dqdTY.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return ()=>{
            if ((0, $5T6N9.fg)('popup-onclose-fix')) setTimeout(()=>{
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        shouldIgnoreCloseEvent,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("41wRV", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $0d4628998d08f689$export$3dee5e4542c672d9);
const $0d4628998d08f689$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
const $0d4628998d08f689$export$3dee5e4542c672d9 = (element)=>{
    if ($0d4628998d08f689$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("dzYm2", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", () => $94a21d8f76f4eba8$export$641fa9c94086b46e);

var $fsvuC = parcelRequire("fsvuC");
const $94a21d8f76f4eba8$export$641fa9c94086b46e = ()=>{
    const animationsRef = (0, $fsvuC.useRef)([]);
    const requestFrame = (0, $fsvuC.useCallback)((callback)=>{
        const id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    const cancelFrame = (0, $fsvuC.useCallback)((id)=>{
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
    }, []);
    const cancelAllFrames = (0, $fsvuC.useCallback)(()=>{
        animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("gSTTn", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", () => $9ef6182dc77e4162$export$10c5169755ce7bd7);

var $fsvuC = parcelRequire("fsvuC");

var $1mzzO = parcelRequire("1mzzO");

var $iqo7S = parcelRequire("iqo7S");

var $1wCqK = parcelRequire("1wCqK");

var $5T6N9 = parcelRequire("5T6N9");

var $dzYm2 = parcelRequire("dzYm2");
const $9ef6182dc77e4162$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $dzYm2.useAnimationFrame)();
    const { currentLevel: currentLevel } = (0, $1wCqK.useLayering)();
    (0, $fsvuC.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $iqo7S.default;
        if (shouldDisableFocusTrap && (0, $5T6N9.fg)('platform_dst_popup-disable-focuslock')) {
            const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(()=>{
                    triggerRef?.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $iqo7S.default;
            }
        }
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $5T6N9.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($1mzzO)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(()=>{
            focusTrap.activate();
        });
        return ()=>{
            cancelAllFrames();
            focusTrap.deactivate();
            if (((0, $5T6N9.fg)('platform-dst-popup-trigger-focus-fix') || (0, $5T6N9.fg)('platform_dst-popup-trigger-initial-focus-ref')) && shouldReturnFocus) requestFrame(()=>{
                if (triggerRef?.isConnected && (document.activeElement === document.body || document.activeElement === document.documentElement || !document.activeElement)) triggerRef.focus();
            });
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});


parcelRegister("9DqUR", function(module, exports) {
$parcel$export(module.exports, "PopupTopLayer", () => $f9312f0ffd56784e$export$e24b8cb659609dee);
/* popup-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $iqo7S = parcelRequire("iqo7S");

var $35OYy = parcelRequire("35OYy");

var $bkfvF = parcelRequire("bkfvF");

var $iR2qO = parcelRequire("iR2qO");

var $lscZ9 = parcelRequire("lscZ9");

var $l1dgd = parcelRequire("l1dgd");

var $6AVCN = parcelRequire("6AVCN");

var $7DQ7q = parcelRequire("7DQ7q");

var $k8DTj = parcelRequire("k8DTj");

var $74Lna = parcelRequire("74Lna");

var $2ooOj = parcelRequire("2ooOj");

var $bAlda = parcelRequire("bAlda");

var $3SV54 = parcelRequire("3SV54");
// Top-layer positioning is handled by CSS Anchor Positioning, not inline styles.
const $f9312f0ffd56784e$var$EMPTY_STYLE = {};
/**
 * `Popover` props for `mode`. A manual popover gets `onClose` only when the consumer gave one, so
 * without it `requestClosePopovers()` cannot close the popup.
 */ function $f9312f0ffd56784e$var$getModeProps({ isManual: isManual, hasOnClose: hasOnClose, handleOnClose: handleOnClose }) {
    if (!isManual) return {
        mode: 'auto',
        onClose: handleOnClose
    };
    if (!hasOnClose) return {
        mode: 'manual'
    };
    return {
        mode: 'manual',
        onClose: handleOnClose
    };
}
const $f9312f0ffd56784e$export$e24b8cb659609dee = /*#__PURE__*/ (0, $fsvuC.memo)(function PopupTopLayer({ xcss: xcss, isOpen: isOpen, id: providedId, offset: offsetProp, testId: testId, UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus, trigger: trigger, content: content, onClose: providedOnClose, mode: mode = 'auto', placement: placement = 'auto', fallbackPlacements: _fallbackPlacements, shouldFlip: _shouldFlip = true, popupComponent: PopupContainer, // top-layer: initial focus follows `role`. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
autoFocus: _autoFocus = true, shouldFitContainer: shouldFitContainer = false, // top-layer: focus restoration is handled natively by the Popover API. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldReturnFocus: _shouldReturnFocus = true, role: role, label: label, titleId: titleId, // No-op props.
// These props are accepted for API compatibility but have no effect
// in the top-layer path. Each is documented with why it is unnecessary.
// top-layer: stacking managed by browser top layer. zIndex is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
zIndex: _zIndex, // top-layer: always renders in top layer. shouldRenderToParent is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldRenderToParent: _shouldRenderToParent, // top-layer: CSS Anchor Positioning replaces Popper strategy. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
strategy: _strategy, // top-layer: Popper.js modifiers not applicable. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
modifiers: _modifiers, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
boundary: _boundary, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
rootBoundary: _rootBoundary, // top-layer: native light dismiss replaces capture-phase click handler.
// Could add mousedown drag guard later if needed.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldUseCaptureOnOutsideClick: _shouldUseCaptureOnOutsideClick, // top-layer: focus trapping is role-based. shouldDisableFocusLock is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldDisableFocusLock: _shouldDisableFocusLock, shouldFitViewport: // top-layer: maps onto `'max-available'`, capping the popup to the space
// between the trigger and the viewport edge. `PopoverSurface` already owns
// `overflow: auto`, so the capped surface scrolls.
//
// Keep the explicit `false`: `undefined` previously reached an
// `isEnabled = true` default and silently enabled fitting for every popup
// that omitted the prop.
shouldFitViewport = false, // top-layer: appearance is accepted but UNSAFE_modal-below-sm is not yet implemented.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
appearance: _appearance }) {
    const onClose = providedOnClose ?? (0, $iqo7S.default);
    const triggerRef = (0, $fsvuC.useRef)(null);
    const popoverRef = (0, $fsvuC.useRef)(null);
    /**
   * Consumer-chosen initial focus target.
   *
   * The legacy `Popup` surfaced `setInitialFocusRef` on the content
   * render prop with a `Dispatch<SetStateAction<HTMLElement | null>>`
   * signature so it could be passed as a React `ref` callback. We
   * keep the same shape for API compatibility, but store the value in
   * a ref. `Popover` reads it as `initialFocusRef` when it opens. For a
   * role that moves focus, a target inside the popup takes focus instead
   * of the role default, and focus moves once. Other roles ignore it. `autoFocus` has no effect here: role and focus go
   * together. See `@atlaskit/top-layer` `notes/decisions/role-and-focus.md`.
   */ const consumerInitialFocusRef = (0, $fsvuC.useRef)(null);
    const setInitialFocusRef = (0, $fsvuC.useCallback)((value)=>{
        consumerInitialFocusRef.current = typeof value === 'function' ? value(consumerInitialFocusRef.current) : value;
    }, []);
    const popoverId = (0, $74Lna.usePopoverId)();
    // Placement conversion.
    // Legacy `offset` is the popper `[along, away]` tuple; `fromLegacyPlacement`
    // folds it into the new `placement.offset` shape so it travels with placement.
    const topLayerPlacement = (0, $fsvuC.useMemo)(()=>(0, $iR2qO.fromLegacyPlacement)({
            legacy: placement,
            offset: offsetProp
        }), [
        placement,
        offsetProp
    ]);
    (0, $7DQ7q.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen,
        ...(0, $2ooOj.getPopupAxisSizes)({
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport
        })
    });
    // onClose bridge.
    // Translates top-layer's { reason: TPopoverCloseReason } into legacy
    // onClose(event, currentLevel?) by synthesizing DOM events.
    //
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    // No manual triggerRef.current?.focus() is needed.
    const handleOnClose = (0, $fsvuC.useCallback)(({ reason: reason })=>{
        onClose((0, $l1dgd.createPopoverCloseEvent)({
            reason: reason
        }));
    }, [
        onClose
    ]);
    /**
   * Manual mode: the browser never light-dismisses the popover, so a press on the trigger does not
   * close it. With `onClose`, an outside press or Escape calls it, as on an auto popup. The trigger
   * is exempt.
   */ const isManual = mode === 'manual';
    const triggerRefs = (0, $fsvuC.useMemo)(()=>[
            triggerRef
        ], []);
    const handleManualLightDismiss = (0, $fsvuC.useCallback)(({ reason: reason })=>{
        if (reason !== 'light-dismiss') {
            handleOnClose({
                reason: reason
            });
            return;
        }
        // Native light dismiss does not restore focus, but the consumer's programmatic close does
        // when focus is inside the popover. The press usually moved focus out already. If not (for
        // example an outside `mousedown` called `preventDefault()`), blur first, as an auto light
        // dismiss would.
        const popover = popoverRef.current;
        const activeElement = popover?.ownerDocument.activeElement;
        if (activeElement instanceof HTMLElement && popover?.contains(activeElement)) activeElement.blur();
        handleOnClose({
            reason: reason
        });
    }, [
        handleOnClose
    ]);
    (0, $k8DTj.useManualLightDismiss)({
        isOpen: isOpen && isManual && Boolean(providedOnClose),
        popoverRef: popoverRef,
        additionalInsideElementRefs: triggerRefs,
        onClose: handleManualLightDismiss
    });
    // Content render-prop bridge.
    // Legacy content() receives { isOpen, update, setInitialFocusRef, onClose }.
    // update is a no-op because CSS Anchor Positioning self-updates.
    // The args always hold the setter; the `TPopup` types decide who can see it.
    const contentProps = (0, $fsvuC.useMemo)(()=>({
            isOpen: isOpen,
            update: (0, $iqo7S.default),
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        }), [
        isOpen,
        onClose,
        setInitialFocusRef
    ]);
    // Role mapping.
    // Build the role/label props for Popover.
    // Roles requiring accessible names must have label or labelledBy.
    const roleProps = (0, $3SV54.useRoleProps)({
        role: role,
        label: label,
        titleId: titleId,
        initialFocusRef: consumerInitialFocusRef
    });
    const resolvedPopoverId = providedId ?? popoverId;
    const ariaAttributes = (0, $bkfvF.getAriaForTrigger)({
        role: (0, $bAlda.getTriggerRole)({
            role: roleProps.role
        }),
        isOpen: isOpen,
        popoverId: resolvedPopoverId
    });
    // Narrow to ForwardRefExoticComponent so JSX accepts the ref prop.
    // All popupComponent implementations use forwardRef per the PopupComponentProps contract.
    const Container = PopupContainer;
    // Map to legacy TriggerProps.
    const triggerProps = {
        ref: (node)=>{
            triggerRef.current = node;
        },
        'aria-controls': ariaAttributes['aria-controls'],
        // `aria-expanded` reflects current open state.
        'aria-expanded': ariaAttributes['aria-expanded'],
        'aria-haspopup': ariaAttributes['aria-haspopup']
    };
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            trigger(triggerProps),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $6AVCN.Popover), {
                ref: popoverRef,
                id: resolvedPopoverId,
                ...roleProps,
                UNSAFE__disableInitialAutoFocus: UNSAFE__disableInitialAutoFocus,
                isOpen: isOpen,
                ...$f9312f0ffd56784e$var$getModeProps({
                    isManual: isManual,
                    hasOnClose: Boolean(providedOnClose),
                    handleOnClose: handleOnClose
                }),
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--container`,
                children: Container ? /*#__PURE__*/ (0, $5chsV.jsx)(Container, {
                    style: $f9312f0ffd56784e$var$EMPTY_STYLE,
                    id: providedId,
                    "data-placement": placement,
                    "data-testid": testId,
                    tabIndex: -1,
                    xcss: xcss,
                    // Forwarded because several in-tree containers key their own
                    // `overflow: auto` branch off it.
                    shouldFitViewport: shouldFitViewport,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $35OYy.default), {
                        children: content(contentProps)
                    })
                }) : // `PopoverSurface` owns `overflow: auto` and the `box-shadow` on the
                // same element, so it is the scroll container. The wrapper exists only
                // to carry the consumer's `xcss`: `PopoverSurface` exposes no
                // `className` or `xcss` by design, so `xcss` lands on a CHILD of the
                // surface. `width` works there; surface-level declarations apply one
                // level in. Same shape as `compositional/popup-content-top-layer.tsx`.
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $lscZ9.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: xcss,
                        "data-testid": testId,
                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $35OYy.default), {
                            children: content(contentProps)
                        })
                    })
                })
            })
        ]
    });
});

});
parcelRegister("lscZ9", function(module, exports) {
$parcel$export(module.exports, "PopoverSurface", () => $fab1437d357a1fbd$export$8b7437164e479115);
/* popover-surface.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $fab1437d357a1fbd$var$styles = {
    root: "_0bjKvD8fU6 _4bt5LAIZbP _2WAcuGIZbP _0KLXruoI2d _1UtDYzy7kJ _2OUyjtGk8v"
};
function $fab1437d357a1fbd$export$8b7437164e479115({ children: children }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            $fab1437d357a1fbd$var$styles.root
        ]),
        children: children
    });
}
$fab1437d357a1fbd$export$8b7437164e479115.displayName = "PopoverSurface";

});

parcelRegister("2ooOj", function(module, exports) {
$parcel$export(module.exports, "getPopupAxisSizes", () => $a20cb4db17f157eb$export$60eb6c71554f82c4);
function $a20cb4db17f157eb$export$60eb6c71554f82c4({ shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport }) {
    const blockSize = shouldFitViewport ? 'max-available' : 'content';
    if (shouldFitContainer) return {
        inlineSize: 'match-anchor',
        blockSize: blockSize
    };
    if (shouldFitViewport) return {
        inlineSize: 'max-available',
        blockSize: blockSize
    };
    return {
        inlineSize: 'content',
        blockSize: blockSize
    };
}

});

parcelRegister("bAlda", function(module, exports) {
$parcel$export(module.exports, "getTriggerRole", () => $23b74e1b91ac4423$export$7647c858fbf2aa3);
/**
 * Narrows a popup `role` to one that `getAriaForTrigger` accepts.
 *
 * Tooltip-family roles and no role give `undefined`, so the trigger gets no `aria-haspopup`.
 */ function $23b74e1b91ac4423$export$7647c858fbf2aa3({ role: role }) {
    if (role === 'dialog' || role === 'alertdialog' || role === 'menu' || role === 'listbox' || role === 'tree' || role === 'grid') return role;
    return undefined;
}

});

parcelRegister("3SV54", function(module, exports) {
$parcel$export(module.exports, "useRoleProps", () => $34d109f09bb0ee71$export$892580369e97d8b9);

var $fsvuC = parcelRequire("fsvuC");
function $34d109f09bb0ee71$export$892580369e97d8b9({ role: role, label: label, titleId: titleId, initialFocusRef: initialFocusRef }) {
    return (0, $fsvuC.useMemo)(()=>{
        if (role === 'dialog' || role === 'alertdialog' || role === 'menu') {
            if (titleId) return {
                role: role,
                labelledBy: titleId,
                initialFocusRef: initialFocusRef
            };
            return {
                role: role,
                label: label ?? 'Popup',
                initialFocusRef: initialFocusRef
            };
        }
        if (role === 'listbox') return {
            role: role,
            label: label,
            initialFocusRef: initialFocusRef
        };
        if (role) return {
            role: role,
            label: label
        };
        // No role supplied: preserve the legacy "no popup semantics" contract.
        return {
            role: undefined,
            label: label
        };
    }, [
        role,
        label,
        titleId,
        initialFocusRef
    ]);
}

});


parcelRegister("Y749c", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", () => $e2e698b74476a1b8$export$4065aef1d79a5730);

var $fsvuC = parcelRequire("fsvuC");

var $aIMFz = parcelRequire("aIMFz");
function $e2e698b74476a1b8$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
    const canBecomeModal = _appearance === 'UNSAFE_modal-below-sm';
    /**
	 * Only subscribe to the below-sm boundary when the popup can become a modal,
	 * to avoid unnecessary state changes for every other popup
	 */ const mq = (0, $aIMFz.UNSAFE_useMediaQuery)('below.sm', canBecomeModal ? (e)=>{
        setIsSmallViewport(!!e.matches);
    } : undefined);
    const [isSmallViewport, setIsSmallViewport] = (0, $fsvuC.useState)(!!mq?.matches);
    const appearance = canBecomeModal && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("aIMFz", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $ba9958d5185b858b$export$49e55ae2c03d6045);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $66Fsw = parcelRequire("66Fsw");
const $ba9958d5185b858b$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $66Fsw.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $66Fsw.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $66Fsw.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $66Fsw.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $66Fsw.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $66Fsw.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $66Fsw.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $66Fsw.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $66Fsw.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $66Fsw.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $66Fsw.media).below.xl.replace('@media ', '').trim())
};
const $ba9958d5185b858b$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $fsvuC.useRef)(listener);
    (0, $fsvuC.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $ba9958d5185b858b$var$queries[queryString];
    (0, $fsvuC.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $dqdTY.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};
$ba9958d5185b858b$export$49e55ae2c03d6045.displayName = "UNSAFE_useMediaQuery";

});
parcelRegister("66Fsw", function(module, exports) {
$parcel$export(module.exports, "media", () => $6e21d4e32b3e63d3$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $6e21d4e32b3e63d3$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("aBy9a", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $7fab7fd313da72fd$export$7cc5c058dd769dff);

var $fsvuC = parcelRequire("fsvuC");

var $kZVJU = parcelRequire("kZVJU");
const $7fab7fd313da72fd$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $fsvuC.useState)(()=>(0, $kZVJU.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("kwVox", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $7d08c6f11419f733$export$5d3a2de79e07b376);

var $fsvuC = parcelRequire("fsvuC");

var $kZVJU = parcelRequire("kZVJU");
const $7d08c6f11419f733$export$5d3a2de79e07b376 = ()=>{
    const [getMemoizedMergedTriggerRefNew] = (0, $fsvuC.useState)(()=>(0, $kZVJU.default)((ref, setTriggerRef)=>{
            return (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRefNew;
};

});


parcelRegister("2f702", function(module, exports) {
$parcel$export(module.exports, "default", () => $a44793a59bd7074f$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $ch70k = parcelRequire("ch70k");

var $biw1y = parcelRequire("biw1y");
/**
 * __Spotlight__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $a44793a59bd7074f$var$Spotlight = ({ actions: actions, actionsBeforeElement: actionsBeforeElement, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth = 400, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label, pulse: pulse = true, scrollPositionBlock: scrollPositionBlock, shouldWatchTarget: shouldWatchTarget = false, target: target, targetBgColor: targetBgColor, targetNode: targetNode, targetOnClick: targetOnClick, targetRadius: targetRadius, targetReplacement: targetReplacement, testId: testId = 'spotlight', titleId: titleId, ...rest })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $biw1y.SpotlightConsumer), {
        children: ({ opened: opened, closed: closed, targets: targets })=>{
            // use the targetNode prop or try get the target from context targets using name
            const actualTargetNode = targetNode || (typeof target === 'string' ? targets[target] : undefined);
            return actualTargetNode ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $ch70k.default), {
                ...rest,
                actions: actions,
                actionsBeforeElement: actionsBeforeElement,
                children: children,
                dialogPlacement: dialogPlacement,
                dialogWidth: dialogWidth,
                footer: footer,
                header: header,
                heading: heading,
                headingAfterElement: headingAfterElement,
                image: image,
                label: label,
                onClosed: closed,
                onOpened: opened,
                pulse: pulse,
                scrollPositionBlock: scrollPositionBlock,
                shouldWatchTarget: shouldWatchTarget,
                target: target,
                targetBgColor: targetBgColor,
                targetNode: actualTargetNode,
                targetOnClick: targetOnClick,
                targetRadius: targetRadius,
                targetReplacement: targetReplacement,
                testId: testId,
                titleId: titleId
            }) : null;
        }
    });
$a44793a59bd7074f$var$Spotlight.displayName = "Spotlight";
var $a44793a59bd7074f$export$2e2bcd8739ae039 = $a44793a59bd7074f$var$Spotlight;

});
parcelRegister("ch70k", function(module, exports) {
$parcel$export(module.exports, "default", () => $345e4c4e01040ede$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $lpPPJ = parcelRequire("lpPPJ");

var $121xR = parcelRequire("121xR");

var $cv14p = parcelRequire("cv14p");

var $5xVTY = parcelRequire("5xVTY");

var $c4Atc = parcelRequire("c4Atc");

var $7IVZh = parcelRequire("7IVZh");

var $5T6N9 = parcelRequire("5T6N9");

var $5OOYg = parcelRequire("5OOYg");

var $j9yMZ = parcelRequire("j9yMZ");

var $lGoBX = parcelRequire("lGoBX");

var $gHg8f = parcelRequire("gHg8f");

var $eOnrR = parcelRequire("eOnrR");

var $d4Odt = parcelRequire("d4Odt");
/**
 * Gives the spotlight dialog a layer level for legacy layered components.
 * On the top-layer path no legacy layered components are rendered, so the
 * children render directly.
 */ function $345e4c4e01040ede$var$SpotlightLayering({ children: children }) {
    if ((0, $5T6N9.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5xVTY.Layering), {
        isDisabled: false,
        children: children
    });
}
$345e4c4e01040ede$var$SpotlightLayering.displayName = "SpotlightLayering";
/**
 * __Spotlight inner__
 *
 * Renders the spotlight target clone and dialog.
 *
 * @internal
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $345e4c4e01040ede$var$SpotlightInner extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
    static{
        this.defaultProps = {
            dialogWidth: 400,
            pulse: true
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.targetNode !== this.props.targetNode) (0, $cv14p.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
    }
    componentDidMount() {
        (0, $cv14p.default)(this.props.targetNode, {
            scrollMode: 'if-needed',
            block: this.props.scrollPositionBlock
        });
        this.props.onOpened();
    }
    componentWillUnmount() {
        this.props.onClosed();
    }
    render() {
        const { pulse: pulse, shouldWatchTarget: shouldWatchTarget, target: target, targetNode: targetNode, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetRadius: targetRadius, testId: testId, targetReplacement: TargetReplacement } = this.props;
        const { replacementElement: replacementElement } = this.state;
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $d4Odt.SpotlightTransitionConsumer), {
            children: ({ isOpen: isOpen, onExited: onExited })=>/*#__PURE__*/ (0, $5chsV.jsxs)((0, $5OOYg.default), {
                    zIndex: 701,
                    children: [
                        TargetReplacement ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $gHg8f.default), {
                            hasNodeResolver: !(0, $5T6N9.fg)('platform_design_system_team_onboarding_noderesolve'),
                            innerRef: (elem)=>this.setState({
                                    replacementElement: elem
                                }),
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $j9yMZ.ElementBox), {
                                element: targetNode,
                                resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                                children: (box)=>/*#__PURE__*/ (0, $5chsV.jsx)(TargetReplacement, {
                                        "data-testid": `${testId}--target`,
                                        ...this.getTargetNodeStyle(box)
                                    })
                            })
                        }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $j9yMZ.ElementBox), {
                            element: targetNode,
                            resizeUpdateMethod: shouldWatchTarget ? 'polling' : undefined,
                            children: (box)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $lGoBX.default), {
                                    shouldWatch: shouldWatchTarget,
                                    testId: `${testId}--target`,
                                    pulse: pulse,
                                    target: target,
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                    style: this.getTargetNodeStyle(box),
                                    targetBgColor: targetBgColor,
                                    targetNode: targetNode,
                                    targetOnClick: targetOnClick,
                                    targetRadius: targetRadius
                                })
                        }),
                        TargetReplacement && !replacementElement ? null : /*#__PURE__*/ (0, $5chsV.jsx)($345e4c4e01040ede$var$SpotlightLayering, {
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $c4Atc.default), {
                                appear: true,
                                children: isOpen && /*#__PURE__*/ (0, $5chsV.jsx)((0, $7IVZh.default), {
                                    onFinish: (state)=>{
                                        state === 'exiting' && onExited();
                                    },
                                    duration: "medium",
                                    children: ({ ref: ref, className: className, style: style })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
                                            ref: ref,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                                            className: className,
                                            style: style,
                                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $eOnrR.default), {
                                                testId: `${testId}--dialog`,
                                                actions: this.props.actions,
                                                actionsBeforeElement: this.props.actionsBeforeElement,
                                                children: this.props.children,
                                                dialogPlacement: this.props.dialogPlacement,
                                                dialogWidth: this.props.dialogWidth,
                                                footer: this.props.footer,
                                                header: this.props.header,
                                                heading: this.props.heading,
                                                titleId: this.props.titleId,
                                                label: this.props.label,
                                                headingAfterElement: this.props.headingAfterElement,
                                                image: this.props.image,
                                                targetNode: replacementElement || targetNode
                                            })
                                        })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($121xR))), {})
                    ]
                })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            // This is only used when targetReplacement is specified.
            // In this case, we have to render the targetReplacement component,
            // get a dom reference from that component, then render again passing
            // that reference into SpotlightDialog (Popper).
            replacementElement: null
        }, this.getTargetNodeStyle = (box)=>{
            if (!(0, $lpPPJ.canUseDOM)) return {};
            const { height: height, left: left, top: top, width: width, ...rest } = box;
            return {
                // Handling this just in case there are invalid elements being sent in to
                // the `box` arg
                ...rest,
                height: height,
                left: left,
                top: top,
                width: width,
                position: 'fixed',
                // when width is 0, set visibility hidden to avoid the target flashing issue
                ...width === 0 && {
                    visibility: 'hidden'
                }
            };
        };
    }
}
$345e4c4e01040ede$var$SpotlightInner.displayName = "SpotlightInner";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$345e4c4e01040ede$export$2e2bcd8739ae039 = $345e4c4e01040ede$var$SpotlightInner;

});
parcelRegister("j9yMZ", function(module, exports) {
$parcel$export(module.exports, "ElementBox", () => $2f0e093cf9ca586d$export$1b6719bd7aff3c00);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $iqo7S = parcelRequire("iqo7S");
// The minimum interval between position updates in milliseconds
const $2f0e093cf9ca586d$var$POSITION_UPDATE_INTERVAL = 200;
const $2f0e093cf9ca586d$var$getElementRect = (element)=>{
    const { height: height, left: left, top: top, width: width } = element.getBoundingClientRect();
    return {
        height: height,
        left: left,
        top: top,
        width: width
    };
};
const $2f0e093cf9ca586d$var$useResizeAwareElementBox = (element, updateMethod)=>{
    const [box, setBox] = (0, $fsvuC.useState)({
        width: 0,
        height: 0,
        left: 0,
        top: 0
    });
    (0, $fsvuC.useLayoutEffect)(()=>{
        if (updateMethod === 'resizeListener') // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
        // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
        setTimeout(()=>{
            setBox($2f0e093cf9ca586d$var$getElementRect(element));
        }, 0);
    }, [
        element,
        updateMethod
    ]);
    (0, $fsvuC.useEffect)(()=>{
        const onResize = ()=>{
            requestAnimationFrame(()=>{
                setBox($2f0e093cf9ca586d$var$getElementRect(element));
            });
        };
        if (updateMethod === 'resizeListener') return (0, $dqdTY.bind)(window, {
            type: 'resize',
            listener: onResize
        });
        return 0, $iqo7S.default;
    }, [
        element,
        updateMethod
    ]);
    return box;
};
const $2f0e093cf9ca586d$var$usePollingElementBox = (element, updateMethod)=>{
    // These are intentionally tracked as number primitives rather than as a shared `box` object.
    // Since the requestAnimationFrame code below updates this often, we want to avoid re-renders
    // when the values are the same.  React uses `Object.is` to figure out if the state changed after a setState.
    // If we represent this as a shared `box` object, this will re-render even if the two objects have identical contents.
    const [width, setWidth] = (0, $fsvuC.useState)(0);
    const [height, setHeight] = (0, $fsvuC.useState)(0);
    const [left, setLeft] = (0, $fsvuC.useState)(0);
    const [top, setTop] = (0, $fsvuC.useState)(0);
    (0, $fsvuC.useLayoutEffect)(()=>{
        if (updateMethod === 'polling') // use setTimeout 0 to defer the state update to avoid content shifting when pages have scrollbars
        // more details are https://www.loom.com/share/96a5d7c2afd74146a3c005bf20a8c69e?sid=968b00c1-e5ab-4ea0-9fe4-e534fe7088e4
        setTimeout(()=>{
            const newBox = $2f0e093cf9ca586d$var$getElementRect(element);
            setWidth(newBox.width);
            setHeight(newBox.height);
            setLeft(newBox.left);
            setTop(newBox.top);
        }, 0);
    }, [
        element,
        updateMethod
    ]);
    // Souce: https://css-tricks.com/using-requestanimationframe-with-react-hooks/
    // Use useRef for mutable variables that we want to persist
    // without triggering a re-render on their change
    const requestRef = (0, $fsvuC.useRef)();
    const previousUpdateTimeRef = (0, $fsvuC.useRef)();
    const animate = (0, $fsvuC.useCallback)((time)=>{
        if (previousUpdateTimeRef.current !== undefined) {
            const timeSinceLastUpdate = time - previousUpdateTimeRef.current;
            if (timeSinceLastUpdate > $2f0e093cf9ca586d$var$POSITION_UPDATE_INTERVAL) {
                const newBox = $2f0e093cf9ca586d$var$getElementRect(element);
                setWidth(newBox.width);
                setHeight(newBox.height);
                setLeft(newBox.left);
                setTop(newBox.top);
                previousUpdateTimeRef.current = time;
            }
        } else // Initialize previousUpdateTimeRef
        previousUpdateTimeRef.current = time;
        requestRef.current = requestAnimationFrame(animate);
    }, [
        element
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (updateMethod === 'polling') requestRef.current = requestAnimationFrame(animate);
        return ()=>{
            if (requestRef.current !== undefined) cancelAnimationFrame(requestRef.current);
        };
    // This useEffect should only run on mount and when `element` or `updateMethod` changes.
    }, [
        animate,
        element,
        updateMethod
    ]);
    const box = (0, $fsvuC.useMemo)(()=>({
            width: width,
            height: height,
            left: left,
            top: top
        }), [
        width,
        height,
        left,
        top
    ]);
    return box;
};
/**
 * Will listen to the document resizing to see if an element has moved positions.
 * Not using ResizeObserver because of IE11 support.
 * @param element HTMLElement to watch when resizing.
 */ const $2f0e093cf9ca586d$var$useElementBox = (element, resizeUpdateMethod)=>{
    const updateMethod = resizeUpdateMethod || 'resizeListener';
    const boxViaResizeListener = $2f0e093cf9ca586d$var$useResizeAwareElementBox(element, updateMethod);
    const boxViaPolling = $2f0e093cf9ca586d$var$usePollingElementBox(element, updateMethod);
    return updateMethod === 'resizeListener' ? boxViaResizeListener : boxViaPolling;
};
const $2f0e093cf9ca586d$export$1b6719bd7aff3c00 = (props)=>{
    const box = $2f0e093cf9ca586d$var$useElementBox(props.element, props.resizeUpdateMethod);
    return props.children(box);
};
$2f0e093cf9ca586d$export$1b6719bd7aff3c00.displayName = "ElementBox";

});

parcelRegister("lGoBX", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b69b17702e709e7$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $c1NAE = parcelRequire("c1NAE");

var $hblw3 = parcelRequire("hblw3");
const $9b69b17702e709e7$var$computedStyleAttributesToClone = [
    'fontSize',
    'fontWeight',
    'lineHeight',
    'padding',
    'color',
    'textOverflow'
];
function $9b69b17702e709e7$var$cloneAndOverrideStyles(node) {
    const shouldCloneChildren = true;
    const clonedNode = node.cloneNode(shouldCloneChildren);
    const computedStyles = getComputedStyle(node);
    $9b69b17702e709e7$var$computedStyleAttributesToClone.forEach((attribute)=>{
        clonedNode.style[attribute] = computedStyles[attribute];
    });
    clonedNode.style.margin = '0';
    clonedNode.style.position = 'static';
    // The target may have other transforms applied. Avoid unintended side effects
    // by zeroing out "translate" rather than applying a value of "none".
    clonedNode.style.transform = 'translate(0, 0) translate3d(0, 0, 0)';
    return clonedNode;
}
/**
 * __Clone__
 *
 * Used for cloning spotlight targets. The clone is positioned on top of the spotlight target with
 * a pulsing animation.
 *
 * @internal
 */ const $9b69b17702e709e7$var$Clone = (props)=>{
    const { pulse: pulse, style: style, shouldWatch: shouldWatch, target: target, targetBgColor: targetBgColor, targetOnClick: targetOnClick, targetNode: targetNode, targetRadius: targetRadius, testId: testId } = props;
    const contentVersion = (0, $hblw3.useElementObserver)(targetNode, {
        disableWatch: !shouldWatch
    });
    const contentHTML = (0, $fsvuC.useMemo)(()=>$9b69b17702e709e7$var$cloneAndOverrideStyles(targetNode).outerHTML, // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to update when the content changes
    [
        contentVersion,
        targetNode
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $c1NAE.TargetInner), {
        "data-testid": testId,
        pulse: pulse,
        bgColor: targetBgColor,
        radius: targetRadius,
        style: style,
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: contentHTML
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    height: '100%',
                    pointerEvents: 'none'
                }
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $c1NAE.TargetOverlay), {
                onClick: targetOnClick ? (event)=>targetOnClick({
                        event: event,
                        target: target
                    }) : undefined
            })
        ]
    });
};
$9b69b17702e709e7$var$Clone.displayName = "Clone";
var $9b69b17702e709e7$export$2e2bcd8739ae039 = $9b69b17702e709e7$var$Clone;

});
parcelRegister("c1NAE", function(module, exports) {
$parcel$export(module.exports, "TargetInner", () => $898363ff4397c3c1$export$b1542cc928b93af);
$parcel$export(module.exports, "TargetOverlay", () => $898363ff4397c3c1$export$a28a07e0025d709d);
$parcel$export(module.exports, "Pulse", () => $898363ff4397c3c1$export$927d63e2511364c0);
/* target.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $898363ff4397c3c1$var$reduceMotionAsPerUserPreference = null;
// NOTE:
// Pulse color "rgb(101, 84, 192)" derived from "colors.P300"
const $898363ff4397c3c1$var$baseShadow = `0 0 0 2px ${"var(--ds-border-discovery, #AF59E1)"}`;
const $898363ff4397c3c1$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $898363ff4397c3c1$var$pulseKeyframes = null;
const $898363ff4397c3c1$var$animationStyles = null;
const $898363ff4397c3c1$var$Base = ({ bgColor: bgColor, children: children, className: className, radius: radius, testId: testId, style: style, // The rest of these props are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style is not allowed at the moment
            ...style,
            backgroundColor: bgColor,
            borderRadius: radius ? typeof radius === 'number' ? `${radius}px` : radius : undefined
        },
        ...props,
        children: children
    });
$898363ff4397c3c1$var$Base.displayName = "Base";
const $898363ff4397c3c1$export$b1542cc928b93af = ({ bgColor: bgColor, children: children, className: className, pulse: pulse, radius: radius, testId: testId, // Thes rest of these are from `HTMLDivElement`
...props })=>/*#__PURE__*/ (0, $5chsV.jsx)($898363ff4397c3c1$var$Base, {
        bgColor: bgColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gJ6nT.default)([
            pulse && "",
            pulse && "_0nFVCG2h6w _03m2nySHWH _1gBibyAup0 _43vdfTs3G2 _2OUyjtgbYL",
            "_39Ohv4YbGa _1SdfoHYbGa",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style,
        children: children
    });
$898363ff4397c3c1$export$b1542cc928b93af.displayName = "TargetInner";
const $898363ff4397c3c1$var$targetOverlayStyles = null;
const $898363ff4397c3c1$export$a28a07e0025d709d = ({ onClick: onClick, ...props })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
        onClick: onClick,
        ...props,
        style: {
            cursor: onClick ? 'pointer' : 'auto'
        },
        className: (0, $gJ6nT.default)([
            "_39xV02N91d _0jFU0VN91d _1mT5xdWVPG _2I62gzPgdg _3iC0zdPgdg"
        ])
    });
$898363ff4397c3c1$export$a28a07e0025d709d.displayName = "TargetOverlay";
const $898363ff4397c3c1$export$927d63e2511364c0 = ({ bgColor: bgColor, children: children, className: className, radius: radius, pulse: pulse = true, testId: testId, ...props })=>/*#__PURE__*/ (0, $5chsV.jsx)($898363ff4397c3c1$var$Base, {
        bgColor: bgColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gJ6nT.default)([
            pulse && "",
            pulse && "_0nFVCG2h6w _03m2nySHWH _1gBibyAup0 _43vdfTs3G2 _2OUyjtgbYL",
            "_39Ohv4YbGa _1SdfoHYbGa",
            className
        ]),
        radius: radius,
        testId: testId,
        ...props,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style,
        children: children
    });
$898363ff4397c3c1$export$927d63e2511364c0.displayName = "Pulse";

});

parcelRegister("hblw3", function(module, exports) {
$parcel$export(module.exports, "useElementObserver", () => $2e7f95dacffe98ba$export$729bafd4e621fba0);

var $fsvuC = parcelRequire("fsvuC");
function $2e7f95dacffe98ba$export$729bafd4e621fba0(element, opts = {}) {
    const { onChange: onChange, disableWatch: disableWatch = false } = opts;
    // This state is used to force a re-render when the target changes
    const [targetContentVersion, setTargetContentVersion] = (0, $fsvuC.useState)(0);
    const mutationObserver = (0, $fsvuC.useRef)(undefined);
    const cancelIdleCallback1 = (0, $fsvuC.useRef)(undefined);
    const disposer = (0, $fsvuC.useCallback)(()=>{
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = undefined;
        mutationObserver.current?.disconnect();
        mutationObserver.current = undefined;
    }, []);
    const onMutation = (0, $fsvuC.useCallback)(()=>{
        // MutationObserver can make multiple calls to the callback in quick succession so debounce when idle
        cancelIdleCallback1.current?.();
        cancelIdleCallback1.current = $2e7f95dacffe98ba$var$callWhenIdle(()=>setTargetContentVersion((v)=>{
                const version = v + 1;
                onChange?.(version);
                return version;
            }));
    }, [
        onChange
    ]);
    (0, $fsvuC.useEffect)(()=>{
        // Clean up any existing observer in the case that the target node has changed
        disposer();
        if (!disableWatch && element) {
            mutationObserver.current = new MutationObserver(onMutation);
            mutationObserver.current.observe(element, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        return disposer;
    }, [
        disableWatch,
        disposer,
        element,
        onMutation
    ]);
    return targetContentVersion;
}
/**
 * When the browser is idle call the callback.
 *
 * This function will use `requestIdleCallback` if available, otherwise it will fallback to `setTimeout`.
 *
 * @param callback The function to call when the browser is idle.
 * @param [opts] Options for the idle callback.
 * @param [opts.timeout=100] The maximum time to wait for the browser to be idle.
 *
 * @returns A function that can be called to cancel the idle callback.
 *
 * @internal
 */ function $2e7f95dacffe98ba$var$callWhenIdle(callback, opts = {}) {
    const { timeout: timeout = 100 } = opts;
    if (typeof window.requestIdleCallback === 'function') {
        const idleHandle = window.requestIdleCallback(callback, {
            timeout: timeout
        });
        return ()=>cancelIdleCallback(idleHandle);
    }
    // Fallback to setTimeout if requestIdleCallback is not available
    const timeoutHandle = setTimeout(callback, timeout);
    return ()=>clearTimeout(timeoutHandle);
}

});


parcelRegister("gHg8f", function(module, exports) {
$parcel$export(module.exports, "default", () => $784f0a9a95332515$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $knrfi = parcelRequire("knrfi");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $784f0a9a95332515$var$NodeResolverSpotlightInner = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    const divRef = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        if (!hasNodeResolver) innerRef(divRef.current?.firstElementChild);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasNodeResolver
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($knrfi))), {
        innerRef: innerRef,
        children: children
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: divRef,
        children: children
    });
};
$784f0a9a95332515$var$NodeResolverSpotlightInner.displayName = "NodeResolverSpotlightInner";
var $784f0a9a95332515$export$2e2bcd8739ae039 = $784f0a9a95332515$var$NodeResolverSpotlightInner;

});

parcelRegister("eOnrR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e67e8e56cc934752$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $kyAKM = parcelRequire("kyAKM");

var $lzKbd = parcelRequire("lzKbd");

var $fpjto = parcelRequire("fpjto");

var $4hvQx = parcelRequire("4hvQx");

var $dqtCv = parcelRequire("dqtCv");

var $67WSB = parcelRequire("67WSB");
/**
 * __Spotlight dialog__
 *
 * An onboarding spotlight introduces new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $e67e8e56cc934752$var$SpotlightDialogComponent extends (0, $fsvuC.Component) {
    componentDidMount() {
        this.focusLockTimeoutId = window.setTimeout(()=>{
            // we delay the enabling of the focus lock to avoid the scroll position
            // jumping around in some situations
            this.setState({
                focusLockDisabled: false
            });
        }, 200);
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusLockTimeoutId);
    }
    render() {
        const { actions: actions, actionsBeforeElement: actionsBeforeElement, children: children, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, footer: footer, header: header, heading: heading, headingAfterElement: headingAfterElement, image: image, label: label = 'Introducing new feature', titleId: titleId, targetNode: targetNode, testId: testId } = this.props;
        const { focusLockDisabled: focusLockDisabled } = this.state;
        const dialogLabel = !heading && !titleId ? label : undefined;
        const dialogLabelledBy = titleId || (heading ? 'spotlight-dialog-label' : undefined);
        const translatedPlacement = dialogPlacement ? ({
            'top left': 'top-start',
            'top center': 'top',
            'top right': 'top-end',
            'right top': 'right-start',
            'right middle': 'right',
            'right bottom': 'right-end',
            'bottom left': 'bottom-start',
            'bottom center': 'bottom',
            'bottom right': 'bottom-end',
            'left top': 'left-start',
            'left middle': 'left',
            'left bottom': 'left-end'
        })[dialogPlacement] : undefined;
        // If there's no room on either side of the popper, it will extend off-screen.
        //  This looks buggy when scroll-lock and focus is placed on the dialog, so we
        //  customise popper so it overflows the spotlight instead with altAxis=true.
        const modifiers = [
            {
                name: 'preventOverflow',
                options: {
                    padding: 5,
                    rootBoundary: 'document',
                    altAxis: true,
                    tether: false
                }
            }
        ];
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $lzKbd.Popper), {
            modifiers: modifiers,
            referenceElement: targetNode,
            placement: translatedPlacement,
            children: ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $67WSB.default), {
                    value: dialogWidth,
                    onChange: update,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kyAKM.default), {
                        disabled: focusLockDisabled,
                        returnFocus: false,
                        autoFocus: true,
                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $fpjto.Box), {
                            style: style,
                            ref: ref,
                            "aria-modal": true,
                            role: "dialog",
                            "aria-label": dialogLabel,
                            "aria-labelledby": dialogLabelledBy,
                            testId: `${testId}-container`,
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $dqtCv.default), {
                                testId: testId,
                                width: dialogWidth,
                                actions: actions,
                                actionsBeforeElement: actionsBeforeElement,
                                image: image && /*#__PURE__*/ (0, $5chsV.jsx)((0, $4hvQx.DialogImage), {
                                    alt: heading,
                                    src: image
                                }),
                                components: {
                                    Header: header,
                                    Footer: footer
                                },
                                heading: heading,
                                headingId: "spotlight-dialog-label",
                                headingAfterElement: headingAfterElement,
                                // This should be heading level 1 since this is technically a modal, including a focus lock on the modal window.
                                // But because it is not a _true_ modal, we are setting it to `2` until that is fixed.
                                headingLevel: 2,
                                children: children
                            })
                        })
                    })
                })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            focusLockDisabled: true
        };
    }
}
$e67e8e56cc934752$var$SpotlightDialogComponent.displayName = "SpotlightDialogComponent";
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e67e8e56cc934752$export$2e2bcd8739ae039 = $e67e8e56cc934752$var$SpotlightDialogComponent;

});
parcelRegister("4hvQx", function(module, exports) {
$parcel$export(module.exports, "DialogImage", () => $9419167d7b0c2b30$export$855e1a47874d6b81);
$parcel$export(module.exports, "DialogActionItemContainer", () => $9419167d7b0c2b30$export$ed9b6b50bbed5f27);
$parcel$export(module.exports, "DialogActionItem", () => $9419167d7b0c2b30$export$6ae54e00f59e1f33);
/* dialog.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $fpjto = parcelRequire("fpjto");
const $9419167d7b0c2b30$var$imageStyles = null;
const $9419167d7b0c2b30$var$actionItemContainerStyles = {
    root: "_3iDTPbQ4SZ _0aFT5vf5Xk _0rIjykPgdg _43nrzTPgdg _2xTnZx5UaJ _0GTcwR5UaJ"
};
const $9419167d7b0c2b30$var$actionItemStyles = {
    root: "_0rIjykPgdg _43nrzTPgdg _2xTnZx1Y8M _0GTcwR1Y8M"
};
const $9419167d7b0c2b30$export$855e1a47874d6b81 = ({ alt: alt, ...props })=>/*#__PURE__*/ (0, $5chsV.jsx)("img", {
        alt: alt,
        ...props,
        className: (0, $gJ6nT.default)([
            "_1EqgXlN91d _0jFU0VIZbP"
        ])
    });
$9419167d7b0c2b30$export$855e1a47874d6b81.displayName = "DialogImage";
const $9419167d7b0c2b30$export$ed9b6b50bbed5f27 = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $fpjto.Box), {
        xcss: $9419167d7b0c2b30$var$actionItemContainerStyles.root,
        children: children
    });
$9419167d7b0c2b30$export$ed9b6b50bbed5f27.displayName = "DialogActionItemContainer";
const $9419167d7b0c2b30$export$6ae54e00f59e1f33 = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $fpjto.Box), {
        xcss: $9419167d7b0c2b30$var$actionItemStyles.root,
        children: children
    });
$9419167d7b0c2b30$export$6ae54e00f59e1f33.displayName = "DialogActionItem";

});

parcelRegister("dqtCv", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4ad547978540c21$export$2e2bcd8739ae039);
/* spotlight-card.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $kE3M8 = parcelRequire("kE3M8");

var $8VO0M = parcelRequire("8VO0M");

var $2YOL2 = parcelRequire("2YOL2");

var $gcAhT = parcelRequire("gcAhT");

var $1wCqK = parcelRequire("1wCqK");

var $5T6N9 = parcelRequire("5T6N9");

var $fpjto = parcelRequire("fpjto");

var $kBK9z = parcelRequire("kBK9z");

var $4hvQx = parcelRequire("4hvQx");

var $k5gxv = parcelRequire("k5gxv");
const $d4ad547978540c21$var$bodyStyles = null;
const $d4ad547978540c21$var$imageStyles = null;
const $d4ad547978540c21$var$defaultHeaderStyles = null;
const $d4ad547978540c21$var$DefaultHeader = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            "_3iDTPbQ4SZ _0hPCNLQame _37wbyuI7V3 _0xmtko2ADO"
        ]),
        children: children
    });
$d4ad547978540c21$var$DefaultHeader.displayName = "DefaultHeader";
const $d4ad547978540c21$var$defaultFooterStyles = null;
const $d4ad547978540c21$var$DefaultFooter = ({ children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": "spotlight--dialog-footer",
        className: (0, $gJ6nT.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _46hvQm2ADO"
        ]),
        children: children
    });
$d4ad547978540c21$var$DefaultFooter.displayName = "DefaultFooter";
const $d4ad547978540c21$var$containerStyles = {
    root: "_0bjKvDKxmn _4bt5LAIZbP _2WAcuGIZbP _0jFU0VE6Kk _1UtDYze5R3 _4ouGXIoaux _1EqgXlpNyl"
};
const $d4ad547978540c21$var$containerShadowStyles = {
    root: "_2OUyjtzwhj"
};
/**
 * __Spotlight card__
 *
 * A spotlight card is for onboarding messages that need a more flexible layout, or don't require a dialog.
 *
 * - [Examples](https://atlassian.design/components/onboarding/spotlight-card/examples)
 * - [Code](https://atlassian.design/components/onboarding/spotlight-card/code)
 * - [Usage](https://atlassian.design/components/onboarding/spotlight-card/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $d4ad547978540c21$var$SpotlightCard = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const { actions: actions = [], actionsBeforeElement: actionsBeforeElement, children: children, components: components = {}, heading: heading, headingLevel: headingLevel = 4, headingAfterElement: headingAfterElement, image: image, innerRef: innerRef, isFlat: isFlat, testId: testId, width: width = 400, headingId: headingId } = props;
    const { Header: Header = $d4ad547978540c21$var$DefaultHeader, Footer: Footer = $d4ad547978540c21$var$DefaultFooter } = components;
    const { currentLevel: currentLevel } = (0, $1wCqK.useLayering)({
        isEnabled: !(0, $5T6N9.fg)('platform-dst-top-layer')
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $8VO0M.default).Provider, {
        value: (0, $k5gxv.spotlightButtonTheme),
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fpjto.Box), {
            backgroundColor: "color.background.discovery.bold",
            xcss: (0, $2YOL2.cx)($d4ad547978540c21$var$containerStyles.root, !isFlat && $d4ad547978540c21$var$containerShadowStyles.root),
            style: {
                width: width
            },
            ref: ref || innerRef,
            testId: testId,
            "data-ds--level": currentLevel,
            // temporarily use this data attribute to prevent clicking outside won't close spotlight correctly issue
            "data-ds--close--type": "single",
            children: [
                typeof image === 'string' ? /*#__PURE__*/ (0, $5chsV.jsx)("img", {
                    src: image,
                    alt: "",
                    className: (0, $gJ6nT.default)([
                        "_3iDTPbvLZJ"
                    ])
                }) : image,
                /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
                    className: (0, $gJ6nT.default)([
                        "_3iDTPbQ4SZ _0aFT5vbt8w _0xmtko5zaO _46hvQm5zaO _03SyCPkG2W _0LQT5EkG2W"
                    ]),
                    children: [
                        heading || headingAfterElement ? /*#__PURE__*/ (0, $5chsV.jsxs)(Header, {
                            children: [
                                /*#__PURE__*/ (0, $5chsV.jsx)((0, $gcAhT.default), {
                                    id: headingId,
                                    size: "medium",
                                    as: `h${headingLevel}`,
                                    color: "color.text.inverse",
                                    children: heading
                                }),
                                headingAfterElement
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $kBK9z.Text), {
                            children: children
                        }),
                        actions.length > 0 || actionsBeforeElement ? /*#__PURE__*/ (0, $5chsV.jsxs)(Footer, {
                            children: [
                                actionsBeforeElement || /*#__PURE__*/ (0, $5chsV.jsx)("span", {}),
                                /*#__PURE__*/ (0, $5chsV.jsx)((0, $4hvQx.DialogActionItemContainer), {
                                    children: actions.map(({ text: text, key: key, ...rest }, idx)=>{
                                        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $4hvQx.DialogActionItem), {
                                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kE3M8.default), {
                                                ...rest,
                                                children: text
                                            })
                                        }, key || (typeof text === 'string' ? text : `${idx}`));
                                    })
                                })
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
});
$d4ad547978540c21$var$SpotlightCard.displayName = 'SpotlightCard';
var $d4ad547978540c21$export$2e2bcd8739ae039 = $d4ad547978540c21$var$SpotlightCard;

});
parcelRegister("k5gxv", function(module, exports) {
$parcel$export(module.exports, "spotlightButtonTheme", () => $6f7e397586cd1e93$export$39a36121076ca24);
$parcel$export(module.exports, "modalButtonTheme", () => $6f7e397586cd1e93$export$d131eb21ba4cbd16);
const $6f7e397586cd1e93$var$spotlightTheme = {
    default: {
        background: {
            default: "var(--ds-background-inverse-subtle, #00000029)",
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: "var(--ds-background-disabled, #0515240F)",
            selected: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            focus: "var(--ds-background-inverse-subtle, #00000029)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #080F214A)",
                dark: "var(--ds-text-disabled, #080F214A)"
            },
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        background: {
            default: 'none',
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: 'none',
            selected: {
                light: "var(--ds-background-selected-hovered, #CFE1FD)",
                dark: "var(--ds-background-selected-hovered, #CFE1FD)"
            },
            focusSelected: {
                light: "var(--ds-background-selected-hovered, #CFE1FD)",
                dark: "var(--ds-background-selected-hovered, #CFE1FD)"
            }
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-disabled, #080F214A)",
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    'subtle-link': {
        textDecoration: {
            hover: `underline ${"var(--ds-text-inverse, #FFFFFF)"}`
        },
        textDecorationLine: {
            active: 'none'
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-discovery, #803FA5)",
            selected: "var(--ds-text-selected, #1868DB)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $6f7e397586cd1e93$var$modalTheme = {
    primary: {
        background: {
            default: "var(--ds-background-discovery-bold, #964AC0)",
            hover: "var(--ds-background-discovery-bold-hovered, #803FA5)",
            active: "var(--ds-background-discovery-bold-pressed, #673286)",
            disabled: {
                light: "var(--ds-background-disabled, #0515240F)",
                dark: "var(--ds-background-disabled, #0515240F)"
            },
            selected: "var(--ds-background-selected-hovered, #CFE1FD)",
            focus: "var(--ds-background-discovery-bold-hovered, #803FA5)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #080F214A)",
                dark: "var(--ds-text-disabled, #080F214A)"
            },
            selected: "var(--ds-text-selected, #1868DB)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
function $6f7e397586cd1e93$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
    if (!newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!node[item]) return undefined;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return undefined;
            }
            node = node[item];
            return undefined;
        });
        return acc;
    }, {});
}
const $6f7e397586cd1e93$export$39a36121076ca24 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$6f7e397586cd1e93$var$extract($6f7e397586cd1e93$var$spotlightTheme, themeProps)
        },
        ...rest
    };
};
const $6f7e397586cd1e93$export$d131eb21ba4cbd16 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$6f7e397586cd1e93$var$extract($6f7e397586cd1e93$var$modalTheme, themeProps)
        },
        ...rest
    };
};

});


parcelRegister("67WSB", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cb6ce84c2396f55$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
class $2cb6ce84c2396f55$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) this.props.onChange();
    }
    render() {
        return this.props.children;
    }
}
$2cb6ce84c2396f55$export$2e2bcd8739ae039.displayName = "ValueChanged";

});


parcelRegister("d4Odt", function(module, exports) {
$parcel$export(module.exports, "SpotlightTransitionConsumer", () => $539229a5578178c6$export$7d63b19b854c2fe8);
$parcel$export(module.exports, "default", () => $539229a5578178c6$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $iqo7S = parcelRequire("iqo7S");
const $539229a5578178c6$var$SpotlightTransitionContext = /*#__PURE__*/ (0, $fsvuC.createContext)({
    isOpen: true,
    onExited: (0, $iqo7S.default)
});
// checks if children exist and are truthy
const $539229a5578178c6$var$hasChildren = (children)=>(0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Children.count(children) > 0 && ((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Children.map(children || false, (child)=>!!child)?.filter(Boolean)?.length || 0) > 0;
/**
 * __Spotlight transition__
 *
 * A spotlight transition holds onto spotlights so they can fade out when exiting the viewport.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $539229a5578178c6$var$SpotlightTransition extends (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Component {
    static getDerivedStateFromProps(props, state) {
        const { currentChildren: previousChildren } = state;
        const exiting = $539229a5578178c6$var$hasChildren(previousChildren) && !$539229a5578178c6$var$hasChildren(props.children);
        return {
            currentChildren: exiting ? previousChildren : props.children
        };
    }
    render() {
        return /*#__PURE__*/ (0, $5chsV.jsx)($539229a5578178c6$var$SpotlightTransitionContext.Provider, {
            value: {
                onExited: this.onExited,
                isOpen: $539229a5578178c6$var$hasChildren(this.props.children)
            },
            children: this.state.currentChildren
        });
    }
    constructor(...args){
        super(...args), this.state = {
            currentChildren: undefined
        }, this.onExited = ()=>{
            this.setState({
                currentChildren: this.props.children
            });
        };
    }
}
$539229a5578178c6$var$SpotlightTransition.displayName = "SpotlightTransition";
const $539229a5578178c6$export$7d63b19b854c2fe8 = $539229a5578178c6$var$SpotlightTransitionContext.Consumer;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$539229a5578178c6$export$2e2bcd8739ae039 = $539229a5578178c6$var$SpotlightTransition;

});


parcelRegister("biw1y", function(module, exports) {
$parcel$export(module.exports, "TargetConsumer", () => $98bd5a4150776c93$export$f643dd64c1952cc8);
$parcel$export(module.exports, "SpotlightContext", () => $98bd5a4150776c93$export$7b5aa0f5b37a336d);
$parcel$export(module.exports, "SpotlightConsumer", () => $98bd5a4150776c93$export$3503199acd121708);
$parcel$export(module.exports, "default", () => $98bd5a4150776c93$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $kZVJU = parcelRequire("kZVJU");

var $iqo7S = parcelRequire("iqo7S");

var $c4Atc = parcelRequire("c4Atc");

var $7IVZh = parcelRequire("7IVZh");

var $5OOYg = parcelRequire("5OOYg");

var $hLIED = parcelRequire("hLIED");

var $hoalA = parcelRequire("hoalA");
const $98bd5a4150776c93$var$dest = /*#__PURE__*/ (0, $fsvuC.createContext)(undefined);
const $98bd5a4150776c93$export$f643dd64c1952cc8 = $98bd5a4150776c93$var$dest.Consumer;
const $98bd5a4150776c93$var$TargetProvider = $98bd5a4150776c93$var$dest.Provider;
const $98bd5a4150776c93$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $fsvuC.createContext)({
    opened: (0, $iqo7S.default),
    closed: (0, $iqo7S.default),
    targets: {}
});
const $98bd5a4150776c93$export$3503199acd121708 = $98bd5a4150776c93$export$7b5aa0f5b37a336d.Consumer;
const $98bd5a4150776c93$var$SpotlightStateProvider = $98bd5a4150776c93$export$7b5aa0f5b37a336d.Provider;
const $98bd5a4150776c93$var$Container = ({ component: Wrapper, children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)(Wrapper, {
        children: children
    });
$98bd5a4150776c93$var$Container.displayName = "Container";
class $98bd5a4150776c93$export$2e2bcd8739ae039 extends (0, $fsvuC.PureComponent) {
    static{
        this.defaultProps = {
            blanketIsTinted: true
        };
    }
    componentDidMount() {
        typeof $hoalA;
    }
    render() {
        const { blanketIsTinted: blanketIsTinted, children: children, component: Tag, onBlanketClicked: onBlanketClicked } = this.props;
        const isActive = this.state.spotlightCount > 0;
        return /*#__PURE__*/ (0, $5chsV.jsx)($98bd5a4150776c93$var$SpotlightStateProvider, {
            value: this.getStateProviderValue(this.state.targets),
            children: /*#__PURE__*/ (0, $5chsV.jsx)($98bd5a4150776c93$var$TargetProvider, {
                value: this.getTargetRef,
                children: /*#__PURE__*/ (0, $5chsV.jsxs)($98bd5a4150776c93$var$Container, {
                    component: Tag || (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment,
                    children: [
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $c4Atc.default), {
                            children: isActive && /*#__PURE__*/ (0, $5chsV.jsx)((0, $7IVZh.default), {
                                duration: "medium",
                                children: ({ ref: ref, className: className, style: style })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $5OOYg.default), {
                                        zIndex: 700,
                                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $hLIED.default), {
                                            ref: ref,
                                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                                            className: className,
                                            style: style,
                                            isTinted: blanketIsTinted,
                                            onBlanketClicked: onBlanketClicked
                                        })
                                    })
                            })
                        }),
                        children
                    ]
                })
            })
        });
    }
    constructor(...args){
        super(...args), this.state = {
            spotlightCount: 0,
            targets: {}
        }, /*
	 * When enabling React Streaming in Confluence, a
	 * "This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering"
	 * error happens.
	 * This is to fix this error by wrapping the state update in startTransition as suggested by React: https://react.dev/errors/421?invariant=421
	 */ this.getTargetRef = (name)=>(element)=>{
                (0, $fsvuC.startTransition)(()=>{
                    this.setState((state)=>({
                            targets: {
                                ...state.targets,
                                [name]: element || undefined
                            }
                        }));
                });
            }, this.spotlightOpen = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount + 1
                }));
        }, this.spotlightClose = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount - 1
                }));
        }, this.getStateProviderValue = (0, $kZVJU.default)((targets)=>({
                opened: this.spotlightOpen,
                closed: this.spotlightClose,
                targets: targets
            }));
    }
}
$98bd5a4150776c93$export$2e2bcd8739ae039.displayName = "SpotlightManager";

});
parcelRegister("hLIED", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3bd8b879d366074$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
// IE11 and Edge: z-index needed because fixed position calculates z-index relative
// to body instead of nearest stacking context (Portal in our case).
const $d3bd8b879d366074$var$blanketStyles = null;
/**
 * __Blanket__
 *
 * A replacement for `@atlaskit/blanket`.
 *
 * We use this for spotlights instead of `@atlaskit/blanket`
 * because spotlights must sit on top of other layered elements,
 * such as modals, which have their own blankets.
 *
 * @internal
 */ const $d3bd8b879d366074$var$Blanket = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ isTinted: isTinted, onBlanketClicked: onBlanketClicked, style: style, className: className }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: ref,
        role: "presentation",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gJ6nT.default)([
            "_49OCfRdnbC _23rrnHZtEe _1mT5xdy1CL _42Yu6BkKjW",
            className
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style props are not allowed
            ...style,
            backgroundColor: isTinted ? "var(--ds-blanket, #050C1F75)" : 'transparent'
        },
        onClick: onBlanketClicked
    });
});
var $d3bd8b879d366074$export$2e2bcd8739ae039 = $d3bd8b879d366074$var$Blanket;

});



parcelRegister("km9jx", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca60bb2318d5ca35$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $8aWu7 = parcelRequire("8aWu7");

var $4XxmM = parcelRequire("4XxmM");
const $ca60bb2318d5ca35$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $ca60bb2318d5ca35$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $fsvuC.useRef)(null);
    const providedColorMode = (0, $8aWu7.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $4XxmM.useThemeObserver)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $fsvuC.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $gJ6nT.default)([
            "_1EqgXlN91d _0jFU0VIZbP",
            className
        ]),
        ref: imgRef,
        ...props
    });
}
$ca60bb2318d5ca35$export$2e2bcd8739ae039.displayName = "Image";

});
parcelRegister("8aWu7", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useColorModeForMigration", () => $22db6d12c3dccae5$export$ce91654eb9fea460);

var $fsvuC = parcelRequire("fsvuC");

var $fMHes = parcelRequire("fMHes");
function $22db6d12c3dccae5$export$ce91654eb9fea460() {
    const value = (0, $fsvuC.useContext)((0, $fMHes.ColorModeContext));
    return value;
}
$22db6d12c3dccae5$export$ce91654eb9fea460.displayName = "UNSAFE_useColorModeForMigration";

});


parcelRegister("ywtDJ", function(module, exports) {
$parcel$export(module.exports, "SpotlightActions", () => $83d000a75f51ad06$export$205c28213090dc52);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $8C8EQ = parcelRequire("8C8EQ");
const $83d000a75f51ad06$var$styles = {
    root: "_39xV02N91d"
};
const $83d000a75f51ad06$export$205c28213090dc52 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $8C8EQ.Flex), {
        ref: ref,
        testId: testId,
        xcss: $83d000a75f51ad06$var$styles.root,
        role: "group",
        justifyContent: "end",
        gap: "space.050",
        children: children
    });
});

});

parcelRegister("cHQFA", function(module, exports) {
$parcel$export(module.exports, "SpotlightBody", () => $03998ae46f52ac58$export$4ae665cf62a00c3f);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $fpjto = parcelRequire("fpjto");
const $03998ae46f52ac58$var$styles = {
    root: "_2Y7lL45zaO _1UtDYze5R3 _46hvQm2ADO"
};
const $03998ae46f52ac58$export$4ae665cf62a00c3f = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fpjto.Box), {
        ref: ref,
        xcss: $03998ae46f52ac58$var$styles.root,
        testId: testId,
        children: children
    });
});

});

parcelRegister("7lw9P", function(module, exports) {
$parcel$export(module.exports, "SpotlightCard", () => $7cbe88303e83a7dc$export$14710e13fc01d383);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $5T6N9 = parcelRequire("5T6N9");

var $7gw65 = parcelRequire("7gw65");

var $3W134 = parcelRequire("3W134");
const $7cbe88303e83a7dc$export$14710e13fc01d383 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, placement: placement, testId: testId }, ref)=>(0, $5T6N9.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $3W134.SpotlightCard), {
        ref: ref,
        placement: placement,
        testId: testId,
        children: children
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $7gw65.SpotlightCard), {
        ref: ref,
        placement: placement,
        testId: testId,
        children: children
    }));

});
parcelRegister("7gw65", function(module, exports) {
$parcel$export(module.exports, "SpotlightCard", () => $69223b7314e2542b$export$14710e13fc01d383);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $2YOL2 = parcelRequire("2YOL2");

var $5T6N9 = parcelRequire("5T6N9");

var $fpjto = parcelRequire("fpjto");

var $hFyni = parcelRequire("hFyni");

var $aLEp2 = parcelRequire("aLEp2");
const $69223b7314e2542b$var$styles = {
    root: "_39xV02E6Kk",
    container: "_1mT5xdRAKS",
    card: "_0bjKvD8fU6 _2mHwu82ADO _1mT5xdWVPG _39xV02T1Vg _46hvQm2ADO _0xmtko8HPE _3iDTPbQ4SZ _0aFT5vbt8w _2OUyjtFYNq"
};
const $69223b7314e2542b$var$placementStyles = {
    'top-start': "_1ZB6UygVvo _1OKFqYYfXA",
    'top-center': "_1ZB6UygVvo _3iC0zdHCju",
    'top-end': "_1ZB6UygVvo _3iC0zdYfXA",
    'right-start': "_3iC0zdgVvo _1ZB6UyUgYP",
    'right-end': "_3iC0zdgVvo _2I62gzUgYP",
    'bottom-start': "_2I62gzgVvo _1OKFqYYfXA",
    'bottom-center': "_2I62gzgVvo _3iC0zdHCju",
    'bottom-end': "_2I62gzgVvo _3iC0zdYfXA",
    'left-start': "_1OKFqYgVvo _1ZB6UyUgYP",
    'left-end': "_1OKFqYgVvo _2I62gzUgYP"
};
const $69223b7314e2542b$export$14710e13fc01d383 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, placement: placement, testId: testId }, ref)=>{
    const { card: card } = (0, $fsvuC.useContext)((0, $hFyni.SpotlightContext));
    const cardRef = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        card.setRef(cardRef);
    }, [
        card
    ]);
    const content = /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        className: (0, $gJ6nT.default)([
            $69223b7314e2542b$var$styles.root
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
            className: (0, $gJ6nT.default)([
                $69223b7314e2542b$var$styles.container
            ]),
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $aLEp2.Caret), {
                    placement: placement || card.placement
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $fpjto.Box), {
                    ref: cardRef,
                    backgroundColor: "color.background.neutral.bold",
                    xcss: (0, $2YOL2.cx)($69223b7314e2542b$var$styles.card, $69223b7314e2542b$var$placementStyles[placement || card.placement]),
                    children: children
                })
            ]
        })
    });
    if ((0, $5T6N9.fg)('platform-dst-motion-uplift-spotlight')) {
        const Motion = card.motion;
        if (Motion) return /*#__PURE__*/ (0, $5chsV.jsx)(Motion, {
            children: content
        });
        else return content;
    }
    return content;
});

});
parcelRegister("aLEp2", function(module, exports) {
$parcel$export(module.exports, "Caret", () => $61165f6fd74c1a49$export$88fca06e22f21720);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $5T6N9 = parcelRequire("5T6N9");

var $4QGMy = parcelRequire("4QGMy");

var $9rVAX = parcelRequire("9rVAX");
const $61165f6fd74c1a49$export$88fca06e22f21720 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ placement: placement, testId: testId }, ref)=>{
    return (0, $5T6N9.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $9rVAX.Caret), {
        ref: ref,
        placement: placement,
        testId: testId
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $4QGMy.Caret), {
        ref: ref,
        placement: placement,
        testId: testId
    });
});

});
parcelRegister("4QGMy", function(module, exports) {
$parcel$export(module.exports, "Caret", () => $febbf2629a3b559f$export$88fca06e22f21720);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $hFyni = parcelRequire("hFyni");
const $febbf2629a3b559f$var$styles = {
    root: "_0KLXrugozt _1uo2Zf1cEy _0jFU0V2sAl _1mT5xdRAKS _39xV022sAl _42Yu6BkKjW",
    'top-start': "_1VJPcaMZzS",
    'top-center': "_1VJPcaMZzS",
    'top-end': "_1VJPcaMZzS",
    'bottom-start': "_1VJPcacqvQ",
    'bottom-center': "_1VJPcacqvQ",
    'bottom-end': "_1VJPcacqvQ",
    'right-start': "_1VJPcaEFNz",
    'right-end': "_1VJPcaEFNz",
    'left-start': "_1VJPcaEoIx",
    'left-end': "_1VJPcaEoIx"
};
const $febbf2629a3b559f$export$88fca06e22f21720 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ placement: placement, testId: testId }, ref)=>{
    const { card: card } = (0, $fsvuC.useContext)((0, $hFyni.SpotlightContext));
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        // Growth Pattern Library designs dictate 1px radius. cssMap only allows tokens
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            borderEndStartRadius: '1px'
        },
        className: (0, $gJ6nT.default)([
            $febbf2629a3b559f$var$styles.root,
            $febbf2629a3b559f$var$styles[placement || card.placement]
        ])
    });
});

});

parcelRegister("9rVAX", function(module, exports) {
$parcel$export(module.exports, "Caret", () => $b12ff2ae32f1f520$export$88fca06e22f21720);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $hFyni = parcelRequire("hFyni");

var $2hwZc = parcelRequire("2hwZc");
const $b12ff2ae32f1f520$var$styles = {
    root: "_0KLXrugozt _1uo2Zf1cEy _0jFU0V2sAl _1mT5xdWVPG _39xV022sAl",
    'start span-start': "_1ZB6UyPgdg _1OKFqYkG2W _1VJPcaMZzS",
    'block-start': "_1ZB6UyPgdg _3iC0zdgHOl _1VJPcaMZzS",
    'start span-end': "_1ZB6UyPgdg _3iC0zdv3tX _1VJPcaMZzS",
    'inline-start': "_1OKFqYPgdg _2I62gzgHOl _1VJPcaEoIx",
    'inline-end': "_3iC0zdPgdg _2I62gzgHOl _1VJPcaEFNz",
    'span-start end': "_3iC0zdPgdg _1ZB6UyEbN9 _1VJPcaEFNz",
    'span-end end': "_3iC0zdPgdg _2I62gzXCiO _1VJPcaEFNz",
    'span-start start': "_1OKFqYPgdg _1ZB6UyEbN9 _1VJPcaEoIx",
    'span-end start': "_1OKFqYPgdg _2I62gzXCiO _1VJPcaEoIx",
    'end span-start': "_2I62gzPgdg _1OKFqYSPN1 _1VJPcacqvQ",
    'block-end': "_2I62gzPgdg _3iC0zdgHOl _1VJPcacqvQ",
    'end span-end': "_2I62gzPgdg _3iC0zdv3tX _1VJPcacqvQ"
};
const $b12ff2ae32f1f520$export$88fca06e22f21720 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ placement: placement, testId: testId }, ref)=>{
    const { card: card, popoverContent: popoverContent } = (0, $fsvuC.useContext)((0, $hFyni.SpotlightContext));
    const positionArea = (0, $2hwZc.getResolvedPositionArea)(placement || card.placement, popoverContent.positionArea);
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        // Growth Pattern Library designs dictate 1px radius. cssMap only allows tokens
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            borderEndStartRadius: '1px'
        },
        className: (0, $gJ6nT.default)([
            $b12ff2ae32f1f520$var$styles.root,
            $b12ff2ae32f1f520$var$styles[positionArea]
        ])
    });
});

});
parcelRegister("2hwZc", function(module, exports) {
$parcel$export(module.exports, "getResolvedPositionArea", () => $1ba44d7a84391af0$export$3aecfab3bd204999);
const $1ba44d7a84391af0$var$caretPositionMap = {
    'top-start': 'start span-start',
    'top-center': 'block-start',
    'top-end': 'start span-end',
    'left-start': 'span-start start',
    'right-start': 'span-start end',
    'left-end': 'span-end start',
    'right-end': 'span-end end',
    'bottom-start': 'end span-start',
    'bottom-center': 'block-end',
    'bottom-end': 'end span-end'
};
const $1ba44d7a84391af0$export$3aecfab3bd204999 = (placement, positionArea)=>{
    if (!positionArea || positionArea === 'none') return $1ba44d7a84391af0$var$caretPositionMap[placement];
    return positionArea;
};

});




parcelRegister("3W134", function(module, exports) {
$parcel$export(module.exports, "SpotlightCard", () => $33052c4c8c64890f$export$14710e13fc01d383);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $5T6N9 = parcelRequire("5T6N9");

var $fpjto = parcelRequire("fpjto");

var $hFyni = parcelRequire("hFyni");

var $2hwZc = parcelRequire("2hwZc");

var $aLEp2 = parcelRequire("aLEp2");
const $33052c4c8c64890f$var$styles = {
    root: "_1mT5xdRAKS _39xV02E6Kk",
    card: "_0bjKvD8fU6 _2mHwu82ADO _39xV02T1Vg _46hvQm2ADO _0xmtko8HPE _3iDTPbQ4SZ _0aFT5vbt8w _2OUyjtFYNq",
    'start span-start': "_0xmtkogVvo",
    'block-start': "_0xmtkogVvo",
    'start span-end': "_0xmtkogVvo",
    'end span-start': "_46hvQmgVvo",
    'block-end': "_46hvQmgVvo",
    'end span-end': "_46hvQmgVvo",
    'inline-start': "_03SyCPgVvo",
    'inline-end': "_0LQT5EgVvo",
    'span-start end': "_0LQT5EgVvo",
    'span-end end': "_0LQT5EgVvo",
    'span-start start': "_03SyCPgVvo",
    'span-end start': "_03SyCPgVvo"
};
const $33052c4c8c64890f$export$14710e13fc01d383 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, placement: placement, testId: testId }, ref)=>{
    const { card: card, popoverContent: popoverContent } = (0, $fsvuC.useContext)((0, $hFyni.SpotlightContext));
    const cardRef = (0, $fsvuC.useRef)(null);
    const positionArea = (0, $2hwZc.getResolvedPositionArea)(placement || card.placement, popoverContent.positionArea);
    (0, $fsvuC.useEffect)(()=>{
        card.setRef(cardRef);
    }, [
        card
    ]);
    const content = /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
        "data-testid": testId,
        ref: ref,
        className: (0, $gJ6nT.default)([
            $33052c4c8c64890f$var$styles.root,
            $33052c4c8c64890f$var$styles[positionArea]
        ]),
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $aLEp2.Caret), {
                placement: placement
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $fpjto.Box), {
                ref: cardRef,
                backgroundColor: "color.background.neutral.bold",
                xcss: $33052c4c8c64890f$var$styles.card,
                children: children
            })
        ]
    });
    if ((0, $5T6N9.fg)('platform-dst-motion-uplift-spotlight')) {
        const Motion = card.motion;
        if (Motion) return /*#__PURE__*/ (0, $5chsV.jsx)(Motion, {
            children: content
        });
    }
    return content;
});

});


parcelRegister("8MgOi", function(module, exports) {
$parcel$export(module.exports, "SpotlightControls", () => $c7fbeaa36000daf2$export$67fb68d4ebe55a86);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $c7fbeaa36000daf2$var$styles = {
    root: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vf5Xk"
};
const $c7fbeaa36000daf2$export$67fb68d4ebe55a86 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ testId: testId, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        role: "group",
        className: (0, $gJ6nT.default)([
            $c7fbeaa36000daf2$var$styles.root
        ]),
        children: children
    });
});

});

parcelRegister("i35ZE", function(module, exports) {
$parcel$export(module.exports, "SpotlightDismissControl", () => $0435bbbd07ff43ae$export$4eef19754b0d485e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $2YOL2 = parcelRequire("2YOL2");

var $irYrv = parcelRequire("irYrv");

var $bRV0V = parcelRequire("bRV0V");

var $hFyni = parcelRequire("hFyni");
const $0435bbbd07ff43ae$var$styles = {
    root: "_0bjKvDKTcp _4c065UgVvo _1UtDYze5R3 _0KLXrugozt _1eOmH6kTlo _3gzVzLVbka"
};
const $0435bbbd07ff43ae$export$4eef19754b0d485e = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ autoFocus: autoFocus = true, onClick: onClick, testId: testId }, ref)=>{
    const { popoverContent: popoverContent } = (0, $fsvuC.useContext)((0, $hFyni.SpotlightContext));
    const dismiss = (event)=>{
        popoverContent.dismiss.current(event);
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bRV0V.Pressable), {
        autoFocus: autoFocus,
        onClick: onClick || dismiss,
        ref: ref,
        testId: testId,
        xcss: (0, $2YOL2.cx)($0435bbbd07ff43ae$var$styles.root),
        "aria-label": "Dismiss",
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($irYrv))), {
            label: "Close"
        })
    });
});

});

parcelRegister("8I7Dt", function(module, exports) {
$parcel$export(module.exports, "SpotlightFooter", () => $657a68e33e0958ef$export$f76dbc85ba76ccc2);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $8C8EQ = parcelRequire("8C8EQ");
const $657a68e33e0958ef$var$styles = {
    root: "_0LQT5E5zaO _03SyCP8HPE _39xV02N91d"
};
const $657a68e33e0958ef$export$f76dbc85ba76ccc2 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $8C8EQ.Flex), {
        ref: ref,
        testId: testId,
        xcss: $657a68e33e0958ef$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        children: children
    });
});

});

parcelRegister("aOV3C", function(module, exports) {
$parcel$export(module.exports, "SpotlightHeader", () => $28076445c6e3bb0a$export$d646029b3ba8ab76);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $8C8EQ = parcelRequire("8C8EQ");
const $28076445c6e3bb0a$var$styles = {
    root: "_0LQT5E5zaO _03SyCP8HPE"
};
const $28076445c6e3bb0a$export$d646029b3ba8ab76 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $8C8EQ.Flex), {
        ref: ref,
        testId: testId,
        xcss: $28076445c6e3bb0a$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.100",
        children: children
    });
});

});

parcelRegister("9UyhC", function(module, exports) {
$parcel$export(module.exports, "SpotlightHeadline", () => $64b31e290b30db02$export$b57275b1b6b9863b);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gcAhT = parcelRequire("gcAhT");

var $hFyni = parcelRequire("hFyni");
const $64b31e290b30db02$export$b57275b1b6b9863b = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, testId: testId }, ref)=>{
    const { heading: heading } = (0, $fsvuC.useContext)((0, $hFyni.SpotlightContext));
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $gcAhT.default), {
        id: heading.id,
        ref: ref,
        testId: testId,
        size: "xsmall",
        children: children
    });
});

});

parcelRegister("70rXn", function(module, exports) {
$parcel$export(module.exports, "SpotlightMedia", () => $b004fca63aa85c79$export$cf33151c3f01cd9a);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $fpjto = parcelRequire("fpjto");
const $b004fca63aa85c79$var$styles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _39xV02T1Vg _0jFU0V13wc"
};
const $b004fca63aa85c79$export$cf33151c3f01cd9a = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $fpjto.Box), {
        ref: ref,
        xcss: $b004fca63aa85c79$var$styles.root,
        testId: testId,
        children: children
    });
});

});

parcelRegister("2BaIE", function(module, exports) {
$parcel$export(module.exports, "PopoverProvider", () => $274eb8340763f6ce$export$bf694c7c431c162a);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $5T6N9 = parcelRequire("5T6N9");

var $9Syhw = parcelRequire("9Syhw");

var $aH35G = parcelRequire("aH35G");
const $274eb8340763f6ce$export$bf694c7c431c162a = ({ children: children })=>(0, $5T6N9.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $aH35G.PopoverProvider), {
        children: children
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $9Syhw.PopoverProvider), {
        children: children
    });
$274eb8340763f6ce$export$bf694c7c431c162a.displayName = "PopoverProvider";

});
parcelRegister("9Syhw", function(module, exports) {
$parcel$export(module.exports, "PopoverProvider", () => $7749601b4b1dc065$export$bf694c7c431c162a);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $jWyYj = parcelRequire("jWyYj");

var $hFyni = parcelRequire("hFyni");
const $7749601b4b1dc065$export$bf694c7c431c162a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hFyni.SpotlightContextProvider), {
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $jWyYj.Manager), {
            children: children
        })
    });
};
$7749601b4b1dc065$export$bf694c7c431c162a.displayName = "PopoverProvider";

});

parcelRegister("aH35G", function(module, exports) {
$parcel$export(module.exports, "PopoverProvider", () => $19f947e557e1ab04$export$bf694c7c431c162a);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $hFyni = parcelRequire("hFyni");
const $19f947e557e1ab04$export$bf694c7c431c162a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hFyni.SpotlightContextProvider), {
        children: children
    });
};
$19f947e557e1ab04$export$bf694c7c431c162a.displayName = "PopoverProvider";

});


parcelRegister("hVU2d", function(module, exports) {
$parcel$export(module.exports, "PopoverTarget", () => $f302eae86a91bf6d$export$5ad0c0856b469f13);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $5T6N9 = parcelRequire("5T6N9");

var $68b30 = parcelRequire("68b30");

var $5iwnr = parcelRequire("5iwnr");
const $f302eae86a91bf6d$export$5ad0c0856b469f13 = ({ children: children })=>(0, $5T6N9.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $5iwnr.PopoverTarget), {
        children: children
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $68b30.PopoverTarget), {
        children: children
    });
$f302eae86a91bf6d$export$5ad0c0856b469f13.displayName = "PopoverTarget";

});
parcelRegister("68b30", function(module, exports) {
$parcel$export(module.exports, "PopoverTarget", () => $0a4fbbf64d21bbd4$export$5ad0c0856b469f13);
/* legacy.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $b5Ymx = parcelRequire("b5Ymx");
const $0a4fbbf64d21bbd4$export$5ad0c0856b469f13 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $b5Ymx.Reference), {
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
                ref: ref,
                children: children
            })
    });
};
$0a4fbbf64d21bbd4$export$5ad0c0856b469f13.displayName = "PopoverTarget";

});

parcelRegister("5iwnr", function(module, exports) {
$parcel$export(module.exports, "PopoverTarget", () => $ceedcb86d3576ff5$export$5ad0c0856b469f13);
/* top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $hFyni = parcelRequire("hFyni");
const $ceedcb86d3576ff5$export$5ad0c0856b469f13 = ({ children: children })=>{
    const localRef = (0, $fsvuC.useRef)(null);
    const { target: target } = (0, $fsvuC.useContext)((0, $hFyni.SpotlightContext));
    (0, $fsvuC.useLayoutEffect)(()=>{
        target.setRef(localRef);
    }, [
        target
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: localRef,
        children: children
    });
};
$ceedcb86d3576ff5$export$5ad0c0856b469f13.displayName = "PopoverTarget";

});


parcelRegister("5duXY", function(module, exports) {
$parcel$export(module.exports, "SpotlightPrimaryAction", () => $d360ede83796ba02$export$eea27caf91a85655);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $2YOL2 = parcelRequire("2YOL2");

var $bRV0V = parcelRequire("bRV0V");

var $kBK9z = parcelRequire("kBK9z");

var $hFyni = parcelRequire("hFyni");
const $d360ede83796ba02$var$styles = {
    root: "_0bjKvDKxmn _1UtDYze5R3",
    outline: "_3hxITi6wH8 _2V7sgONvrM _3vBAKHFIvx _0KLXrugozt _1eOmH6kTlo _3gzVzLVbka",
    primary: "_3hxITi6wH8 _2V7sgONvrM _3vBAKHJrlu _0KLXruDM2k _1eOmH6hmrj _3gzVzLczkD"
};
const $d360ede83796ba02$export$eea27caf91a85655 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, appearance: appearance = 'outline', testId: testId }, ref)=>{
    const { primaryAction: primaryAction } = (0, $fsvuC.useContext)((0, $hFyni.SpotlightContext));
    const done = (event)=>{
        primaryAction.action.current(event);
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bRV0V.Pressable), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: (0, $2YOL2.cx)($d360ede83796ba02$var$styles.root, $d360ede83796ba02$var$styles[appearance]),
        onClick: onClick || done,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kBK9z.Text), {
            as: "span",
            children: children
        })
    });
});

});

parcelRegister("vlJo2", function(module, exports) {
$parcel$export(module.exports, "SpotlightSecondaryAction", () => $f312d4c56fc17e62$export$869dfff69399fe87);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $bRV0V = parcelRequire("bRV0V");

var $kBK9z = parcelRequire("kBK9z");

var $hFyni = parcelRequire("hFyni");
const $f312d4c56fc17e62$var$styles = {
    rootMotion: "_0bjKvDKxmn _23rrnHyKLB _1UtDYze5R3 _0KLXrugozt _1eOmH6kTlo _3sFUREiSCN _3gzVzLVbka"
};
const $f312d4c56fc17e62$export$869dfff69399fe87 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId }, ref)=>{
    const { secondaryAction: secondaryAction } = (0, $fsvuC.useContext)((0, $hFyni.SpotlightContext));
    const back = (event)=>{
        secondaryAction.action.current(event);
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bRV0V.Pressable), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $f312d4c56fc17e62$var$styles.rootMotion,
        onClick: onClick || back,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kBK9z.Text), {
            as: "span",
            children: children
        })
    });
});

});

parcelRegister("74qTs", function(module, exports) {
$parcel$export(module.exports, "SpotlightStepCount", () => $3f2897a04b1c9e39$export$f4d9def8bfebca);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $8C8EQ = parcelRequire("8C8EQ");

var $kBK9z = parcelRequire("kBK9z");

var $01oqo = parcelRequire("01oqo");
const $3f2897a04b1c9e39$var$styles = {
    root: "_4ouGXIW9qI"
};
const $3f2897a04b1c9e39$export$f4d9def8bfebca = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $8C8EQ.Flex), {
        xcss: $3f2897a04b1c9e39$var$styles.root,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $kBK9z.Text), {
            ref: ref,
            testId: testId,
            children: [
                children,
                " ",
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $01oqo.default), {
                    children: "steps"
                })
            ]
        })
    });
});

});

parcelRegister("drzMN", function(module, exports) {
$parcel$export(module.exports, "default", () => $9090b8b709f6f7d4$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $5T6N9 = parcelRequire("5T6N9");

var $aEhSe = parcelRequire("aEhSe");

var $biw1y = parcelRequire("biw1y");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $9090b8b709f6f7d4$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $biw1y.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $aEhSe.default), {
                name: name,
                hasNodeResolver: !(0, $5T6N9.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$9090b8b709f6f7d4$var$SpotlightTarget.displayName = "SpotlightTarget";
$9090b8b709f6f7d4$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $9090b8b709f6f7d4$export$2e2bcd8739ae039 = $9090b8b709f6f7d4$var$SpotlightTarget;

});
parcelRegister("aEhSe", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9c7254f09f216fb$export$2e2bcd8739ae039);
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $knrfi = parcelRequire("knrfi");
const $b9c7254f09f216fb$var$spanStyles = null;
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {string} props.name - The name to reference from Spotlight.
 * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $b9c7254f09f216fb$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($knrfi))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        ref: divRef,
        className: (0, $gJ6nT.default)([
            "_3iDTPbcK7c"
        ]),
        children: children
    });
};
$b9c7254f09f216fb$var$NodeResolverSpotlightTarget.displayName = "NodeResolverSpotlightTarget";
$b9c7254f09f216fb$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $b9c7254f09f216fb$export$2e2bcd8739ae039 = $b9c7254f09f216fb$var$NodeResolverSpotlightTarget;

});


parcelRegister("kxfZ1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Box", () => $4233dc5a8a92b3ce$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $4233dc5a8a92b3ce$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $h2YWL = parcelRequire("h2YWL");

var $clHAv = parcelRequire("clHAv");

var $22JLY = parcelRequire("22JLY");

var $biAMw = parcelRequire("biAMw");

var $lyBcK = parcelRequire("lyBcK");

var $hgZMM = parcelRequire("hgZMM");

var $iAPxH = parcelRequire("iAPxH");
function $4233dc5a8a92b3ce$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4233dc5a8a92b3ce$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $hgZMM.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $h2YWL.jsx)(Component, {
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $4233dc5a8a92b3ce$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $22JLY.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $biAMw.isSurfaceColorToken)(backgroundColor) && (0, $iAPxH.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $lyBcK.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $lyBcK.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $lyBcK.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $lyBcK.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $lyBcK.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $lyBcK.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $lyBcK.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $h2YWL.jsx)((0, $clHAv.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$4233dc5a8a92b3ce$export$2e2bcd8739ae039 = $4233dc5a8a92b3ce$export$e71c4d32a2263218;
const $4233dc5a8a92b3ce$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};

});
parcelRegister("22JLY", function(module, exports) {
$parcel$export(module.exports, "backgroundColorStylesMap", () => $93455ccf0001ae76$export$e7af83bafe7f9e63);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3mfqd = parcelRequire("3mfqd");

var $eWiho = parcelRequire("eWiho");
const $93455ccf0001ae76$export$e7af83bafe7f9e63 = (0, $eWiho.getSerializedStylesMap)('backgroundColor', (0, $3mfqd.backgroundColorMap));

});
parcelRegister("3mfqd", function(module, exports) {
$parcel$export(module.exports, "backgroundColorMap", () => $4c1775a1ad4b7300$export$d1d79bf68ac056bd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b9ffd6dcccead720baadbffd4a1648a>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $4c1775a1ad4b7300$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.code.added.highlight': "var(--ds-background-code-added-highlight, #DCFFF1)",
    'color.background.code.added.line': "var(--ds-background-code-added-line, #BAF3DB66)",
    'color.background.code.default': "var(--ds-background-code-default, #FFFFFF)",
    'color.background.code.gutter': "var(--ds-background-code-gutter, #F0F1F2)",
    'color.background.code.highlight': "var(--ds-background-code-highlight, #F0F1F2)",
    'color.background.code.removed.highlight': "var(--ds-background-code-removed-highlight, #FFECEB)",
    'color.background.code.removed.line': "var(--ds-background-code-removed-line, #FFD5D266)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};

});

parcelRegister("eWiho", function(module, exports) {
$parcel$export(module.exports, "getSerializedStylesMap", () => $108f99986316a1ee$export$ca0f9c2de39ffed7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $h2YWL = parcelRequire("h2YWL");
const $108f99986316a1ee$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, tokenName)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[tokenName] = /*#__PURE__*/ (0, $h2YWL.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[tokenName]
        });
        return emotionSpacingMap;
    }, {});
};

});


parcelRegister("biAMw", function(module, exports) {
$parcel$export(module.exports, "isSurfaceColorToken", () => $64e21a551cd57b7d$export$5e65a44e5b6ecadb);

var $8X1LJ = parcelRequire("8X1LJ");
const $64e21a551cd57b7d$export$5e65a44e5b6ecadb = (color)=>(0, $8X1LJ.surfaceColorMap)[color] !== undefined;

});
parcelRegister("8X1LJ", function(module, exports) {
$parcel$export(module.exports, "surfaceColorMap", () => $83b0fe00cda93931$export$41a358c9c2356760);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6c124f7044e82421c90bec6e00efe281>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $83b0fe00cda93931$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #17171708)",
    'elevation.surface.container.hovered': "var(--ds-surface-container-hovered, #0515240F)",
    'elevation.surface.container.pressed': "var(--ds-surface-container-pressed, #0B120E24)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};

});


parcelRegister("lyBcK", function(module, exports) {
$parcel$export(module.exports, "paddingStylesMap", () => $be0c442adad63227$export$e615f061ca585a6c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $dhNCw = parcelRequire("dhNCw");

var $kagey = parcelRequire("kagey");
const $be0c442adad63227$export$e615f061ca585a6c = (0, $dhNCw.createSpacingStylesMap)((0, $kagey.positiveSpaceMap), [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd'
]);

});
parcelRegister("dhNCw", function(module, exports) {
$parcel$export(module.exports, "createSpacingStylesMap", () => $5e091096a70d4d07$export$f2bee1f59203ac70);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eWiho = parcelRequire("eWiho");
const $5e091096a70d4d07$var$spacingProperties = [
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'gap',
    'rowGap',
    'columnGap'
];
const $5e091096a70d4d07$export$f2bee1f59203ac70 = (tokenMap, properties)=>{
    return properties.reduce((styleMap, spacingProperty)=>{
        styleMap[spacingProperty] = (0, $eWiho.getSerializedStylesMap)(spacingProperty, tokenMap);
        return styleMap;
    }, {});
};

});

parcelRegister("kagey", function(module, exports) {
$parcel$export(module.exports, "positiveSpaceMap", () => $ac41ed299f2db967$export$958d0ae7f2977ae4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd46ff4a983762dcab797228d1ab2ee6>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::27b3f9240cb9c6f16e54a6ebd2c859b9>>
 */ const $ac41ed299f2db967$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};

});


parcelRegister("hgZMM", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $ffcb16670692cfe2$export$a9c84988c8f81f2d);
/* parse-xcss.tsx generated by @compiled/babel-plugin v3.0.2 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("fsvuC");

var $7Zsy9 = parcelRequire("7Zsy9");
const $ffcb16670692cfe2$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $ffcb16670692cfe2$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [(0, $7Zsy9.uniqueSymbol)]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};

});
parcelRegister("7Zsy9", function(module, exports) {
$parcel$export(module.exports, "uniqueSymbol", () => $c6c860e4951562d6$export$43e479c916cb4ada);
const $c6c860e4951562d6$export$43e479c916cb4ada = Symbol('UNSAFE_INTERNAL_styles');

});


parcelRegister("iAPxH", function(module, exports) {
$parcel$export(module.exports, "surfaceColorStylesMap", () => $75ba67f236cf8013$export$ff257d957d48c421);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $jJkuL = parcelRequire("jJkuL");

var $eWiho = parcelRequire("eWiho");

var $8X1LJ = parcelRequire("8X1LJ");
const $75ba67f236cf8013$export$ff257d957d48c421 = (0, $eWiho.getSerializedStylesMap)((0, $jJkuL.CURRENT_SURFACE_CSS_VAR), (0, $8X1LJ.surfaceColorMap));

});


parcelRegister("gJeXl", function(module, exports) {
$parcel$export(module.exports, "xcss", () => $65e58d96cd772878$export$f6c783d06584602c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $h2YWL = parcelRequire("h2YWL");

var $8z5o3 = parcelRequire("8z5o3");

var $7Zsy9 = parcelRequire("7Zsy9");

var $hoalA = parcelRequire("hoalA");
const $65e58d96cd772878$var$isSafeEnvToThrow = ()=>typeof $hoalA === 'object' && typeof $hoalA.env === 'object' && false;
const $65e58d96cd772878$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $65e58d96cd772878$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $65e58d96cd772878$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
     // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($65e58d96cd772878$var$transformStyles);
     // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $65e58d96cd772878$var$safeSelectors.test(key)) {
            styleObj[key] = $65e58d96cd772878$var$transformStyles(value);
            return;
        }
        if ($65e58d96cd772878$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($65e58d96cd772878$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        } // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in (0, $8z5o3.tokensMap))) return;
        const tokenValue = (0, $8z5o3.tokensMap)[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $65e58d96cd772878$var$baseXcss = (style)=>{
    const transformedStyles = $65e58d96cd772878$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [(0, $7Zsy9.uniqueSymbol)]: /*#__PURE__*/ (0, $h2YWL.css)(transformedStyles)
    };
};
function $65e58d96cd772878$export$f6c783d06584602c(style) {
    return $65e58d96cd772878$var$baseXcss(style);
}

});
parcelRegister("8z5o3", function(module, exports) {
$parcel$export(module.exports, "tokensMap", () => $adf67bde377679e3$export$9a199fbafee0014e);

var $loeno = parcelRequire("loeno");

var $3mfqd = parcelRequire("3mfqd");

var $2IYSU = parcelRequire("2IYSU");

var $u855d = parcelRequire("u855d");

var $1n7IK = parcelRequire("1n7IK");

var $4cmoi = parcelRequire("4cmoi");

var $2FnbH = parcelRequire("2FnbH");

var $4M3qC = parcelRequire("4M3qC");

var $lrT68 = parcelRequire("lrT68");

var $flcK3 = parcelRequire("flcK3");

var $bGckj = parcelRequire("bGckj");

var $ifUZT = parcelRequire("ifUZT");

var $kagey = parcelRequire("kagey");

var $gZN6b = parcelRequire("gZN6b");

var $1Mlbr = parcelRequire("1Mlbr");
const $adf67bde377679e3$export$9a199fbafee0014e = {
    backgroundColor: (0, $3mfqd.backgroundColorMap),
    blockSize: (0, $4cmoi.dimensionMap),
    borderBlockColor: (0, $2IYSU.borderColorMap),
    borderBlockEndColor: (0, $2IYSU.borderColorMap),
    borderBlockEndWidth: (0, $1n7IK.borderWidthMap),
    borderBlockStartColor: (0, $2IYSU.borderColorMap),
    borderBlockStartWidth: (0, $1n7IK.borderWidthMap),
    borderBlockWidth: (0, $1n7IK.borderWidthMap),
    borderBottomColor: (0, $2IYSU.borderColorMap),
    borderBottomLeftRadius: (0, $u855d.borderRadiusMap),
    borderBottomRightRadius: (0, $u855d.borderRadiusMap),
    borderBottomWidth: (0, $1n7IK.borderWidthMap),
    borderColor: (0, $2IYSU.borderColorMap),
    borderEndEndRadius: (0, $u855d.borderRadiusMap),
    borderEndStartRadius: (0, $u855d.borderRadiusMap),
    borderInlineColor: (0, $2IYSU.borderColorMap),
    borderInlineEndColor: (0, $2IYSU.borderColorMap),
    borderInlineEndWidth: (0, $1n7IK.borderWidthMap),
    borderInlineStartColor: (0, $2IYSU.borderColorMap),
    borderInlineStartWidth: (0, $1n7IK.borderWidthMap),
    borderInlineWidth: (0, $1n7IK.borderWidthMap),
    borderLeftColor: (0, $2IYSU.borderColorMap),
    borderLeftWidth: (0, $1n7IK.borderWidthMap),
    borderRadius: (0, $u855d.borderRadiusMap),
    borderRightColor: (0, $2IYSU.borderColorMap),
    borderRightWidth: (0, $1n7IK.borderWidthMap),
    borderStartEndRadius: (0, $u855d.borderRadiusMap),
    borderStartStartRadius: (0, $u855d.borderRadiusMap),
    borderTopColor: (0, $2IYSU.borderColorMap),
    borderTopLeftRadius: (0, $u855d.borderRadiusMap),
    borderTopRightRadius: (0, $u855d.borderRadiusMap),
    borderTopWidth: (0, $1n7IK.borderWidthMap),
    borderWidth: (0, $1n7IK.borderWidthMap),
    bottom: (0, $loeno.allSpaceMap),
    boxShadow: (0, $gZN6b.shadowMap),
    color: (0, $1Mlbr.textColorMap),
    columnGap: (0, $flcK3.gapSpaceMap),
    font: (0, $2FnbH.fontMap),
    fontFamily: (0, $4M3qC.fontFamilyMap),
    fontWeight: (0, $lrT68.fontWeightMap),
    gap: (0, $flcK3.gapSpaceMap),
    height: (0, $4cmoi.dimensionMap),
    inlineSize: (0, $4cmoi.dimensionMap),
    inset: (0, $loeno.allSpaceMap),
    insetBlock: (0, $loeno.allSpaceMap),
    insetBlockEnd: (0, $loeno.allSpaceMap),
    insetBlockStart: (0, $loeno.allSpaceMap),
    insetInline: (0, $loeno.allSpaceMap),
    insetInlineEnd: (0, $loeno.allSpaceMap),
    insetInlineStart: (0, $loeno.allSpaceMap),
    left: (0, $loeno.allSpaceMap),
    margin: (0, $loeno.allSpaceMap),
    marginBlock: (0, $loeno.allSpaceMap),
    marginBlockEnd: (0, $loeno.allSpaceMap),
    marginBlockStart: (0, $loeno.allSpaceMap),
    marginBottom: (0, $loeno.allSpaceMap),
    marginInline: (0, $loeno.allSpaceMap),
    marginInlineEnd: (0, $loeno.allSpaceMap),
    marginInlineStart: (0, $loeno.allSpaceMap),
    marginLeft: (0, $loeno.allSpaceMap),
    marginRight: (0, $loeno.allSpaceMap),
    marginTop: (0, $loeno.allSpaceMap),
    maxBlockSize: (0, $4cmoi.dimensionMap),
    maxHeight: (0, $4cmoi.dimensionMap),
    maxInlineSize: (0, $4cmoi.dimensionMap),
    maxWidth: (0, $4cmoi.dimensionMap),
    minBlockSize: (0, $4cmoi.dimensionMap),
    minHeight: (0, $4cmoi.dimensionMap),
    minInlineSize: (0, $4cmoi.dimensionMap),
    minWidth: (0, $4cmoi.dimensionMap),
    opacity: (0, $ifUZT.opacityMap),
    outlineColor: (0, $2IYSU.borderColorMap),
    outlineOffset: (0, $loeno.allSpaceMap),
    outlineWidth: (0, $1n7IK.borderWidthMap),
    padding: (0, $kagey.positiveSpaceMap),
    paddingBlock: (0, $kagey.positiveSpaceMap),
    paddingBlockEnd: (0, $kagey.positiveSpaceMap),
    paddingBlockStart: (0, $kagey.positiveSpaceMap),
    paddingBottom: (0, $kagey.positiveSpaceMap),
    paddingInline: (0, $kagey.positiveSpaceMap),
    paddingInlineEnd: (0, $kagey.positiveSpaceMap),
    paddingInlineStart: (0, $kagey.positiveSpaceMap),
    paddingLeft: (0, $kagey.positiveSpaceMap),
    paddingRight: (0, $kagey.positiveSpaceMap),
    paddingTop: (0, $kagey.positiveSpaceMap),
    right: (0, $loeno.allSpaceMap),
    rowGap: (0, $flcK3.gapSpaceMap),
    top: (0, $loeno.allSpaceMap),
    width: (0, $4cmoi.dimensionMap),
    zIndex: (0, $bGckj.layerMap)
};

});
parcelRegister("loeno", function(module, exports) {
$parcel$export(module.exports, "allSpaceMap", () => $643b82e5ad23295d$export$632685d741f3dbbf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3cc1af374b7280144c0465457ed9f756>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::27b3f9240cb9c6f16e54a6ebd2c859b9>>
 */ const $643b82e5ad23295d$export$632685d741f3dbbf = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};

});

parcelRegister("2IYSU", function(module, exports) {
$parcel$export(module.exports, "borderColorMap", () => $71a2a32c7cd110c1$export$1531ad5bb3fbedac);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2852cd6e8656adbef1c6b8cb926235c9>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $71a2a32c7cd110c1$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.code': "var(--ds-border-code, #0B120E24)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.input.search': "var(--ds-border-input-search, #0B120E24)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};

});

parcelRegister("u855d", function(module, exports) {
$parcel$export(module.exports, "borderRadiusMap", () => $ac4bc8caf2829b84$export$3c0a6c3e64bb180d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aac51b10fd4c84e2b653aff461a93b73>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::419cf7fccef8a341df2ce9890e3cdad2>>
 */ const $ac4bc8caf2829b84$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};

});

parcelRegister("1n7IK", function(module, exports) {
$parcel$export(module.exports, "borderWidthMap", () => $df6daede14944f24$export$e1b83c5210c471b8);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cdb9fba904c3ac54bf1c429a821ffc2>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-shape.tsx <<SignedSource::419cf7fccef8a341df2ce9890e3cdad2>>
 */ const $df6daede14944f24$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};

});

parcelRegister("4cmoi", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $888925e4a5770e88$export$6ccdbebca2ee545f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e4616710c813452a5dda10e6c422716>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 */ const $888925e4a5770e88$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};

});

parcelRegister("2FnbH", function(module, exports) {
$parcel$export(module.exports, "fontMap", () => $0a9666d6db6d0cfd$export$6ffa317d5e70375);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9dc903b89132658c3e8db351b3cf92f>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $0a9666d6db6d0cfd$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("4M3qC", function(module, exports) {
$parcel$export(module.exports, "fontFamilyMap", () => $96a0fe56b18da667$export$3c7e9587132614b4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1bd05ea1282426e07fb0ae630b07823d>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $96a0fe56b18da667$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};

});

parcelRegister("lrT68", function(module, exports) {
$parcel$export(module.exports, "fontWeightMap", () => $88db52066bdfb55a$export$303e322c6b1ed114);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::709c4cdac6e8ef806ec1e227c3e362d1>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $88db52066bdfb55a$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};

});

parcelRegister("flcK3", function(module, exports) {
$parcel$export(module.exports, "gapSpaceMap", () => $1273a50550a92c43$export$ae2d66f16ab57ecd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71d191c679a99ef0b72b3412372b1db9>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-spacing.tsx <<SignedSource::27b3f9240cb9c6f16e54a6ebd2c859b9>>
 */ const $1273a50550a92c43$export$ae2d66f16ab57ecd = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)",
    'space.gap.large': "var(--ds-space-gap-large, 12px)",
    'space.gap.medium': "var(--ds-space-gap-medium, 8px)",
    'space.gap.small': "var(--ds-space-gap-small, 6px)",
    'space.gap.xlarge': "var(--ds-space-gap-xlarge, 16px)",
    'space.gap.xsmall': "var(--ds-space-gap-xsmall, 4px)",
    'space.gap.xxlarge': "var(--ds-space-gap-xxlarge, 24px)",
    'space.gap.xxsmall': "var(--ds-space-gap-xxsmall, 2px)"
};

});

parcelRegister("bGckj", function(module, exports) {
$parcel$export(module.exports, "layerMap", () => $0271cf99349046c6$export$b5f31a7e431d2eab);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::10940883f780b624bff6c0029b7ac6fd>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../scripts/codegen-file-templates/dimensions.tsx <<SignedSource::cc9b3f12104c6ede803da6a42daac0b0>>
 * @codegenDependency ../../scripts/codegen-file-templates/layer.tsx <<SignedSource::92793ca02dbfdad66e53ffbe9f0baa0a>>
 */ const $0271cf99349046c6$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};

});

parcelRegister("ifUZT", function(module, exports) {
$parcel$export(module.exports, "opacityMap", () => $f8359fabf4909f08$export$daf94a976c798b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f768e44d85ca8256730a17510c4d3901>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $f8359fabf4909f08$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};

});

parcelRegister("gZN6b", function(module, exports) {
$parcel$export(module.exports, "shadowMap", () => $0acf78cfc2dcb0c2$export$7aff6e7ba39bb774);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::31f7af0716c25896201100f27266bca7>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $0acf78cfc2dcb0c2$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};

});

parcelRegister("1Mlbr", function(module, exports) {
$parcel$export(module.exports, "textColorMap", () => $d919384688f5a798$export$8473307aa00d6ea1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c49ded1370dd9125e2572ecce0dec81>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */ const $d919384688f5a798$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.code.accent.1': "var(--ds-text-code-accent-1, #943D73)",
    'color.text.code.accent.2': "var(--ds-text-code-accent-2, #1558BC)",
    'color.text.code.comments': "var(--ds-text-code-comments, #505258)",
    'color.text.code.default': "var(--ds-text-code-default, #505258)",
    'color.text.code.functions': "var(--ds-text-code-functions, #216E4E)",
    'color.text.code.gutter': "var(--ds-text-code-gutter, #6B6E76)",
    'color.text.code.keywords': "var(--ds-text-code-keywords, #AE2E24)",
    'color.text.code.numbers': "var(--ds-text-code-numbers, #7F5F01)",
    'color.text.code.operators': "var(--ds-text-code-operators, #292A2E)",
    'color.text.code.strings': "var(--ds-text-code-strings, #4C6B1F)",
    'color.text.code.tags': "var(--ds-text-code-tags, #9E4C00)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};

});



parcelRegister("76zfX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $fbf5b870dce0e89a$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $cpUTy = parcelRequire("cpUTy");

var $2COqC = parcelRequire("2COqC");

var $5h9Qx = parcelRequire("5h9Qx");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $fbf5b870dce0e89a$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $cpUTy.default), {
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName,
        ...saferRest,
        children: [
            iconBefore && /*#__PURE__*/ (0, $5chsV.jsx)((0, $2COqC.default), {
                type: "icon",
                position: "before",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5h9Qx.default), {
                    icon: iconBefore,
                    spacing: spacing
                })
            }),
            children && /*#__PURE__*/ (0, $5chsV.jsx)((0, $2COqC.default), {
                isLoading: isLoading,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $5chsV.jsx)((0, $2COqC.default), {
                type: "icon",
                position: "after",
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5h9Qx.default), {
                    icon: iconAfter,
                    spacing: spacing
                })
            })
        ]
    });
}));
$fbf5b870dce0e89a$var$Button.displayName = 'Button';
var $fbf5b870dce0e89a$export$2e2bcd8739ae039 = $fbf5b870dce0e89a$var$Button;

});

parcelRegister("j5tZH", function(module, exports) {
$parcel$export(module.exports, "Flex", () => $ede3022312e50085$export$f51f4c4ede09e011);
$parcel$export(module.exports, "default", () => $ede3022312e50085$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $h2YWL = parcelRequire("h2YWL");

var $hgZMM = parcelRequire("hgZMM");

var $jzlOE = parcelRequire("jzlOE");
function $ede3022312e50085$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ede3022312e50085$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $ede3022312e50085$var$flexDirectionMap = {
    column: {
        name: "qdeacm",
        styles: "flex-direction:column"
    },
    row: {
        name: "mcnhyd",
        styles: "flex-direction:row"
    }
};
const $ede3022312e50085$var$flexWrapMap = {
    wrap: {
        name: "1qemjat",
        styles: "flex-wrap:wrap"
    },
    nowrap: {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    }
};
const $ede3022312e50085$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    },
    stretch: {
        name: "1ikgkii",
        styles: "align-items:stretch"
    }
};
const $ede3022312e50085$var$baseStyles = {
    name: "kxpnum",
    styles: "display:flex;box-sizing:border-box"
};
const $ede3022312e50085$export$f51f4c4ede09e011 = /*#__PURE__*/ (0, $fsvuC.memo)(/*#__PURE__*/ (0, $fsvuC.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, id: id }, ref)=>{
    const resolvedStyles = (0, $hgZMM.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $h2YWL.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $ede3022312e50085$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $jzlOE.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $jzlOE.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $jzlOE.spaceStylesMap).rowGap[rowGap],
            alignItems && $ede3022312e50085$var$alignItemsMap[alignItems],
            direction && $ede3022312e50085$var$flexDirectionMap[direction],
            justifyContent && $ede3022312e50085$var$justifyContentMap[justifyContent],
            wrap && $ede3022312e50085$var$flexWrapMap[wrap],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$ede3022312e50085$export$f51f4c4ede09e011.displayName = 'Flex';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ede3022312e50085$export$2e2bcd8739ae039 = $ede3022312e50085$export$f51f4c4ede09e011;

});
parcelRegister("jzlOE", function(module, exports) {
$parcel$export(module.exports, "spaceStylesMap", () => $9e41aaee70f8dd65$export$bf46c3f9eeafc71f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $dhNCw = parcelRequire("dhNCw");

var $flcK3 = parcelRequire("flcK3");
const $9e41aaee70f8dd65$export$bf46c3f9eeafc71f = (0, $dhNCw.createSpacingStylesMap)((0, $flcK3.gapSpaceMap), [
    'gap',
    'rowGap',
    'columnGap'
]);

});


parcelRegister("159VF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "Pressable", () => $f4e663f45dd926de$export$27c701ed9e449e99);
$parcel$export(module.exports, "default", () => $f4e663f45dd926de$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $h2YWL = parcelRequire("h2YWL");

var $fkuHa = parcelRequire("fkuHa");

var $iqo7S = parcelRequire("iqo7S");

var $6Pi1A = parcelRequire("6Pi1A");

var $22JLY = parcelRequire("22JLY");

var $2IYSU = parcelRequire("2IYSU");

var $1n7IK = parcelRequire("1n7IK");

var $lyBcK = parcelRequire("lyBcK");

var $hgZMM = parcelRequire("hgZMM");

var $kagey = parcelRequire("kagey");
function $f4e663f45dd926de$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $f4e663f45dd926de$var$focusRingStyles = /*#__PURE__*/ (0, $h2YWL.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $2IYSU.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $kagey.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $1n7IK.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $1n7IK.borderWidthMap)['border.width']} solid`
        }
    }
});
const $f4e663f45dd926de$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
const $f4e663f45dd926de$var$enabledStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $f4e663f45dd926de$var$disabledStyles = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
const $f4e663f45dd926de$export$27c701ed9e449e99 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $iqo7S.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $fsvuC.useContext)((0, $6Pi1A.default));
    const handleClick = (0, $fsvuC.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $fkuHa.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $hgZMM.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $h2YWL.jsx)("button", {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $f4e663f45dd926de$var$baseStyles,
            $f4e663f45dd926de$var$focusRingStyles,
            isDisabled ? $f4e663f45dd926de$var$disabledStyles : $f4e663f45dd926de$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $22JLY.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $lyBcK.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $lyBcK.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $lyBcK.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $lyBcK.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $lyBcK.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $lyBcK.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $lyBcK.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId
    }, children);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f4e663f45dd926de$export$2e2bcd8739ae039 = $f4e663f45dd926de$export$27c701ed9e449e99;

});

parcelRegister("gE4pd", function(module, exports) {
$parcel$export(module.exports, "getTokenValue", () => $61436fb8bce09daf$export$37e2c47c7e49c28a);


var $jw6Xp = parcelRequire("jw6Xp");

var $hoalA = parcelRequire("hoalA");
function $61436fb8bce09daf$export$37e2c47c7e49c28a(tokenId, fallback = '') {
    let token = (0, $jw6Xp.default)[tokenId];
    let tokenValue = fallback;
    typeof $hoalA;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $61436fb8bce09daf$export$2e2bcd8739ae039 = $61436fb8bce09daf$export$37e2c47c7e49c28a;

});

parcelRegister("ce865", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c4ef75f8de0c36c$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $76zfX = parcelRequire("76zfX");


var $1cXpO = parcelRequire("1cXpO");

var $iqo7S = parcelRequire("iqo7S");

var $avtnw = parcelRequire("avtnw");

var $2Yxk5 = parcelRequire("2Yxk5");

var $9cVKi = parcelRequire("9cVKi");

var $1wCqK = parcelRequire("1wCqK");

var $5T6N9 = parcelRequire("5T6N9");

var $2LKzh = parcelRequire("2LKzh");

var $QrsDO = parcelRequire("QrsDO");

var $eWP2e = parcelRequire("eWP2e");

var $5G75S = parcelRequire("5G75S");

var $3HWXX = parcelRequire("3HWXX");

var $kASaR = parcelRequire("kASaR");

var $h0Ojh = parcelRequire("h0Ojh");

var $dmvfi = parcelRequire("dmvfi");
const $4c4ef75f8de0c36c$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $4c4ef75f8de0c36c$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $4c4ef75f8de0c36c$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$4c4ef75f8de0c36c$var$opposites[crossAxis]}`,
            `${$4c4ef75f8de0c36c$var$opposites[mainAxis]}-${crossAxis}`,
            `${$4c4ef75f8de0c36c$var$opposites[mainAxis]}`,
            `${$4c4ef75f8de0c36c$var$opposites[mainAxis]}-${$4c4ef75f8de0c36c$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$4c4ef75f8de0c36c$var$opposites[mainAxis]}`,
        `${$4c4ef75f8de0c36c$var$opposites[mainAxis]}-start`,
        `${$4c4ef75f8de0c36c$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $4c4ef75f8de0c36c$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ function $4c4ef75f8de0c36c$var$DropdownMenuLegacy({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $iqo7S.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $QrsDO.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $avtnw.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $fsvuC.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $fsvuC.useState)(false);
    const id = (0, $dmvfi.default)();
    const itemRef = (0, $h0Ojh.default)();
    const { currentLevel: currentLevel } = (0, $1wCqK.useLayering)();
    const fallbackPlacements = (0, $fsvuC.useMemo)(()=>$4c4ef75f8de0c36c$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $fsvuC.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $fsvuC.useCallback)((event, currentLevel)=>{
        const isTabLeftOrEscapeKey = $4c4ef75f8de0c36c$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $4096afce6d06a916$export$fc4577f2a2af0ae3));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $4c4ef75f8de0c36c$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $4096afce6d06a916$export$fc4577f2a2af0ae3))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $dmvfi.PREFIX)}] [aria-haspopup="menu"], [id^=${(0, $dmvfi.PREFIX)}] [aria-haspopup="true"]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($4c4ef75f8de0c36c$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $4096afce6d06a916$export$fc4577f2a2af0ae3))) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $2Yxk5.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $fsvuC.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $iqo7S.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $iqo7S.default;
        return (0, $dqdTY.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $dmvfi.PREFIX)}] [aria-haspopup="menu"], [id^=${(0, $dmvfi.PREFIX)}] [aria-haspopup="true"]`);
                if (e.key === (0, $4096afce6d06a916$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $4096afce6d06a916$export$e51a3576c045c8d5) || e.key === (0, $4096afce6d06a916$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $4096afce6d06a916$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $kASaR.default), {
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $2LKzh.Popup), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $1cXpO.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $5chsV.jsx)((0, $76zfX.default), {
                    ...bindFocus,
                    ref: (0, $1cXpO.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9cVKi))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            // Legacy only. Run time passes the setter for every role; the types hide it.
            // The cast goes at the flag cleanup.
            content: (contentProps)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $5G75S.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $3HWXX.default), {
                        spacing: spacing,
                        maxHeight: $4c4ef75f8de0c36c$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: contentProps.update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? contentProps.setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
}
$4c4ef75f8de0c36c$var$DropdownMenuLegacy.displayName = "DropdownMenuLegacy";
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $4c4ef75f8de0c36c$var$DropdownMenu = (props)=>{
    const { autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading, isOpen: isOpen, onOpenChange: onOpenChange = (0, $iqo7S.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    if ((0, $5T6N9.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $eWP2e.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, $5chsV.jsx)($4c4ef75f8de0c36c$var$DropdownMenuLegacy, {
        ...props
    });
};
$4c4ef75f8de0c36c$var$DropdownMenu.displayName = "DropdownMenu";
var $4c4ef75f8de0c36c$export$2e2bcd8739ae039 = $4c4ef75f8de0c36c$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $4096afce6d06a916$export$390330c10ff2b9a1 = 'ArrowUp';
const $4096afce6d06a916$export$a80636c6f41931fe = 'ArrowDown';
const $4096afce6d06a916$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $4096afce6d06a916$export$c40f9845adc73fb5 = 'ArrowRight';
const $4096afce6d06a916$export$4af703091671bc = 'Home';
const $4096afce6d06a916$export$e2bc30913faa5db7 = 'End';
const $4096afce6d06a916$export$10f6869ed0a7d75b = 'Tab';
const $4096afce6d06a916$export$8152f929a25a0ff4 = 'Enter';
const $4096afce6d06a916$export$e51a3576c045c8d5 = 'Space';
const $4096afce6d06a916$export$2bb790b9008907b4 = 'Escape';

parcelRegister("avtnw", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0a6b56ec5fa5e1b$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
function $f0a6b56ec5fa5e1b$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $fsvuC.useState)(getDefaultPropValue);
    const isControlledRef = (0, $fsvuC.useRef)(isControlled);
    (0, $fsvuC.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $fsvuC.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("2Yxk5", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fde8ff540167697$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
function $3fde8ff540167697$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $fsvuC.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $fsvuC.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $fsvuC.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("eWP2e", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a6d6ea1dc21130e$export$2e2bcd8739ae039);
/* dropdown-menu-top-layer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $dqdTY = parcelRequire("dqdTY");

var $76zfX = parcelRequire("76zfX");


var $iqo7S = parcelRequire("iqo7S");

var $avtnw = parcelRequire("avtnw");

var $2Yxk5 = parcelRequire("2Yxk5");

var $9cVKi = parcelRequire("9cVKi");

var $gs9oK = parcelRequire("gs9oK");

var $k403E = parcelRequire("k403E");

var $bkfvF = parcelRequire("bkfvF");

var $5z6YI = parcelRequire("5z6YI");

var $iR2qO = parcelRequire("iR2qO");

var $lscZ9 = parcelRequire("lscZ9");

var $6AVCN = parcelRequire("6AVCN");

var $7DQ7q = parcelRequire("7DQ7q");

var $kmtsi = parcelRequire("kmtsi");

var $74Lna = parcelRequire("74Lna");

var $kASaR = parcelRequire("kASaR");
const $8a6d6ea1dc21130e$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $8a6d6ea1dc21130e$var$styles = {
    spinnerContainer: "_3iDTPbQ4SZ _4ouGXIoaux _37wbyuDIqT _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
};
function $8a6d6ea1dc21130e$var$getRootMenuPopover({ menu: menu }) {
    const parentMenu = menu.parentElement?.closest('[popover][role="menu"]');
    if (!parentMenu) return menu;
    return $8a6d6ea1dc21130e$var$getRootMenuPopover({
        menu: parentMenu
    });
}
/**
 * Loading indicator for the dropdown menu.
 */ function $8a6d6ea1dc21130e$var$LoadingIndicator({ statusLabel: statusLabel = 'Loading', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        role: "menuitem",
        className: (0, $gJ6nT.default)([
            $8a6d6ea1dc21130e$var$styles.spinnerContainer
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $k403E.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
}
$8a6d6ea1dc21130e$var$LoadingIndicator.displayName = "LoadingIndicator";
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $8a6d6ea1dc21130e$var$DropdownMenuTopLayer({ children: children, defaultOpen: defaultOpen = false, isLoading: isLoading, isOpen: isOpenProp, onOpenChange: onOpenChange = (0, $iqo7S.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $avtnw.default)(isOpenProp, ()=>defaultOpen);
    const triggerRef = (0, $fsvuC.useRef)(null);
    const popoverRef = (0, $fsvuC.useRef)(null);
    const setPopoverRef = (0, $fsvuC.useCallback)((element)=>{
        popoverRef.current = element;
        // Leave untouched menus without a busy state; retain false once it has been set.
        if (isLoading !== undefined || element?.hasAttribute('aria-busy')) element?.setAttribute('aria-busy', String(Boolean(isLoading)));
    }, [
        isLoading
    ]);
    const popoverId = (0, $74Lna.usePopoverId)();
    const topLayerPlacement = (0, $fsvuC.useMemo)(()=>(0, $iR2qO.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]);
    // DropdownMenu has no `shouldFitViewport` equivalent, so neither axis ever
    // fits and `blockSize` stays `'content'` - `MenuGroup`'s `maxHeight` owns the
    // block axis.
    (0, $7DQ7q.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen,
        inlineSize: shouldFitContainer ? 'min-anchor' : 'content'
    });
    // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    const handleOnClose = (0, $fsvuC.useCallback)(()=>{
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    // Trigger click handling.
    const handleTriggerClicked = (0, $fsvuC.useCallback)((event)=>{
        const nextIsOpen = !isLocalOpen;
        setLocalIsOpen(nextIsOpen);
        // Extract the native DOM event for onOpenChange
        const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: nextIsOpen,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $2Yxk5.default)();
    // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $fsvuC.useEffect)(()=>{
        if (!isFocused || isLocalOpen) return;
        // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        const isNestedTrigger = Boolean(triggerRef.current?.closest('[role="menu"]'));
        return (0, $dqdTY.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $4096afce6d06a916$export$a80636c6f41931fe) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]);
    const handleNestedOpen = (0, $fsvuC.useCallback)(({ trigger: trigger })=>{
        if (!trigger.matches('[aria-haspopup="menu"], [aria-haspopup="true"]')) return;
        trigger.click();
    }, []);
    const handleTabClose = (0, $fsvuC.useCallback)(()=>{
        const currentMenu = popoverRef.current;
        if (!currentMenu) return;
        // Hiding the root native popover synchronously closes its descendant popovers and restores
        // focus to the root trigger. The browser can then perform the Tab default action from there.
        $8a6d6ea1dc21130e$var$getRootMenuPopover({
            menu: currentMenu
        }).hidePopover();
    }, []);
    (0, $kmtsi.useArrowNavigation)({
        containerRef: popoverRef,
        onClose: handleTabClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleOnClose,
        isEnabled: isLocalOpen,
        filter: (0, $5z6YI.isAtCurrentMenuLevel)
    });
    // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested submenu triggers.
    const handleMenuClick = (0, $fsvuC.useCallback)((e)=>{
        if (!(e.target instanceof Element)) return;
        const menuItem = e.target.closest?.('[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        const isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio';
        // Only menu/true popup values identify submenus.
        // The nested dropdown will handle its own open/close.
        const isNestedTrigger = menuItem.matches('[aria-haspopup="menu"], [aria-haspopup="true"]');
        if (!isCheckboxOrRadio && !isNestedTrigger) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    const ariaAttributes = (0, $bkfvF.getAriaForTrigger)({
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    });
    /**
   * Custom trigger consumers historically receive a callback ref,
   * and their code assumes it is one.
   * Using this wrapper for compatibility...
   */ const setTriggerRef = (0, $fsvuC.useCallback)((node)=>{
        triggerRef.current = node;
    }, []);
    const renderTrigger = ()=>{
        if (typeof trigger === 'function') return trigger({
            ...ariaAttributes,
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            triggerRef: setTriggerRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`
        });
        return /*#__PURE__*/ (0, $5chsV.jsx)((0, $76zfX.default), {
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            ref: setTriggerRef,
            ...ariaAttributes,
            isSelected: isLocalOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9cVKi))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`,
            "aria-label": label,
            interactionName: interactionName,
            children: trigger
        });
    };
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $kASaR.default), {
        children: [
            renderTrigger(),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $6AVCN.Popover), {
                ref: setPopoverRef,
                id: popoverId,
                role: "menu",
                label: menuLabel ?? label ?? (typeof trigger === 'string' ? trigger : 'Menu'),
                isOpen: isLocalOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--content`,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $lscZ9.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $gs9oK.default), {
                        maxHeight: $8a6d6ea1dc21130e$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClick: handleMenuClick,
                        spacing: spacing,
                        testId: testId && `${testId}--menu-wrapper--menu-group`,
                        children: isLoading ? /*#__PURE__*/ (0, $5chsV.jsx)($8a6d6ea1dc21130e$var$LoadingIndicator, {
                            statusLabel: statusLabel,
                            testId: testId && `${testId}--menu-wrapper--loading-indicator`
                        }) : children
                    })
                })
            })
        ]
    });
}
$8a6d6ea1dc21130e$var$DropdownMenuTopLayer.displayName = "DropdownMenuTopLayer";
var $8a6d6ea1dc21130e$export$2e2bcd8739ae039 = $8a6d6ea1dc21130e$var$DropdownMenuTopLayer;

});
parcelRegister("gs9oK", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a62f828e540db59$export$2e2bcd8739ae039);
/* menu-group.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $cUgBc = parcelRequire("cUgBc");

var $7ZgJa = parcelRequire("7ZgJa");
const $6a62f828e540db59$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $6a62f828e540db59$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', menuLabel: menuLabel, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $cUgBc.SpacingContext).Provider, {
        value: spacing,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $7ZgJa.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "border",
            children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                "aria-busy": isLoading,
                style: {
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    minHeight: minHeight,
                    maxHeight: maxHeight
                },
                "data-testid": testId,
                role: role,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $gJ6nT.default)([
                    "_4bt5LAIZbP _2WAcuGIZbP _3iDTPbQ4SZ _1mT5xd5HSx _0aFT5vbt8w",
                    UNSAFE_className
                ]),
                "aria-label": menuLabel,
                ...rest
            })
        })
    });
$6a62f828e540db59$var$MenuGroup.displayName = "MenuGroup";
var $6a62f828e540db59$export$2e2bcd8739ae039 = $6a62f828e540db59$var$MenuGroup;

});
parcelRegister("cUgBc", function(module, exports) {
$parcel$export(module.exports, "SpacingContext", () => $ed297e0f5605ab24$export$443076ec7ebce042);

var $fsvuC = parcelRequire("fsvuC");
const $ed297e0f5605ab24$export$443076ec7ebce042 = /*#__PURE__*/ (0, $fsvuC.createContext)('cozy');

});

parcelRegister("7ZgJa", function(module, exports) {
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $422158e8eb59a577$export$9ca534b70725964d);

var $fsvuC = parcelRequire("fsvuC");
const $422158e8eb59a577$export$9ca534b70725964d = /*#__PURE__*/ (0, $fsvuC.createContext)('border');

});


parcelRegister("5z6YI", function(module, exports) {
$parcel$export(module.exports, "isAtCurrentMenuLevel", () => $95d3aa7d6875fa90$export$f1bba0ef464d60af);
const $95d3aa7d6875fa90$var$menuSelector = '[role="menu"]';
/**
 * Walks up from `element` and returns `true` when it reaches `container` before any other
 * `role="menu"` element.
 */ function $95d3aa7d6875fa90$var$reachesContainerWithoutNestedMenu({ element: element, container: container }) {
    if (!element) return false;
    if (element === container) return true;
    if (element.getAttribute('role') === 'menu') return false;
    return $95d3aa7d6875fa90$var$reachesContainerWithoutNestedMenu({
        element: element.parentElement,
        container: container
    });
}
function $95d3aa7d6875fa90$export$f1bba0ef464d60af(element, container) {
    const closestMenu = element.closest($95d3aa7d6875fa90$var$menuSelector);
    // Pattern 1: the element belongs to this level if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Pattern 2: the container is a wrapper without `role="menu"`. An element in no menu belongs to
    // this level.
    if (closestMenu === null) return true;
    // Start from the parent, so the walk does not stop at `closestMenu` itself.
    return $95d3aa7d6875fa90$var$reachesContainerWithoutNestedMenu({
        element: closestMenu.parentElement,
        container: container
    });
}

});

parcelRegister("kmtsi", function(module, exports) {
$parcel$export(module.exports, "useArrowNavigation", () => $2565731d43f758f2$export$23dfbae28e0cc453);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");


var $7JsUS = parcelRequire("7JsUS");

var $joN5p = parcelRequire("joN5p");

var $cwd0u = parcelRequire("cwd0u");
const $2565731d43f758f2$var$menuSelector = '[role="menu"]';
/**
 * Whether the focused element belongs to this menu level, so the hook acts on the key. A nested
 * menu handles its own keys.
 */ function $2565731d43f758f2$var$isFocusedElementAtThisLevel({ focusedElement: focusedElement, container: container, filter: filter }) {
    if (!(focusedElement instanceof HTMLElement)) return true;
    if (filter) return filter(focusedElement, container);
    if (container.getAttribute('role') !== 'menu') return true;
    return focusedElement.closest($2565731d43f758f2$var$menuSelector) === container;
}
function $2565731d43f758f2$export$23dfbae28e0cc453({ containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: isEnabled = true, filter: filter }) {
    const handleKeyDown = (0, $fsvuC.useCallback)((event)=>{
        const container = containerRef.current;
        if (!container) return;
        const focusedElement = container.ownerDocument.activeElement;
        if (!$2565731d43f758f2$var$isFocusedElementAtThisLevel({
            focusedElement: focusedElement,
            container: container,
            filter: filter
        })) return;
        if (event.key === (0, $4096afce6d06a916$export$a80636c6f41931fe)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $cwd0u.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4096afce6d06a916$export$390330c10ff2b9a1)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $cwd0u.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4096afce6d06a916$export$4af703091671bc)) {
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (0, $7JsUS.getFirstFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4096afce6d06a916$export$e2bc30913faa5db7)) {
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (0, $joN5p.getLastFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $4096afce6d06a916$export$10f6869ed0a7d75b)) {
            onClose();
            return;
        }
        // Nested menus (WAI-ARIA menu pattern): ArrowRight on an item with `aria-haspopup` opens
        // its submenu.
        if (event.key === (0, $4096afce6d06a916$export$c40f9845adc73fb5)) {
            if (onNestedOpen && focusedElement instanceof HTMLElement && focusedElement.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focusedElement
                });
            }
            return;
        }
        // ArrowLeft closes this menu only if it is a submenu.
        if (event.key === (0, $4096afce6d06a916$export$fc4577f2a2af0ae3)) {
            if (onNestedClose) {
                // Start from the parent, so `closest()` does not match the container itself.
                const isNested = Boolean(container.parentElement?.closest($2565731d43f758f2$var$menuSelector));
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $fsvuC.useEffect)(()=>{
        const container = containerRef.current;
        if (!container || !isEnabled) return;
        return (0, $dqdTY.bind)(container, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
}

});

parcelRegister("kASaR", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2a5bcbe9093c798$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $aFrri = parcelRequire("aFrri");
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $a2a5bcbe9093c798$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $fsvuC.useRef)({});
    const context = (0, $fsvuC.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $aFrri.SelectionStoreContext).Provider, {
        value: context,
        children: children
    });
};
$a2a5bcbe9093c798$var$SelectionStore.displayName = "SelectionStore";
var $a2a5bcbe9093c798$export$2e2bcd8739ae039 = $a2a5bcbe9093c798$var$SelectionStore;

});
parcelRegister("aFrri", function(module, exports) {
$parcel$export(module.exports, "SelectionStoreContext", () => $97ddfd79bb377bc1$export$756f795847463ebd);

var $fsvuC = parcelRequire("fsvuC");

var $iqo7S = parcelRequire("iqo7S");
const $97ddfd79bb377bc1$export$756f795847463ebd = /*#__PURE__*/ (0, $fsvuC.createContext)({
    setItemState: (0, $iqo7S.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $iqo7S.default),
    getGroupState: ()=>({})
});

});



parcelRegister("5G75S", function(module, exports) {
$parcel$export(module.exports, "default", () => $8852d311acaaee05$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $1wCqK = parcelRequire("1wCqK");

var $l5Jah = parcelRequire("l5Jah");

var $iak9S = parcelRequire("iak9S");
/**
 * Focus manager logic.
 */ const $8852d311acaaee05$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $fsvuC.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $fsvuC.useState)(0);
    const registerMode = (0, $fsvuC.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $fsvuC.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $1wCqK.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $fsvuC.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $fsvuC.useEffect)(()=>(0, $dqdTY.bind)(window, {
            type: 'keydown',
            listener: (0, $l5Jah.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $iak9S.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
$8852d311acaaee05$var$FocusManager.displayName = "FocusManager";
var $8852d311acaaee05$export$2e2bcd8739ae039 = $8852d311acaaee05$var$FocusManager;

});
parcelRegister("l5Jah", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ba63115c15a6187$export$2e2bcd8739ae039);


var $5T6N9 = parcelRequire("5T6N9");

var $dmvfi = parcelRequire("dmvfi");
const $1ba63115c15a6187$var$actionMap = {
    [(0, $4096afce6d06a916$export$a80636c6f41931fe)]: 'next',
    [(0, $4096afce6d06a916$export$390330c10ff2b9a1)]: 'prev',
    [(0, $4096afce6d06a916$export$4af703091671bc)]: 'first',
    [(0, $4096afce6d06a916$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $1ba63115c15a6187$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $1ba63115c15a6187$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $1ba63115c15a6187$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $5T6N9.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $dmvfi.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $4096afce6d06a916$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $4096afce6d06a916$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $4096afce6d06a916$export$fc4577f2a2af0ae3)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $4096afce6d06a916$export$c40f9845adc73fb5)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $1ba63115c15a6187$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $1ba63115c15a6187$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $1ba63115c15a6187$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $1ba63115c15a6187$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $1ba63115c15a6187$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("dmvfi", function(module, exports) {
$parcel$export(module.exports, "PREFIX", () => $2c4dddb37fd200e3$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $2c4dddb37fd200e3$export$2e2bcd8739ae039);

var $k9FWI = parcelRequire("k9FWI");
const $2c4dddb37fd200e3$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $2c4dddb37fd200e3$export$2e2bcd8739ae039() {
    const id = (0, $k9FWI.useId)();
    return `${$2c4dddb37fd200e3$export$8a682ae47622dbb9}${id}`;
}

});


parcelRegister("iak9S", function(module, exports) {
$parcel$export(module.exports, "FocusManagerContext", () => $9ee910210f4030ab$export$f18c1d4fc7326096);

var $fsvuC = parcelRequire("fsvuC");

var $iqo7S = parcelRequire("iqo7S");
const $9ee910210f4030ab$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $fsvuC.createContext)({
    menuItemRefs: [],
    registerRef: (0, $iqo7S.default)
});

});


parcelRegister("3HWXX", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ac7e6753537b703$export$2e2bcd8739ae039);
/* menu-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gs9oK = parcelRequire("gs9oK");

var $5T6N9 = parcelRequire("5T6N9");

var $fpjto = parcelRequire("fpjto");

var $k403E = parcelRequire("k403E");

var $cvBSI = parcelRequire("cvBSI");

var $5yKEY = parcelRequire("5yKEY");

var $iak9S = parcelRequire("iak9S");
const $1ac7e6753537b703$var$styles = {
    spinnerContainer: "_3iDTPbQ4SZ _4ouGXIoaux _37wbyuDIqT _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
};
const $1ac7e6753537b703$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $fpjto.Box), {
        xcss: $1ac7e6753537b703$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $k403E.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
$1ac7e6753537b703$var$LoadingIndicator.displayName = "LoadingIndicator";
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $1ac7e6753537b703$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $fsvuC.useContext)((0, $iak9S.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $cvBSI.default)(menuItem) || (0, $5yKEY.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $fsvuC.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $fsvuC.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $5T6N9.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $gs9oK.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $5chsV.jsx)($1ac7e6753537b703$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
$1ac7e6753537b703$var$MenuWrapper.displayName = "MenuWrapper";
var $1ac7e6753537b703$export$2e2bcd8739ae039 = $1ac7e6753537b703$var$MenuWrapper;

});
parcelRegister("cvBSI", function(module, exports) {
$parcel$export(module.exports, "default", () => $111c480f73d532af$export$2e2bcd8739ae039);
function $111c480f73d532af$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("5yKEY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4c30cd9adeffbe6$export$2e2bcd8739ae039);
function $a4c30cd9adeffbe6$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("h0Ojh", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3b9f3462db1d6ba$export$2e2bcd8739ae039);
// eslint-disable-next-line sort-imports

var $fsvuC = parcelRequire("fsvuC");

var $5T6N9 = parcelRequire("5T6N9");

var $iak9S = parcelRequire("iak9S");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $c3b9f3462db1d6ba$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $fsvuC.useContext)((0, $iak9S.FocusManagerContext));
    const itemRef = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        if (hasPopup && (0, $5T6N9.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $c3b9f3462db1d6ba$export$2e2bcd8739ae039 = $c3b9f3462db1d6ba$var$useRegisterItemWithFocusManager;

});


parcelRegister("8HvJO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28569a1ba0e49d9b1ede9e97db5921f7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $655af55ba814acd4$var$_react = $655af55ba814acd4$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $655af55ba814acd4$var$_iconNew = $655af55ba814acd4$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $655af55ba814acd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiSearch".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-search
 * Usage guidance:
 * Reserved for search interactions powered by Rovo/AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $655af55ba814acd4$var$AiSearchIcon = (props)=>/*#__PURE__*/ $655af55ba814acd4$var$_react.default.createElement($655af55ba814acd4$var$_iconNew.default, Object.assign({
        name: "AiSearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M6 2.612A4.501 4.501 0 0 0 7 11.5a4.48 4.48 0 0 0 3.182-1.318A4.5 4.5 0 0 0 11.387 8h1.53a6 6 0 0 1-1.179 2.678l3.292 3.292-1.06 1.06-3.292-3.292A6 6 0 1 1 6 1.084z"/><path fill="currentcolor" d="M14 3.25a.75.75 0 0 1-.493.705l-1.285.469a.5.5 0 0 0-.298.298l-.469 1.285a.75.75 0 0 1-1.41 0l-.469-1.285a.5.5 0 0 0-.298-.298l-1.285-.469a.75.75 0 0 1-.484-.589L7.5 3.25l.009-.116a.75.75 0 0 1 .484-.59l1.285-.468a.5.5 0 0 0 .298-.298l.469-1.285.049-.106A.75.75 0 0 1 10.749 0l.116.009a.75.75 0 0 1 .541.378l.05.106.468 1.285a.5.5 0 0 0 .298.298l1.285.469A.75.75 0 0 1 14 3.25"/>`
    }, props));
$655af55ba814acd4$var$AiSearchIcon.displayName = 'AiSearchIcon';
var $655af55ba814acd4$var$_default = module.exports.default = $655af55ba814acd4$var$AiSearchIcon;

});

parcelRegister("ko03f", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $77e380836b575fa4$export$e23ae35269442b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4ebbb5ba469a9ff5e91d5204f2f881d>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $hBUvp = parcelRequire("hBUvp");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $77e380836b575fa4$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
function $77e380836b575fa4$export$e23ae35269442b4f({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hBUvp.IconWrapper), {
        svg: $77e380836b575fa4$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$77e380836b575fa4$export$e23ae35269442b4f.displayName = "RovoIcon";

});

parcelRegister("7ircd", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f1f5e59a1768f91$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $2YOL2 = parcelRequire("2YOL2");

var $1cXpO = parcelRequire("1cXpO");

var $9gFl0 = parcelRequire("9gFl0");

var $5hZWH = parcelRequire("5hZWH");

var $f4lus = parcelRequire("f4lus");

var $01oqo = parcelRequire("01oqo");

var $2COqC = parcelRequire("2COqC");

var $5h9Qx = parcelRequire("5h9Qx");
const $5f1f5e59a1768f91$var$styles = {
    base: "_0bjKvDKTcp _2sNsIgmnOE _23rrnHoacQ _2V7sgOdnbC _4c065UgVvo _3iDTPbccYA _24h04i2Njc _39xV02IZbP _1EqgXlN91d _1mT5xdRAKS _0hPCNLQame _37wbyuDIqT _17lj8p1Y8M _3YEZNOdnbC _0jFU0VZ49V _1kk5Tkf7mX _03SyCP8HPE _0LQT5E8HPE _2fwxA5DIqT _1RrJLit2nV _2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _2tbAUcYbGa _2WYcYGWVPG",
    interactiveMotion: "_23rrnHyKLB _3sFUREiSCN",
    linkDecorationUnset: "_00uqCYIoZn _3xtjKNOiJt _0H9qDFp3yX _32C2rkyL8i _0i9AWAYbGa _0mm6KQ6wH8 _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8",
    disabled: "_0wOv4Qsyl5 _0KLXruVrZW _1UtDYzot27 _0GBAIrYbGa _1eOmH6VrZW _0clgaMot27 _3gzVzLVrZW _0CMRbkot27",
    spacingCompact: "_4c065UFQfX _17lj8p1Y8M _03SyCP8HPE _0LQT5E8HPE _1RrJLit2nV _0jFU0V9DVM _39xV029DVM",
    iconButton: "_0jFU0VZ49V _39xV02Z49V _03SyCPPgdg _0LQT5EPgdg",
    circle: "_0bjKvDS5Zs"
};
const $5f1f5e59a1768f91$var$defaultStyles = {
    root: "_0KLXru5FNy _1UtDYzZpcK _0z8nYC9r67 _0GBAIrogpp _2nTuUYZpcK _10n1R5ZpcK _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $5f1f5e59a1768f91$var$primaryStyles = {
    root: "_0KLXruDM2k _1UtDYze5R3 _2nTuUYe5R3 _0clgaMe5R3 _1eOmH6hmrj _0CMRbke5R3 _3gzVzLczkD"
};
const $5f1f5e59a1768f91$var$rovoStyles = {
    root: "_0KLXruWwnm _1UtDYze5R3 _2nTuUYe5R3 _1eOmH63nEM _3gzVzLjYGY"
};
const $5f1f5e59a1768f91$var$discoveryStyles = {
    root: "_0KLXruqjHC _1UtDYze5R3 _2nTuUYe5R3 _0clgaMe5R3 _1eOmH6nIkF _0CMRbke5R3 _3gzVzLSHT5"
};
const $5f1f5e59a1768f91$var$subtleStyles = {
    root: "_0KLXru5FNy _1UtDYzZpcK _2nTuUYZpcK _10n1R5zfdP _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $5f1f5e59a1768f91$var$selectedStyles = {
    root: "_0KLXruY9q9 _1UtDYzjTy9 _0z8nYCrzt2 _0GBAIrogpp _2nTuUYjTy9 _10n1R5jTy9 _0clgaMjTy9 _0CMRbkjTy9",
    discovery: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9"
};
const $5f1f5e59a1768f91$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, newWindowLabel: newWindowLabel, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const localRef = (0, $fsvuC.useRef)(null);
    (0, $9gFl0.default)(localRef, autoFocus);
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $f4lus.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        hasNewContentOnTriggerClick: tooltip?.hasNewContentOnTriggerClick,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        children: (triggerProps)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $5hZWH.Anchor), {
                ...saferRest,
                "aria-labelledby": ariaLabelledBy,
                newWindowLabel: newWindowLabel,
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                // Shared between tooltip and native props
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                // Shared between tooltip and base props
                onClick: (event, analyticsEvent)=>{
                    onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                ref: (0, $1cXpO.default)([
                    localRef,
                    ref,
                    triggerProps.ref
                ].filter(Boolean)),
                // Base props only
                xcss: (0, $2YOL2.cx)($5f1f5e59a1768f91$var$styles.base, !isDisabled && $5f1f5e59a1768f91$var$styles.interactiveMotion, appearance === 'default' && $5f1f5e59a1768f91$var$defaultStyles.root, appearance === 'primary' && $5f1f5e59a1768f91$var$primaryStyles.root, appearance === 'rovo' && $5f1f5e59a1768f91$var$rovoStyles.root, appearance === 'discovery' && $5f1f5e59a1768f91$var$discoveryStyles.root, appearance === 'subtle' && $5f1f5e59a1768f91$var$subtleStyles.root, $5f1f5e59a1768f91$var$styles.linkDecorationUnset, isSelected && $5f1f5e59a1768f91$var$selectedStyles.root, isSelected && appearance === 'discovery' && $5f1f5e59a1768f91$var$selectedStyles.discovery, isDisabled && $5f1f5e59a1768f91$var$styles.disabled, $5f1f5e59a1768f91$var$styles.iconButton, spacing === 'compact' && $5f1f5e59a1768f91$var$styles.spacingCompact, shape === 'circle' && $5f1f5e59a1768f91$var$styles.circle),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                /**
       * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
       * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
       */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
                href: isDisabled ? undefined : href,
                role: isDisabled ? 'link' : undefined,
                "aria-disabled": isDisabled === true ? true : undefined,
                children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $2COqC.default), {
                    type: "icon",
                    isLoading: false,
                    children: [
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $5h9Qx.default), {
                            icon: icon,
                            spacing: spacing
                        }),
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $01oqo.default), {
                            children: label
                        })
                    ]
                })
            })
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5hZWH.Anchor), {
        ...saferRest,
        // aria-label={preventedAriaLabel}
        "aria-labelledby": ariaLabelledBy,
        newWindowLabel: newWindowLabel,
        ref: (0, $1cXpO.default)([
            localRef,
            ref
        ]),
        xcss: (0, $2YOL2.cx)($5f1f5e59a1768f91$var$styles.base, !isDisabled && $5f1f5e59a1768f91$var$styles.interactiveMotion, appearance === 'default' && $5f1f5e59a1768f91$var$defaultStyles.root, appearance === 'primary' && $5f1f5e59a1768f91$var$primaryStyles.root, appearance === 'rovo' && $5f1f5e59a1768f91$var$rovoStyles.root, appearance === 'discovery' && $5f1f5e59a1768f91$var$discoveryStyles.root, appearance === 'subtle' && $5f1f5e59a1768f91$var$subtleStyles.root, $5f1f5e59a1768f91$var$styles.linkDecorationUnset, isSelected && $5f1f5e59a1768f91$var$selectedStyles.root, isSelected && appearance === 'discovery' && $5f1f5e59a1768f91$var$selectedStyles.discovery, isDisabled && $5f1f5e59a1768f91$var$styles.disabled, $5f1f5e59a1768f91$var$styles.iconButton, spacing === 'compact' && $5f1f5e59a1768f91$var$styles.spacingCompact, shape === 'circle' && $5f1f5e59a1768f91$var$styles.circle),
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $2COqC.default), {
            type: "icon",
            isLoading: false,
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $5h9Qx.default), {
                    icon: icon,
                    spacing: spacing
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $01oqo.default), {
                    children: label
                })
            ]
        })
    });
};
$5f1f5e59a1768f91$var$LinkIconButtonBase.displayName = "LinkIconButtonBase";
// Workarounds to support generic types with forwardRef + memo
const $5f1f5e59a1768f91$var$WithRef = /*#__PURE__*/ (0, $fsvuC.forwardRef)($5f1f5e59a1768f91$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ const $5f1f5e59a1768f91$var$LinkIconButton = /*#__PURE__*/ (0, $fsvuC.memo)($5f1f5e59a1768f91$var$WithRef);
var $5f1f5e59a1768f91$export$2e2bcd8739ae039 = $5f1f5e59a1768f91$var$LinkIconButton;

});

parcelRegister("eBNGe", function(module, exports) {
$parcel$export(module.exports, "default", () => $28355e276abc892e$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $2YOL2 = parcelRequire("2YOL2");

var $1cXpO = parcelRequire("1cXpO");

var $9gFl0 = parcelRequire("9gFl0");

var $5hZWH = parcelRequire("5hZWH");

var $2COqC = parcelRequire("2COqC");

var $5h9Qx = parcelRequire("5h9Qx");
const $28355e276abc892e$var$styles = {
    base: "_0bjKvDKTcp _2sNsIgmnOE _23rrnHoacQ _2V7sgOdnbC _4c065UgVvo _3iDTPbccYA _24h04i2Njc _39xV02IZbP _1EqgXlN91d _1mT5xdRAKS _0hPCNLQame _37wbyuDIqT _17lj8p1Y8M _3YEZNOdnbC _0jFU0VZ49V _1kk5Tkf7mX _03SyCP8HPE _0LQT5E8HPE _2fwxA5DIqT _1RrJLit2nV _2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _2tbAUcYbGa _2WYcYGWVPG",
    interactiveMotion: "_23rrnHyKLB _3sFUREiSCN",
    linkDecorationUnset: "_00uqCYIoZn _3xtjKNOiJt _0H9qDFp3yX _32C2rkyL8i _0i9AWAYbGa _0mm6KQ6wH8 _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8",
    disabled: "_0wOv4Qsyl5 _0KLXruVrZW _1UtDYzot27 _0GBAIrYbGa _2nTuUYot27 _1iy5hxVrZW _10n1R5ot27 _1eOmH6VrZW _0clgaMot27 _3gzVzLVrZW _0CMRbkot27",
    spacingCompact: "_4c065UFQfX _17lj8p1Y8M _0jFU0V9DVM _03SyCP8HPE _0LQT5E8HPE _1RrJLit2nV",
    buttonIconBefore: "_0LQT5E8HPE _17lj8pgVvo",
    buttonIconAfter: "_03SyCP8HPE _17lj8pgVvo",
    fullWidth: "_39xV02N91d"
};
const $28355e276abc892e$var$defaultStyles = {
    root: "_0KLXru5FNy _1UtDYzZpcK _0z8nYC9r67 _0GBAIrogpp _2nTuUYZpcK _10n1R5ZpcK _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $28355e276abc892e$var$primaryStyles = {
    root: "_0KLXruDM2k _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _1eOmH6hmrj _0CMRbke5R3 _3gzVzLczkD"
};
const $28355e276abc892e$var$rovoStyles = {
    root: "_0KLXruWwnm _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _1eOmH63nEM _3gzVzLjYGY"
};
const $28355e276abc892e$var$warningStyles = {
    root: "_0KLXruKLKE _1UtDYzVW6T _2nTuUYVW6T _10n1R5VW6T _0clgaMVW6T _1eOmH6OCpk _0CMRbkVW6T _3gzVzLSN2W"
};
const $28355e276abc892e$var$dangerStyles = {
    root: "_0KLXruqsXs _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _1eOmH6EISo _0CMRbke5R3 _3gzVzLL5fL"
};
const $28355e276abc892e$var$discoveryStyles = {
    root: "_0KLXruqjHC _1UtDYze5R3 _2nTuUYe5R3 _10n1R5e5R3 _0clgaMe5R3 _1eOmH6nIkF _0CMRbke5R3 _3gzVzLSHT5"
};
const $28355e276abc892e$var$subtleStyles = {
    root: "_0KLXru5FNy _1UtDYzZpcK _2nTuUYZpcK _10n1R5zfdP _1eOmH6o126 _0clgaMZpcK _3gzVzLN4oS _0CMRbkZpcK"
};
const $28355e276abc892e$var$selectedStyles = {
    root: "_0KLXruY9q9 _1UtDYzjTy9 _0z8nYCrzt2 _0GBAIrogpp _2nTuUYjTy9 _10n1R5jTy9 _0clgaMjTy9 _0CMRbkjTy9",
    warning: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9",
    danger: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9",
    discovery: "_0KLXruY9q9 _1UtDYzjTy9 _0clgaMjTy9 _1eOmH6Y9q9 _0CMRbkjTy9 _3gzVzLY9q9"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $28355e276abc892e$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus = false, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $fsvuC.useRef)(null);
    (0, $9gFl0.default)(localRef, autoFocus);
    const combinedRef = (0, $1cXpO.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5hZWH.Anchor), {
        analyticsContext: analyticsContext,
        ref: combinedRef,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName,
        ...saferRest,
        xcss: (0, $2YOL2.cx)($28355e276abc892e$var$styles.base, !isDisabled && $28355e276abc892e$var$styles.interactiveMotion, appearance === 'default' && $28355e276abc892e$var$defaultStyles.root, appearance === 'primary' && $28355e276abc892e$var$primaryStyles.root, appearance === 'rovo' && $28355e276abc892e$var$rovoStyles.root, appearance === 'warning' && $28355e276abc892e$var$warningStyles.root, appearance === 'danger' && $28355e276abc892e$var$dangerStyles.root, appearance === 'discovery' && $28355e276abc892e$var$discoveryStyles.root, appearance === 'subtle' && $28355e276abc892e$var$subtleStyles.root, $28355e276abc892e$var$styles.linkDecorationUnset, isSelected && $28355e276abc892e$var$selectedStyles.root, isSelected && appearance === 'danger' && $28355e276abc892e$var$selectedStyles.danger, isSelected && appearance === 'warning' && $28355e276abc892e$var$selectedStyles.warning, isSelected && appearance === 'discovery' && $28355e276abc892e$var$selectedStyles.discovery, isDisabled && $28355e276abc892e$var$styles.disabled, spacing === 'compact' && $28355e276abc892e$var$styles.spacingCompact, hasIconBefore && $28355e276abc892e$var$styles.buttonIconBefore, hasIconAfter && $28355e276abc892e$var$styles.buttonIconAfter, shouldFitContainer && $28355e276abc892e$var$styles.fullWidth),
        children: [
            iconBefore && /*#__PURE__*/ (0, $5chsV.jsx)((0, $2COqC.default), {
                type: "icon",
                position: "before",
                isLoading: false,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5h9Qx.default), {
                    icon: iconBefore,
                    spacing: spacing
                })
            }),
            children && /*#__PURE__*/ (0, $5chsV.jsx)((0, $2COqC.default), {
                isLoading: false,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $5chsV.jsx)((0, $2COqC.default), {
                type: "icon",
                position: "after",
                isLoading: false,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5h9Qx.default), {
                    icon: iconAfter,
                    spacing: spacing
                })
            })
        ]
    });
};
$28355e276abc892e$var$LinkButtonBase.displayName = "LinkButtonBase";
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $28355e276abc892e$var$LinkButton = /*#__PURE__*/ (0, $fsvuC.forwardRef)($28355e276abc892e$var$LinkButtonBase);
$28355e276abc892e$var$LinkButton.displayName = 'LinkButton';
var $28355e276abc892e$export$2e2bcd8739ae039 = $28355e276abc892e$var$LinkButton;

});

parcelRegister("1egdo", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b49508482dbb7a2$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $1cXpO = parcelRequire("1cXpO");

var $7YBt1 = parcelRequire("7YBt1");

var $9aeBH = parcelRequire("9aeBH");

var $dS0R6 = parcelRequire("dS0R6");

var $5T6N9 = parcelRequire("5T6N9");

var $h0Ojh = parcelRequire("h0Ojh");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $6b49508482dbb7a2$var$DropdownMenuItem = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // Nested submenu triggers register with the focus manager inside DropdownMenu.
    // Dialog triggers must register here so arrow navigation can reach them.
    const isNestedTrigger = !!rest['aria-haspopup'] && rest['aria-haspopup'] !== 'dialog';
    const itemRef = (0, $h0Ojh.default)(isNestedTrigger);
    const handleItemClick = (0, $fsvuC.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $9aeBH.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1cXpO.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $dS0R6.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1cXpO.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $5chsV.jsx)((0, $7YBt1.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1cXpO.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        ...isNestedTrigger && (0, $5T6N9.fg)('platform_dst_dropdown_nested_trigger_aria_current') ? {
            'aria-current': undefined
        } : {},
        children: children
    });
});
var $6b49508482dbb7a2$export$2e2bcd8739ae039 = $6b49508482dbb7a2$var$DropdownMenuItem;

});
parcelRegister("7YBt1", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e1f1079f28abea8$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $6Pi1A = parcelRequire("6Pi1A");

var $6EB4Z = parcelRequire("6EB4Z");
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $2e1f1079f28abea8$var$ButtonItem = /*#__PURE__*/ (0, $fsvuC.memo)(/*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const { children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $fsvuC.useContext)((0, $6Pi1A.default));
    const handleClick = (0, $fsvuC.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6EB4Z.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $5chsV.jsx)("button", {
                "data-testid": testId,
                // This is intentionally placed before the `...rest` spread to prevent overriding existing usages of `aria-current`,
                // which are already being passed to the button element.
                "aria-current": isSelected ? 'true' : undefined,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                disabled: isDisabled,
                onClick: handleClick,
                onMouseDown: onMouseDownHandler,
                type: "button",
                children: children
            })
    });
}));
var $2e1f1079f28abea8$export$2e2bcd8739ae039 = $2e1f1079f28abea8$var$ButtonItem;

});
parcelRegister("6EB4Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f11f855ea0df006$export$2e2bcd8739ae039);
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $9EEzo = parcelRequire("9EEzo");

var $cUgBc = parcelRequire("cUgBc");

var $7ZgJa = parcelRequire("7ZgJa");
const $1f11f855ea0df006$var$renderTitle = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        ...props
    });
const $1f11f855ea0df006$var$styles = {
    root: "_30huDKdnbC _2xIroY98eZ _497WNwYbGa _2zndICdnbC _00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _1mT5xdRAKS _3iDTPbQ4SZ _24h04i2Njc _39xV02N91d _4kiQYAUF4f _43nrzTPgdg _2xTnZxPgdg _0rIjykPgdg _0GTcwRPgdg _0hPCNLDIqT _20VacPYbGa _0wOv4Q7zJH _2hGPVj98eZ _2i3C1kYbGa _2kH23qT6kp _1zr6DcnXvL _1ubuxonXvL _38a67RZPSy _34b3D2ZPSy _0htemX6wH8 _1NDpvb6wH8 _067Lcevc3e _2wtOC9vc3e _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _3e11vU6wH8 _0hSAgbHZdu",
    beforeAfterElement: "_3iDTPbQ4SZ _4ouGXIoWWg _4kiQYAoWWg _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
    content: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _2O5Vij7dHp _2fwxA5ecOK",
    truncate: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39HuIbz8Lp _1ANEUSLRg7",
    title: "_2sNsIgmnOE",
    wordBreak: "_3W2Oc8wPeg",
    description: "_2sNsIg7NXe _1UtDYzKGUX",
    disabledDescription: "_1UtDYzot27",
    unselected: "_0KLXru5FNy _1UtDYz98eZ _2nTuUY98eZ _1eOmH6o126 _0clgaM98eZ _3gzVzLo126 _0CMRbk98eZ",
    disabled: "_0wOv4Qsyl5 _0KLXru5FNy _1UtDYzot27 _1eOmH65FNy _0clgaMot27 _3gzVzL5FNy _0CMRbkot27",
    selectedBorder: "_3ScelF4Jdh _3dCYwDWVPG _4diMdqrzt2 _3Ku51Iogpp _3p3AmIPgdg _1cR5ZLPgdg _2jTvwtPgdg",
    selectedNotch: "_1OimfuMLSV _3ScelFUNDJ _3dCYwDWVPG _4diMdqrzt2 _3Ku51Iogpp _3p3AmI8HPE _1cR5ZL8HPE _2jTvwtPgdg",
    selected: "_0KLXruY9q9 _1UtDYzjTy9 _2nTuUYjTy9 _1eOmH6sumd _0clgaM866Z _3gzVzLXsxn _0CMRbkjTy9",
    selectedOld: "_0clgaMjTy9",
    motionUnselected: "_23rrnHo10F _1B4rbIo10F _3sFUREDdj4",
    motionSelected: "_23rrnHWE38 _1B4rbIo10F"
};
const $1f11f855ea0df006$var$spacingMapStyles = {
    cozy: "_4c065U2ADO _2Y7lL45zaO",
    compact: "_4c065U1Y8M _2Y7lL48HPE _4kiQYAUofl"
};
const $1f11f855ea0df006$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ const $1f11f855ea0df006$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, testId: testId })=>{
    const spacing = (0, $fsvuC.useContext)((0, $cUgBc.SpacingContext));
    const selectionStyle = (0, $fsvuC.useContext)((0, $7ZgJa.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const UNSAFE_className = UNSAFE_externalClassName;
    return (()=>{
        return children({
            className: (0, $gJ6nT.default)([
                (0, $gJ6nT.default)([
                    $1f11f855ea0df006$var$styles.root,
                    $1f11f855ea0df006$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $1f11f855ea0df006$var$styles.unselected,
                    !isDisabled && !isSelected && $1f11f855ea0df006$var$styles.motionUnselected,
                    !isDisabled && isSelected && $1f11f855ea0df006$var$styles.selected,
                    !isDisabled && isSelected && $1f11f855ea0df006$var$styles.motionSelected,
                    !isDisabled && isSelected && $1f11f855ea0df006$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $1f11f855ea0df006$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $1f11f855ea0df006$var$styles.selectedNotch,
                    isDisabled && $1f11f855ea0df006$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $9EEzo.Inline), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $1f11f855ea0df006$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`,
                children: [
                    iconBefore && /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                        "data-item-elem-before": true,
                        "data-testid": testId && `${testId}--icon-before`,
                        className: (0, $gJ6nT.default)([
                            $1f11f855ea0df006$var$styles.beforeAfterElement
                        ]),
                        children: iconBefore
                    }),
                    title && /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
                        className: (0, $gJ6nT.default)([
                            $1f11f855ea0df006$var$styles.content
                        ]),
                        children: [
                            $1f11f855ea0df006$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                                children: title,
                                className: (0, $gJ6nT.default)([
                                    $1f11f855ea0df006$var$styles.title,
                                    shouldTitleWrap ? $1f11f855ea0df006$var$styles.wordBreak : $1f11f855ea0df006$var$styles.truncate
                                ]),
                                'data-item-title': true
                            }),
                            description && /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                                "data-item-description": true,
                                className: (0, $gJ6nT.default)([
                                    $1f11f855ea0df006$var$styles.description,
                                    isDisabled && $1f11f855ea0df006$var$styles.disabledDescription,
                                    shouldDescriptionWrap && $1f11f855ea0df006$var$styles.wordBreak,
                                    !shouldDescriptionWrap && $1f11f855ea0df006$var$styles.truncate
                                ]),
                                children: description
                            })
                        ]
                    }),
                    iconAfter && /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                        "data-item-elem-after": true,
                        "data-testid": testId && `${testId}--icon-after`,
                        className: (0, $gJ6nT.default)([
                            $1f11f855ea0df006$var$styles.beforeAfterElement
                        ]),
                        children: iconAfter
                    })
                ]
            })
        });
    })();
};
$1f11f855ea0df006$var$MenuItemPrimitive.displayName = "MenuItemPrimitive";
var $1f11f855ea0df006$export$2e2bcd8739ae039 = $1f11f855ea0df006$var$MenuItemPrimitive;

});


parcelRegister("9aeBH", function(module, exports) {
$parcel$export(module.exports, "default", () => $56fb8a4288b2badd$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $6Pi1A = parcelRequire("6Pi1A");

var $6EB4Z = parcelRequire("6EB4Z");
const $56fb8a4288b2badd$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Custom item__
 *
 * @deprecated
 * CustomItem must not be used and will be deleted soon. Custom menu items are not supported.
 * Use ButtonItem or LinkItem instead. If you need a custom list item, do not use `@atlaskit/menu`.
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $56fb8a4288b2badd$var$CustomItem = /*#__PURE__*/ (0, $fsvuC.memo)(/*#__PURE__*/ (0, $fsvuC.forwardRef)(({ component: Component, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $fsvuC.useContext)((0, $6Pi1A.default));
    const handleClick = (0, $fsvuC.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6EB4Z.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $5chsV.jsx)(Component, {
                "data-testid": testId,
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                ref: ref,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $56fb8a4288b2badd$var$preventEvent
                },
                onMouseDown: isDisabled ? $56fb8a4288b2badd$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $56fb8a4288b2badd$var$preventEvent : handleClick,
                tabIndex: isDisabled ? -1 : undefined,
                "aria-disabled": isDisabled || undefined,
                children: children
            })
    });
}));
var $56fb8a4288b2badd$export$2e2bcd8739ae039 = $56fb8a4288b2badd$var$CustomItem;

});

parcelRegister("dS0R6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2dca3d7858c4ebe6$export$2e2bcd8739ae039);
/* link-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $8bI31 = parcelRequire("8bI31");

var $6Pi1A = parcelRequire("6Pi1A");

var $6EB4Z = parcelRequire("6EB4Z");
const $2dca3d7858c4ebe6$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $2dca3d7858c4ebe6$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $2dca3d7858c4ebe6$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $2dca3d7858c4ebe6$var$LinkItem = /*#__PURE__*/ (0, $fsvuC.memo)(/*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const { children: children, href: href, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $8bI31.useRouterLink)();
    const interactionContext = (0, $fsvuC.useContext)((0, $6Pi1A.default));
    const handleClick = (0, $fsvuC.useCallback)((e)=>{
        interactionContext?.tracePress(interactionName, e.timeStamp);
        onClick?.(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    const isExternal = typeof href === 'string' && $2dca3d7858c4ebe6$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $2dca3d7858c4ebe6$var$IS_NON_HTTP_BASED.test(href);
    const isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $6EB4Z.default), {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && `${testId}--primitive`,
        children: ({ children: children, className: className })=>/*#__PURE__*/ (0, $5chsV.jsx)(Component, {
                "data-testid": testId,
                "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
                "data-vc": "link-item",
                ...rest,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // @ts-expect-error
                href: isDisabled ? undefined : href,
                ...UNSAFE_isDraggable ? {} : {
                    draggable: false,
                    onDragStart: $2dca3d7858c4ebe6$var$preventEvent
                },
                onMouseDown: isDisabled ? $2dca3d7858c4ebe6$var$preventEvent : onMouseDownHandler,
                onClick: isDisabled ? $2dca3d7858c4ebe6$var$preventEvent : handleClick,
                "aria-current": isSelected ? 'page' : undefined,
                "aria-disabled": isDisabled || undefined,
                ref: ref,
                children: children
            })
    });
}));
var $2dca3d7858c4ebe6$export$2e2bcd8739ae039 = $2dca3d7858c4ebe6$var$LinkItem;

});


parcelRegister("buELT", function(module, exports) {
$parcel$export(module.exports, "default", () => $4088683f4eb1db47$export$2e2bcd8739ae039);

var $fsvuC = parcelRequire("fsvuC");
var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $4088683f4eb1db47$export$2e2bcd8739ae039 = (0, $fsvuC.forwardRef);

});

parcelRegister("aCTVG", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4bd61d938743d18$export$2e2bcd8739ae039);
/* avatar.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $hkZUI = parcelRequire("hkZUI");

var $k9FWI = parcelRequire("k9FWI");

var $5T6N9 = parcelRequire("5T6N9");

var $dIFTo = parcelRequire("dIFTo");

var $aM5Dp = parcelRequire("aM5Dp");

var $81xzH = parcelRequire("81xzH");

var $ikrk9 = parcelRequire("ikrk9");

var $fHKB9 = parcelRequire("fHKB9");

var $f1dgk = parcelRequire("f1dgk");

var $fb87k = parcelRequire("fb87k");

var $4rOra = parcelRequire("4rOra");
const $f4bd61d938743d18$var$packageName = "platform-pkg";
const $f4bd61d938743d18$var$packageVersion = "0.0.0-use.local";
const $f4bd61d938743d18$var$containerStyles = null;
const $f4bd61d938743d18$var$updatedHexagonNegativeMarginMap = {
    xxsmall: "_0rIjykJnIq _43nrzTJnIq",
    small: "_0rIjykwUPW _43nrzTwUPW",
    medium: "_0rIjykP0CX _43nrzTP0CX",
    large: "_0rIjykO0L5 _43nrzTO0L5",
    xlarge: "_0rIjykFQC7 _43nrzTFQC7",
    xxlarge: "_0rIjykaf0R _43nrzTaf0R"
};
const $f4bd61d938743d18$var$normalizeAvatarSize = (size)=>size === 'xsmall' && !(0, $5T6N9.fg)('platform_design-system-team_avatar-remove-xsmall') ? 'xxsmall' : size; /**
                                                                                                                                                            * Popup trigger ARIA attributes are optional. Use `aria-controls` to identify
                                                                                                                                                            * the popup and `aria-expanded` to announce whether it is open. An
                                                                                                                                                            * `aria-haspopup` value indicating a popup renders Avatar as a button,
                                                                                                                                                            * even when `onClick` is absent.
                                                                                                                                                            */ 
const $f4bd61d938743d18$var$Avatar = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div', imgLoading: imgLoading, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $hkZUI.useAnalyticsEvents)();
    const context = (0, $4rOra.useAvatarContext)();
    const size = $f4bd61d938743d18$var$normalizeAvatarSize(sizeProp || context?.size || 'medium');
    const isUpdatedHexagonGeometry = appearance === 'hexagon' && Boolean(UNSAFE_isUpdatedGeometry) && size !== 'UNSAFE_xsmall';
    const customPresenceNode = /*#__PURE__*/ (0, $fsvuC.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $fsvuC.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xxsmall' && size !== 'xsmall'; // Presence/status indicators are only defined for `IndicatorSizeType`
    // (small, medium, large, xlarge). Compute `indicatorSize` only for sizes
    // that support an indicator (`isValidIconSize`), so the value is
    // structurally guaranteed to be a valid `IndicatorSizeType` rather than
    // relying on the guard at each call site. The `UNSAFE_xsmall` (20px) size
    // reuses the `small` indicator sizing as its nearest supported neighbor;
    // unsupported sizes (`xxsmall`/`xsmall`/`xxlarge`) fall back to `small` and are never
    // actually rendered because `isPresence`/`isStatus` also guard on
    // `isValidIconSize`.
    const indicatorSize = !isValidIconSize ? 'small' : size === 'UNSAFE_xsmall' ? 'small' : size;
    const lastAnalytics = (0, $fsvuC.useRef)(analyticsContext);
    const labelId = (0, $k9FWI.useId)();
    (0, $fsvuC.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $fsvuC.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $f4bd61d938743d18$var$packageName,
                packageVersion: $f4bd61d938743d18$var$packageVersion
            }
        }); /**
         * To avoid wrapping this component in AnalyticsContext we manually
         * push the parent context's meta data into the context.
         */ 
        const context = {
            componentName: 'avatar',
            packageName: $f4bd61d938743d18$var$packageName,
            packageVersion: $f4bd61d938743d18$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context); /**
                                           * Replicating the logic in the `withAnalyticsEvents` HOC.
                                           */ 
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status; // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled || ariaHasPopup;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $ikrk9.EnsureIsInsideAvatarContext).Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)(AvatarContainer, {
            "data-testid": testId,
            role: containerShouldBeImage ? 'img' : undefined,
            "aria-labelledby": containerShouldBeImage ? labelId : undefined,
            style: {
                zIndex: stackIndex
            },
            className: (0, $gJ6nT.default)([
                "_2xIroY98eZ _497WNwYbGa _2zndICdnbC _3iDTPbvbI6 _1mT5xdRAKS",
                isUpdatedHexagonGeometry && $f4bd61d938743d18$var$updatedHexagonNegativeMarginMap[size]
            ]),
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $81xzH.AvatarContentContext).Provider, {
                    value: {
                        as: (0, $fHKB9.default)(isDisabled, href, onClick, ariaHasPopup),
                        appearance: appearance,
                        UNSAFE_isUpdatedGeometry: isUpdatedHexagonGeometry,
                        borderColor: borderColor,
                        href: href,
                        isDisabled: isDisabled,
                        label: label || defaultLabel,
                        onClick: isInteractive ? onClickHandler : undefined,
                        ref: ref,
                        size: size,
                        stackIndex: stackIndex,
                        target: target,
                        testId: testId ? `${testId}--inner` : undefined,
                        'aria-controls': ariaControls,
                        'aria-expanded': ariaExpanded,
                        'aria-haspopup': ariaHasPopup,
                        avatarImage: /*#__PURE__*/ (0, $5chsV.jsx)((0, $aM5Dp.default), {
                            alt: !containerShouldBeImage && src ? name : undefined,
                            src: src,
                            appearance: appearance,
                            UNSAFE_isUpdatedGeometry: isUpdatedHexagonGeometry,
                            size: size,
                            testId: testId,
                            imgLoading: imgLoading
                        })
                    },
                    children: children || /*#__PURE__*/ (0, $5chsV.jsx)((0, $dIFTo.AvatarContent), {})
                }),
                isPresence && /*#__PURE__*/ (0, $5chsV.jsx)((0, $f1dgk.default), {
                    appearance: appearance,
                    size: indicatorSize,
                    presence: typeof presence === 'string' ? presence : undefined,
                    testId: testId,
                    children: customPresenceNode
                }),
                isStatus && /*#__PURE__*/ (0, $5chsV.jsx)((0, $fb87k.default), {
                    appearance: appearance,
                    size: indicatorSize,
                    borderColor: borderColor,
                    status: typeof status === 'string' ? status : undefined,
                    testId: testId,
                    children: customStatusNode
                }),
                containerShouldBeImage ? /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                    "data-testid": testId && `${testId}--label`,
                    id: labelId,
                    hidden: true,
                    children: defaultLabel
                }) : undefined
            ]
        })
    });
});
$f4bd61d938743d18$var$Avatar.displayName = 'Avatar';
var $f4bd61d938743d18$export$2e2bcd8739ae039 = $f4bd61d938743d18$var$Avatar;

});
parcelRegister("dIFTo", function(module, exports) {
$parcel$export(module.exports, "AvatarContent", () => $e8585df2e8a7661f$export$47fbc0b44cae5559);
/* avatar-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $5T6N9 = parcelRequire("5T6N9");

var $81xzH = parcelRequire("81xzH");

var $239ku = parcelRequire("239ku");
const $e8585df2e8a7661f$var$boxShadowCssVar = '--avatar-box-shadow';
const $e8585df2e8a7661f$var$bgColorCssVar = '--avatar-bg-color';
const $e8585df2e8a7661f$var$styles = {
    root: "_30huDKYbGa _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAnQyn _2WAcuGnQyn _23rrnHiNRm _3iDTPbQ4SZ _1mT5xd5HSx _0hPCNLFlnN _37wbyuDIqT _0aFT5vbt8w _0wOv4QOLYo _0rIjykFQfX _43nrzTFQfX _2xTnZxFQfX _0GTcwRFQfX _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _1VJPcaeKTE _0EnhYgPgdg _1JM8vv4Jcb _2jfUf9N91d _2WYcYGWVPG _3wEj0XyL8i _0GBAIrJ5bs _43i6GSdnbC _2tbAUcYbGa _3kPd40YbGa _1ubuxonXvL _34b3D2FQfX _1NDpvb6wH8 _2wtOC9vc3e _0hSAgbNvrM",
    circle: "_0bjKvDaaQb _2Gfj6iaaQb",
    square: "_0bjKvD0O7w",
    positionRelative: "_1mT5xdRAKS",
    disabled: "_0wOv4Qsyl5 _3wEj0XlfZc _43i6GSVx3j"
};
const $e8585df2e8a7661f$var$unboundStyles = {
    root: "_2uo31fVZWJ _24h04iyL8i _2OUyjtrcoi",
    hexagonFocusContainer: "_4c065U9E27 _2Y7lL42M4S _3SamIHoYZL _2YLqiKnBff _0KLXruyL8i _1uo2ZfTcEg _3YCJEinXvL",
    updatedHexagonClipPath: "_1uo2ZfEXe0",
    hexagonBorderContainer: "_2uo31fVZWJ _4c065U7oRc _2Y7lL4Aa7o _3SamIHzX4W _2YLqiKTz7d _1uo2ZfOLYo _3YCJEilfZc",
    hexagon: "_0bjKvDdnbC _1uo2ZfOLYo _2OUyjtZqHV _2Gfj6idnbC _3kPd40ZqHV _2wtOC9dnbC _0hSAgbdnbC",
    interactive: "_0wOv4Q7zJH _0jKh9gMC01 _0ZgYXI7dHp _14Uf36qui9 _0WVYA37dHp _1if2KaHZdu",
    interactiveMotion: "_23rrnHimX9 _1sLQ8qC67X _3NJLv82rpu"
};
const $e8585df2e8a7661f$var$hexagonBorderFixStyles = {
    hexagonBorderContainer: "_0xmtkoUduD _46hvQmUduD _03SyCPUduD _0LQT5EUduD _0rIjykPM89 _43nrzTPM89 _2xTnZxPM89 _0GTcwRPM89",
    hexagonFocusContainer: "_0xmtko7SV6 _46hvQm7SV6 _03SyCP7SV6 _0LQT5E7SV6 _0rIjykAoU6 _43nrzTAoU6 _2xTnZxAoU6 _0GTcwRAoU6"
};
// See https://hello.atlassian.net/wiki/spaces/DST/pages/7432283012
const $e8585df2e8a7661f$var$updatedHexagonBorderFixStyles = {
    hexagonBorderContainer: "_0xmtkofkS7 _46hvQmfkS7 _03SyCPdnbC _0LQT5EdnbC _0rIjyk5hfz _43nrzT5hfz _2xTnZxdnbC _0GTcwRdnbC",
    hexagonFocusContainer: "_0xmtkoQVeh _46hvQmQVeh _03SyCP2M4S _0LQT5E2M4S _0rIjyk59JZ _43nrzT59JZ _2xTnZxnBff _0GTcwRnBff"
};
const $e8585df2e8a7661f$var$widthHeightMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F",
    xsmall: "_39xV02ey7F _0jFU0Vey7F",
    UNSAFE_xsmall: "_39xV02SPN1 _0jFU0VSPN1",
    small: "_39xV02oWWg _0jFU0VoWWg",
    medium: "_39xV02Uofl _0jFU0VUofl",
    large: "_39xV02UF4f _0jFU0VUF4f",
    xlarge: "_39xV02JgOI _0jFU0VJgOI",
    xxlarge: "_39xV02NNui _0jFU0VNNui"
};
// The sole source of truth for the updated hexagon width/height geometry (per size).
const $e8585df2e8a7661f$var$updatedHexagonDimensionMap = {
    xxsmall: "_39xV02EGCh _0jFU0VQSd4",
    small: "_39xV021R6D _0jFU0V7qhK",
    medium: "_39xV02U2XU _0jFU0VRlO4",
    large: "_39xV02s3iu _0jFU0VNmyB",
    xlarge: "_39xV02OhVQ _0jFU0VHWFU",
    xxlarge: "_39xV02c73x _0jFU0VSk01"
};
const $e8585df2e8a7661f$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children }, ref)=>{
    (0, $239ku.useEnsureIsInsideAvatar)();
    const { as: Container, appearance: appearance, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, avatarImage: avatarImage, borderColor: borderColor = "var(--ds-surface, #FFFFFF)", href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup } = (0, $fsvuC.useContext)((0, $81xzH.AvatarContentContext));
    const isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    const renderedContent = /*#__PURE__*/ (0, $5chsV.jsx)(Container, {
        style: {
            [$e8585df2e8a7661f$var$bgColorCssVar]: borderColor,
            [$e8585df2e8a7661f$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $gJ6nT.default)([
            $e8585df2e8a7661f$var$unboundStyles.root,
            $e8585df2e8a7661f$var$styles.root,
            appearance === 'square' && $e8585df2e8a7661f$var$styles.square,
            appearance === 'circle' && $e8585df2e8a7661f$var$styles.circle,
            appearance === 'hexagon' && $e8585df2e8a7661f$var$unboundStyles.hexagon,
            $e8585df2e8a7661f$var$widthHeightMap[size],
            UNSAFE_isUpdatedGeometry && $e8585df2e8a7661f$var$updatedHexagonDimensionMap[size],
            stackIndex !== undefined && $e8585df2e8a7661f$var$styles.positionRelative,
            isInteractive && !isDisabled && $e8585df2e8a7661f$var$unboundStyles.interactive,
            isInteractive && !isDisabled && appearance !== 'hexagon' && (0, $5T6N9.fg)('platform-dst-motion-uplift') && $e8585df2e8a7661f$var$unboundStyles.interactiveMotion,
            isDisabled && $e8585df2e8a7661f$var$styles.disabled
        ]),
        children: children || avatarImage
    });
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        style: {
            [$e8585df2e8a7661f$var$bgColorCssVar]: borderColor,
            [$e8585df2e8a7661f$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        "data-testid": testId ? `${testId}-hexagon-focus-container` : 'hexagon-focus-container',
        className: (0, $gJ6nT.default)([
            $e8585df2e8a7661f$var$unboundStyles.hexagonFocusContainer,
            UNSAFE_isUpdatedGeometry && $e8585df2e8a7661f$var$unboundStyles.updatedHexagonClipPath,
            isInteractive && !isDisabled && (0, $5T6N9.fg)('platform-dst-motion-uplift') && $e8585df2e8a7661f$var$unboundStyles.interactiveMotion,
            UNSAFE_isUpdatedGeometry && $e8585df2e8a7661f$var$updatedHexagonBorderFixStyles.hexagonFocusContainer,
            (0, $5T6N9.fg)('platform_editor_agent_mentions_drop_one_fixes') && !UNSAFE_isUpdatedGeometry && $e8585df2e8a7661f$var$hexagonBorderFixStyles.hexagonFocusContainer
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
            "data-testid": testId ? `${testId}-hexagon-border-container` : 'hexagon-border-container',
            className: (0, $gJ6nT.default)([
                $e8585df2e8a7661f$var$unboundStyles.hexagonBorderContainer,
                UNSAFE_isUpdatedGeometry && $e8585df2e8a7661f$var$updatedHexagonBorderFixStyles.hexagonBorderContainer,
                (0, $5T6N9.fg)('platform_editor_agent_mentions_drop_one_fixes') && !UNSAFE_isUpdatedGeometry && $e8585df2e8a7661f$var$hexagonBorderFixStyles.hexagonBorderContainer
            ]),
            children: renderedContent
        })
    });
});

});
parcelRegister("81xzH", function(module, exports) {
$parcel$export(module.exports, "AvatarContentContext", () => $5be15607a696400e$export$b983474ddd0b6d28);

var $fsvuC = parcelRequire("fsvuC");
const $5be15607a696400e$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const $5be15607a696400e$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $fsvuC.createContext)($5be15607a696400e$var$defaultAvatarContentProps);

});

parcelRegister("239ku", function(module, exports) {
$parcel$export(module.exports, "useEnsureIsInsideAvatar", () => $d0d6d9680336b406$export$7db5c57474082dd9);

var $fsvuC = parcelRequire("fsvuC");

var $ikrk9 = parcelRequire("ikrk9");
const $d0d6d9680336b406$export$7db5c57474082dd9 = ()=>{
    const context = (0, $fsvuC.useContext)((0, $ikrk9.EnsureIsInsideAvatarContext));
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});
parcelRegister("ikrk9", function(module, exports) {
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", () => $a29415d02d087435$export$6b4cbd90d24955ad);

var $fsvuC = parcelRequire("fsvuC");
const $a29415d02d087435$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $fsvuC.createContext)(false);

});



parcelRegister("aM5Dp", function(module, exports) {
$parcel$export(module.exports, "default", () => $00828df5957eb286$export$2e2bcd8739ae039);
/* avatar-image.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $gjVYm = parcelRequire("gjVYm");

var $gI1yN = parcelRequire("gI1yN");

var $anXxY = parcelRequire("anXxY");
const $00828df5957eb286$var$styles = {
    image: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d",
    icon: "_3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d _0KLXruG6qS",
    circle: "_0bjKvDS5Zs",
    hexagon: "_1uo2ZfTcEg",
    updatedHexagonIcon: "_0hPCNLDIqT _37wbyuDIqT",
    updatedHexagonImage: "_1uo2ZfOLYo _00EA0eiObl _3IONCnIZbP"
};
const $00828df5957eb286$var$borderRadiusMap = {
    xxsmall: "_0bjKvDcjp5",
    xsmall: "_0bjKvDcjp5",
    UNSAFE_xsmall: "_0bjKvDcjp5",
    small: "_0bjKvDcjp5",
    medium: "_0bjKvDKxmn",
    large: "_0bjKvDKxmn",
    xlarge: "_0bjKvDKTcp",
    xxlarge: "_0bjKvDyzSk"
};
const $00828df5957eb286$var$nestedSvgStylesMap = {
    xxsmall: "_27VeLCey7F _2Qxi4ney7F",
    xsmall: "_27VeLCey7F _2Qxi4ney7F",
    UNSAFE_xsmall: "_27VeLCSPN1 _2Qxi4nSPN1",
    small: "_27VeLCoWWg _2Qxi4noWWg",
    medium: "_27VeLCUofl _2Qxi4nUofl",
    large: "_27VeLCUF4f _2Qxi4nUF4f",
    xlarge: "_27VeLCJgOI _2Qxi4nJgOI",
    xxlarge: "_27VeLCNNui _2Qxi4nNNui"
};
// NOTE: Must mirror `updatedHexagonDimensionMap` in `../avatar-content.tsx`.
const $00828df5957eb286$var$updatedHexagonNestedSvgStylesMap = {
    xxsmall: "_27VeLCEGCh _2Qxi4nQSd4",
    small: "_27VeLC1R6D _2Qxi4n7qhK",
    medium: "_27VeLCU2XU _2Qxi4nRlO4",
    large: "_27VeLCs3iu _2Qxi4nNmyB",
    xlarge: "_27VeLCOhVQ _2Qxi4nHWFU",
    xxlarge: "_27VeLCc73x _2Qxi4nSk01"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $00828df5957eb286$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, UNSAFE_isUpdatedGeometry: UNSAFE_isUpdatedGeometry, size: size, testId: testId, imgLoading: imgLoading })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $fsvuC.useState)(false);
    // If src changes, reset state
    (0, $fsvuC.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        let renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gI1yN))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--person`,
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gjVYm))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--agent`,
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($anXxY))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--ship`,
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
            className: (0, $gJ6nT.default)([
                $00828df5957eb286$var$styles.icon,
                UNSAFE_isUpdatedGeometry ? $00828df5957eb286$var$updatedHexagonNestedSvgStylesMap[size] : $00828df5957eb286$var$nestedSvgStylesMap[size],
                UNSAFE_isUpdatedGeometry && $00828df5957eb286$var$styles.updatedHexagonIcon
            ]),
            children: renderedIcon
        });
    }
    return /*#__PURE__*/ (0, $5chsV.jsx)("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $gJ6nT.default)([
            $00828df5957eb286$var$styles.image,
            $00828df5957eb286$var$borderRadiusMap[size],
            appearance === 'circle' && $00828df5957eb286$var$styles.circle,
            appearance === 'hexagon' && $00828df5957eb286$var$styles.hexagon,
            UNSAFE_isUpdatedGeometry && $00828df5957eb286$var$styles.updatedHexagonImage
        ])
    });
};
$00828df5957eb286$var$AvatarImage.displayName = "AvatarImage";
var $00828df5957eb286$export$2e2bcd8739ae039 = $00828df5957eb286$var$AvatarImage;

});

parcelRegister("fHKB9", function(module, exports) {
$parcel$export(module.exports, "default", () => $956284604e28c40b$export$2e2bcd8739ae039);
const $956284604e28c40b$var$getCustomElement = (isDisabled, href, onClick, ariaHasPopup)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
var $956284604e28c40b$export$2e2bcd8739ae039 = $956284604e28c40b$var$getCustomElement;

});

parcelRegister("f1dgk", function(module, exports) {
$parcel$export(module.exports, "default", () => $169656815e08565f$export$2e2bcd8739ae039);
/* presence-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $13X0d = parcelRequire("13X0d");
const $169656815e08565f$var$styles = {
    root: "_1mT5xdWVPG _1pp6NdYbGa"
};
const $169656815e08565f$var$iconSizeMap = {
    small: "_0jFU0VxpxF _39xV02xpxF",
    medium: "_0jFU0VEbN9 _39xV02EbN9",
    large: "_0jFU0V2sAl _39xV022sAl",
    xlarge: "_0jFU0V70UD _39xV0270UD"
};
const $169656815e08565f$var$circleIconOffsetMap = {
    small: "_0Bm75GdnbC _4ApkO2dnbC",
    medium: "_0Bm75GdnbC _4ApkO2dnbC",
    large: "_0Bm75GHZdu _4ApkO2HZdu",
    xlarge: "_0Bm75GXJux _4ApkO2XJux"
};
const $169656815e08565f$var$squareIconOffsetMap = {
    root: "_0Bm75GVo9d _4ApkO2Vo9d"
};
const $169656815e08565f$var$hexagonIconOffsetMap = {
    small: "_0Bm75GA17z _4ApkO2A17z",
    medium: "_0Bm75GA17z _4ApkO2A17z",
    large: "_0Bm75GUNDJ _4ApkO2Vo9d",
    xlarge: "_0Bm75GvFgp _4ApkO28e2l"
};
/**
 * __Presence wrapper__
 *
 * A presence wrapper is used internally to position presence ontop of the avatar.
 */ const $169656815e08565f$var$PresenceWrapper = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, $gJ6nT.default)([
            $169656815e08565f$var$styles.root,
            $169656815e08565f$var$iconSizeMap[size],
            $169656815e08565f$var$circleIconOffsetMap[size],
            appearance === 'square' && $169656815e08565f$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $169656815e08565f$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $13X0d.default), {
            borderColor: borderColor,
            presence: !children ? presence : undefined,
            children: children
        })
    });
};
$169656815e08565f$var$PresenceWrapper.displayName = "PresenceWrapper";
var $169656815e08565f$export$2e2bcd8739ae039 = $169656815e08565f$var$PresenceWrapper;

});
parcelRegister("13X0d", function(module, exports) {
$parcel$export(module.exports, "default", () => $1abb2303afea23a3$export$2e2bcd8739ae039);
/* presence.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $1UQgf = parcelRequire("1UQgf");
const $1abb2303afea23a3$var$BusyIndicator = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
    children: [
        /*#__PURE__*/ (0, $5chsV.jsx)("circle", {
            fill: "var(--ds-icon-danger, #C9372C)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $5chsV.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
        })
    ]
});
const $1abb2303afea23a3$var$FocusIndicator = /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Fragment), {
    children: /*#__PURE__*/ (0, $5chsV.jsx)("path", {
        fill: "var(--ds-icon-discovery, #AF59E1)",
        d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
    })
});
const $1abb2303afea23a3$var$OfflineIndicator = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
    children: [
        /*#__PURE__*/ (0, $5chsV.jsx)("path", {
            fill: "var(--ds-text-subtlest, #6B6E76)",
            d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        }),
        /*#__PURE__*/ (0, $5chsV.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
        })
    ]
});
const $1abb2303afea23a3$var$OnlineIndicator = /*#__PURE__*/ (0, $5chsV.jsx)("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function $1abb2303afea23a3$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $1abb2303afea23a3$var$BusyIndicator;
        case 'focus':
            return $1abb2303afea23a3$var$FocusIndicator;
        case 'offline':
            return $1abb2303afea23a3$var$OfflineIndicator;
        case 'online':
            return $1abb2303afea23a3$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $1abb2303afea23a3$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $1UQgf.default), {
        bgColor: borderColor,
        children: presence ? /*#__PURE__*/ (0, $5chsV.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $1abb2303afea23a3$var$getPresence(presence)
        }) : children
    });
$1abb2303afea23a3$var$AvatarPresence.displayName = "AvatarPresence";
var $1abb2303afea23a3$export$2e2bcd8739ae039 = $1abb2303afea23a3$var$AvatarPresence;

});
parcelRegister("1UQgf", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f92050c49ea232e$export$2e2bcd8739ae039);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $6f92050c49ea232e$var$styles = {
    root: "_0bjKvDaaQb _4bt5LAnQyn _2WAcuGnQyn _2V7sgO2M4S _3hxITi6wH8 _3iDTPbQ4SZ _24h04i2Njc _39xV02N91d _0jFU0VN91d _0hPCNLDIqT _0GwItXDIqT _0KLXruoI2d"
};
const $6f92050c49ea232e$var$unboundStyles = {
    root: "_3vBAKHoI2d"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $6f92050c49ea232e$var$IconWrapper = ({ bgColor: bgColor, children: children })=>/*#__PURE__*/ (0, $5chsV.jsx)("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $gJ6nT.default)([
            $6f92050c49ea232e$var$styles.root,
            $6f92050c49ea232e$var$unboundStyles.root
        ]),
        children: children
    });
$6f92050c49ea232e$var$IconWrapper.displayName = "IconWrapper";
var $6f92050c49ea232e$export$2e2bcd8739ae039 = $6f92050c49ea232e$var$IconWrapper;

});



parcelRegister("fb87k", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f8ae62fe443e6a2$export$2e2bcd8739ae039);
/* status-wrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $7mrvS = parcelRequire("7mrvS");
const $0f8ae62fe443e6a2$var$styles = {
    root: "_1mT5xdWVPG"
};
const $0f8ae62fe443e6a2$var$iconSizeMap = {
    small: "_0jFU0VxpxF _39xV02xpxF",
    medium: "_0jFU0VEbN9 _39xV02EbN9",
    large: "_0jFU0V2sAl _39xV022sAl",
    xlarge: "_0jFU0V70UD _39xV0270UD"
};
const $0f8ae62fe443e6a2$var$circleIconOffsetMap = {
    small: "_1OKFqYdnbC _2I62gzdnbC",
    medium: "_1OKFqYdnbC _2I62gzdnbC",
    large: "_1OKFqYHZdu _2I62gzHZdu",
    xlarge: "_1OKFqYXJux _2I62gzXJux"
};
const $0f8ae62fe443e6a2$var$squareIconOffsetMap = {
    root: "_1OKFqYdnbC _2I62gzdnbC"
};
const $0f8ae62fe443e6a2$var$hexagonIconOffsetMap = {
    small: "_1OKFqYA17z _2I62gzA17z",
    medium: "_1OKFqYA17z _2I62gzA17z",
    large: "_1OKFqYVo9d _2I62gzUNDJ",
    xlarge: "_1OKFqY8e2l _2I62gzvFgp"
};
/**
 * __Status wrapper__
 *
 * A status wrapper is used internally to position status on top of the avatar.
 */ const $0f8ae62fe443e6a2$var$StatusWrapper = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, $gJ6nT.default)([
            $0f8ae62fe443e6a2$var$styles.root,
            $0f8ae62fe443e6a2$var$iconSizeMap[size],
            $0f8ae62fe443e6a2$var$circleIconOffsetMap[size],
            appearance === 'square' && $0f8ae62fe443e6a2$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $0f8ae62fe443e6a2$var$hexagonIconOffsetMap[size]
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $7mrvS.default), {
            borderColor: borderColor,
            status: !children ? status : undefined,
            children: children
        })
    });
};
$0f8ae62fe443e6a2$var$StatusWrapper.displayName = "StatusWrapper";
var $0f8ae62fe443e6a2$export$2e2bcd8739ae039 = $0f8ae62fe443e6a2$var$StatusWrapper;

});
parcelRegister("7mrvS", function(module, exports) {
$parcel$export(module.exports, "default", () => $858de77b1bfd1d48$export$2e2bcd8739ae039);
/* status.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $1UQgf = parcelRequire("1UQgf");
const $858de77b1bfd1d48$var$ApprovedIndicator = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
    children: [
        /*#__PURE__*/ (0, $5chsV.jsx)("circle", {
            fill: "var(--ds-icon-success, #6A9A23)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $5chsV.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
        })
    ]
});
const $858de77b1bfd1d48$var$DeclinedIndicator = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
    children: [
        /*#__PURE__*/ (0, $5chsV.jsx)("circle", {
            fill: "var(--ds-icon-danger, #C9372C)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $5chsV.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
        })
    ]
});
const $858de77b1bfd1d48$var$LockedIndicator = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
    children: [
        /*#__PURE__*/ (0, $5chsV.jsx)("circle", {
            fill: "var(--ds-text-subtlest, #6B6E76)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $5chsV.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
        })
    ]
});
const $858de77b1bfd1d48$var$WarningIndicator = /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
    children: [
        /*#__PURE__*/ (0, $5chsV.jsx)("circle", {
            fill: "var(--ds-icon-warning, #E06C00)",
            cx: "4",
            cy: "4",
            r: "4"
        }),
        /*#__PURE__*/ (0, $5chsV.jsx)("path", {
            fill: "var(--ds-surface-overlay, #FFFFFF)",
            d: "M4,1.33333333 C4.36918944,1.33333333 4.66666667,1.63081056 4.66666667,2 L4.66666667,4 C4.66666667,4.36918944 4.36918944,4.66666667 4,4.66666667 C3.63081056,4.66666667 3.33333333,4.36918944 3.33333333,4 L3.33333333,2 C3.33333333,1.63081056 3.63081056,1.33333333 4,1.33333333 Z M4,5.33333333 C4.36918944,5.33333333 4.66666667,5.63081056 4.66666667,6 C4.66666667,6.36918944 4.36918944,6.66666667 4,6.66666667 C3.63081056,6.66666667 3.33333333,6.36918944 3.33333333,6 C3.33333333,5.63081056 3.63081056,5.33333333 4,5.33333333 Z"
        })
    ]
});
function $858de77b1bfd1d48$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $858de77b1bfd1d48$var$ApprovedIndicator;
        case 'declined':
            return $858de77b1bfd1d48$var$DeclinedIndicator;
        case 'locked':
            return $858de77b1bfd1d48$var$LockedIndicator;
        case 'warning':
            return $858de77b1bfd1d48$var$WarningIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $858de77b1bfd1d48$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $1UQgf.default), {
        bgColor: borderColor,
        children: status ? /*#__PURE__*/ (0, $5chsV.jsx)("svg", {
            height: "100%",
            version: "1.1",
            viewBox: "0 0 8 8",
            width: "100%",
            xmlns: "http://www.w3.org/2000/svg",
            children: $858de77b1bfd1d48$var$getStatus(status)
        }) : children
    });
$858de77b1bfd1d48$var$AvatarStatus.displayName = "AvatarStatus";
var $858de77b1bfd1d48$export$2e2bcd8739ae039 = $858de77b1bfd1d48$var$AvatarStatus;

});


parcelRegister("4rOra", function(module, exports) {
$parcel$export(module.exports, "useAvatarContext", () => $96132b89ecba6588$export$b50b87a1c4086b23);

var $fsvuC = parcelRequire("fsvuC");

var $iTWAk = parcelRequire("iTWAk");
const $96132b89ecba6588$export$b50b87a1c4086b23 = ()=>(0, $fsvuC.useContext)((0, $iTWAk.AvatarContext));

});
parcelRegister("iTWAk", function(module, exports) {
$parcel$export(module.exports, "AvatarContext", () => $f203eb4c63c3c0fc$export$a20dad690e1279e2);

var $fsvuC = parcelRequire("fsvuC");
const $f203eb4c63c3c0fc$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $fsvuC.createContext)(undefined);

});



parcelRegister("5jAhG", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fd5ee61f43c2bbd$export$2e2bcd8739ae039);
/* section.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $e46kc = parcelRequire("e46kc");
const $5fd5ee61f43c2bbd$var$itemHeadingTopMargin = 20;
const $5fd5ee61f43c2bbd$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $5fd5ee61f43c2bbd$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const $5fd5ee61f43c2bbd$var$skeletonHeadingHeight = 8;
const $5fd5ee61f43c2bbd$var$skeletonHeadingMarginOffset = 3;
const $5fd5ee61f43c2bbd$var$skeletonHeadingTopMargin = $5fd5ee61f43c2bbd$var$itemHeadingTopMargin + ($5fd5ee61f43c2bbd$var$itemHeadingContentHeight - $5fd5ee61f43c2bbd$var$skeletonHeadingHeight) - $5fd5ee61f43c2bbd$var$skeletonHeadingMarginOffset;
const $5fd5ee61f43c2bbd$var$sectionPaddingTopBottom = 6;
const $5fd5ee61f43c2bbd$var$styles = {
    root: "_4Gb5FivLZJ _0OU75rvLZJ _47eTBtZimw _1lBcDcZimw _0GBAIrogpp _3Ku51Iogpp _420PbdZimw _3LXXKoSPN1 _1DqDD4EbN9 _0Ipfpy2AF2 _1apEF8fFOW _3R93WOXCiO _38a67RA17z",
    scrollable: "_4bt5LAIZbP _2WAcuGIZbP _3YEZNO7dHp",
    unscrollable: "_3YEZNOdnbC",
    thinSeparator: "_1v3aPqo71H",
    noSeparator: "_1wX8q6mW1D",
    sideNavSectionHeading: "_2Y7lL42ADO"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $5fd5ee61f43c2bbd$var$Section = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, isSideNavSection: isSideNavSection = false, label: label, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    const content = isList ? /*#__PURE__*/ (0, $5chsV.jsx)("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        },
        children: (0, $fsvuC.Children).map((0, $fsvuC.Children).toArray(children), (child, index)=>/*#__PURE__*/ (0, $5chsV.jsx)("li", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    listStyleType: 'none',
                    margin: 0,
                    padding: 0
                },
                children: child
            }, index))
    }) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $e46kc.default), {
                testId: testId && `${testId}--heading`,
                "aria-hidden": true,
                // @ts-expect-error
                // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
                className: (0, $gJ6nT.default)([
                    isSideNavSection && $5fd5ee61f43c2bbd$var$styles.sideNavSectionHeading
                ]),
                children: title
            }),
            content
        ]
    }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $fsvuC.Fragment), {
        children: content
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gJ6nT.default)([
            $5fd5ee61f43c2bbd$var$styles.root,
            isScrollable ? $5fd5ee61f43c2bbd$var$styles.scrollable : $5fd5ee61f43c2bbd$var$styles.unscrollable,
            hasSeparator ? $5fd5ee61f43c2bbd$var$styles.thinSeparator : $5fd5ee61f43c2bbd$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref,
        children: childrenMarkup
    });
});
var $5fd5ee61f43c2bbd$export$2e2bcd8739ae039 = $5fd5ee61f43c2bbd$var$Section;

});
parcelRegister("e46kc", function(module, exports) {
$parcel$export(module.exports, "default", () => $a39a677cbd1d62cf$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $a39a677cbd1d62cf$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $a39a677cbd1d62cf$var$HeadingItem = /*#__PURE__*/ (0, $fsvuC.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gJ6nT.default)([
            "_2sNsIgd8bj _4c065UPgdg _2Y7lL45zaO _1UtDYzZpcK",
            UNSAFE_className
        ]),
        ...rest,
        children: children
    });
});
var $a39a677cbd1d62cf$export$2e2bcd8739ae039 = $a39a677cbd1d62cf$var$HeadingItem;

});


parcelRegister("aDFIW", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf3e74bb11bed9bf$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $k9FWI = parcelRequire("k9FWI");

var $5jAhG = parcelRequire("5jAhG");

var $4KL8n = parcelRequire("4KL8n");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $bf3e74bb11bed9bf$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $k9FWI.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5jAhG.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $5chsV.jsx)((0, $4KL8n.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $bf3e74bb11bed9bf$export$2e2bcd8739ae039 = $bf3e74bb11bed9bf$var$DropdownMenuItemGroup;

});
parcelRegister("4KL8n", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d7a11621e5f6bdb$export$2e2bcd8739ae039);
/* group-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $fpjto = parcelRequire("fpjto");
const $9d7a11621e5f6bdb$var$styles = {
    heading: "_2sNsIgd8bj _4c065UPgdg _2Y7lL45zaO _1UtDYzZpcK"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ const $9d7a11621e5f6bdb$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $fpjto.Box), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $9d7a11621e5f6bdb$var$styles.heading,
        children: title
    });
$9d7a11621e5f6bdb$var$GroupTitle.displayName = "GroupTitle";
var $9d7a11621e5f6bdb$export$2e2bcd8739ae039 = $9d7a11621e5f6bdb$var$GroupTitle;

});


parcelRegister("exn3G", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $9a1ce52173e8aa5f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $6Pi1A = parcelRequire("6Pi1A");

var $5T6N9 = parcelRequire("5T6N9");
const $9a1ce52173e8aa5f$var$shimmerKeyframes = null;
const $9a1ce52173e8aa5f$var$skeletonStyles = null;
const $9a1ce52173e8aa5f$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $9a1ce52173e8aa5f$var$useLayoutEffect = typeof window === 'undefined' ? (0, $fsvuC.useEffect) : (0, $fsvuC.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $9a1ce52173e8aa5f$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $fsvuC.useContext)((0, $6Pi1A.default));
    $9a1ce52173e8aa5f$var$useLayoutEffect(()=>{
        if (context != null && (0, $5T6N9.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $gJ6nT.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            isShimmering && "",
            isShimmering && "_1gBibyKB6V"
        ])
    });
};
$9a1ce52173e8aa5f$var$Skeleton.displayName = "Skeleton";
var $9a1ce52173e8aa5f$export$2e2bcd8739ae039 = $9a1ce52173e8aa5f$var$Skeleton;

});

parcelRegister("kusdB", function(module, exports) {
$parcel$export(module.exports, "hasOpenDialogOrPopover", () => $9cb1b47dee0188d6$export$bc25fb0b0107cf3f);

var $aRngQ = parcelRequire("aRngQ");

var $357xf = parcelRequire("357xf");
function $9cb1b47dee0188d6$export$bc25fb0b0107cf3f({ within: within = document, type: type } = {}) {
    const dialogs = Array.from(within.querySelectorAll('dialog'));
    if (type === 'modal') return dialogs.some((dialog)=>(0, $aRngQ.isModalDialog)({
            element: dialog
        }));
    if (dialogs.some((dialog)=>dialog.open)) return true;
    return (0, $357xf.getOpenClosablePopovers)({
        within: within
    }).some((popover)=>popover.getAttribute('role') !== 'tooltip');
}

});
parcelRegister("357xf", function(module, exports) {
$parcel$export(module.exports, "getOpenClosablePopovers", () => $1b2b7ecdd885a383$export$5ac803c52a27f775);


var $6OnfV = parcelRequire("6OnfV");
function $1b2b7ecdd885a383$export$5ac803c52a27f775({ within: within }) {
    return Array.from(within.querySelectorAll(`[${(0, $ba52e8a77c149a28$export$c6890d80f1a52941)}]`)).filter((element)=>(0, $6OnfV.isNativeElementOpen)({
            element: element
        }));
}

});
/**
 * `Popover` sets this attribute on its host element when it has an `onClose`. Only those popovers
 * can be asked to close, so `hasOpenDialogOrPopover` counts only those and `requestClosePopovers`
 * asks only those. Outside code cannot dismiss a popover without `onClose` (for example the flag
 * group or a spotlight), so both skip it.
 *
 * `Popover` writes the attribute name as a literal JSX prop. Keep the two in sync.
 */ const $ba52e8a77c149a28$export$c6890d80f1a52941 = 'data-top-layer-closable';
const $ba52e8a77c149a28$export$17ed9502ee8e92da = 'top-layer-request-close';



parcelRegister("7WPU3", function(module, exports) {
$parcel$export(module.exports, "requestClosePopovers", () => $cf21bb54d26c56e2$export$1df483fbb5ff0091);


var $357xf = parcelRequire("357xf");
function $cf21bb54d26c56e2$export$1df483fbb5ff0091({ within: within = document } = {}) {
    (0, $357xf.getOpenClosablePopovers)({
        within: within
    }).forEach((popover)=>{
        popover.dispatchEvent(new Event((0, $ba52e8a77c149a28$export$17ed9502ee8e92da)));
    });
}

});

parcelRegister("bB72C", function(module, exports) {
$parcel$export(module.exports, "AssetsIcon", () => $9933a0bd33cc37ea$export$d89497e7f33ca6f5);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::505dbad49a3dfa1729f04b26edcebd32>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $hBUvp = parcelRequire("hBUvp");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $9933a0bd33cc37ea$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>
</svg>
`;
const $9933a0bd33cc37ea$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>
</svg>
`;
function $9933a0bd33cc37ea$export$d89497e7f33ca6f5({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Assets', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hBUvp.IconWrapper), {
        svg: $9933a0bd33cc37ea$var$svg,
        customThemeSvg: $9933a0bd33cc37ea$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$9933a0bd33cc37ea$export$d89497e7f33ca6f5.displayName = "AssetsIcon";

});

parcelRegister("7mAoN", function(module, exports) {
$parcel$export(module.exports, "SplitButton", () => $a2b08a88137ea1d1$export$651ad66661acd392);
/* split-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $aGcZ9 = parcelRequire("aGcZ9");

var $2KMFV = parcelRequire("2KMFV");

var $9AbXq = parcelRequire("9AbXq");

var $59UEW = parcelRequire("59UEW");
const $a2b08a88137ea1d1$var$buttonStyles = {
    primaryButton: "_3rzkiodnbC _1kWzVtdnbC _0uVYyIdnbC _2qDbL0dnbC",
    secondaryButton: "_1jomYRdnbC _4oPZ7ddnbC _2kv5QsdnbC _0geU8cdnbC"
};
const $a2b08a88137ea1d1$export$651ad66661acd392 = ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $59UEW.getActions)(children);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2KMFV.SplitButtonContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $9AbXq.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    className: (0, $gJ6nT.default)([
                        $a2b08a88137ea1d1$var$buttonStyles.primaryButton
                    ]),
                    children: PrimaryAction
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $aGcZ9.Divider), {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    className: (0, $gJ6nT.default)([
                        $a2b08a88137ea1d1$var$buttonStyles.secondaryButton
                    ]),
                    children: SecondaryAction
                })
            ]
        })
    });
};
$a2b08a88137ea1d1$export$651ad66661acd392.displayName = "SplitButton";

});
parcelRegister("aGcZ9", function(module, exports) {
$parcel$export(module.exports, "Divider", () => $dffd25cb4c8d9bd1$export$2e0a83ec2e27ecbb);
/* divider.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $dffd25cb4c8d9bd1$var$dividerStyles = {
    baseDivider: "_39xV02NvrM _1mT5xdRAKS _42Yu6B7dHp",
    dividerDisabled: "_0KLXruhQC5 _0wOv4Qsyl5",
    dividerOffset: "_2YLqiKA17z"
};
const $dffd25cb4c8d9bd1$var$dividerAppearanceStyles = {
    default: "_0KLXru9r67",
    primary: "_0KLXruxCOs _1YKVNsjLrf",
    navigation: "_3SamIH2ADO _2YLqiKwmY0 _0jFU0Vey7F _0KLXruZpcK _1YKVNsCfZC"
};
const $dffd25cb4c8d9bd1$var$dividerHeightStyles = {
    default: "_0jFU0VZ49V",
    compact: "_0jFU0V9DVM"
};
const $dffd25cb4c8d9bd1$var$defaultDividerHeightStyles = {
    default: "_0jFU0Vbu0M",
    compact: "_0jFU0Vv8uz"
};
const $dffd25cb4c8d9bd1$export$2e0a83ec2e27ecbb = ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const isDefaultDivider = appearance === 'default' && !isDisabled;
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            $dffd25cb4c8d9bd1$var$dividerStyles.baseDivider,
            isDefaultDivider && $dffd25cb4c8d9bd1$var$defaultDividerHeightStyles[spacing],
            !isDefaultDivider && $dffd25cb4c8d9bd1$var$dividerHeightStyles[spacing],
            isDisabled && $dffd25cb4c8d9bd1$var$dividerStyles.dividerDisabled,
            !isDisabled && $dffd25cb4c8d9bd1$var$dividerAppearanceStyles[appearance],
            $dffd25cb4c8d9bd1$var$dividerStyles.dividerOffset
        ])
    });
};
$dffd25cb4c8d9bd1$export$2e0a83ec2e27ecbb.displayName = "Divider";

});

parcelRegister("2KMFV", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContainer", () => $50d97bf3117aabb3$export$994ba1b4c598f7);
/* split-button-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $50d97bf3117aabb3$var$buttonStyles = {
    splitButton: "_3iDTPbccYA _1mT5xdRAKS _0hPCNLDIqT _1ANEUSLRg7",
    defaultAppearanceContainer: "_0bjKvDKTcp _2xIroY9r67 _3e6OgrA17z _497WNw6wH8 _2zndICHZdu",
    defaultAppearanceDisabledContainer: "_2xIroYhQC5"
};
const $50d97bf3117aabb3$export$994ba1b4c598f7 = ({ appearance: appearance, children: children, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            appearance === 'default' && $50d97bf3117aabb3$var$buttonStyles.defaultAppearanceContainer,
            appearance === 'default' && isDisabled && $50d97bf3117aabb3$var$buttonStyles.defaultAppearanceDisabledContainer,
            $50d97bf3117aabb3$var$buttonStyles.splitButton
        ]),
        children: children
    });
$50d97bf3117aabb3$export$994ba1b4c598f7.displayName = "SplitButtonContainer";

});

parcelRegister("59UEW", function(module, exports) {
$parcel$export(module.exports, "getActions", () => $97889841e9e8191e$export$fe3955935f564b31);

var $fsvuC = parcelRequire("fsvuC");

var $hoalA = parcelRequire("hoalA");
const $97889841e9e8191e$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $fsvuC.Children).toArray(children);
    typeof $hoalA;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


parcelRegister("dDqFm", function(module, exports) {
$parcel$export(module.exports, "Grid", () => $4d7bf1d3d9f95247$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $h2YWL = parcelRequire("h2YWL");

var $hgZMM = parcelRequire("hgZMM");

var $jzlOE = parcelRequire("jzlOE");
function $4d7bf1d3d9f95247$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4d7bf1d3d9f95247$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $4d7bf1d3d9f95247$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $4d7bf1d3d9f95247$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $4d7bf1d3d9f95247$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $4d7bf1d3d9f95247$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $4d7bf1d3d9f95247$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $4d7bf1d3d9f95247$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $4d7bf1d3d9f95247$var$baseStyles = /*#__PURE__*/ (0, $h2YWL.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$4d7bf1d3d9f95247$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$4d7bf1d3d9f95247$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$4d7bf1d3d9f95247$var$gridTemplateRowsVar})`
});
const $4d7bf1d3d9f95247$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
const $4d7bf1d3d9f95247$export$ef2184bd89960b14 = /*#__PURE__*/ (0, $fsvuC.memo)(/*#__PURE__*/ (0, $fsvuC.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $hgZMM.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $fsvuC.useMemo)(()=>({
            [$4d7bf1d3d9f95247$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$4d7bf1d3d9f95247$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$4d7bf1d3d9f95247$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $h2YWL.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $4d7bf1d3d9f95247$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $jzlOE.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $jzlOE.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $jzlOE.spaceStylesMap).rowGap[rowGap],
            alignItems && $4d7bf1d3d9f95247$var$alignItemsMap[alignItems],
            alignContent && $4d7bf1d3d9f95247$var$alignContentMap[alignContent],
            justifyContent && $4d7bf1d3d9f95247$var$justifyContentMap[justifyContent],
            autoFlow && $4d7bf1d3d9f95247$var$gridAutoFlowMap[autoFlow],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$4d7bf1d3d9f95247$export$ef2184bd89960b14.displayName = 'Grid';

});

parcelRegister("amuPR", function(module, exports) {
$parcel$export(module.exports, "default", () => $f15c7bf8370232c0$export$2e2bcd8739ae039);
/* skeleton-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $f15c7bf8370232c0$var$skeletonItemElemSize = 20;
const $f15c7bf8370232c0$var$styles = {
    root: "_4c065UPgdg _2Y7lL4kG2W _3iDTPbQ4SZ _4kiQYAUF4f _0hPCNLDIqT _1pp6NdYbGa _2Gfj6iQEt6 _47eTBt2AF2 _3wEj0XGsB2 _0GBAIrogpp _0eSLDaHZdu",
    defaultWidth: "_1ShRFFoBHb _0jufqb715P _0KfecEygnw _1v7p3wE1Ft _0pFvyeR1Le _1n9qNYrXaT",
    customWidth: "_2v4nLRyRC6",
    beforeElement: "_3ScelFSPN1 _1lBcDcSPN1 _0tXlYZdnbC _4diMdqGsB2 _3Ku51Iogpp _3QFY1HEbN9 _4bQ7pPFQfX",
    avatar: "_1OimfuS5Zs",
    icon: "_1OimfuzXzM",
    sideNavSkeleton: "_2Y7lL42ADO _1lBcDc9DVM _3QFY1H5zaO _3ScelF9DVM"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $f15c7bf8370232c0$var$shimmerKeyframes = null;
/**
 * These styles are defined using `css` rather than `cssMap` as there is a bug when using
 * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
 */ const $f15c7bf8370232c0$var$shimmerStyles = null;
/**
 * __Skeleton item__
 *
 * A skeleton item is used in place of an item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $f15c7bf8370232c0$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            $f15c7bf8370232c0$var$styles.root,
            (hasAvatar || hasIcon) && $f15c7bf8370232c0$var$styles.beforeElement,
            hasAvatar && $f15c7bf8370232c0$var$styles.avatar,
            hasIcon && $f15c7bf8370232c0$var$styles.icon,
            width ? $f15c7bf8370232c0$var$styles.customWidth : $f15c7bf8370232c0$var$styles.defaultWidth,
            isSideNavSkeleton && $f15c7bf8370232c0$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_21qtfOkSs3 _0160FKkSs3 _1nw4qxfONH _1iAcE9fONH _2VLDZtSHWH _0YTlblSHWH _30VpOT55dm _2ofBtg55dm _2WuqwLHVQb _2lXp1JHVQb _3wEj0XGsB2 _4diMdqGsB2",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
$f15c7bf8370232c0$var$SkeletonItem.displayName = "SkeletonItem";
var $f15c7bf8370232c0$export$2e2bcd8739ae039 = $f15c7bf8370232c0$var$SkeletonItem;

});

parcelRegister("8ULYr", function(module, exports) {
$parcel$export(module.exports, "getWorkspaceThemePreference", () => $3033e3e03242fec3$export$8a05dde4568766d5);
$parcel$export(module.exports, "updateWorkspaceThemePreference", () => $3033e3e03242fec3$export$21a54a869d2847fd);

var $iR1nz = parcelRequire("iR1nz");

var $6Q8my = parcelRequire("6Q8my");

var $iNT4o = parcelRequire("iNT4o");

var $5T6N9 = parcelRequire("5T6N9");

var $LFGzO = parcelRequire("LFGzO");

var $6o5gz = parcelRequire("6o5gz");
const $3033e3e03242fec3$export$8a05dde4568766d5 = async (environment, workspaceAri, accountId)=>{
    if (!(0, $5T6N9.fg)('shared-user-preferences')) return undefined;
    const response = await (0, $iNT4o.fetchQuery)(environment, (0, $6Q8my.default), {
        workspaceAri: workspaceAri,
        accountId: accountId
    }).toPromise();
    const themeString = response?.settings_userPreferencesResolved?.theme;
    if (!themeString) return undefined;
    return (0, $6o5gz.updateThemeWithDefaultValues)(themeString);
};
const $3033e3e03242fec3$export$21a54a869d2847fd = async (environment, workspaceAri, accountId, themeState)=>{
    if (!(0, $5T6N9.fg)('shared-user-preferences')) return;
    // Serialize theme object to string for GraphQL
    const themeString = (0, $LFGzO.themeObjectToString)(themeState);
    // Shared cache updater function for both optimistic and confirmed updates
    const updateCache = (store)=>{
        const root = store.getRoot();
        const resolvedPreferences = root.getLinkedRecord('settings_userPreferencesResolved', {
            workspaceAri: workspaceAri,
            accountId: accountId
        });
        if (resolvedPreferences) resolvedPreferences.setValue(themeString, 'theme');
    };
    return new Promise((resolve, reject)=>{
        (0, $iNT4o.commitMutation)(environment, {
            mutation: (0, $iR1nz.default),
            variables: {
                workspaceAri: workspaceAri,
                accountId: accountId,
                theme: themeString
            },
            // Optimistically update the cache for immediate UI feedback
            // Relay automatically reverts this if the mutation fails
            optimisticUpdater: updateCache,
            // Apply the confirmed server response to the cache
            updater: updateCache,
            onCompleted: (_, errors)=>{
                if (errors && errors.length > 0) reject(new Error(errors.map((e)=>e.message).join('; ')));
                else resolve();
            },
            onError: (error)=>{
                reject(error);
            }
        });
    });
};

});
parcelRegister("iR1nz", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c2a99492a373577$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<987867774544e4f15c78f3627b3a8203>>
 * @relayHash ced2fc19e942c004393c066bef43384d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2d8511617c2ae739deca629af208d0c0aff791868ae7f06fd41f3bca8189b104
const $6c2a99492a373577$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "theme"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                },
                {
                    "kind": "Variable",
                    "name": "theme",
                    "variableName": "theme"
                },
                {
                    "kind": "Variable",
                    "name": "workspaceAri",
                    "variableName": "workspaceAri"
                }
            ],
            "concreteType": "SettingsUserPreferences",
            "kind": "LinkedField",
            "name": "settings_updateUserPreferencesWorkspace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "theme"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "workspaceThemeManagementSetWorkspaceThemePreferenceMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "workspaceThemeManagementSetWorkspaceThemePreferenceMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "2d8511617c2ae739deca629af208d0c0aff791868ae7f06fd41f3bca8189b104",
            "metadata": {},
            "name": "workspaceThemeManagementSetWorkspaceThemePreferenceMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$6c2a99492a373577$var$node.hash = "a59aa9b6da224d8962255852220e8493";
var $6c2a99492a373577$export$2e2bcd8739ae039 = $6c2a99492a373577$var$node;

});

parcelRegister("6Q8my", function(module, exports) {
$parcel$export(module.exports, "default", () => $fabfe3a0f43f15b8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f3d7efe2efb8521ac39409b96cee46e7>>
 * @relayHash 62e15c72deef7eaf4c9035e5e1976db0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 58bfe0135afad3b1d316f22b2877ad9574655e849a508aebd203bfbc9e5828dc
const $fabfe3a0f43f15b8$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                },
                {
                    "kind": "Variable",
                    "name": "workspaceAri",
                    "variableName": "workspaceAri"
                }
            ],
            "concreteType": "SettingsUserPreferences",
            "kind": "LinkedField",
            "name": "settings_userPreferencesResolved",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "theme"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "workspaceThemeManagementGetWorkspaceThemePreferenceQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "workspaceThemeManagementGetWorkspaceThemePreferenceQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "58bfe0135afad3b1d316f22b2877ad9574655e849a508aebd203bfbc9e5828dc",
            "metadata": {},
            "name": "workspaceThemeManagementGetWorkspaceThemePreferenceQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$fabfe3a0f43f15b8$var$node.hash = "3f7fd599e886181a5359ad8f6fbe4487";
var $fabfe3a0f43f15b8$export$2e2bcd8739ae039 = $fabfe3a0f43f15b8$var$node;

});

parcelRegister("6o5gz", function(module, exports) {
$parcel$export(module.exports, "updateThemeWithDefaultValues", () => $0d8fecdb8dc2447c$export$bc77b52491b156d8);

var $86SBo = parcelRequire("86SBo");

var $11XE4 = parcelRequire("11XE4");
const $0d8fecdb8dc2447c$export$bc77b52491b156d8 = (themeString)=>(0, $11XE4.updateThemeObjectWithDefaultValues)((0, $86SBo.themeStringToObject)(themeString));

});
parcelRegister("11XE4", function(module, exports) {
$parcel$export(module.exports, "updateThemeObjectWithDefaultValues", () => $5676c6dab9682db0$export$830acc849806885d);

var $izWkI = parcelRequire("izWkI");
const $5676c6dab9682db0$export$830acc849806885d = (themeObject)=>({
        ...(0, $izWkI.DEFAULT_THEME),
        ...themeObject
    });

});
parcelRegister("izWkI", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_THEME", () => $5dc97f2474489efa$export$2faeed762aac6741);
const $5dc97f2474489efa$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
const $5dc97f2474489efa$export$854b45b62d1eb6d4 = 'auto';
const $5dc97f2474489efa$export$2faeed762aac6741 = {
    dark: 'dark',
    light: 'light',
    colorMode: $5dc97f2474489efa$export$854b45b62d1eb6d4,
    typography: 'typography'
};

});




parcelRegister("iK2XO", function(module, exports) {
$parcel$export(module.exports, "SideNav", () => (parcelRequire("60M9M")).SideNav);
$parcel$export(module.exports, "SideNavHeader", () => (parcelRequire("7GTPw")).SideNavHeader);
$parcel$export(module.exports, "SideNavBody", () => (parcelRequire("9YTPO")).SideNavBody);
$parcel$export(module.exports, "SideNavFooter", () => (parcelRequire("6rVbP")).SideNavFooter);
$parcel$export(module.exports, "SideNavToggleButton", () => (parcelRequire("cdJPv")).SideNavToggleButton);
$parcel$export(module.exports, "useToggleSideNav", () => (parcelRequire("lGVkp")).useToggleSideNav);
$parcel$export(module.exports, "useExpandSideNav", () => (parcelRequire("9Ofex")).useExpandSideNav);
$parcel$export(module.exports, "useSideNavRef", () => (parcelRequire("6a1tO")).useSideNavRef);
$parcel$export(module.exports, "SideNavPanelSplitter", () => (parcelRequire("diBAM")).SideNavPanelSplitter);

var $60M9M = parcelRequire("60M9M");

var $7GTPw = parcelRequire("7GTPw");

var $9YTPO = parcelRequire("9YTPO");

var $6rVbP = parcelRequire("6rVbP");

var $cdJPv = parcelRequire("cdJPv");

var $lGVkp = parcelRequire("lGVkp");

var $9Ofex = parcelRequire("9Ofex");

var $6a1tO = parcelRequire("6a1tO");

var $diBAM = parcelRequire("diBAM");

});
parcelRegister("60M9M", function(module, exports) {
$parcel$export(module.exports, "SideNav", () => $7b5d093607cf439b$export$1a35787d6353cf6a);
/* side-nav.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $80czl = parcelRequire("80czl");

var $dqdTY = parcelRequire("dqdTY");

var $hkZUI = parcelRequire("hkZUI");

var $1cXpO = parcelRequire("1cXpO");

var $k3Yn7 = parcelRequire("k3Yn7");

var $hT71o = parcelRequire("hT71o");

var $lsWhN = parcelRequire("lsWhN");

var $5T6N9 = parcelRequire("5T6N9");

var $gKvs9 = parcelRequire("gKvs9");

var $kusdB = parcelRequire("kusdB");

var $4ZPLN = parcelRequire("4ZPLN");

var $hNxdc = parcelRequire("hNxdc");

var $d4nKw = parcelRequire("d4nKw");

var $cSKcF = parcelRequire("cSKcF");

var $f0Dt1 = parcelRequire("f0Dt1");

var $9EEC1 = parcelRequire("9EEC1");

var $llimD = parcelRequire("llimD");

var $axEnb = parcelRequire("axEnb");

var $oprSU = parcelRequire("oprSU");

var $c2HIo = parcelRequire("c2HIo");

var $lYppp = parcelRequire("lYppp");

var $e3hSW = parcelRequire("e3hSW");

var $7RD7t = parcelRequire("7RD7t");

var $8YYZx = parcelRequire("8YYZx");


var $idbiA = parcelRequire("idbiA");

var $gglrm = parcelRequire("gglrm");

var $1IQui = parcelRequire("1IQui");

var $5gKBq = parcelRequire("5gKBq");

var $9Ofex = parcelRequire("9Ofex");

var $eJT0F = parcelRequire("eJT0F");

var $6a1tO = parcelRequire("6a1tO");

var $gK2XA = parcelRequire("gK2XA");

var $jhX8I = parcelRequire("jhX8I");

var $77Daw = parcelRequire("77Daw");

var $lGVkp = parcelRequire("lGVkp");
const $7b5d093607cf439b$var$panelSplitterResizingVar = '--n_snvRsz';
const $7b5d093607cf439b$var$fallbackMinWidth = '240px';
function $7b5d093607cf439b$var$getPixelCustomProperty(element, propertyName, fallback) {
    const raw = getComputedStyle(element).getPropertyValue(propertyName).trim();
    const value = Number.parseFloat(raw);
    return Number.isFinite(value) ? (0, $axEnb.resolveLayoutWidth)(raw.endsWith('vw') ? `${value}vw` : value, window.innerWidth) : fallback;
}
/**
 * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
 * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
 * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
 */ const $7b5d093607cf439b$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $7b5d093607cf439b$var$textEntryInputTypes = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password',
    'number'
]);
function $7b5d093607cf439b$var$isEditableContent({ element: element }) {
    if (element instanceof HTMLElement && typeof element.isContentEditable === 'boolean') return element.isContentEditable;
    // Fallback for DOM implementations without `isContentEditable`.
    const editingHost = element.closest('[contenteditable]');
    return editingHost !== null && editingHost.getAttribute('contenteditable') !== 'false';
}
/**
 * Returns `true` for an element that the user can type text into.
 */ function $7b5d093607cf439b$var$isTextEntryElement({ element: element }) {
    if (element instanceof HTMLInputElement) return $7b5d093607cf439b$var$textEntryInputTypes.has(element.type) && !element.readOnly && !element.disabled;
    if (element instanceof HTMLTextAreaElement) return !element.readOnly && !element.disabled;
    return $7b5d093607cf439b$var$isEditableContent({
        element: element
    });
}
/**
 * Used when the `platform-dst-top-layer` gate is on.
 *
 * The flyout stays open while a layer opened from the side nav is open, or while the user
 * is typing in a text field inside the side nav (for example while renaming an item inline).
 */ function $7b5d093607cf439b$var$isFlyoutHeldOpen({ nav: nav }) {
    if ((0, $kusdB.hasOpenDialogOrPopover)({
        within: nav
    })) return true;
    const activeElement = nav.ownerDocument.activeElement;
    return activeElement !== null && nav.contains(activeElement) && $7b5d093607cf439b$var$isTextEntryElement({
        element: activeElement
    });
}
const $7b5d093607cf439b$var$styles = {
    root: "_2YmqfPYbGa _1VfddaYbGa _0KLXruoI2d _2OUyjtGk8v _24h04i2Njc _0jFU0VlOMI _2I62gzgiHs _1mT5xdHE3j _39xV02uZus _42Yu6BiZR3 _2EWYUbX3P0 _1KvygPUzyj _1EUs3cOeNX _0hAebtlfZc _1RYJRxYbGa _0xO92q39pk",
    chatPanelSizing: "_39xV02X3P0",
    managedOverlay: "_0PZ8vNOQJL _0qV2O6YbGa _27XaGGoI2d _3GwBusGk8v",
    flyoutOpen: "_1KvygPOQJL _1EUs3cYbGa _0hAebtoI2d _1RYJRxGk8v _2AFbI1Rodp _4kVtJl2HTN _1UvFJ1ThaV _1E7uFmIt9z",
    flyoutAnimateClosed: "_3iDTPbYbGa _1KvygPOQJL _2AFbI1Rodp _4kVtJl2HTN _1UvFJ1ThaV _4pNSLEIt9z",
    flexContainer: "_0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuI7V3",
    hiddenMobileAndDesktop: "_3iDTPbYbGa",
    hiddenMobileOnly: "_3iDTPbYbGa _0THHewyL8i",
    hiddenDesktopOnly: "_0THHewYbGa"
};
/**
 * Styles for the side nav enter/exit animations when `platform-dst-motion-uplift-sidenav` is enabled.
 *
 * These use the `motion.sidenav.*` tokens (keyframe animations) instead of the `transform` transitions
 * with `@starting-style` used by `styles`.
 *
 * ⚠️ The `transition-duration` values below need to stay in sync with the duration baked into the tokens
 * (`motion.sidenav.enter.*` is 250ms, `motion.sidenav.exit.*` is 200ms). The `display` property is
 * transitioned (with `allow-discrete`) so the element stays rendered for the length of the exit animation —
 * if the transition is shorter than the animation, `display: none` applies early and the exit animation
 * never runs.
 */ const $7b5d093607cf439b$var$motionUpliftStyles = {
    animationRTLSupport: "_0PlsTg2NCt _41VWnOVFMz _3G2eGnoK2N _0bboGQuqca",
    animationBaseStyles: "_2qDx9m4Gny _4tikTSThaV _03Q0eeLrT7",
    expandAnimationMobile: "_1jZhRJWRfq",
    collapseAnimationMobile: "_3NcSKiOQJL _1jZhRJTRd8",
    flyoutOpen: "_1KvygPOQJL _1EUs3cYbGa _0hAebtoI2d _1RYJRxGk8v _0k9R9aWRfq _4kVtJlqvoi _1UvFJ1ThaV",
    flyoutAnimateClosed: "_3iDTPbYbGa _1KvygPOQJL _0k9R9aTRd8 _4kVtJlLrT7 _1UvFJ1ThaV",
    expandAnimationDesktop: "_4fJQ5SUzyj _1wp4FmWRfq _4Bj9bNOQJL _2SsmzmIE5y _19NLAJxlqh _4y5EJLCT93",
    collapseAnimationDesktop: "_4fJQ5SOQJL _1wp4FmTRd8 _2SsmzmjYL6 _19NLAJw3oi _4y5EJLxGIf"
};
const $7b5d093607cf439b$var$fallbackDefaultWidth = 320;
const $7b5d093607cf439b$export$c735dc1c21910e21 = 500;
/**
 * We need an additional component layer so we can wrap the side nav in a `OpenLayerObserver` and have access to the
 * context value.
 */ function $7b5d093607cf439b$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidthProp = $7b5d093607cf439b$var$fallbackDefaultWidth, minWidth: minWidth = $7b5d093607cf439b$var$fallbackMinWidth, maxWidth: maxWidth, testId: testId, label: label = 'Sidebar', skipLinkLabel: skipLinkLabel = label, onExpand: onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, id: providedId, canToggleWithShortcut: canToggleWithShortcut }) {
    const isChatPanelLayoutEnabled = (0, $5T6N9.fg)('platform-dst-chat-panel-layout');
    const id = (0, $lYppp.useLayoutId)({
        providedId: providedId
    });
    const expandAndFocusSideNav = (0, $9Ofex.useExpandSideNav)({
        trigger: 'skip-link'
    });
    /**
   * Called after clicking on the side nav skip link, and ensures the side nav is expanded so that it is focusable.
   *
   * We need to update the DOM synchronously because `.focus()` is called synchronously after this state update.
   *
   * Only used when `platform_dst_nav4_skip_link_a11y_1` is OFF; can be removed on gate cleanup.
   */ const synchronouslyExpandSideNav = (0, $fsvuC.useCallback)(()=>{
        (0, $80czl.flushSync)(()=>{
            /**
       * Calling this unconditionally and relying on it to avoid no-op renders.
       *
       * We _could_ call it conditionally, but we'd be duplicating the screen size checks `expandAndFocusSideNav` makes.
       */ expandAndFocusSideNav();
        });
    }, [
        expandAndFocusSideNav
    ]);
    (0, $4ZPLN.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        /**
     * `navigate` is the gate-on contract: it owns expanding the side nav AND moving
     * focus to the first nav item, atomically (via `useExpandSideNav`'s `flushSync`).
     *
     * `onBeforeNavigate` is the legacy contract used only when the gate is OFF.
     * On gate cleanup, drop `onBeforeNavigate` and `synchronouslyExpandSideNav` here.
     */ navigate: (0, $5T6N9.fg)('platform_dst_nav4_skip_link_a11y_1') ? expandAndFocusSideNav : undefined,
        onBeforeNavigate: (0, $5T6N9.fg)('platform_dst_nav4_skip_link_a11y_1') ? undefined : synchronouslyExpandSideNav
    });
    const sideNavState = (0, $fsvuC.useContext)((0, $5gKBq.SideNavVisibilityState));
    const setSideNavState = (0, $fsvuC.useContext)((0, $idbiA.SetSideNavVisibilityState));
    const { isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile } = (0, $jhX8I.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    // We are placing `defaultCollapsed` into a state container so we can have a stable reference to the initial value.
    // This is so we can use it in an effect _that only runs once_, after the initial render on the client,
    // to sync the side nav context (provided in `<Root>`) with the `defaultCollapsed` prop provided to `<SideNav>`.
    const [initialDefaultCollapsed] = (0, $fsvuC.useState)(defaultCollapsed);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $hkZUI.useAnalyticsEvents)();
    const [initialIsExpandedOnDesktop] = (0, $fsvuC.useState)(isExpandedOnDesktop);
    /**
   * Captures the initial collapsed/expanded state of the side nav.
   *
   * Only firing on desktop because the nav is never open by default on mobile.
   */ (0, $fsvuC.useEffect)(()=>{
        if (initialIsExpandedOnDesktop) {
            const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
            if (isDesktop) {
                const navigationAnalyticsEvent = createAnalyticsEvent({
                    source: 'topNav',
                    actionSubject: 'sideNav',
                    action: 'viewedOnLoad',
                    actionSubjectId: 'sideNavMenu',
                    attributes: {
                        screen: 'desktop'
                    }
                });
                navigationAnalyticsEvent.fire('navigation');
            }
        }
    }, [
        createAnalyticsEvent,
        initialIsExpandedOnDesktop
    ]);
    const defaultWidth = (0, $7RD7t.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $7b5d093607cf439b$var$fallbackDefaultWidth,
        slotName: 'SideNav'
    });
    const [inlineWidth, setInlineWidth] = (0, $fsvuC.useState)(defaultWidth);
    const [overlayWidth, setOverlayWidth] = (0, $fsvuC.useState)(defaultWidth);
    const [isInline, setIsInline] = (0, $fsvuC.useState)(false);
    (0, $fsvuC.useEffect)(()=>{
        if (!isChatPanelLayoutEnabled) return;
        const mediaQuery = window.matchMedia('(min-width: 64rem)');
        setIsInline(mediaQuery.matches);
        const onChange = (event)=>setIsInline(event.matches);
        return (0, $dqdTY.bind)(mediaQuery, {
            type: 'change',
            listener: onChange
        });
    }, [
        isChatPanelLayoutEnabled
    ]);
    const toggleVisibilityForChatPanel = (0, $lGVkp.useToggleSideNav)({
        trigger: 'programmatic'
    });
    const closeOverlayForChatPanel = (0, $fsvuC.useCallback)(()=>{
        // Allocation can overlay an expanded desktop nav when other slots consume
        // its space. Dismiss the visibility state selected by the viewport, not the mode.
        const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
        if (isDesktop ? isExpandedOnDesktop : isExpandedOnMobile) toggleVisibilityForChatPanel();
    }, [
        isExpandedOnDesktop,
        isExpandedOnMobile,
        toggleVisibilityForChatPanel
    ]);
    const { state: managedSizing, isManaged: isManaged, prepareResize: prepareResize, getResizeBounds: getManagedResizeBounds, startResize: startResize, resize: resize, completeResize: completeResize } = (0, $c2HIo.useLayoutAreaSizing)({
        area: 'side-nav',
        config: {
            defaultWidth: defaultWidth,
            minWidth: minWidth,
            maxWidth: maxWidth,
            isOpen: isInline ? isExpandedOnDesktop : isExpandedOnMobile,
            onRequestClose: closeOverlayForChatPanel
        }
    });
    const mode = managedSizing?.mode ?? (isInline ? 'inline' : 'overlay');
    const renderedWidth = isChatPanelLayoutEnabled ? managedSizing?.width ?? (mode === 'inline' ? inlineWidth : overlayWidth) : inlineWidth;
    const configuredMaxWidth = maxWidth ?? '100vw';
    const clampedWidth = !isChatPanelLayoutEnabled ? `clamp(240px, ${inlineWidth}px, 50vw)` : managedSizing ? `${renderedWidth}px` : `clamp(${minWidth}, ${renderedWidth}px, ${configuredMaxWidth})`;
    const dangerouslyHoistSlotSizes = (0, $fsvuC.useContext)((0, $f0Dt1.DangerouslyHoistSlotSizes));
    const navRef = (0, $fsvuC.useRef)(null);
    const getResizeBounds = (0, $fsvuC.useCallback)(()=>{
        if (!isChatPanelLayoutEnabled) return {
            min: '240px',
            max: '50vw'
        };
        const managedBounds = getManagedResizeBounds();
        if (managedBounds) return managedBounds;
        const sideNav = navRef.current;
        const layoutRoot = sideNav?.parentElement;
        const main = layoutRoot?.querySelector(':scope > [data-layout-slot][role="main"]');
        const fallbackMaxWidth = maxWidth ?? (mode === 'inline' ? '100vw' : '90vw');
        if (!sideNav || mode === 'overlay') {
            const chatPanel = layoutRoot?.querySelector(':scope > [data-layout-chat-panel]');
            const inlineChatPanelWidth = chatPanel && getComputedStyle(chatPanel).gridArea === 'chat-panel' ? chatPanel.getBoundingClientRect().width : 0;
            const overlayMaxWidth = Math.floor((window.innerWidth - inlineChatPanelWidth) * 0.9);
            const constrainedMaxWidth = maxWidth ? Math.min((0, $9EEC1.convertResizeBoundToPixels)(maxWidth), overlayMaxWidth) : overlayMaxWidth;
            return {
                min: minWidth,
                max: `${Math.max((0, $9EEC1.convertResizeBoundToPixels)(minWidth), constrainedMaxWidth)}px`
            };
        }
        if (!main) return {
            min: minWidth,
            max: fallbackMaxWidth
        };
        const sideNavWidth = sideNav.getBoundingClientRect().width;
        const mainWidth = main.getBoundingClientRect().width;
        // JSDOM does not perform layout, so retain the static fallback in unit tests and other
        // environments where used widths cannot be measured.
        if (sideNavWidth === 0 || mainWidth === 0) return {
            min: minWidth,
            max: fallbackMaxWidth
        };
        const localPanel = main.querySelector('[data-layout-with-panel-slot]');
        const isLocalPanelInline = localPanel && getComputedStyle(localPanel).gridArea === 'panel';
        const localPanelWidth = isLocalPanelInline ? localPanel.getBoundingClientRect().width : 0;
        const mainContentWidth = mainWidth - localPanelWidth;
        const mainMinimumWidth = $7b5d093607cf439b$var$getPixelCustomProperty(main, (0, $d4nKw.mainMinimumWidthVar), (0, $d4nKw.defaultMainMinWidth));
        const availableWidth = Math.max(0, mainContentWidth - mainMinimumWidth);
        const availableInlineWidth = Math.floor(sideNavWidth + availableWidth);
        const constrainedMaxWidth = maxWidth ? Math.min((0, $9EEC1.convertResizeBoundToPixels)(maxWidth), availableInlineWidth) : availableInlineWidth;
        return {
            min: minWidth,
            max: `${Math.max((0, $9EEC1.convertResizeBoundToPixels)(minWidth), constrainedMaxWidth)}px`
        };
    }, [
        getManagedResizeBounds,
        isChatPanelLayoutEnabled,
        maxWidth,
        minWidth,
        mode
    ]);
    /**
   * Used to share the side nav element with the `Panel`,
   * which observes the side nav to determine its maximum width.
   */ const sharedRef = (0, $6a1tO.useSideNavRef)();
    const mergedRef = (0, $1cXpO.default)([
        navRef,
        sharedRef
    ]);
    const onCompleteResize = (0, $fsvuC.useCallback)((finalWidth)=>{
        if (!isChatPanelLayoutEnabled) {
            setInlineWidth(finalWidth);
            return;
        }
        if (mode === 'inline') setInlineWidth(finalWidth);
        else setOverlayWidth(finalWidth);
        completeResize(mode, finalWidth);
    }, [
        completeResize,
        isChatPanelLayoutEnabled,
        mode
    ]);
    const onResizeStartInternal = (0, $fsvuC.useCallback)(()=>{
        startResize(mode);
    }, [
        mode,
        startResize
    ]);
    const onResizeInternal = (0, $fsvuC.useCallback)((width)=>resize(mode, width), [
        mode,
        resize
    ]);
    const toggleButtonElement = (0, $fsvuC.useContext)((0, $gglrm.SideNavToggleButtonElement));
    const topNavStartElement = (0, $fsvuC.useContext)((0, $hNxdc.TopNavStartElement));
    const devTimeOnlyAttributes = {};
    const openLayerObserver = (0, $lsWhN.useOpenLayerObserver)({
        isEnabled: !(0, $5T6N9.fg)('platform-dst-top-layer')
    });
    const flyoutStateRef = (0, $fsvuC.useRef)({
        type: 'not-active'
    });
    const isFlyoutVisible = sideNavState?.flyout === 'open';
    // Flyouts, including their close animation, already have overlay placement.
    // The CSS-first inline allocation must not override it with an ID selector.
    const shouldApplyUnmanagedSizing = !managedSizing && sideNavState?.flyout !== 'open' && sideNavState?.flyout !== 'triggered-animate-close';
    const isExpandedOnDesktopRef = (0, $k3Yn7.default)(isExpandedOnDesktop);
    const hasPeekStartedRef = (0, $fsvuC.useRef)(false);
    const onPeekStartRef = (0, $k3Yn7.default)(onPeekStart);
    const onPeekEndRef = (0, $k3Yn7.default)(onPeekEnd);
    const onPeekStartTimeoutIdRef = (0, $fsvuC.useRef)(undefined);
    (0, $fsvuC.useEffect)(()=>{
        return ()=>{
            clearTimeout(onPeekStartTimeoutIdRef.current);
        };
    }, []);
    const updateFlyoutState = (0, $fsvuC.useMemo)(()=>{
        function tryAbortPendingClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        }
        function open() {
            const prevFlyoutState = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'open'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout !== 'open') return {
                    ...currentState,
                    flyout: 'open'
                };
                return currentState;
            });
            // Avoid redundant calls to `onPeekStart()`
            if (prevFlyoutState.type === 'not-active') {
                clearTimeout(onPeekStartTimeoutIdRef.current);
                onPeekStartTimeoutIdRef.current = setTimeout(()=>{
                    // If the flyout isn't still open after ~500ms then we won't count the peek
                    // As we want to track user intention rather than all hovers
                    if (isExpandedOnDesktopRef.current || flyoutStateRef.current.type !== 'open') return;
                    hasPeekStartedRef.current = true;
                    onPeekStartRef.current?.();
                }, $7b5d093607cf439b$export$c735dc1c21910e21);
            }
        }
        function close() {
            const prevFlyoutState = flyoutStateRef.current;
            tryAbortPendingClose();
            flyoutStateRef.current = {
                type: 'not-active'
            };
            setSideNavState((currentState)=>{
                if (currentState?.desktop === 'collapsed' && currentState?.flyout === 'open') return {
                    ...currentState,
                    flyout: 'triggered-animate-close'
                };
                return currentState;
            });
            // Avoid redundant calls to `onPeekEnd()`
            if (prevFlyoutState.type !== 'not-active' && hasPeekStartedRef.current) {
                hasPeekStartedRef.current = false;
                onPeekEndRef.current?.({
                    trigger: isExpandedOnDesktopRef.current ? 'side-nav-expand' : 'mouse-leave'
                });
            }
        }
        function canClose() {
            if (!(0, $5T6N9.fg)('platform-dst-top-layer')) return openLayerObserver?.getCount({
                namespace: (0, $d4nKw.openLayerObserverSideNavNamespace)
            }) === 0;
            const nav = navRef.current;
            return !(nav && $7b5d093607cf439b$var$isFlyoutHeldOpen({
                nav: nav
            }));
        }
        return function onAction(action) {
            if (action === 'drag-from-flyout-started') {
                open();
                flyoutStateRef.current = {
                    type: 'is-dragging-from-flyout'
                };
                return;
            }
            if (action === 'drag-from-flyout-finished') {
                open();
                return;
            }
            // ignoring all actions until the drag is finished
            if (flyoutStateRef.current.type === 'is-dragging-from-flyout') return;
            if (action === 'open') {
                open();
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                // A timeout is used to close the flyout after a delay when the user mouses out of the flyout area, and to allow
                // us to cancel the close if the user mouses back in.
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, (0, $506751ca64a81ea5$export$a7801e29f563faad));
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                // If there are no open layers, we can close the flyout.
                if (canClose()) {
                    close();
                    return;
                }
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                return;
            }
            if (action === 'force-close') {
                close();
                return;
            }
        };
    }, [
        isExpandedOnDesktopRef,
        onPeekEndRef,
        onPeekStartRef,
        openLayerObserver,
        setSideNavState
    ]);
    const toggleVisibilityByScreenResize = (0, $lGVkp.useToggleSideNav)({
        trigger: 'screen-resize'
    });
    const toggleVisibilityByClickOutsideOnMobile = (0, $lGVkp.useToggleSideNav)({
        trigger: 'click-outside-on-mobile'
    });
    // Using `useLayoutEffect` so that there's no visual shift in non-SSR environments when using legacy API
    // For SSR the new API is still necessary
    (0, $fsvuC.useLayoutEffect)(()=>{
        if (sideNavState !== null) // Only need to do an initial sync if it hasn't been initialized from Root
        return;
        // Sync the visibility in context (provided in `<Root>`) with the local `defaultCollapsed` prop provided to `SideNav`
        // after SSR hydration. This should only run once, after the initial render on the client.
        (0, $fsvuC.startTransition)(()=>{
            setSideNavState({
                desktop: initialDefaultCollapsed ? 'collapsed' : 'expanded',
                mobile: 'collapsed',
                flyout: 'closed',
                lastTrigger: null
            });
        });
    }, [
        initialDefaultCollapsed,
        setSideNavState,
        sideNavState
    ]);
    const handleExpand = (0, $fsvuC.useCallback)(({ screen: screen, trigger: trigger })=>{
        onExpand?.({
            screen: screen,
            trigger: trigger
        });
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'expanded',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger
            }
        });
        navigationAnalyticsEvent.fire('navigation');
        // When the side nav gets expanded, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to expand.
        updateFlyoutState('force-close');
    }, [
        onExpand,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    const handleCollapse = (0, $fsvuC.useCallback)(({ screen: screen, trigger: trigger })=>{
        onCollapse?.({
            screen: screen,
            trigger: trigger
        });
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'collapsed',
            actionSubjectId: 'sideNavMenu',
            attributes: {
                trigger: trigger
            }
        });
        navigationAnalyticsEvent.fire('navigation');
        // When the side nav gets collapsed, we close the flyout to reset it.
        // This prevents the flyout from staying open and ensures we are respecting the user's intent to collapse.
        updateFlyoutState('force-close');
    }, [
        onCollapse,
        updateFlyoutState,
        createAnalyticsEvent
    ]);
    (0, $77Daw.useSideNavVisibilityCallbacks)({
        onExpand: handleExpand,
        onCollapse: handleCollapse,
        isExpandedOnDesktop: isExpandedOnDesktop,
        isExpandedOnMobile: isExpandedOnMobile,
        lastTrigger: sideNavState?.lastTrigger ?? null
    });
    (0, $fsvuC.useEffect)(()=>{
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $dqdTY.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                if (mediaQueryList.matches) // We're transitioning from tablet to desktop viewport size.
                // We forcibly show the side nav if it was shown on mobile.
                {
                    if (isExpandedOnMobile && !isExpandedOnDesktop) toggleVisibilityByScreenResize();
                }
            }
        });
    }, [
        toggleVisibilityByScreenResize,
        isExpandedOnDesktop,
        isExpandedOnMobile
    ]);
    /**
   * Close the mobile side nav if there is a click outside.
   *
   * Binding/unbinding on changes to `isExpandedOnMobile` instead of window size changes for simplicity.
   * If we listened to window size changes we'd need nested `bind()` calls.
   */ (0, $fsvuC.useEffect)(()=>{
        if (!isExpandedOnMobile) return;
        /**
     * The expected URL fragment used by the side nav skip link.
     */ const skipLinkUrlFragment = `#${id}`;
        return (0, $dqdTY.bind)(window, {
            type: 'click',
            listener (event) {
                if (window.matchMedia('(min-width: 64rem)').matches) // Clicks on desktop should do nothing
                return;
                const sideNav = navRef.current;
                if (!sideNav || !(event.target instanceof Node)) // Ignore if our element references are invalid
                return;
                if (!event.target.isConnected) /**
           * If the element that was clicked is no longer in the document, we should not collapse the side nav.
           * This can happen when the user clicks on a dropdown menu item (such as one used in a `...` More menu),
           * as the dropdown menu will close after being clicked. By the time this event listener runs, the clicked
           * element will no longer be in the document, so the check below for `sideNav.contains(event.target)` will fail.
           */ return;
                if (sideNav.contains(event.target)) // Clicks inside the side nav should not close it
                return;
                if (toggleButtonElement?.contains(event.target)) // Clicks on the toggle button will already toggle the side nav,
                // so we need to ignore it or we end up doing a double toggle
                return;
                if (event.target instanceof HTMLAnchorElement && /**
         * Intentionally using `.getAttribute()` for simplicity to match exactly what we expect
         * for skip links.
         *
         * Alternatives considered:
         *
         * - Using `.href` returns a full URL, which would then require extra parsing.
         * - Using `.hash` could incorrectly capture `<a href="/another-page#skip-link-id>` so we'd need extra checks.
         *
         * This approach has an edge case of `<a href="/same-page#skip-link-id>` not being captured,
         * but we are okay with that trade-off.
         */ event.target.getAttribute('href') === skipLinkUrlFragment) // This was a click on a link to the side nav, so we shouldn't try to collapse the SideNav.
                // It was most likely the skip link, although anyone can render a link with the ID.
                // In either case keeping the SideNav expanded makes sense.
                return;
                toggleVisibilityByClickOutsideOnMobile();
            }
        });
    }, [
        id,
        isExpandedOnMobile,
        toggleButtonElement,
        toggleVisibilityByClickOutsideOnMobile
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $dqdTY.bind)(toggleButtonElement, {
            type: 'mouseenter',
            listener () {
                // Only flyout the side nav if the user hovered while the side nav was collapsed
                if (isExpandedOnDesktop) return;
                // Only flyout the side nav on desktop viewports
                const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                if (matches) updateFlyoutState('open');
            }
        });
    }, [
        updateFlyoutState,
        toggleButtonElement,
        isExpandedOnDesktop
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!toggleButtonElement) return;
        return (0, $dqdTY.bind)(toggleButtonElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        toggleButtonElement,
        updateFlyoutState
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $dqdTY.bind)(navRef.current, {
            type: 'mouseenter',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                // The user mouses has moused back over the side nav
                updateFlyoutState('open');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState,
        isExpandedOnDesktop
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!navRef.current) return;
        return (0, $dqdTY.bind)(navRef.current, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $fsvuC.useEffect)(()=>{
        const nav = navRef.current;
        if (!nav) return;
        if (!isFlyoutVisible) return;
        // Using a monitor rather than a drop target. Rationale:
        // - We are not creating a drop target for the users to drop on,
        //   we are just interested in listening to events within an element
        // - We do not want to impact `location.{*}.dropTargets` in events
        return (0, $gKvs9.monitorForElements)({
            canMonitor ({ source: source }) {
                return nav.contains(source.element);
            },
            onGenerateDragPreview () {
                updateFlyoutState('drag-from-flyout-started');
            },
            onDrop ({ location: location }) {
                // Always marking the drag and done
                updateFlyoutState('drag-from-flyout-finished');
                // If the user dropped outside of the flyout, we will close the flyout
                const underUsersPointer = document.elementFromPoint(location.current.input.clientX, location.current.input.clientY);
                if (!nav.contains(underUsersPointer)) updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!topNavStartElement || !toggleButtonElement) return;
        return (0, $dqdTY.bind)(topNavStartElement, {
            type: 'mouseover',
            listener (event) {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (isExpandedOnDesktop || !isFlyoutVisible) return;
                if (event.target === topNavStartElement) {
                    // The mouse is directly over the TopNavStart element, so cancel any pending flyout closes.
                    updateFlyoutState('open');
                    return;
                }
                if (event.target instanceof Element && toggleButtonElement.contains(event.target)) // The mouse is over the toggle button or any of its children, so we don't want to close the flyout.
                // We also don't need to cancel any pending closes, as we have separate event listeners for the toggle button mouse events.
                return;
                // The user has moused over a child element of the TopNavStart element that isn't the toggle button, e.g. the app switcher or nav logo,
                // so we should close the flyout (with a delay).
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        toggleButtonElement,
        isExpandedOnDesktop,
        updateFlyoutState
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!topNavStartElement) return;
        return (0, $dqdTY.bind)(topNavStartElement, {
            type: 'mouseleave',
            listener () {
                // If the side nav is not in flyout mode, we don't need to do anything
                if (!isFlyoutVisible) return;
                // The mouse has left the TopNavStart element, so we should close the flyout with a delay.
                updateFlyoutState('waiting-for-close');
            }
        });
    }, [
        topNavStartElement,
        isFlyoutVisible,
        updateFlyoutState
    ]);
    (0, $fsvuC.useEffect)(()=>{
        // Close the flyout if there are no more layers open and the user is not mousing over the
        // flyout areas (side nav, TopNavStart element)
        return openLayerObserver?.onChange(({ count: count })=>{
            if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) updateFlyoutState('force-close');
        }, {
            namespace: (0, $d4nKw.openLayerObserverSideNavNamespace)
        });
    }, [
        openLayerObserver,
        updateFlyoutState
    ]);
    const focusOutTimeoutIdRef = (0, $fsvuC.useRef)(undefined);
    (0, $fsvuC.useEffect)(()=>{
        // The same as the open layer observer `onChange` above, for when the `platform-dst-top-layer`
        // gate is on. Top-layer surfaces opened from the side nav are DOM descendants of it.
        const nav = navRef.current;
        if (!nav || !(0, $5T6N9.fg)('platform-dst-top-layer')) return;
        function closeIfReady() {
            if (flyoutStateRef.current.type !== 'ready-to-close' || !nav) return;
            if ($7b5d093607cf439b$var$isFlyoutHeldOpen({
                nav: nav
            })) return;
            updateFlyoutState('force-close');
        }
        const unbindLayerChange = (0, $8YYZx.bindOpenLayerChange)({
            within: nav,
            onChange: closeIfReady
        });
        const unbindFocusOut = (0, $dqdTY.bind)(nav, {
            type: 'focusout',
            listener () {
                // Wait for focus to move before checking where it went.
                clearTimeout(focusOutTimeoutIdRef.current);
                focusOutTimeoutIdRef.current = setTimeout(closeIfReady, 0);
            }
        });
        // Removing the focused text field (for example when an inline rename ends) fires no
        // `focusout` in some browsers, so also check again when content inside the side nav changes.
        const removalObserver = new MutationObserver(closeIfReady);
        removalObserver.observe(nav, {
            childList: true,
            subtree: true
        });
        return function cleanup() {
            unbindLayerChange();
            unbindFocusOut();
            removalObserver.disconnect();
            clearTimeout(focusOutTimeoutIdRef.current);
        };
    }, [
        updateFlyoutState
    ]);
    (0, $fsvuC.useEffect)(()=>{
        // Clear flyout close timer if being unmounted
        return function cleanupPendingFlyoutClose() {
            if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
        };
    }, []);
    (0, $gK2XA.useSideNavToggleKeyboardShortcut)({
        canToggleWithShortcut: canToggleWithShortcut
    });
    // Used to conditionally display the keyboard shortcut in the SideNavPanelSplitter tooltip.
    const isShortcutEnabled = (0, $eJT0F.useIsSideNavShortcutEnabled)();
    (0, $e3hSW.useResizingWidthCssVarOnRootElement)({
        isEnabled: !isChatPanelLayoutEnabled || !managedSizing,
        cssVar: $7b5d093607cf439b$var$panelSplitterResizingVar,
        panelId: (0, $d4nKw.sideNavPanelSplitterId)
    });
    const isExpandedStateDifferentFromInitial = isExpandedOnMobile || isExpandedOnDesktop !== initialIsExpandedOnDesktop;
    /**
   * Used to track (between renders) if the expanded state of the side nav has ever changed since mount.
   *
   * Cannot rely solely on `isExpandedStateDifferentFromInitial` because the expanded state can go back to the initial state.
   */ const hasExpandedStateChangedRef = (0, $fsvuC.useRef)(false);
    (0, $fsvuC.useEffect)(()=>{
        if (hasExpandedStateChangedRef.current) return;
        if (isExpandedStateDifferentFromInitial) hasExpandedStateChangedRef.current = true;
    }, [
        isExpandedStateDifferentFromInitial
    ]);
    /**
   * If the expanded state of the side nav has ever changed since mount.
   *
   * Used to prevent sidebar expand animations from running on the initial load.
   * Otherwise, the `@starting-style` rule will cause the sidebar to slide in initially.
   */ const hasExpandedStateChanged = isExpandedStateDifferentFromInitial || hasExpandedStateChangedRef.current;
    const isMotionUpliftEnabled = (0, $5T6N9.fg)('platform-dst-motion-uplift-sidenav');
    // This is only used for the regular expand and collapse animations, not the flyout animations.
    const shouldShowSidebarToggleAnimation = isMotionUpliftEnabled && // We do not apply the animation styles on the initial render, as the `@starting-style` rule will cause the sidebar to
    // slide in initially.
    hasExpandedStateChanged && // We also do not apply the animation styles if the side nav is in flyout mode to make sure we don't override flyout styles.
    // If we instead try to unset the `transform` property in the flyout styles using `transform: initial`, it results in the entire
    // flyout animation being disabled.
    !isFlyoutVisible && /**
   * Disabling animations for Firefox, as it doesn't support animating the `display` property:
   * https://caniuse.com/mdn-css_properties_display_is_transitionable
   *
   * As of October 2025, Firefox supports the expand animation, but not the collapse animation (it instantly changes to `display: none`).
   * Because of this, we are disabling all sidebar animations for Firefox so it doesn't look like a bug.
   *
   * Unfortunately we cannot use `@supports` to target the support of `transition-behavior: allow-discrete` specifically
   * for the `display` property. And `@supports at-rule(@starting-style)` is also not ready for browser use yet.
   *
   * We are using JS to detect Firefox and disable animations, instead of using CSS, as Compiled currently does not merge duplicate
   * CSS at-rules when at-rules are nested: https://github.com/atlassian-labs/compiled/blob/e04a325915e1d13010205089e4915de0e53bc2d4/packages/css/src/plugins/merge-duplicate-at-rules.ts#L5
   * Avoiding nesting the `@supports` at-rule inside of `@media` means Compiled can remove duplicate styles from the generated CSS.
   */ !$7b5d093607cf439b$var$isFirefox;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment, {
        children: /*#__PURE__*/ (0, $5chsV.jsxs)("nav", {
            id: id,
            ...devTimeOnlyAttributes,
            "data-layout-slot": true,
            "aria-label": label,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop
                [(0, $d4nKw.sideNavVar)]: clampedWidth
            },
            ref: mergedRef,
            "data-testid": testId,
            className: (0, $gJ6nT.default)([
                $7b5d093607cf439b$var$styles.root,
                isChatPanelLayoutEnabled && $7b5d093607cf439b$var$styles.chatPanelSizing,
                isChatPanelLayoutEnabled && managedSizing?.mode === 'overlay' && $7b5d093607cf439b$var$styles.managedOverlay,
                isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $7b5d093607cf439b$var$styles.hiddenMobileOnly,
                !isExpandedOnDesktop && isExpandedOnMobile && !isFlyoutVisible && $7b5d093607cf439b$var$styles.hiddenDesktopOnly,
                !isExpandedOnDesktop && !isExpandedOnMobile && !isFlyoutVisible && $7b5d093607cf439b$var$styles.hiddenMobileAndDesktop,
                isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.animationRTLSupport,
                shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.animationBaseStyles,
                isExpandedOnMobile && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.expandAnimationMobile,
                !isExpandedOnMobile && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.collapseAnimationMobile,
                isExpandedOnDesktop && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.expandAnimationDesktop,
                !isExpandedOnDesktop && shouldShowSidebarToggleAnimation && isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.collapseAnimationDesktop,
                sideNavState?.flyout === 'open' && isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.flyoutOpen,
                sideNavState?.flyout === 'open' && !isMotionUpliftEnabled && $7b5d093607cf439b$var$styles.flyoutOpen,
                sideNavState?.flyout === 'triggered-animate-close' && isMotionUpliftEnabled && $7b5d093607cf439b$var$motionUpliftStyles.flyoutAnimateClosed,
                sideNavState?.flyout === 'triggered-animate-close' && !isMotionUpliftEnabled && $7b5d093607cf439b$var$styles.flyoutAnimateClosed
            ]),
            children: [
                isChatPanelLayoutEnabled && // CSS reserves only the nav minimum for chat's fit decision, before effects or lazy loading.
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
                /*#__PURE__*/ (0, $5chsV.jsx)("style", {
                    children: `
#${(0, $oprSU.gridRootChatFitId)} { --n_fitNav: 0px; }
${shouldApplyUnmanagedSizing ? `#${0, $oprSU.gridRootId} nav[data-layout-slot] { grid-area: main / aside / aside / aside; width: min(90%, ${clampedWidth}); }` : ''}
@media (min-width: 64rem) {
  @container navigation-main-space (min-width: ${minWidth}) {
    #${(0, $oprSU.gridRootChatFitId)} { --n_fitNav: ${isExpandedOnDesktop ? minWidth : '0px'}; }
    ${shouldApplyUnmanagedSizing ? `#${0, $oprSU.gridRootId} nav[data-layout-slot] { grid-area: side-nav; width: min(${clampedWidth}, calc(100cqw + var(--n_fitNav) - var(--n_chatTrack, 0px))); }` : ''}
  }
}
`
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $cSKcF.DangerouslyHoistCssVarToDocumentRoot), {
                    variableName: (0, $d4nKw.sideNavLiveWidthVar),
                    value: "0px",
                    mediaQuery: '@media (min-width: 64rem)',
                    responsiveValue: isExpandedOnDesktop ? `var(${$7b5d093607cf439b$var$panelSplitterResizingVar}, ${clampedWidth})` : 0
                }),
                dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                // When they aren't needed anymore we can delete them wholesale.
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $cSKcF.DangerouslyHoistCssVarToDocumentRoot), {
                    variableName: (0, $d4nKw.UNSAFE_sideNavLayoutVar),
                    value: `var(${(0, $d4nKw.sideNavLiveWidthVar)})`
                }),
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $llimD.PanelSplitterProvider), {
                    panelId: (0, $d4nKw.sideNavPanelSplitterId),
                    panelRef: navRef,
                    panelWidth: renderedWidth,
                    onCompleteResize: onCompleteResize,
                    onResizeStartInternal: isChatPanelLayoutEnabled && isManaged ? onResizeStartInternal : undefined,
                    onResizeInternal: isChatPanelLayoutEnabled && isManaged ? onResizeInternal : undefined,
                    prepareResize: isChatPanelLayoutEnabled ? prepareResize : undefined,
                    getResizeBounds: getResizeBounds,
                    resizingCssVar: $7b5d093607cf439b$var$panelSplitterResizingVar,
                    // Not resizable when in peek (flyout) mode.
                    isEnabled: !isFlyoutVisible,
                    shortcut: isShortcutEnabled ? (0, $1IQui.sideNavToggleTooltipKeyboardShortcut) : undefined,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                        className: (0, $gJ6nT.default)([
                            $7b5d093607cf439b$var$styles.flexContainer
                        ]),
                        children: children
                    })
                })
            ]
        })
    });
}
$7b5d093607cf439b$var$SideNavInternal.displayName = "SideNavInternal";
function $7b5d093607cf439b$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, minWidth: minWidth, maxWidth: maxWidth, testId: testId, label: label, skipLinkLabel: // Default value is defined in `SideNavInternal`
skipLinkLabel = label, onExpand: // Default value is defined in `SideNavInternal`
onExpand, onCollapse: onCollapse, onPeekStart: onPeekStart, onPeekEnd: onPeekEnd, canToggleWithShortcut: canToggleWithShortcut, id: id }) {
    const sideNav = /*#__PURE__*/ (0, $5chsV.jsx)($7b5d093607cf439b$var$SideNavInternal, {
        defaultCollapsed: defaultCollapsed,
        defaultWidth: defaultWidth,
        minWidth: minWidth,
        maxWidth: maxWidth,
        testId: testId,
        label: label,
        skipLinkLabel: skipLinkLabel,
        onExpand: onExpand,
        onCollapse: onCollapse,
        onPeekStart: onPeekStart,
        onPeekEnd: onPeekEnd,
        id: id,
        canToggleWithShortcut: canToggleWithShortcut,
        children: children
    });
    // Top-layer surfaces are found through the DOM, so the namespace is only needed when the gate is off.
    if ((0, $5T6N9.fg)('platform-dst-top-layer')) return sideNav;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hT71o.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $d4nKw.openLayerObserverSideNavNamespace),
        children: sideNav
    });
}
$7b5d093607cf439b$export$1a35787d6353cf6a.displayName = "SideNav";

});
parcelRegister("hT71o", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceProvider", () => $3659ed05c9f3cd7c$export$327d0d2a7ae6f7cc);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $l9kus = parcelRequire("l9kus");

var $96QRY = parcelRequire("96QRY");

var $9Bacx = parcelRequire("9Bacx");
function $3659ed05c9f3cd7c$export$327d0d2a7ae6f7cc({ children: children, namespace: namespace }) {
    // If there is an existing namespace context being provided, throw an invariant.
    // This use case is not supported at this time.
    const parentContext = (0, $9Bacx.useOpenLayerObserverNamespace)();
    (0, $fsvuC.useEffect)(()=>{
        (0, $l9kus.default)(parentContext === null, `An OpenLayerObserver namespace already exists in this component tree: ${parentContext}. Nesting OpenLayerObserverNamespaceProvider is not supported.`);
    }, [
        parentContext
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $96QRY.OpenLayerObserverNamespaceContext).Provider, {
        value: namespace,
        children: children
    });
}
$3659ed05c9f3cd7c$export$327d0d2a7ae6f7cc.displayName = "OpenLayerObserverNamespaceProvider";

});

parcelRegister("lsWhN", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserver", () => $f472546e69974679$export$750f5b0d6c51617e);

var $fsvuC = parcelRequire("fsvuC");

var $doEd2 = parcelRequire("doEd2");
function $f472546e69974679$export$750f5b0d6c51617e({ isEnabled: isEnabled = true } = {}) {
    const context = (0, $fsvuC.useContext)((0, $doEd2.OpenLayerObserverContext));
    const publicAPI = (0, $fsvuC.useMemo)(()=>{
        if (context === null || !isEnabled) return null;
        return {
            getCount: context.getCount,
            onChange: context.onChange,
            closeLayers: context.closeLayers
        };
    }, [
        context,
        isEnabled
    ]);
    return publicAPI;
}

});

parcelRegister("4ZPLN", function(module, exports) {
$parcel$export(module.exports, "useSkipLinkInternal", () => $ce390b749750af84$export$707b94c26b8b75aa);

var $fsvuC = parcelRequire("fsvuC");

var $5LJgO = parcelRequire("5LJgO");
const $ce390b749750af84$export$707b94c26b8b75aa = ({ id: id, label: label, listIndex: listIndex, onBeforeNavigate: onBeforeNavigate, navigate: navigate, isHidden: isHidden })=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $fsvuC.useContext)((0, $5LJgO.SkipLinksContext));
    (0, $fsvuC.useEffect)(()=>{
        if (isHidden) /**
			 * Skip links are hidden for slots with 0 height or width.
			 * They should not be registered.
			 */ return;
        registerSkipLink({
            id: id,
            label: label,
            listIndex: listIndex,
            onBeforeNavigate: onBeforeNavigate,
            navigate: navigate,
            isHidden: isHidden
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        isHidden,
        label,
        listIndex,
        onBeforeNavigate,
        navigate,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});
parcelRegister("5LJgO", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContext", () => $946c78b5942500a6$export$4c5cc3b14c7678a);

var $fsvuC = parcelRequire("fsvuC");

var $iqo7S = parcelRequire("iqo7S");
const $946c78b5942500a6$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $fsvuC.createContext)({
    registerSkipLink: (0, $iqo7S.default),
    unregisterSkipLink: (0, $iqo7S.default)
});

});


parcelRegister("hNxdc", function(module, exports) {
$parcel$export(module.exports, "TopNavStartElement", () => $e5172eb2eb9a8b67$export$e9e5087bd319cc8c);

var $fsvuC = parcelRequire("fsvuC");
const $e5172eb2eb9a8b67$export$e9e5087bd319cc8c = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});

parcelRegister("d4nKw", function(module, exports) {
$parcel$export(module.exports, "defaultMainMinWidth", () => $57d63fd66b043080$export$5a062db428107571);
$parcel$export(module.exports, "sideNavVar", () => $57d63fd66b043080$export$951bf5156e86d974);
$parcel$export(module.exports, "asideVar", () => $57d63fd66b043080$export$594e6a30db7c057e);
$parcel$export(module.exports, "panelVar", () => $57d63fd66b043080$export$db0c2e1d744fb281);
$parcel$export(module.exports, "mainMinimumWidthVar", () => $57d63fd66b043080$export$c331a3472b90c7fa);
$parcel$export(module.exports, "bannerMountedVar", () => $57d63fd66b043080$export$515a0b1baafe906c);
$parcel$export(module.exports, "topNavMountedVar", () => $57d63fd66b043080$export$60ef3a7b1ed42328);
$parcel$export(module.exports, "localPanelWidthVar", () => $57d63fd66b043080$export$7faa975823006a4c);
$parcel$export(module.exports, "sideNavLiveWidthVar", () => $57d63fd66b043080$export$1216dacffd1e9e65);
$parcel$export(module.exports, "sideNavPanelSplitterId", () => $57d63fd66b043080$export$5db28b16b6e686bc);
$parcel$export(module.exports, "asidePanelSplitterId", () => $57d63fd66b043080$export$de580d653bac8ad9);
$parcel$export(module.exports, "panelPanelSplitterId", () => $57d63fd66b043080$export$3452dcb65711af44);
$parcel$export(module.exports, "contentInsetBlockStart", () => $57d63fd66b043080$export$bfabd8c2c572ad29);
$parcel$export(module.exports, "UNSAFE_topNavVar", () => $57d63fd66b043080$export$855f5a09f5c99ac);
$parcel$export(module.exports, "UNSAFE_bannerVar", () => $57d63fd66b043080$export$26354f9814213292);
$parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", () => $57d63fd66b043080$export$6bfc931a04ec5741);
$parcel$export(module.exports, "UNSAFE_asideLayoutVar", () => $57d63fd66b043080$export$bbbace2ff0c7ae1b);
$parcel$export(module.exports, "UNSAFE_panelLayoutVar", () => $57d63fd66b043080$export$753bf7651b25db91);
$parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", () => $57d63fd66b043080$export$6460bd6a2446260);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", () => $57d63fd66b043080$export$3055529fab2b4edf);
$parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", () => $57d63fd66b043080$export$166d8fd766c3eb92);
$parcel$export(module.exports, "openLayerObserverSideNavNamespace", () => $57d63fd66b043080$export$876effa8b02edc2f);
$parcel$export(module.exports, "openLayerObserverTopNavMiddleNamespace", () => $57d63fd66b043080$export$762ad20d97870b35);
$parcel$export(module.exports, "openLayerObserverTopNavEndNamespace", () => $57d63fd66b043080$export$8dd71e8a7db48024);
/**
 * These variables are shared across the different page layout slots.
 * This violates the [UI styling standard](https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-imported-style-values/usage).
 * We have chosen to ignore this rule to prevent duplicating them across the different slots, and to provide a high level view of them and how they relate.
 */ /**
 * Default minimum width of Main, in pixels, before a custom minimum is registered.
 */ const $57d63fd66b043080$export$5a062db428107571 = 320;
const $57d63fd66b043080$export$951bf5156e86d974 = '--n_sNvw';
const $57d63fd66b043080$export$594e6a30db7c057e = '--n_asDw';
const $57d63fd66b043080$export$db0c2e1d744fb281 = '--n_pnlW';
const $57d63fd66b043080$export$8b0055855c9c088f = '--n_cPnlW';
const $57d63fd66b043080$export$c80e4a9eb4c90d80 = '--n_cPnlLw';
const $57d63fd66b043080$export$c331a3472b90c7fa = '--n_mainMinW';
const $57d63fd66b043080$export$515a0b1baafe906c = '--n_bnrM';
const $57d63fd66b043080$export$60ef3a7b1ed42328 = '--n_tNvM';
const $57d63fd66b043080$export$a16bbd599f6269e7 = '--n_rbnW';
const $57d63fd66b043080$export$7faa975823006a4c = '--n_localPanelWidth';
const $57d63fd66b043080$export$1216dacffd1e9e65 = '--n_sNvlw';
const $57d63fd66b043080$export$5db28b16b6e686bc = Symbol('SideNav PanelSplitter');
const $57d63fd66b043080$export$de580d653bac8ad9 = Symbol('Aside PanelSplitter');
const $57d63fd66b043080$export$3452dcb65711af44 = Symbol('Panel PanelSplitter');
const $57d63fd66b043080$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $57d63fd66b043080$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $57d63fd66b043080$export$855f5a09f5c99ac = '--topNavigationHeight';
const $57d63fd66b043080$export$26354f9814213292 = '--bannerHeight';
const $57d63fd66b043080$export$6bfc931a04ec5741 = '--leftSidebarWidth';
const $57d63fd66b043080$export$58de0a46980ca7f4 = '--leftPanelWidth';
const $57d63fd66b043080$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
const $57d63fd66b043080$export$753bf7651b25db91 = '--rightPanelWidth';
const $57d63fd66b043080$export$6460bd6a2446260 = `calc(var(${$57d63fd66b043080$export$26354f9814213292}, 0px) + var(${$57d63fd66b043080$export$855f5a09f5c99ac}, 0px))`;
const $57d63fd66b043080$export$3055529fab2b4edf = `calc(var(${$57d63fd66b043080$export$58de0a46980ca7f4}, 0px) + var(${$57d63fd66b043080$export$6bfc931a04ec5741}, 0px))`;
const $57d63fd66b043080$export$166d8fd766c3eb92 = `calc(var(${$57d63fd66b043080$export$bbbace2ff0c7ae1b}, 0px) + var(${$57d63fd66b043080$export$753bf7651b25db91}, 0px))`;
const $57d63fd66b043080$export$61156ceb1a99f6a0 = {
    // Chat overlays the app, including TopNav and SideNav, below the banner.
    chatPanelOverlay: 5,
    ribbon: 4,
    topBar: 4,
    banner: 4,
    sideNav: 2,
    panelSmallViewports: 1
};
const $57d63fd66b043080$export$876effa8b02edc2f = 'side-nav';
const $57d63fd66b043080$export$762ad20d97870b35 = 'top-nav-middle';
const $57d63fd66b043080$export$8dd71e8a7db48024 = 'top-nav-end';

});

parcelRegister("cSKcF", function(module, exports) {
$parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", () => $9e17359a9ab8218d$export$9f45a1325e3cdfb8);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");
const $9e17359a9ab8218d$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
const $9e17359a9ab8218d$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
    /**
	 * Note don't put multiple variables in multiple lines. eg
	 * <style>
	 *   {css1}
	 *   {css2}
	 * </style>
	 *
	 * React will insert an empty HTML comment in between the text in SSR.
	 * This is not a valid tag and will break the page.
	 * <style>foo<!-- -->bar</style>
	 */ let style = `:root { ${variableName}: ${$9e17359a9ab8218d$var$getCssStringValue(value)} }`;
    if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$9e17359a9ab8218d$var$getCssStringValue(responsiveValue)} } }`;
    return(// Using a global style is required for SSR, as we can't use React hooks
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
    /*#__PURE__*/ (0, $5chsV.jsx)("style", {
        children: style
    }));
};
$9e17359a9ab8218d$export$9f45a1325e3cdfb8.displayName = "DangerouslyHoistCssVarToDocumentRoot";

});

parcelRegister("f0Dt1", function(module, exports) {
$parcel$export(module.exports, "DangerouslyHoistSlotSizes", () => $c4461e3991b53dc7$export$66e2c1a0115af861);

var $fsvuC = parcelRequire("fsvuC");
const $c4461e3991b53dc7$export$66e2c1a0115af861 = /*#__PURE__*/ (0, $fsvuC.createContext)(false);

});

parcelRegister("9EEC1", function(module, exports) {
$parcel$export(module.exports, "convertResizeBoundToPixels", () => $9d3d5dbe595744b9$export$3d412b3011b66f82);
function $9d3d5dbe595744b9$export$3d412b3011b66f82(resizeBound) {
    if (resizeBound.endsWith('vw')) {
        // Max width was provided in `vw` units, so is relative to the viewport width.
        // e.g. 50vw = 50% of the viewport width.
        // `parseInt` will remove the `vw` suffix.
        const maxWidthFraction = parseInt(resizeBound) / 100;
        return Math.floor(window.innerWidth * maxWidthFraction);
    }
    // Max width was provided in `px` units, so we can parse it directly.
    // `parseInt` will remove the `px` suffix.
    return Math.floor(parseInt(resizeBound));
}

});

parcelRegister("llimD", function(module, exports) {
$parcel$export(module.exports, "PanelSplitterProvider", () => $8eb1e13b67fb4c86$export$f662bfb764348932);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $6y6Kb = parcelRequire("6y6Kb");
const $8eb1e13b67fb4c86$export$f662bfb764348932 = ({ panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, onResizeStartInternal: onResizeStartInternal, onResizeInternal: onResizeInternal, prepareResize: prepareResize, getResizeBounds: getResizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, resizingElementRef: resizingElementRef, portalRef: providedPortalRef, position: position = 'end', isEnabled: isEnabled = true, shortcut: shortcut, children: children })=>{
    const portalRef = (0, $fsvuC.useRef)(null);
    const context = (0, $fsvuC.useMemo)(()=>({
            panelId: panelId,
            panelWidth: panelWidth,
            onCompleteResize: onCompleteResize,
            onResizeStartInternal: onResizeStartInternal,
            onResizeInternal: onResizeInternal,
            prepareResize: prepareResize,
            getResizeBounds: getResizeBounds,
            resizingCssVar: resizingCssVar,
            position: position,
            panelRef: panelRef,
            resizingElementRef: resizingElementRef,
            isEnabled: isEnabled,
            portalRef: typeof providedPortalRef !== 'undefined' ? providedPortalRef : portalRef,
            shortcut: shortcut
        }), [
        panelId,
        panelWidth,
        onCompleteResize,
        onResizeStartInternal,
        onResizeInternal,
        prepareResize,
        getResizeBounds,
        resizingCssVar,
        position,
        panelRef,
        resizingElementRef,
        isEnabled,
        providedPortalRef,
        shortcut
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $6y6Kb.PanelSplitterContext).Provider, {
                value: context,
                children: children
            }),
            typeof providedPortalRef !== 'undefined' ? null : /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                ref: portalRef
            })
        ]
    });
};
$8eb1e13b67fb4c86$export$f662bfb764348932.displayName = "PanelSplitterProvider";

});
parcelRegister("6y6Kb", function(module, exports) {
$parcel$export(module.exports, "PanelSplitterContext", () => $3e7aacc7f68a248b$export$7a4054f2c546f2cd);

var $fsvuC = parcelRequire("fsvuC");
const $3e7aacc7f68a248b$export$7a4054f2c546f2cd = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});


parcelRegister("axEnb", function(module, exports) {
$parcel$export(module.exports, "resolveLayoutWidth", () => $a5071eebbafcd3c9$export$fca44cc45c9c7d43);
function $a5071eebbafcd3c9$export$fca44cc45c9c7d43(bound, viewportWidth) {
    if (typeof bound === 'number') return bound;
    const value = Number.parseFloat(bound);
    return bound.endsWith('vw') ? viewportWidth * value / 100 : value;
}

});

parcelRegister("oprSU", function(module, exports) {
$parcel$export(module.exports, "gridRootId", () => $700536b761cea3fa$export$a6d827031bcb31d1);
$parcel$export(module.exports, "gridRootFitId", () => $700536b761cea3fa$export$27a44a3a56ddb00b);
$parcel$export(module.exports, "gridRootChatFitId", () => $700536b761cea3fa$export$5903b21beb1d1891);
$parcel$export(module.exports, "Root", () => $700536b761cea3fa$export$be92b6f5f03c0fe9);
/* root.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $ktTmd = parcelRequire("ktTmd");

var $5T6N9 = parcelRequire("5T6N9");

var $7ZrMB = parcelRequire("7ZrMB");

var $fCDmj = parcelRequire("fCDmj");

var $f0Dt1 = parcelRequire("f0Dt1");

var $2sL5I = parcelRequire("2sL5I");

var $dKcuv = parcelRequire("dKcuv");

var $2Q7OI = parcelRequire("2Q7OI");

var $5EUEV = parcelRequire("5EUEV");

var $gUXQX = parcelRequire("gUXQX");
const $700536b761cea3fa$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
const $700536b761cea3fa$export$27a44a3a56ddb00b = `${$700536b761cea3fa$export$a6d827031bcb31d1}-fit`;
const $700536b761cea3fa$export$5903b21beb1d1891 = `${$700536b761cea3fa$export$a6d827031bcb31d1}-chat-fit`;
const $700536b761cea3fa$var$styles = {
    widthContainer: "_0u2WMmrU95 _3n40gWjQQ2 _39xV02N91d",
    mainSpace: "_0x0m3Pytah _3e862PzZoh _0u2WMmrU95 _3n40gWhnFZ _24h04iyL8i _39xV02Yi9r",
    chatSpace: "_00F2PoB6f5 _0u2WMmrU95 _3n40gWwgYM _39xV02riSj",
    legacyRoot: "_3iDTPbgBM8 _4kiQYAWP8C _3NN0tOsKlt _2iEGP28wUV _0ca6V72ulg _2xgI2Ymk5d _2yz9PXk6i4 _4cQPhCuAep _2dnLWx2dcB _1h2oUBk6i4 _1YDlQuSe0G",
    root: "_3e862PzZoh _3iDTPbgBM8 _4kiQYAWP8C _39xV024eQp _3NN0tOsKlt _2iEGP28wUV _0ca6V72ulg _2wGBBqwhpO _0sNGaGmt1K _2xgI2Y0gUc _2yz9PXk6i4 _4cQPhCXkqu _2dnLWxRpCc _1YDlQuBl9j",
    safetyRail: "_3cypjiOiJt",
    safetyRailWithTopLayer: "_4lA8aSOiJt",
    panelUplift: "_4bt5LAoWuR _2WAcuGoWuR"
};
function $700536b761cea3fa$var$LayoutFitContainers({ children: children }) {
    // CSS cannot use custom properties in a size-query condition. Query the
    // remaining capacity instead: these wrappers subtract configured minimums
    // and occupied tracks, while the actual grid keeps its original host width.
    return /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
        "data-layout-width-container": "",
        className: (0, $gJ6nT.default)([
            $700536b761cea3fa$var$styles.widthContainer
        ]),
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: `@property --n_layoutW { syntax: '<length>'; inherits: true; initial-value: 0px; }`
                }
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                id: $700536b761cea3fa$export$27a44a3a56ddb00b,
                className: (0, $gJ6nT.default)([
                    $700536b761cea3fa$var$styles.mainSpace
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    id: $700536b761cea3fa$export$5903b21beb1d1891,
                    className: (0, $gJ6nT.default)([
                        $700536b761cea3fa$var$styles.chatSpace
                    ]),
                    children: children
                })
            })
        ]
    });
}
$700536b761cea3fa$var$LayoutFitContainers.displayName = "LayoutFitContainers";
function $700536b761cea3fa$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = (0, $5T6N9.fg)('platform_dst_nav4_skip_link_a11y_1') ? 'Skip to' : 'Skip to:', skipLinksTriggerLabel: skipLinksTriggerLabel = 'Skip to', testId: testId, defaultSideNavCollapsed: defaultSideNavCollapsed, isSideNavShortcutEnabled: isSideNavShortcutEnabled = false }) {
    const ref = (0, $fsvuC.useRef)(null);
    const isChatPanelLayoutEnabled = (0, $5T6N9.fg)('platform-dst-chat-panel-layout');
    const LayoutProvider = isChatPanelLayoutEnabled ? (0, $2sL5I.LayoutAreaSizingProvider) : (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment;
    const WidthContainer = isChatPanelLayoutEnabled ? $700536b761cea3fa$var$LayoutFitContainers : (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment;
    // Top-layer surfaces are found through the DOM, so the observer is only needed when the gate is off.
    const LayerObserverProvider = (0, $5T6N9.fg)('platform-dst-top-layer') ? (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment : (0, $ktTmd.OpenLayerObserver);
    (0, $fsvuC.useEffect)(()=>{}, []);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $gUXQX.SideNavVisibilityProvider), {
        defaultCollapsed: defaultSideNavCollapsed,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5EUEV.SideNavToggleButtonProvider), {
            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $2Q7OI.SideNavElementProvider), {
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $dKcuv.IsSideNavShortcutEnabledProvider), {
                    isSideNavShortcutEnabled: isSideNavShortcutEnabled,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $fCDmj.TopNavStartProvider), {
                        children: /*#__PURE__*/ (0, $5chsV.jsx)(LayoutProvider, {
                            ...isChatPanelLayoutEnabled ? {
                                layoutRef: ref
                            } : {},
                            children: /*#__PURE__*/ (0, $5chsV.jsx)(LayerObserverProvider, {
                                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $f0Dt1.DangerouslyHoistSlotSizes).Provider, {
                                    value: UNSAFE_dangerouslyHoistSlotSizes,
                                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $7ZrMB.SkipLinksProvider), {
                                        label: skipLinksLabel,
                                        triggerLabel: skipLinksTriggerLabel,
                                        testId: testId,
                                        children: /*#__PURE__*/ (0, $5chsV.jsx)(WidthContainer, {
                                            children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                                                ref: ref,
                                                className: (0, $gJ6nT.default)([
                                                    isChatPanelLayoutEnabled ? $700536b761cea3fa$var$styles.root : $700536b761cea3fa$var$styles.legacyRoot,
                                                    (0, $5T6N9.fg)('platform-dst-motion-uplift-panel') && $700536b761cea3fa$var$styles.panelUplift,
                                                    (0, $5T6N9.fg)('platform-dst-top-layer') ? $700536b761cea3fa$var$styles.safetyRailWithTopLayer : $700536b761cea3fa$var$styles.safetyRail,
                                                    xcss
                                                ]),
                                                id: $700536b761cea3fa$export$a6d827031bcb31d1,
                                                "data-testid": testId,
                                                children: children
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
}
$700536b761cea3fa$export$be92b6f5f03c0fe9.displayName = "Root";

});
parcelRegister("ktTmd", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserver", () => $f0c4b36ad4e8b46b$export$97afddda23bcd287);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $l9kus = parcelRequire("l9kus");

var $doEd2 = parcelRequire("doEd2");
/**
 * Layers that are registered without a namespace are grouped under this fallback namespace.
 */ const $f0c4b36ad4e8b46b$var$noNamespaceSymbol = Symbol('no-namespace');
/**
 * Returns the number of open layers across all namespaces.
 * It calculates the sum of the set sizes in the map, which corresponds to the number of open layers.
 */ function $f0c4b36ad4e8b46b$var$getTotalOpenLayerCount(registry) {
    return Array.from(registry.values()).reduce((acc, listeners)=>acc + listeners.size, 0);
}
/**
 * Returns the number of layers in the set that match the type filter.
 */ function $f0c4b36ad4e8b46b$var$getLayerCountWithFilter({ layers: layers, type: type }) {
    return Array.from(layers.values()).filter((layer)=>layer.type === type).length;
}
/**
 * Returns the layer count change listeners set for the namespace.
 * If there are no listeners registered for the namespace yet, it creates a new set
 * and adds it to the registry, then returns the new set.
 */ function $f0c4b36ad4e8b46b$var$getListeners({ registry: registry, namespace: namespace }) {
    // 1. If there are existing listeners for this namespace, return the existing set.
    const existingListeners = registry.get(namespace);
    if (existingListeners) return existingListeners;
    // 2. If there are no existing listeners for this namespace, create a new set for this namespace
    // and add it to the registry, then return the new set.
    const newSet = new Set();
    registry.set(namespace, newSet);
    return newSet;
}
/**
 * Returns an instance of the open layer observer API. It internally keeps track of the number of open layers and
 * exposes methods to get the current count, increment/decrement the count, and subscribe to changes.
 */ function $f0c4b36ad4e8b46b$var$createInternalAPI() {
    /**
	 * The layer count change listeners for each namespace.
	 */ const namespaceToChangeListenerRegistry = new Map();
    /**
	 * The registered layers for each namespace.
	 * Each layer registers with an `onClose` callback, and optionally with a layer type (`type`).
	 * **When the layer is open**, its `onClose`
	 * callback is registered in this set along with its type.
	 *
	 * This data structure is also used determine the number of open layers.
	 */ const namespaceToLayerRegistry = new Map();
    /**
	 * Calls the appropriate layer count change listeners after the number of open layers has changed.
	 */ function callChangeListeners({ namespace: namespace, newCount: newCount }) {
        // 1. Call listeners registered to the specific namespace
        if (namespace) {
            const listenersForNamespace = namespaceToChangeListenerRegistry.get(namespace);
            // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
            // iterating over it.
            Array.from(listenersForNamespace ?? []).forEach((listener)=>listener({
                    count: newCount
                }));
        }
        // 2. Call listeners registered without a specific namespace
        const noNamespaceListeners = namespaceToChangeListenerRegistry.get($f0c4b36ad4e8b46b$var$noNamespaceSymbol);
        // Return early if no listeners
        if (!noNamespaceListeners) return;
        // For the listeners without a specific namespace, we need to provide the sum of all namespace counts
        // as the callback `count` arg.
        const totalCount = $f0c4b36ad4e8b46b$var$getTotalOpenLayerCount(namespaceToLayerRegistry);
        Array.from(noNamespaceListeners).forEach((listener)=>listener({
                count: totalCount
            }));
    }
    /**
	 * Returns the current count of open layers.
	 *
	 * - If a namespace is provided, the count for that namespace is returned.
	 * - If a type is provided, only layers of that type are counted.
	 * - If both are provided, only layers matching both criteria are counted.
	 * - Otherwise, the sum of all namespace counts is returned.
	 */ function getCount({ namespace: namespace, type: type } = {}) {
        if (namespace) {
            // 1. A namespace was requested, so we count only layers in that namespace
            const layersForNamespace = namespaceToLayerRegistry.get(namespace);
            if (!layersForNamespace) return 0;
            if (type) // Count layers in the namespace that match the type filter
            return $f0c4b36ad4e8b46b$var$getLayerCountWithFilter({
                layers: layersForNamespace,
                type: type
            });
            // No type filter - just return the size of the set
            return layersForNamespace.size;
        }
        // 2. A specific namespace was not requested, so we count across all namespaces
        if (type) // Count layers in each namespace that match the type filter
        return Array.from(namespaceToLayerRegistry.values()).reduce((acc, layers)=>acc + $f0c4b36ad4e8b46b$var$getLayerCountWithFilter({
                layers: layers,
                type: type
            }), 0);
        // No type filter - count all layers across all namespaces
        return $f0c4b36ad4e8b46b$var$getTotalOpenLayerCount(namespaceToLayerRegistry);
    }
    /**
	 * Adds a listener that will be called when the number of open layers changes.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onChange(listener, { namespace: providedNamespace } = {}) {
        /**
		 * We are wrapping the passed listener in a function to ensure that each call to `onChange` creates a unique
		 * function reference. This is to handle scenarios where the same function is provided to several different `onChange`
		 * calls - we want to ensure that each call to `unsubscribe` only removes the specific listener registration that was added.
		 */ function wrapped(...args) {
            listener(...args);
        }
        const namespace = providedNamespace ?? $f0c4b36ad4e8b46b$var$noNamespaceSymbol;
        const listenersForNamespace = $f0c4b36ad4e8b46b$var$getListeners({
            namespace: namespace,
            registry: namespaceToChangeListenerRegistry
        });
        listenersForNamespace.add(wrapped);
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToChangeListenerRegistry.delete(namespace);
        };
    }
    /**
	 * Adds a listener to the registry that tells the observer how to close the layer component.
	 * The listener should only be added if the layer is open. This is handled by `useNotifyOpenLayerObserver`.
	 *
	 * All close listeners will be called by the observer when `closeLayers` is called.
	 *
	 * @returns a cleanup function to unsubscribe, which should be called when the component unmounts.
	 */ function onClose(listener, { namespace: providedNamespace, type: type }) {
        const wrapped = {
            listener: listener,
            type: type
        };
        const namespace = providedNamespace ?? $f0c4b36ad4e8b46b$var$noNamespaceSymbol;
        const listenersForNamespace = $f0c4b36ad4e8b46b$var$getListeners({
            namespace: namespace,
            registry: namespaceToLayerRegistry
        });
        listenersForNamespace.add(wrapped);
        callChangeListeners({
            namespace: providedNamespace,
            newCount: listenersForNamespace.size
        });
        return function unsubscribe() {
            listenersForNamespace.delete(wrapped);
            callChangeListeners({
                namespace: providedNamespace,
                newCount: listenersForNamespace.size
            });
            // If there are no listeners for this namespace, remove the registry entry.
            if (listenersForNamespace.size === 0) namespaceToLayerRegistry.delete(namespace);
        };
    }
    /**
	 * Closes all open layers registered across all namespaces.
	 */ function closeLayers() {
        // Using `Array.from` to ensure we iterate over a stable list - e.g. in case a listener adds to the registry while we are
        // iterating over it.
        Array.from(namespaceToLayerRegistry.values()).forEach((listeners)=>{
            Array.from(listeners).forEach(({ listener: listener })=>listener());
        });
    }
    const internalAPI = {
        getCount: getCount,
        onChange: onChange,
        onClose: onClose,
        closeLayers: closeLayers
    };
    return internalAPI;
}
function $f0c4b36ad4e8b46b$export$97afddda23bcd287({ children: children }) {
    // Using state to ensure a stable reference to a single instance.
    const [internalAPI] = (0, $fsvuC.useState)(()=>$f0c4b36ad4e8b46b$var$createInternalAPI());
    const parentContext = (0, $fsvuC.useContext)((0, $doEd2.OpenLayerObserverContext));
    // We don't expect a parent context. If there is one, that means this component is nested within another `OpenLayerObserver`
    // - which we don't support.
    (0, $l9kus.default)(parentContext === null, '`OpenLayerObserver` cannot be nested within another `OpenLayerObserver`.');
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $doEd2.OpenLayerObserverContext).Provider, {
        value: internalAPI,
        children: children
    });
}
$f0c4b36ad4e8b46b$export$97afddda23bcd287.displayName = "OpenLayerObserver";

});

parcelRegister("7ZrMB", function(module, exports) {
$parcel$export(module.exports, "SkipLinksProvider", () => $7e9ab7c4cfd5c7a3$export$fe514f9f7b03d46f);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $3zbIU = parcelRequire("3zbIU");

var $5LJgO = parcelRequire("5LJgO");
const $7e9ab7c4cfd5c7a3$var$getByDomOrderSortFunction = ()=>{
    const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
    return (a, b)=>{
        const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
        const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
        /**
		 * If they are tied it is because one (or both) is
		 * a custom skiplink with a set index.
		 *
		 * Give the custom skiplink priority.
		 */ if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
};
function $7e9ab7c4cfd5c7a3$export$fe514f9f7b03d46f({ children: children, label: label, triggerLabel: triggerLabel, testId: testId }) {
    const [links, setLinks] = (0, $fsvuC.useState)([]);
    const registerSkipLink = (0, $fsvuC.useCallback)((skipLinkData)=>{
        // Don't add duplicate skip links
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($7e9ab7c4cfd5c7a3$var$getByDomOrderSortFunction());
        });
    }, []);
    const unregisterSkipLink = (0, $fsvuC.useCallback)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    }, []);
    const contextValue = (0, $fsvuC.useMemo)(()=>{
        const data = {
            registerSkipLink: registerSkipLink,
            unregisterSkipLink: unregisterSkipLink
        };
        return data;
    }, [
        registerSkipLink,
        unregisterSkipLink
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5LJgO.SkipLinksContext).Provider, {
        value: contextValue,
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $3zbIU.SkipLinksContainer), {
                label: label,
                triggerLabel: triggerLabel,
                testId: testId,
                links: links
            }),
            children
        ]
    });
}
$7e9ab7c4cfd5c7a3$export$fe514f9f7b03d46f.displayName = "SkipLinksProvider";

});
parcelRegister("3zbIU", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContainer", () => $d6ec7c0157d53826$export$fce25a0c32fbc1e1);
/* skip-links-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $5T6N9 = parcelRequire("5T6N9");

var $kBK9z = parcelRequire("kBK9z");

var $hIWzO = parcelRequire("hIWzO");

var $bj2It = parcelRequire("bj2It");
const $d6ec7c0157d53826$var$styles = {
    root: "_2mHwu81Y8M _0bjKvDKxmn _4c065U8HPE _2Y7lL48HPE _3iDTPbQ4SZ _0aFT5vbt8w _1mT5xdy1CL _3iC0zdkG2W _2I62gzkG2W _0KLXruoI2d _2OUyjtGk8v _42Yu6BvQQr _1YKVNsdnbC _1pp6NdYbGa _3gBTfLGYeU _3Tg68S7dHp _2VJVb2IZbP",
    skipLinkList: "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _4zmD5lTNeH _0aNu0LYbGa _43nrzTPgdg _0LQT5EPgdg"
};
/**
 * Keydown handler to hide the skip links when escape is pressed.
 *
 * TODO: consider removing this, it doesn't make a lot of sense.
 * The skip links look like a popup but in reality they aren't.
 * Even though we hide them when the user presses Escape, when
 * they press TAB it will reopen the list and move to the next one...
 *
 * One potential option is to use a tree walker to focus on the
 * next focusable element in the DOM (outside the skip links
 * container).
 */ const $d6ec7c0157d53826$var$closeOnEscape = (event)=>{
    if (event.key !== 'Escape') return;
    const activeElement = document.activeElement;
    if (activeElement instanceof HTMLElement) activeElement.blur();
};
const $d6ec7c0157d53826$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $d6ec7c0157d53826$var$assignIndex(num + 1, arr);
};
/**
 * Sorts an array of skip links by list indexes.
 *
 * Skip links with custom list indexes are positioned first, followed by regular skip links,
 * which are automatically assigned available index positions to avoid conflicts.
 */ function $d6ec7c0157d53826$var$sortSkipLinks(arr) {
    const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
    if (customLinks.length === 0) return arr;
    const usedIndexes = customLinks.map((a)=>a.listIndex);
    const regularLinksWithIndex = arr.filter((link)=>link.listIndex === undefined).map((link, index)=>{
        const listIndex = $d6ec7c0157d53826$var$assignIndex(index, usedIndexes);
        usedIndexes.push(listIndex);
        return {
            ...link,
            listIndex: listIndex
        };
    });
    return [
        ...customLinks,
        ...regularLinksWithIndex
    ].sort((a, b)=>a.listIndex - b.listIndex);
}
const $d6ec7c0157d53826$var$isOnlyWhitespaceRegex = /^\s*$/;
function $d6ec7c0157d53826$export$fce25a0c32fbc1e1({ label: label, triggerLabel: triggerLabel, testId: testId, links: links }) {
    const sortedLinks = (0, $fsvuC.useMemo)(()=>{
        return $d6ec7c0157d53826$var$sortSkipLinks(links);
    }, [
        links
    ]);
    if (sortedLinks.length === 0) return null;
    const isEmptyLabel = $d6ec7c0157d53826$var$isOnlyWhitespaceRegex.test(label);
    if ((0, $5T6N9.fg)('platform_dst_nav4_skip_link_a11y_1')) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bj2It.SkipLinksPopup), {
        label: label,
        triggerLabel: triggerLabel,
        testId: testId,
        links: sortedLinks
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
        onKeyDown: $d6ec7c0157d53826$var$closeOnEscape,
        "data-testid": testId ? `${testId}--skip-links-container` : undefined,
        className: (0, $gJ6nT.default)([
            $d6ec7c0157d53826$var$styles.root
        ]),
        children: [
            !isEmptyLabel && /*#__PURE__*/ (0, $5chsV.jsx)((0, $kBK9z.Text), {
                weight: "bold",
                testId: testId ? `${testId}--skip-links-container--label` : undefined,
                children: label
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("ol", {
                className: (0, $gJ6nT.default)([
                    $d6ec7c0157d53826$var$styles.skipLinkList
                ]),
                children: sortedLinks.map(({ id: id, label: label, onBeforeNavigate: onBeforeNavigate })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $hIWzO.SkipLink), {
                        id: id,
                        onBeforeNavigate: onBeforeNavigate,
                        children: label
                    }, id))
            })
        ]
    });
}
$d6ec7c0157d53826$export$fce25a0c32fbc1e1.displayName = "SkipLinksContainer";

});
parcelRegister("hIWzO", function(module, exports) {
$parcel$export(module.exports, "SkipLink", () => $e4a78c86a91a6915$export$ef95c37428582a65);
/* skip-link.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $5T6N9 = parcelRequire("5T6N9");

var $5hZWH = parcelRequire("5hZWH");

var $h9KZD = parcelRequire("h9KZD");
const $e4a78c86a91a6915$var$styles = {
    skipLinkListItem: "_43nrzTPgdg",
    skipLinkListItemNew: "_4c065U2ADO"
};
const $e4a78c86a91a6915$export$ef95c37428582a65 = ({ id: id, children: children, onBeforeNavigate: onBeforeNavigate, navigate: navigate })=>{
    const href = `#${id}`;
    const handleClick = (0, $fsvuC.useCallback)((event)=>{
        event.preventDefault();
        if (navigate && (0, $5T6N9.fg)('platform_dst_nav4_skip_link_a11y_1')) /**
       * The consumer takes over the navigation effect (e.g. expanding the
       * side nav and focusing the first nav item). The universal pre/post
       * work below (e.g. `window.scrollTo`) still runs around it.
       */ navigate();
        else {
            // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
            const target = document.getElementById(id);
            if (!target) return;
            /**
       * Legacy `onBeforeNavigate` hook. Intentionally NOT called when
       * `platform_dst_nav4_skip_link_a11y_1` is enabled — under the gate the
       * gate-on path delegates state mutation + focus management to `navigate`,
       * and `SkipLinksPopup` injects its popup-close behavior into the
       * `navigate` wrapper instead of relying on this hook.
       *
       * This callback can be removed entirely on gate cleanup.
       */ if (!(0, $5T6N9.fg)('platform_dst_nav4_skip_link_a11y_1')) onBeforeNavigate?.();
            (0, $h9KZD.focusElement)(target);
        }
        /**
     * We should look into removing this, or only calling it in specific cases.
     *
     * It means if the skip link element is in the window scroll container
     * then it might not get scrolled into view properly.
     *
     * This is not an issue for the default slots on desktop, but could break custom skip links or
     * even `Aside` on mobile.
     *
     * Keeping existing behavior for now because resetting the window scroll is actually good for some cases.
     * E.g. jumping to main / aside it makes sense to look at the start of the content.
     */ window.scrollTo(0, 0);
    }, [
        id,
        onBeforeNavigate,
        navigate
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)("li", {
        className: (0, $gJ6nT.default)([
            $e4a78c86a91a6915$var$styles.skipLinkListItem,
            (0, $5T6N9.fg)('platform_dst_nav4_skip_link_a11y_1') && $e4a78c86a91a6915$var$styles.skipLinkListItemNew
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5hZWH.Anchor), {
            /**
     * It looks like Safari handles link clicks during `pointerdown` unless it has an explicit `tabIndex={0}` :/
     *
     * Adding this explicitly makes the behavior consistent between browsers and lets us `event.preventDefault()`
     * in the `onClick` handler.
     */ tabIndex: 0,
            href: href,
            onClick: handleClick,
            children: children
        })
    });
};
$e4a78c86a91a6915$export$ef95c37428582a65.displayName = "SkipLink";

});
parcelRegister("h9KZD", function(module, exports) {
$parcel$export(module.exports, "focusElement", () => $ae991f867d0bfed7$export$5fed9cc43865dc7e);

var $dqdTY = parcelRequire("dqdTY");
function $ae991f867d0bfed7$export$5fed9cc43865dc7e(element) {
    /**
	 * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
	 * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
	 *
	 * Our slots are not interactive, so this is required.
	 *
	 * In the future we may want to check if there is an existing `tabindex` attribute,
	 * as custom skip linked elements might already have one.
	 */ element.setAttribute('tabindex', '-1');
    /**
	 * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
	 *
	 * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
	 *
	 * - mess with click events
	 * - potentially cause a focus ring to be always visible
	 */ (0, $dqdTY.bind)(element, {
        type: 'blur',
        listener () {
            element.removeAttribute('tabindex');
        },
        options: {
            // Using a one-time listener so it cleans itself up
            once: true
        }
    });
    /**
	 * Move focus to the slot or custom target.
	 *
	 * Calling `.focus()` will also scroll the element into view:
	 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
	 */ element.focus({
        // Forces the focus ring to appear after moving focus to the slot
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
        focusVisible: true
    });
}

});


parcelRegister("bj2It", function(module, exports) {
$parcel$export(module.exports, "SkipLinksPopup", () => $fc2cac3e1658055b$export$759eb47efaee9eec);
/* skip-links-popup.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $80czl = parcelRequire("80czl");

var $76zfX = parcelRequire("76zfX");

var $1cXpO = parcelRequire("1cXpO");

var $2LKzh = parcelRequire("2LKzh");

var $h9KZD = parcelRequire("h9KZD");

var $hIWzO = parcelRequire("hIWzO");
const $fc2cac3e1658055b$var$contentStyles = {
    root: "_4c065U2ADO _2Y7lL45zaO _3iDTPbQ4SZ _0aFT5vbt8w _42Yu6BGYeU",
    skipLinkList: "_3iDTPbQ4SZ _0aFT5vbt8w _4zmD5lTNeH _0aNu0LYbGa _43nrzTPgdg _0LQT5EPgdg",
    label: "_2sNsIgd8bj _4c065U2ADO _1UtDYzZpcK"
};
const $fc2cac3e1658055b$var$triggerStyles = {
    root: "_0bjKvDKxmn _3hxITiYbGa _1mT5xdy1CL _3iC0zd8HPE _2I62gz8HPE _42Yu6BvQQr _1YKVNsdnbC _0KLXruoI2d _0j9PH9GYeU _0O4CrC7dHp",
    isOpen: "_1YKVNsdnbC _1VJPca0OLL"
};
const $fc2cac3e1658055b$var$popupOffset = [
    0,
    0
];
function $fc2cac3e1658055b$export$759eb47efaee9eec({ label: title, triggerLabel: triggerLabel, testId: testId, links: links }) {
    const titleId = (0, $fsvuC.useId)();
    const [isOpen, setIsOpen] = (0, $fsvuC.useState)(false);
    const triggerRef = (0, $fsvuC.useRef)(null);
    const openPopup = (0, $fsvuC.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    /**
   * Closes the popup.
   *
   * Uses `flushSync` to avoid issues with focus management.
   * This ensures the popup's focus lock is fully released by the time skip links or our `onClose` try to move focus.
   */ const closePopup = (0, $fsvuC.useCallback)(()=>{
        (0, $80czl.flushSync)(()=>{
            setIsOpen(false);
        });
    }, []);
    /**
   * Restores focus to the trigger on close, if it hasn't moved to another element, such as when Esc is pressed instead of a skip link.
   *
   * We need this because using the standard `shouldReturnFocus` on the popup would break the skip link focus behaviour,
   * as focus would always move back to the trigger.
   */ const onClose = (0, $fsvuC.useCallback)(()=>{
        closePopup();
        // Focus on the body implies a skip link was not clicked
        if (document.activeElement === document.body) triggerRef.current?.focus();
    }, [
        closePopup
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2LKzh.Popup), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        shouldRenderToParent: true,
        shouldReturnFocus: false,
        role: "dialog",
        titleId: titleId,
        testId: testId ? `${testId}--skip-links-container` : undefined,
        offset: $fc2cac3e1658055b$var$popupOffset,
        content: ()=>/*#__PURE__*/ (0, $5chsV.jsxs)("div", {
                className: (0, $gJ6nT.default)([
                    $fc2cac3e1658055b$var$contentStyles.root
                ]),
                children: [
                    /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                        "data-testid": testId ? `${testId}--skip-links-container--label` : undefined,
                        id: titleId,
                        className: (0, $gJ6nT.default)([
                            $fc2cac3e1658055b$var$contentStyles.label
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)("ol", {
                        className: (0, $gJ6nT.default)([
                            $fc2cac3e1658055b$var$contentStyles.skipLinkList
                        ]),
                        children: links.map(({ id: id, label: label, navigate: navigate })=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $hIWzO.SkipLink), {
                                id: id,
                                /**
       * The popup always owns the navigation effect under the
       * `platform_dst_nav4_skip_link_a11y_1` gate (the only path
       * that renders `SkipLinksPopup`). It first closes itself
       * synchronously so its focus lock is released, then either:
       *
       *  - delegates to the consumer's `navigate` (e.g. SideNav
       *    expanding and focusing its first nav item), or
       *  - falls back to focusing the slot element with `id`.
       *
       * This means `SkipLink`'s `onBeforeNavigate` hook is never
       * needed under the gate and can be removed on cleanup.
       */ navigate: ()=>{
                                    closePopup();
                                    if (navigate) {
                                        navigate();
                                        return;
                                    }
                                    // Intentionally not using `document.querySelector` because many valid IDs are not valid selectors.
                                    const target = document.getElementById(id);
                                    if (target) (0, $h9KZD.focusElement)(target);
                                },
                                children: label
                            }, id))
                    })
                ]
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $5chsV.jsx)("div", {
                className: (0, $gJ6nT.default)([
                    $fc2cac3e1658055b$var$triggerStyles.root,
                    isOpen && $fc2cac3e1658055b$var$triggerStyles.isOpen
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $76zfX.default), {
                    ...triggerProps,
                    ref: (0, $1cXpO.default)([
                        triggerProps.ref,
                        triggerRef
                    ]),
                    appearance: "primary",
                    isSelected: isOpen,
                    testId: testId ? `${testId}--skip-links-trigger` : undefined,
                    onClick: openPopup,
                    children: triggerLabel
                })
            })
    });
}
$fc2cac3e1658055b$export$759eb47efaee9eec.displayName = "SkipLinksPopup";

});



parcelRegister("fCDmj", function(module, exports) {
$parcel$export(module.exports, "TopNavStartProvider", () => $8c9cfb4b5a58f2ed$export$bc9d0ad0bce43e75);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $f26MV = parcelRequire("f26MV");

var $hNxdc = parcelRequire("hNxdc");
const $8c9cfb4b5a58f2ed$export$bc9d0ad0bce43e75 = ({ children: children })=>{
    const [element, setElement] = (0, $fsvuC.useState)(null);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hNxdc.TopNavStartElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $f26MV.TopNavStartAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};
$8c9cfb4b5a58f2ed$export$bc9d0ad0bce43e75.displayName = "TopNavStartProvider";

});
parcelRegister("f26MV", function(module, exports) {
$parcel$export(module.exports, "TopNavStartAttachRef", () => $6d6b97b1b859fce4$export$55f0a642b785fb1f);

var $fsvuC = parcelRequire("fsvuC");

var $iqo7S = parcelRequire("iqo7S");
const $6d6b97b1b859fce4$export$55f0a642b785fb1f = /*#__PURE__*/ (0, $fsvuC.createContext)((0, $iqo7S.default));

});


parcelRegister("2sL5I", function(module, exports) {
$parcel$export(module.exports, "LayoutAreaSizingProvider", () => $a4784a5c8a75a368$export$c026181e8eaf0b9f);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $d4nKw = parcelRequire("d4nKw");

var $BFYYG = parcelRequire("BFYYG");

var $b1omk = parcelRequire("b1omk");

var $idv8G = parcelRequire("idv8G");

function $a4784a5c8a75a368$export$c026181e8eaf0b9f({ children: children, layoutRef: layoutRef }) {
    const [Runtime, setRuntime] = (0, $fsvuC.useState)(null);
    const [states, setStates] = (0, $fsvuC.useState)({});
    const actions = (0, $fsvuC.useRef)(null);
    const configs = (0, $fsvuC.useRef)({});
    const [lastOpenedOverlay, setLastOpenedOverlay] = (0, $fsvuC.useState)(null);
    const [configRevision, setConfigRevision] = (0, $fsvuC.useState)(0);
    const cssModes = (0, $idv8G.useCssLayoutAreaStates)(layoutRef, configRevision, Runtime === null);
    const sideNavMode = states['side-nav']?.mode ?? cssModes['side-nav'];
    const chatPanelMode = states['chat-panel']?.mode ?? cssModes['chat-panel'];
    // Overlay dismissal is available before the sizing chunk loads. Keep the open
    // order here too: replaying registrations into the runtime loses that order.
    (0, $fsvuC.useEffect)(()=>{
        const inlineChatQuery = window.matchMedia('(min-width: 40rem)');
        const dismissOlderOverlay = ()=>{
            const sideNav = configs.current['side-nav'];
            const chatPanel = configs.current['chat-panel'];
            if (!sideNav?.isOpen || !chatPanel?.isOpen || !lastOpenedOverlay) return;
            // Before allocation, CSS puts both areas in overlay below 40rem. Once
            // sizing is active, also honour overlays caused by custom widths/slots.
            if (inlineChatQuery.matches && (sideNavMode !== 'overlay' || chatPanelMode !== 'overlay')) return;
            const olderOverlay = lastOpenedOverlay === 'side-nav' ? chatPanel : sideNav;
            olderOverlay.onRequestClose?.();
        };
        dismissOlderOverlay();
        return (0, $dqdTY.bind)(inlineChatQuery, {
            type: 'change',
            listener: dismissOlderOverlay
        });
    }, [
        chatPanelMode,
        lastOpenedOverlay,
        sideNavMode
    ]);
    const splitters = (0, $fsvuC.useRef)(new Set());
    const registerSplitter = (0, $fsvuC.useCallback)((element)=>{
        splitters.current.add(element);
        return ()=>{
            splitters.current.delete(element);
        };
    }, []);
    const mainMinWidth = (0, $fsvuC.useRef)((0, $d4nKw.defaultMainMinWidth));
    const loadRef = (0, $fsvuC.useRef)(()=>{});
    const ready = (0, $fsvuC.useRef)(false);
    const waiting = (0, $fsvuC.useRef)([]);
    const pending = (0, $fsvuC.useRef)([]);
    const prepareResize = (0, $fsvuC.useCallback)(()=>{
        if (ready.current) return Promise.resolve(true);
        return new Promise((resolve)=>{
            waiting.current.push(resolve);
            loadRef.current();
        });
    }, []);
    (0, $fsvuC.useEffect)(()=>{
        const root = layoutRef?.current;
        if (!root) return;
        let cancelled = false;
        let loading = false;
        const waitingForRuntime = waiting.current;
        const load = ()=>{
            if (loading) return;
            loading = true;
            (parcelRequire("jE5DW")).then(({ LayoutAreaSizingRuntime: LayoutAreaSizingRuntime })=>{
                if (!cancelled) setRuntime(()=>LayoutAreaSizingRuntime);
            }, ()=>{
                loading = false;
                pending.current = [];
                for (const resolve of waitingForRuntime.splice(0))resolve(false);
            });
        };
        loadRef.current = load;
        const loadForSplitter = (event)=>{
            if (!(event.target instanceof Node)) return;
            for (const splitter of splitters.current)if (splitter.contains(event.target)) {
                load();
                return;
            }
        };
        const unbindRoot = (0, $dqdTY.bindAll)(root, [
            {
                type: 'pointerover',
                listener: loadForSplitter,
                options: {
                    passive: true
                }
            },
            {
                type: 'focusin',
                listener: loadForSplitter
            },
            {
                type: 'pointerdown',
                listener: loadForSplitter,
                options: {
                    passive: true
                }
            }
        ]);
        return ()=>{
            cancelled = true;
            ready.current = false;
            pending.current = [];
            for (const resolve of waitingForRuntime.splice(0))resolve(false);
            loadRef.current = ()=>{};
            unbindRoot();
        };
    }, [
        layoutRef
    ]);
    const onReady = (0, $fsvuC.useCallback)((runtime)=>{
        actions.current = runtime;
        if (runtime) {
            runtime.setMainMinWidth(mainMinWidth.current);
            for (const area of [
                'side-nav',
                'panel',
                'chat-panel'
            ]){
                const config = configs.current[area];
                if (config) runtime.registerArea(area, config);
            }
        }
    }, []);
    const onUpdate = (0, $fsvuC.useCallback)((next)=>{
        setStates(next);
        const runtime = actions.current;
        if (runtime && Object.values(next).some(Boolean)) {
            ready.current = true;
            for (const action of pending.current.splice(0))action(runtime);
            for (const resolve of waiting.current.splice(0))resolve(true);
        }
    }, []);
    const dispatch = (0, $fsvuC.useCallback)((action)=>{
        if (ready.current && actions.current) action(actions.current);
        else {
            pending.current.push(action);
            loadRef.current();
        }
    }, []);
    const value = (0, $fsvuC.useMemo)(()=>({
            prepareResize: prepareResize,
            registerSplitter: registerSplitter,
            registerArea: (area, config)=>{
                if (area !== 'panel' && config.isOpen && !configs.current[area]?.isOpen) setLastOpenedOverlay(area);
                configs.current[area] = config;
                setConfigRevision((revision)=>revision + 1);
                actions.current?.registerArea(area, config);
            },
            unregisterArea: (area)=>{
                delete configs.current[area];
                setConfigRevision((revision)=>revision + 1);
                actions.current?.unregisterArea(area);
            },
            setMainMinWidth: (width)=>{
                if (mainMinWidth.current !== width) setConfigRevision((revision)=>revision + 1);
                mainMinWidth.current = width;
                actions.current?.setMainMinWidth(width);
            },
            getResizeBounds: (area)=>actions.current?.getResizeBounds(area),
            startResize: (area, mode)=>dispatch((runtime)=>runtime.startResize(area, mode)),
            resize: (area, mode, width)=>dispatch((runtime)=>runtime.resize(area, mode, width)),
            completeResize: (area, mode, width)=>dispatch((runtime)=>runtime.completeResize(area, mode, width))
        }), [
        dispatch,
        prepareResize,
        registerSplitter
    ]);
    const SideNavStateProvider = (0, $b1omk.layoutAreaStateContexts)['side-nav'].Provider;
    const PanelStateProvider = (0, $b1omk.layoutAreaStateContexts).panel.Provider;
    const ChatPanelStateProvider = (0, $b1omk.layoutAreaStateContexts)['chat-panel'].Provider;
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $BFYYG.LayoutAreaSizingContext).Provider, {
        value: value,
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)(SideNavStateProvider, {
                value: states['side-nav'],
                children: /*#__PURE__*/ (0, $5chsV.jsx)(PanelStateProvider, {
                    value: states.panel,
                    children: /*#__PURE__*/ (0, $5chsV.jsx)(ChatPanelStateProvider, {
                        value: states['chat-panel'],
                        children: children
                    })
                })
            }),
            Runtime && /*#__PURE__*/ (0, $5chsV.jsx)(Runtime, {
                layoutRef: layoutRef,
                onReady: onReady,
                onUpdate: onUpdate
            })
        ]
    });
}
$a4784a5c8a75a368$export$c026181e8eaf0b9f.displayName = "LayoutAreaSizingProvider";

});
parcelRegister("BFYYG", function(module, exports) {
$parcel$export(module.exports, "LayoutAreaSizingContext", () => $221107e4b6c5651b$export$bbdf82f5436c2324);

var $fsvuC = parcelRequire("fsvuC");
const $221107e4b6c5651b$export$bbdf82f5436c2324 = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});

parcelRegister("b1omk", function(module, exports) {
$parcel$export(module.exports, "layoutAreaStateContexts", () => $8f72cee5e896f838$export$c272236272fe50dc);

var $fsvuC = parcelRequire("fsvuC");
const $8f72cee5e896f838$export$c272236272fe50dc = {
    'side-nav': /*#__PURE__*/ (0, $fsvuC.createContext)(undefined),
    panel: /*#__PURE__*/ (0, $fsvuC.createContext)(undefined),
    'chat-panel': /*#__PURE__*/ (0, $fsvuC.createContext)(undefined)
};

});

parcelRegister("idv8G", function(module, exports) {
$parcel$export(module.exports, "useCssLayoutAreaStates", () => $dbf2606fe2868a79$export$4a5d1943691d3cd7);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");
function $dbf2606fe2868a79$export$4a5d1943691d3cd7(layoutRef, revision, isEnabled) {
    const [modes, setModes] = (0, $fsvuC.useState)({});
    (0, $fsvuC.useEffect)(()=>{
        const root = layoutRef?.current;
        if (!root || !isEnabled) return;
        const measure = ()=>{
            const selectors = {
                'side-nav': ':scope > nav[data-layout-slot]',
                panel: '[data-layout-with-panel-slot]',
                'chat-panel': ':scope > [data-layout-chat-panel]'
            };
            const next = {};
            for (const area of [
                'side-nav',
                'panel',
                'chat-panel'
            ]){
                const element = root.querySelector(selectors[area]);
                if (element) next[area] = getComputedStyle(element).gridArea.split('/')[0].trim() === area ? 'inline' : 'overlay';
            }
            setModes((previous)=>[
                    'side-nav',
                    'panel',
                    'chat-panel'
                ].every((area)=>previous[area] === next[area]) ? previous : next);
        };
        const widths = new Map();
        const observer = new ResizeObserver((entries)=>{
            let changed = false;
            for (const entry of entries)if (widths.get(entry.target) !== entry.contentRect.width) {
                widths.set(entry.target, entry.contentRect.width);
                changed = true;
            }
            if (changed) measure();
        });
        const observeSlots = ()=>{
            observer.disconnect();
            widths.clear();
            const occupied = Array.from(root.children).filter((element)=>element.matches('[data-layout-slot]:not(nav):not(header):not([role="main"]):not([data-layout-chat-panel])') && [
                    'aside',
                    'ribbon',
                    'panel'
                ].includes(getComputedStyle(element).gridArea.split('/')[0].trim()));
            for (const element of [
                root,
                ...occupied
            ]){
                widths.set(element, element.getBoundingClientRect().width);
                observer.observe(element);
            }
            measure();
        };
        observeSlots();
        const mutations = new MutationObserver(observeSlots);
        mutations.observe(root, {
            childList: true
        });
        const queries = [
            window.matchMedia('(min-width: 40rem)'),
            window.matchMedia('(min-width: 64rem)')
        ];
        const unbind = [
            (0, $dqdTY.bindAll)(window, [
                {
                    type: 'resize',
                    listener: measure
                }
            ]),
            ...queries.map((query)=>(0, $dqdTY.bindAll)(query, [
                    {
                        type: 'change',
                        listener: measure
                    }
                ]))
        ];
        return ()=>{
            observer.disconnect();
            mutations.disconnect();
            unbind.forEach((cleanup)=>cleanup());
        };
    }, [
        isEnabled,
        layoutRef,
        revision
    ]);
    return modes;
}

});

parcelRegister("jE5DW", function(module, exports) {

var $dk4lR = parcelRequire("dk4lR");
module.exports = $dk4lR("4b0Px").then(()=>parcelRequire('hXEOB'));

});
parcelRegister("dk4lR", function(module, exports) {
"use strict";

function $9b3084c5dabc3940$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("8b7E8")).resolve(id));
}
module.exports = $9b3084c5dabc3940$var$load;

});
parcelRegister("8b7E8", function(module, exports) {
$parcel$export(module.exports, "register", () => $01896021d7502578$export$6503ec6e8aabbaf, (v) => $01896021d7502578$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $01896021d7502578$export$f7ad0328861e2f03, (v) => $01896021d7502578$export$f7ad0328861e2f03 = v);
var $01896021d7502578$export$6503ec6e8aabbaf;
var $01896021d7502578$export$f7ad0328861e2f03;
"use strict";
var $01896021d7502578$var$mapping = new Map();
function $01896021d7502578$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$01896021d7502578$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $01896021d7502578$var$resolve(id) {
    var resolved = $01896021d7502578$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$01896021d7502578$export$6503ec6e8aabbaf = $01896021d7502578$var$register;
$01896021d7502578$export$f7ad0328861e2f03 = $01896021d7502578$var$resolve;

});




parcelRegister("dKcuv", function(module, exports) {
$parcel$export(module.exports, "IsSideNavShortcutEnabledProvider", () => $24b4e2c3d036aa36$export$f76029d097da8c58);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $i0PKj = parcelRequire("i0PKj");
function $24b4e2c3d036aa36$export$f76029d097da8c58({ children: children, isSideNavShortcutEnabled: isSideNavShortcutEnabled }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $i0PKj.IsSideNavShortcutEnabledContext).Provider, {
        value: isSideNavShortcutEnabled,
        children: children
    });
}
$24b4e2c3d036aa36$export$f76029d097da8c58.displayName = "IsSideNavShortcutEnabledProvider";

});
parcelRegister("i0PKj", function(module, exports) {
$parcel$export(module.exports, "IsSideNavShortcutEnabledContext", () => $3f8a1404d572969d$export$c41e1ac5602bc8d5);

var $fsvuC = parcelRequire("fsvuC");
const $3f8a1404d572969d$export$c41e1ac5602bc8d5 = /*#__PURE__*/ (0, $fsvuC.createContext)(false);

});


parcelRegister("2Q7OI", function(module, exports) {
$parcel$export(module.exports, "SideNavElementProvider", () => $849f025af6031702$export$85c1ff84bbf6e6dc);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $2ee9Q = parcelRequire("2ee9Q");
function $849f025af6031702$export$85c1ff84bbf6e6dc({ children: children }) {
    const sideNavRef = (0, $fsvuC.useRef)(null);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $2ee9Q.SideNavRefContext).Provider, {
        value: sideNavRef,
        children: children
    });
}
$849f025af6031702$export$85c1ff84bbf6e6dc.displayName = "SideNavElementProvider";

});
parcelRegister("2ee9Q", function(module, exports) {
$parcel$export(module.exports, "SideNavRefContext", () => $f4eb2f070ea63766$export$1cd490805a3a9874);

var $fsvuC = parcelRequire("fsvuC");
const $f4eb2f070ea63766$export$1cd490805a3a9874 = /*#__PURE__*/ (0, $fsvuC.createContext)({
    current: null
});

});


parcelRegister("5EUEV", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonProvider", () => $9c7c1a76a3dfac0c$export$ceb8e60e9790fc0f);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $3P30h = parcelRequire("3P30h");

var $gglrm = parcelRequire("gglrm");
const $9c7c1a76a3dfac0c$export$ceb8e60e9790fc0f = ({ children: children })=>{
    const [element, setElement] = (0, $fsvuC.useState)(null);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $gglrm.SideNavToggleButtonElement).Provider, {
        value: element,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $3P30h.SideNavToggleButtonAttachRef).Provider, {
            value: setElement,
            children: children
        })
    });
};
$9c7c1a76a3dfac0c$export$ceb8e60e9790fc0f.displayName = "SideNavToggleButtonProvider";

});
parcelRegister("3P30h", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonAttachRef", () => $38f4c5625e5fc782$export$fb8fa9a80240785e);

var $fsvuC = parcelRequire("fsvuC");

var $iqo7S = parcelRequire("iqo7S");
const $38f4c5625e5fc782$export$fb8fa9a80240785e = /*#__PURE__*/ (0, $fsvuC.createContext)((0, $iqo7S.default));

});

parcelRegister("gglrm", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButtonElement", () => $bb784f03217b068b$export$9c1768094bef896);

var $fsvuC = parcelRequire("fsvuC");
const $bb784f03217b068b$export$9c1768094bef896 = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});


parcelRegister("gUXQX", function(module, exports) {
$parcel$export(module.exports, "SideNavVisibilityProvider", () => $24d9818f917dde97$export$aac8e996360f6ad9);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $idbiA = parcelRequire("idbiA");

var $5gKBq = parcelRequire("5gKBq");
const $24d9818f917dde97$export$aac8e996360f6ad9 = ({ children: children, defaultCollapsed: defaultCollapsed })=>{
    const initialState = typeof defaultCollapsed === 'boolean' ? {
        desktop: defaultCollapsed ? 'collapsed' : 'expanded',
        mobile: 'collapsed',
        flyout: 'closed',
        lastTrigger: null
    } : null;
    // Defaults to null so we can determine if the value has been set yet (for SSR)
    const [sideNavState, setSideNavState] = (0, $fsvuC.useState)(initialState);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5gKBq.SideNavVisibilityState).Provider, {
        value: sideNavState,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $idbiA.SetSideNavVisibilityState).Provider, {
            value: setSideNavState,
            children: children
        })
    });
};
$24d9818f917dde97$export$aac8e996360f6ad9.displayName = "SideNavVisibilityProvider";

});
parcelRegister("idbiA", function(module, exports) {
$parcel$export(module.exports, "SetSideNavVisibilityState", () => $8cbdb922ec6a9685$export$f6b496b07d1ea493);

var $fsvuC = parcelRequire("fsvuC");

var $iqo7S = parcelRequire("iqo7S");
const $8cbdb922ec6a9685$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $fsvuC.createContext)((0, $iqo7S.default));

});

parcelRegister("5gKBq", function(module, exports) {
$parcel$export(module.exports, "SideNavVisibilityState", () => $3b359623232c4156$export$eb04201bb6dd1e4e);

var $fsvuC = parcelRequire("fsvuC");
const $3b359623232c4156$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});



parcelRegister("c2HIo", function(module, exports) {
$parcel$export(module.exports, "useLayoutAreaSizing", () => $21a716b04fa0443d$export$f7d96a85aaf64f7c);

var $fsvuC = parcelRequire("fsvuC");

var $BFYYG = parcelRequire("BFYYG");

var $b1omk = parcelRequire("b1omk");
function $21a716b04fa0443d$export$f7d96a85aaf64f7c({ area: area, config: config }) {
    const context = (0, $fsvuC.useContext)((0, $BFYYG.LayoutAreaSizingContext));
    const { requestedWidth: requestedWidth, defaultWidth: defaultWidth, compactDefaultWidth: compactDefaultWidth, minWidth: minWidth, maxWidth: maxWidth, isOpen: isOpen, onRequestClose: onRequestClose } = config;
    const registerArea = context?.registerArea;
    const unregisterArea = context?.unregisterArea;
    const startAreaResize = context?.startResize;
    const resizeArea = context?.resize;
    const completeAreaResize = context?.completeResize;
    const getAreaResizeBounds = context?.getResizeBounds;
    const state = (0, $fsvuC.useContext)((0, $b1omk.layoutAreaStateContexts)[area]);
    // Dismissal is not a sizing input. Register a stable delegate while keeping
    // the consumer's latest committed callback outside allocation state.
    const onRequestCloseRef = (0, $fsvuC.useRef)(onRequestClose);
    (0, $fsvuC.useEffect)(()=>{
        onRequestCloseRef.current = onRequestClose;
    }, [
        onRequestClose
    ]);
    const requestClose = (0, $fsvuC.useCallback)(()=>onRequestCloseRef.current?.(), []);
    (0, $fsvuC.useEffect)(()=>{
        registerArea?.(area, {
            requestedWidth: requestedWidth,
            defaultWidth: defaultWidth,
            compactDefaultWidth: compactDefaultWidth,
            minWidth: minWidth,
            maxWidth: maxWidth,
            isOpen: isOpen,
            onRequestClose: requestClose
        });
    }, [
        area,
        compactDefaultWidth,
        defaultWidth,
        isOpen,
        maxWidth,
        minWidth,
        registerArea,
        requestClose,
        requestedWidth
    ]);
    (0, $fsvuC.useEffect)(()=>()=>unregisterArea?.(area), [
        area,
        unregisterArea
    ]);
    const startResize = (0, $fsvuC.useCallback)((mode)=>startAreaResize?.(area, mode), [
        area,
        startAreaResize
    ]);
    const resize = (0, $fsvuC.useCallback)((mode, width)=>resizeArea?.(area, mode, width), [
        area,
        resizeArea
    ]);
    const completeResize = (0, $fsvuC.useCallback)((mode, width)=>completeAreaResize?.(area, mode, width), [
        area,
        completeAreaResize
    ]);
    const getResizeBounds = (0, $fsvuC.useCallback)(()=>getAreaResizeBounds?.(area), [
        area,
        getAreaResizeBounds
    ]);
    return {
        state: state,
        startResize: startResize,
        resize: resize,
        completeResize: completeResize,
        getResizeBounds: getResizeBounds,
        isManaged: context !== null,
        prepareResize: context?.prepareResize
    };
}

});

parcelRegister("lYppp", function(module, exports) {
$parcel$export(module.exports, "useLayoutId", () => $c208a285e1477049$export$110c3550c7c1c9aa);

var $awBdA = parcelRequire("awBdA");
function $c208a285e1477049$export$110c3550c7c1c9aa({ providedId: providedId } = {}) {
    const uniqueId = (0, $awBdA.useSkipLinkId)();
    const id = providedId ? providedId : uniqueId;
    return id;
}

});
parcelRegister("awBdA", function(module, exports) {
$parcel$export(module.exports, "useSkipLinkId", () => $99f34335d98cd8f1$export$fa3cfac0c8e29c5c);

var $k9FWI = parcelRequire("k9FWI");
function $99f34335d98cd8f1$export$fa3cfac0c8e29c5c() {
    const uniqueId = (0, $k9FWI.useId)();
    return uniqueId;
}

});


parcelRegister("e3hSW", function(module, exports) {
$parcel$export(module.exports, "useResizingWidthCssVarOnRootElement", () => $357d80b6388acae0$export$d4931ecf0fbcc8fc);

var $fsvuC = parcelRequire("fsvuC");

var $gKvs9 = parcelRequire("gKvs9");

var $k0iCs = parcelRequire("k0iCs");

var $gAEEt = parcelRequire("gAEEt");
function $357d80b6388acae0$export$d4931ecf0fbcc8fc({ isEnabled: isEnabled = true, cssVar: cssVar, panelId: panelId }) {
    (0, $fsvuC.useEffect)(()=>{
        if (!isEnabled) return;
        return (0, $k0iCs.combine)((0, $gKvs9.monitorForElements)({
            canMonitor ({ source: source }) {
                return source.data.panelId === panelId;
            },
            onDrag ({ source: source }) {
                if (!(0, $gAEEt.isPanelSplitterDragData)(source.data)) return;
                /**
					 * Copies the resizing width value to the `<html>` element.
					 *
					 * Required to reflect the live width of the side navigation.
					 *
					 * Used by:
					 *   - Legacy `--leftSidebarWidth` variable
					 *   - Panel slot max-width constraint
					 *
					 * When the legacy `--leftSidebarWidth` variable is no longer needed,
					 * we could consider writing to the `Panel` element instead.
					 */ document.documentElement.style.setProperty(cssVar, source.data.resizingWidth);
            },
            onDrop () {
                document.documentElement.style.removeProperty(cssVar);
            }
        }));
    }, [
        cssVar,
        isEnabled,
        panelId
    ]);
    (0, $fsvuC.useEffect)(()=>{
        if (!isEnabled) return;
        /**
		 * Ensures that the resizing CSS var on the `<html>` element is cleaned up properly
		 * if the component unmounts during a drag.
		 */ return function cleanupGlobalResizingCssVar() {
            document.documentElement.style.removeProperty(cssVar);
        };
    }, [
        cssVar,
        isEnabled
    ]);
}

});
parcelRegister("gAEEt", function(module, exports) {
$parcel$export(module.exports, "isPanelSplitterDragData", () => $86cb41d21ba6850b$export$e239b3966b677000);

var $ieEsD = parcelRequire("ieEsD");
function $86cb41d21ba6850b$export$e239b3966b677000(data) {
    return data[0, $ieEsD.panelSplitterDragDataSymbol] === true;
}

});
parcelRegister("ieEsD", function(module, exports) {
$parcel$export(module.exports, "panelSplitterDragDataSymbol", () => $cf052ddbcaae1226$export$64f49ceb7f6e9a23);
const $cf052ddbcaae1226$export$64f49ceb7f6e9a23 = Symbol('panel-splitter-drag-data');

});



parcelRegister("7RD7t", function(module, exports) {
$parcel$export(module.exports, "useSafeDefaultWidth", () => $c6e9d8f87ccc2d9f$export$cff429d7d83ba1f0);
/**
 * Returns the `fallbackWidth` if the provided `defaultWidthProp` is not an integer value.
 */ function $c6e9d8f87ccc2d9f$export$cff429d7d83ba1f0({ defaultWidthProp: defaultWidthProp, fallbackDefaultWidth: fallbackDefaultWidth, slotName: slotName }) {
    // If the provided `defaultWidth` is invalid then we use our fallback.
    // We are using a runtime check because some invalid numbers like `NaN` are not caught by types,
    // and we saw some issues in products where our experience broke due to this.
    if (!Number.isInteger(defaultWidthProp)) return fallbackDefaultWidth;
    return defaultWidthProp;
}

});

parcelRegister("8YYZx", function(module, exports) {
$parcel$export(module.exports, "bindOpenLayerChange", () => $4f8f669b90e34d49$export$f4f80a09122f514a);

var $dqdTY = parcelRequire("dqdTY");
function $4f8f669b90e34d49$export$f4f80a09122f514a({ within: within, onChange: onChange }) {
    let isBound = true;
    function listener() {
        onChange();
    }
    function deferredListener() {
        queueMicrotask(()=>{
            if (isBound) onChange();
        });
    }
    const unbind = (0, $dqdTY.bindAll)(within, [
        {
            type: 'beforetoggle',
            listener: deferredListener,
            options: {
                capture: true
            }
        },
        {
            type: 'toggle',
            listener: listener,
            options: {
                capture: true
            }
        },
        {
            type: 'close',
            listener: listener,
            options: {
                capture: true
            }
        }
    ]);
    return function cleanup() {
        isBound = false;
        unbind();
    };
}

});

// Note: this value has been pulled into a separate file to better
// support testing with Playwright. Playwright did not like importing
// an exported value from `sidenav.tsx` which has `@jsxRuntime classic`.
//
// Error:
// > importSource cannot be set when runtime is classic.
/**
 * How long the flyout should remain open after the users
 * pointer has left the side nav flyout
 */ const $506751ca64a81ea5$export$a7801e29f563faad = 400;

parcelRegister("1IQui", function(module, exports) {
$parcel$export(module.exports, "sideNavToggleTooltipKeyboardShortcut", () => $7ba719d1baf40105$export$bcd616a79072c3e4);
/**
 * The keyboard shortcut used in tooltips for indicating how to toggle the side nav.
 *
 * Used in `SideNavToggleButton` and `SideNavPanelSplitter` tooltips.
 */ const $7ba719d1baf40105$export$bcd616a79072c3e4 = [
    'Ctrl',
    '['
];

});

parcelRegister("9Ofex", function(module, exports) {
$parcel$export(module.exports, "useExpandSideNav", () => $a2ffd7e379d4bc12$export$e44b4744d8ff971a);

var $fsvuC = parcelRequire("fsvuC");

var $80czl = parcelRequire("80czl");

var $dqdTY = parcelRequire("dqdTY");

var $5T6N9 = parcelRequire("5T6N9");

var $idbiA = parcelRequire("idbiA");

var $6a1tO = parcelRequire("6a1tO");
/**
 * Moves focus to the first focusable item in the side nav, or the side nav element itself as a fallback.
 */ function $a2ffd7e379d4bc12$var$focusFirstNavItem(sideNavElement) {
    /**
	 * Try to get the first focusable item in the side nav.
	 * The selector is not very broad, but should be appropriate for items from this package.
	 */ const firstNavItem = sideNavElement.querySelector('a, button');
    const isFirstNavItemVisible = firstNavItem !== null && (firstNavItem.checkVisibility?.() ?? false);
    const itemToFocus = isFirstNavItemVisible ? firstNavItem : sideNavElement;
    if (itemToFocus === sideNavElement) {
        /**
		 * Elements without an explicit `tabindex` attribute are not guaranteed to be focusable:
		 * https://html.spec.whatwg.org/multipage/interaction.html#attr-tabindex
		 *
		 * Our slots are not interactive, so this is required.
		 *
		 * In the future we may want to check if there is an existing `tabindex` attribute,
		 * as custom skip linked elements might already have one.
		 */ sideNavElement.setAttribute('tabindex', '-1');
        /**
		 * Cleanup the `tabindex` attribute we set when the slot or custom target loses focus.
		 *
		 * This is preferable to always having `tabindex="-1"` because always applying the tab index can:
		 *
		 * - mess with click events
		 * - potentially cause a focus ring to be always visible
		 */ (0, $dqdTY.bind)(sideNavElement, {
            type: 'blur',
            listener () {
                sideNavElement.removeAttribute('tabindex');
            },
            options: {
                once: true
            }
        });
    }
    /**
	 * Not using `focusVisible` option because we don't want clicks on the toggle button to show a focus ring.
	 */ itemToFocus.focus();
}
const $a2ffd7e379d4bc12$var$triggersWithFocusOnExpand = new Set([
    'toggle-button',
    'skip-link'
]);
function $a2ffd7e379d4bc12$export$e44b4744d8ff971a({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $fsvuC.useContext)((0, $idbiA.SetSideNavVisibilityState));
    const sideNavRef = (0, $6a1tO.useSideNavRef)();
    const expandSideNav = (0, $fsvuC.useCallback)(()=>{
        const { matches: isDesktop } = window.matchMedia('(min-width: 64rem)');
        const runUpdate = ()=>{
            if (isDesktop) setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                // Skip the re-render if it's a no-op change
                if (currentState.desktop === 'expanded' && currentState.flyout === 'closed') return currentState;
                return {
                    mobile: currentState.mobile,
                    desktop: 'expanded',
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
            else setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                // Skip the re-render if it's a no-op change
                if (currentState.mobile === 'expanded' && currentState.flyout === 'closed') return currentState;
                return {
                    desktop: currentState.desktop,
                    mobile: 'expanded',
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
        };
        if ($a2ffd7e379d4bc12$var$triggersWithFocusOnExpand.has(trigger) && (0, $5T6N9.fg)('platform_dst_nav4_skip_link_a11y_1')) {
            (0, $80czl.flushSync)(runUpdate);
            const sideNavElement = sideNavRef.current;
            if (sideNavElement) $a2ffd7e379d4bc12$var$focusFirstNavItem(sideNavElement);
        } else runUpdate();
    }, [
        setSideNavState,
        sideNavRef,
        trigger
    ]);
    return expandSideNav;
}

});
parcelRegister("6a1tO", function(module, exports) {
$parcel$export(module.exports, "useSideNavRef", () => $5cfa43cf69eadedc$export$fa4d0cff03b1ea4f);

var $fsvuC = parcelRequire("fsvuC");

var $2ee9Q = parcelRequire("2ee9Q");
function $5cfa43cf69eadedc$export$fa4d0cff03b1ea4f() {
    return (0, $fsvuC.useContext)((0, $2ee9Q.SideNavRefContext));
}

});


parcelRegister("eJT0F", function(module, exports) {
$parcel$export(module.exports, "useIsSideNavShortcutEnabled", () => $050f8dafd4fc6e4c$export$be30cdcd17f95ec7);

var $fsvuC = parcelRequire("fsvuC");

var $i0PKj = parcelRequire("i0PKj");
function $050f8dafd4fc6e4c$export$be30cdcd17f95ec7() {
    return (0, $fsvuC.useContext)((0, $i0PKj.IsSideNavShortcutEnabledContext));
}

});

parcelRegister("gK2XA", function(module, exports) {
$parcel$export(module.exports, "useSideNavToggleKeyboardShortcut", () => $d1241db1f485c9c4$export$f762e7ac9d86adb0);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $k3Yn7 = parcelRequire("k3Yn7");

var $lsWhN = parcelRequire("lsWhN");

var $5T6N9 = parcelRequire("5T6N9");

var $kusdB = parcelRequire("kusdB");

var $7WPU3 = parcelRequire("7WPU3");

var $eJT0F = parcelRequire("eJT0F");

var $lGVkp = parcelRequire("lGVkp");
function $d1241db1f485c9c4$export$f762e7ac9d86adb0({ canToggleWithShortcut: canToggleWithShortcut }) {
    const openLayerObserver = (0, $lsWhN.useOpenLayerObserver)({
        isEnabled: !(0, $5T6N9.fg)('platform-dst-top-layer')
    });
    const toggleVisibilityByShortcut = (0, $lGVkp.useToggleSideNav)({
        trigger: 'keyboard'
    });
    const canToggleWithShortcutStableRef = (0, $k3Yn7.default)(canToggleWithShortcut);
    const isSideNavShortcutEnabled = (0, $eJT0F.useIsSideNavShortcutEnabled)();
    (0, $fsvuC.useEffect)(()=>{
        if (!isSideNavShortcutEnabled) return;
        return (0, $dqdTY.bind)(window, {
            type: 'keydown',
            listener (event) {
                if (event.ctrlKey && event.key === '[') {
                    if (canToggleWithShortcutStableRef.current && !canToggleWithShortcutStableRef.current()) // Return early if the callback returns false.
                    // If the callback is not provided, we assume the shortcut is enabled.
                    return;
                    if (event.repeat) // Ignore repeated keydown events from holding down the keys
                    return;
                    if ((0, $5T6N9.fg)('platform-dst-top-layer') && (0, $kusdB.hasOpenDialogOrPopover)({
                        type: 'modal'
                    })) // Return early if there are any open modal dialogs
                    return;
                    if (openLayerObserver && openLayerObserver.getCount({
                        type: 'modal'
                    }) > 0) // Return early if there are any open modals
                    return;
                    // Not gated. Top-layer tooltips (`platform-dst-top-layer-tooltip`) are not known to the observer.
                    (0, $7WPU3.requestClosePopovers)();
                    openLayerObserver?.closeLayers();
                    toggleVisibilityByShortcut();
                }
            }
        });
    }, [
        canToggleWithShortcutStableRef,
        isSideNavShortcutEnabled,
        openLayerObserver,
        toggleVisibilityByShortcut
    ]);
}

});
parcelRegister("lGVkp", function(module, exports) {
$parcel$export(module.exports, "useToggleSideNav", () => $2d9351746aa173b8$export$477ee35601a0a8ce);

var $fsvuC = parcelRequire("fsvuC");

var $5T6N9 = parcelRequire("5T6N9");

var $idbiA = parcelRequire("idbiA");

var $5gKBq = parcelRequire("5gKBq");

var $9Ofex = parcelRequire("9Ofex");
function $2d9351746aa173b8$export$477ee35601a0a8ce({ trigger: trigger = 'programmatic' } = {}) {
    const setSideNavState = (0, $fsvuC.useContext)((0, $idbiA.SetSideNavVisibilityState));
    const sideNavState = (0, $fsvuC.useContext)((0, $5gKBq.SideNavVisibilityState));
    const expandSideNav = (0, $9Ofex.useExpandSideNav)({
        trigger: trigger
    });
    const isCollapsedOnDesktop = sideNavState?.desktop === 'collapsed';
    const isCollapsedOnMobile = sideNavState?.mobile === 'collapsed';
    const toggleSideNav = (0, $fsvuC.useCallback)(()=>{
        const { matches: isDesktop } = window.matchMedia('(min-width: 64rem)');
        if ((0, $5T6N9.fg)('platform_dst_nav4_skip_link_a11y_1')) {
            const isExpanding = isDesktop ? isCollapsedOnDesktop : isCollapsedOnMobile;
            if (isExpanding) expandSideNav();
            else setSideNavState((currentState)=>{
                // No-op if the side nav state has not been initialised yet
                // e.g. if the SideNav has not been mounted yet
                if (!currentState) return null;
                return {
                    mobile: isDesktop ? currentState.mobile : 'collapsed',
                    desktop: isDesktop ? 'collapsed' : currentState.desktop,
                    flyout: 'closed',
                    lastTrigger: trigger
                };
            });
            return;
        }
        if (isDesktop) setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            return {
                mobile: currentState.mobile,
                desktop: currentState.desktop === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
        else setSideNavState((currentState)=>{
            // No-op if the side nav state has not been initialised yet
            // e.g. if the SideNav has not been mounted yet
            if (!currentState) return null;
            return {
                desktop: currentState.desktop,
                mobile: currentState.mobile === 'expanded' ? 'collapsed' : 'expanded',
                flyout: 'closed',
                lastTrigger: trigger
            };
        });
    }, [
        expandSideNav,
        isCollapsedOnDesktop,
        isCollapsedOnMobile,
        setSideNavState,
        trigger
    ]);
    return toggleSideNav;
}

});


parcelRegister("jhX8I", function(module, exports) {
$parcel$export(module.exports, "useSideNavVisibility", () => $b4f5de71b1c7dae7$export$4a602ad7e09bdb2c);

var $fsvuC = parcelRequire("fsvuC");

var $5gKBq = parcelRequire("5gKBq");
const $b4f5de71b1c7dae7$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
    const sideNavState = (0, $fsvuC.useContext)((0, $5gKBq.SideNavVisibilityState));
    // If the context value is `null`, it means we are still in SSR, and should use the default values.
    // For desktop, it comes from the `defaultCollapsed` prop, and for mobile, it is always `false`.
    if (sideNavState === null) return {
        isExpandedOnDesktop: !defaultCollapsed,
        isExpandedOnMobile: false
    };
    return {
        isExpandedOnDesktop: sideNavState.desktop === 'expanded',
        isExpandedOnMobile: sideNavState.mobile === 'expanded'
    };
};

});

parcelRegister("77Daw", function(module, exports) {
$parcel$export(module.exports, "useSideNavVisibilityCallbacks", () => $45cff059e5a76520$export$1904b8f2577aba9a);

var $fsvuC = parcelRequire("fsvuC");

var $822dj = parcelRequire("822dj");
function $45cff059e5a76520$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, isExpandedOnDesktop: isExpandedOnDesktop, isExpandedOnMobile: isExpandedOnMobile, lastTrigger: lastTrigger }) {
    // Wrapping in refs so we can call them in `useEffect` without changes to them triggering the `useEffect`
    const onExpandRef = (0, $fsvuC.useRef)(onExpand);
    const onCollapseRef = (0, $fsvuC.useRef)(onCollapse);
    (0, $fsvuC.useEffect)(()=>{
        onExpandRef.current = onExpand;
        onCollapseRef.current = onCollapse;
    }, [
        onExpand,
        onCollapse
    ]);
    const previousIsExpandedOnDesktop = (0, $822dj.default)(isExpandedOnDesktop);
    (0, $fsvuC.useEffect)(()=>{
        if (previousIsExpandedOnDesktop === undefined || previousIsExpandedOnDesktop === isExpandedOnDesktop) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnDesktop) onExpandRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'desktop',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnDesktop,
        isExpandedOnDesktop,
        lastTrigger
    ]);
    const previousIsExpandedOnMobile = (0, $822dj.default)(isExpandedOnMobile);
    (0, $fsvuC.useEffect)(()=>{
        if (previousIsExpandedOnMobile === undefined || previousIsExpandedOnMobile === isExpandedOnMobile) /**
			 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
			 *
			 * The previous value can be equal to the current one if the component re-renders due to something else changing.
			 *
			 * In both cases the value hasn't changed and we don't want to notify consumers.
			 */ return;
        if (isExpandedOnMobile) onExpandRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
        else onCollapseRef.current?.({
            screen: 'mobile',
            trigger: lastTrigger
        });
    }, [
        previousIsExpandedOnMobile,
        isExpandedOnMobile,
        lastTrigger
    ]);
}

});


parcelRegister("7GTPw", function(module, exports) {
$parcel$export(module.exports, "SideNavHeader", () => $652e02b93d01434c$export$9d28ff3a0d89869c);
/* side-nav-header.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $652e02b93d01434c$var$styles = {
    root: "_2Y7lL48HPE _46hvQm8HPE _0xmtko1Y8M"
};
const $652e02b93d01434c$export$9d28ff3a0d89869c = ({ children: children })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            $652e02b93d01434c$var$styles.root
        ]),
        children: children
    });
};
$652e02b93d01434c$export$9d28ff3a0d89869c.displayName = "SideNavHeader";

});

parcelRegister("9YTPO", function(module, exports) {
$parcel$export(module.exports, "SideNavBody", () => $40d5aa5eba3ccc26$export$28f21f3651df4fa1);
/* side-nav-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");
const $40d5aa5eba3ccc26$export$28f21f3651df4fa1 = /*#__PURE__*/ (0, $fsvuC.forwardRef)($40d5aa5eba3ccc26$var$_SideNavContent);
// Placing this const below the function breaks Compiled!
const $40d5aa5eba3ccc26$var$styles = {
    scrollContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAIZbP _2WAcuGIZbP",
    paddingContainer: "_46hvQm8HPE _03SyCP8HPE _0xmtko8HPE _0LQT5E8HPE"
};
function $40d5aa5eba3ccc26$var$_SideNavContent({ children: children, testId: testId }, forwardedRef) {
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: forwardedRef,
        "data-testid": testId,
        className: (0, $gJ6nT.default)([
            $40d5aa5eba3ccc26$var$styles.scrollContainer
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
            className: (0, $gJ6nT.default)([
                $40d5aa5eba3ccc26$var$styles.paddingContainer
            ]),
            children: children
        })
    });
}

});

parcelRegister("6rVbP", function(module, exports) {
$parcel$export(module.exports, "SideNavFooter", () => $c352ef8c244dceaa$export$b773c4c9cf740fbe);
/* side-nav-footer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $c352ef8c244dceaa$var$styles = {
    root: "_46hvQm8HPE _03SyCP8HPE _0xmtko8HPE _0LQT5E8HPE _0vfIXINvrM _4hyvPa6wH8 _1KhSQW9r67"
};
const $c352ef8c244dceaa$export$b773c4c9cf740fbe = ({ children: /**
   * The content of the layout area.
   */ children, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            $c352ef8c244dceaa$var$styles.root,
            xcss
        ]),
        children: children
    });
};
$c352ef8c244dceaa$export$b773c4c9cf740fbe.displayName = "SideNavFooter";

});

parcelRegister("cdJPv", function(module, exports) {
$parcel$export(module.exports, "SideNavToggleButton", () => $0c5c24d93c37a843$export$8bd77667631fec25);
/* toggle-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $hkZUI = parcelRequire("hkZUI");

var $dVPyc = parcelRequire("dVPyc");

var $9s66L = parcelRequire("9s66L");

var $lsWhN = parcelRequire("lsWhN");

var $5T6N9 = parcelRequire("5T6N9");

var $7WPU3 = parcelRequire("7WPU3");

var $58UFo = parcelRequire("58UFo");

var $3P30h = parcelRequire("3P30h");

var $1IQui = parcelRequire("1IQui");

var $5gKBq = parcelRequire("5gKBq");

var $eJT0F = parcelRequire("eJT0F");

var $jhX8I = parcelRequire("jhX8I");

var $lGVkp = parcelRequire("lGVkp");
const $0c5c24d93c37a843$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true,
    // A press swaps the label between `collapseLabel` and `expandLabel`, so keep the
    // tooltip open to show the new label.
    hasNewContentOnTriggerClick: true
};
// For duplicate "mouseenter" issue when changing icons (see below)
const $0c5c24d93c37a843$var$silentIconStyles = null;
const $0c5c24d93c37a843$export$8bd77667631fec25 = ({ defaultCollapsed: defaultCollapsed = false, expandLabel: expandLabel, collapseLabel: collapseLabel, testId: testId, interactionName: interactionName, onClick: onClick })=>{
    const { isExpandedOnDesktop: isSideNavExpandedOnDesktop, isExpandedOnMobile: isSideNavExpandedOnMobile } = (0, $jhX8I.useSideNavVisibility)({
        defaultCollapsed: defaultCollapsed
    });
    const sideNavState = (0, $fsvuC.useContext)((0, $5gKBq.SideNavVisibilityState));
    // When default state is provided to `Root` the state in context will already be
    // initialized in SSR
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $fsvuC.useState)(sideNavState === null ? !defaultCollapsed : isSideNavExpandedOnDesktop);
    const ref = (0, $fsvuC.useContext)((0, $3P30h.SideNavToggleButtonAttachRef));
    /**
   * Addresses HOT-121458 by ensuring that the toggle button element in context is always up to date.
   *
   * My theory is that something to do with SSR, hydration and suspense was causing the
   * underlying HTML element to change but without causing the toggle button to remount.
   *
   * This meant the effect calling `ref()` did not re-run, and the value in context became stale.
   */ const [element, setElement] = (0, $fsvuC.useState)(null);
    (0, $fsvuC.useEffect)(()=>{
        ref(element);
    }, [
        element,
        ref
    ]);
    (0, $fsvuC.useEffect)(()=>{
        const { matches: matches } = window.matchMedia('(min-width: 64rem)');
        setIsSideNavExpanded(matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    (0, $fsvuC.useEffect)(()=>{
        // When screen size changes, ensure we use the correct visibility state
        const mediaQueryList = window.matchMedia('(min-width: 64rem)');
        return (0, $dqdTY.bind)(mediaQueryList, {
            type: 'change',
            listener () {
                setIsSideNavExpanded(mediaQueryList.matches ? isSideNavExpandedOnDesktop : isSideNavExpandedOnMobile);
            }
        });
    }, [
        isSideNavExpandedOnDesktop,
        isSideNavExpandedOnMobile
    ]);
    const toggleVisibility = (0, $lGVkp.useToggleSideNav)({
        trigger: 'toggle-button'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $hkZUI.useAnalyticsEvents)();
    const openLayerObserver = (0, $lsWhN.useOpenLayerObserver)({
        isEnabled: !(0, $5T6N9.fg)('platform-dst-top-layer')
    });
    const handleClick = (0, $fsvuC.useCallback)((event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent, {
            isSideNavVisible: isSideNavExpanded
        });
        toggleVisibility();
        // Not gated. Top-layer tooltips (`platform-dst-top-layer-tooltip`) are not known to the observer.
        (0, $7WPU3.requestClosePopovers)();
        openLayerObserver?.closeLayers();
    }, [
        isSideNavExpanded,
        onClick,
        openLayerObserver,
        toggleVisibility
    ]);
    const handlePointerEnter = (0, $fsvuC.useCallback)(()=>{
        // Hovers don't do anything on mobile, so not capturing
        const isDesktop = window.matchMedia('(min-width: 64rem)').matches;
        if (!isDesktop) return;
        const navigationAnalyticsEvent = createAnalyticsEvent({
            source: 'topNav',
            actionSubject: 'sideNav',
            action: 'hovered',
            actionSubjectId: 'sideNavButton',
            attributes: {
                itemState: isSideNavExpanded ? 'expanded' : 'collapsed',
                screen: 'desktop'
            }
        });
        navigationAnalyticsEvent.fire('navigation');
    }, [
        createAnalyticsEvent,
        isSideNavExpanded
    ]);
    /**
   * ## Behaviour
   * It is intentional that collapse icon will be used while the flyout is open.
   * The icon is tied to the expanded / collapse state, and not the flyout state.
   *
   * ## Why a function?
   * Unfortunately, changing the icon inside an <IconButton> when the user is over
   * the button will cause the svg element to be replaced, which can trigger a
   * "mouseenter" event. This is problematic when the user is already over the button,
   * as it can result in a "mouseenter" event after the user manually entered the button.
   *
   * `icon` accepts a function for the `icon` prop (ie a render prop), so we don't need to
   * memoize it, or pull it out into a new function
   */ const icon = (props)=>/*#__PURE__*/ (0, $5chsV.jsx)("span", {
            className: (0, $gJ6nT.default)([
                "_3iDTPbcK7c _1pp6NdYbGa"
            ]),
            children: isSideNavExpanded ? /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dVPyc))), {
                ...props
            }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9s66L))), {
                ...props
            })
        });
    const isShortcutEnabled = (0, $eJT0F.useIsSideNavShortcutEnabled)();
    const tooltipProps = (0, $fsvuC.useMemo)(()=>({
            ...$0c5c24d93c37a843$var$toggleButtonTooltipOptions,
            shortcut: isShortcutEnabled ? (0, $1IQui.sideNavToggleTooltipKeyboardShortcut) : undefined
        }), [
        isShortcutEnabled
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $58UFo.IconButton), {
        appearance: "subtle",
        label: isSideNavExpanded ? collapseLabel : expandLabel,
        icon: icon,
        onClick: handleClick,
        onPointerEnter: handlePointerEnter,
        testId: testId,
        isTooltipDisabled: false,
        interactionName: interactionName,
        ref: setElement,
        tooltip: tooltipProps
    });
};
$0c5c24d93c37a843$export$8bd77667631fec25.displayName = "SideNavToggleButton";

});
parcelRegister("58UFo", function(module, exports) {
$parcel$export(module.exports, "IconButton", () => $7b1c543d6d3dc2e7$export$c25acd513dcc8062);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $8gTjU = parcelRequire("8gTjU");

var $e2VD8 = parcelRequire("e2VD8");

var $7tjD6 = parcelRequire("7tjD6");
const $7b1c543d6d3dc2e7$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $e2VD8.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $7tjD6.ThemedIconButton) : (0, $8gTjU.default);
    return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("e2VD8", function(module, exports) {
$parcel$export(module.exports, "HasCustomThemeContext", () => $d9d857dfd3d8c7c7$export$d158fa15757a1890);
$parcel$export(module.exports, "useHasCustomTheme", () => $d9d857dfd3d8c7c7$export$abfcaeeca4ae7a55);

var $fsvuC = parcelRequire("fsvuC");
const $d9d857dfd3d8c7c7$export$d158fa15757a1890 = /*#__PURE__*/ (0, $fsvuC.createContext)(false);
function $d9d857dfd3d8c7c7$export$abfcaeeca4ae7a55() {
    return (0, $fsvuC.useContext)($d9d857dfd3d8c7c7$export$d158fa15757a1890);
}

});

parcelRegister("7tjD6", function(module, exports) {
$parcel$export(module.exports, "ThemedIconButton", () => $15a1bae76ff19e0a$export$d9c2d067feb61447);
/* themed-icon-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $1cXpO = parcelRequire("1cXpO");

var $f4lus = parcelRequire("f4lus");

var $01oqo = parcelRequire("01oqo");

var $jQC6P = parcelRequire("jQC6P");

var $gCNxI = parcelRequire("gCNxI");
const $15a1bae76ff19e0a$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(function ThemedIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $f4lus.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $5chsV.jsxs)((0, $gCNxI.ThemedPressable), {
                ...props,
                shape: "square",
                ref: (0, $1cXpO.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $jQC6P.default), {
                        icon: Icon
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $01oqo.default), {
                        children: label
                    })
                ]
            })
    });
});

});
parcelRegister("jQC6P", function(module, exports) {
$parcel$export(module.exports, "default", () => $6993306b9740d931$export$2e2bcd8739ae039);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $5T6N9 = parcelRequire("5T6N9");
function $6993306b9740d931$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 * This is copied from @atlaskit/button to render IconButtons. Some IconButton's DOM element
 * will be re-created during SSR -> SPA hydration without using this, which delays TTVC. As
 * IconRenderer is already used in @atlaskit/button to mitigate this issue, add it here to
 * mitigate the same issue for IconButtons in navigation-system, especially for ThemedIconButton.
 *
 */ const $6993306b9740d931$var$IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $6993306b9740d931$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $5T6N9.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-expect-error -- The render-prop guard returns IconProp (a component type), which is not a ReactNode.
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5chsV.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $5chsV.jsx)(Icon, {
            ...iconProps
        })
    });
};
$6993306b9740d931$var$IconRenderer.displayName = "IconRenderer";
var $6993306b9740d931$export$2e2bcd8739ae039 = $6993306b9740d931$var$IconRenderer;

});

parcelRegister("gCNxI", function(module, exports) {
$parcel$export(module.exports, "ThemedPressable", () => $22c6870b81b4ab5d$export$66240319f1f78d74);
/* themed-pressable.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $4twf9 = parcelRequire("4twf9");

var $bRV0V = parcelRequire("bRV0V");

var $l413Q = parcelRequire("l413Q");
const $22c6870b81b4ab5d$var$styles = {
    root: "_2mHwu8gVvo _2sNsIgmnOE _0bjKvDKTcp _23rrnHyKLB _00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _4c065UPgdg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VymQ6 _1mT5xdRAKS _3WzCGiyL8i _32C2rkyL8i _0DCa9DyL8i _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8 _3sFUREiSCN",
    border: "_2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _0GBAIrogpp _2WYcYGWVPG",
    selected: "_2uo31fhe06 _1UtDYzysOt _0z8nYC0GCl _10n1R5ysOt _2nTuUYysOt _30zrXRUQDy _0clgaMysOt _1gxogc4k8R _0CMRbkysOt",
    disabled: "_2uo31ftHCb _1UtDYzn3Ip _0z8nYCs4Fm _10n1R5n3Ip _2nTuUYn3Ip _30zrXRtHCb _0clgaMn3Ip _1gxogctHCb _0CMRbkn3Ip"
};
const $22c6870b81b4ab5d$var$shapeStyles = {
    default: "_2Y7lL48HPE",
    square: "_2Y7lL4Pgdg _39xV02ymQ6 _26BoRwdnbC"
};
const $22c6870b81b4ab5d$var$appearanceStyles = {
    default: "_2uo31fGfro _1UtDYz98eZ _0z8nYCQMmr _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    subtle: "_2uo31fGfro _1UtDYz98eZ _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    primary: "_2uo31fxjIo _1UtDYzwGpT _10n1R5wGpT _2nTuUYwGpT _30zrXR2rJx _0clgaMwGpT _1gxogcHVA2 _0CMRbkwGpT"
};
const $22c6870b81b4ab5d$export$66240319f1f78d74 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref)=>{
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $bRV0V.Pressable), {
        ...(0, $l413Q.getPrimitiveSpreadProps)(props),
        ref: ref,
        type: "button",
        /**
   * We are using some style values that are outside of the strict
   * `@atlaskit/css` types.
   */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $4twf9.cx)($22c6870b81b4ab5d$var$styles.root, $22c6870b81b4ab5d$var$shapeStyles[shape], hasBorder && $22c6870b81b4ab5d$var$styles.border, $22c6870b81b4ab5d$var$appearanceStyles[appearance], isSelected && $22c6870b81b4ab5d$var$styles.selected, isDisabled && $22c6870b81b4ab5d$var$styles.disabled),
        isDisabled: isDisabled
    });
});

});
parcelRegister("l413Q", function(module, exports) {
$parcel$export(module.exports, "getPrimitiveSpreadProps", () => $9f498716220b0637$export$e4c95325a21f9785);
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ function $9f498716220b0637$export$e4c95325a21f9785({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}

});





parcelRegister("diBAM", function(module, exports) {
$parcel$export(module.exports, "SideNavPanelSplitter", () => $c89c918fe8e7675b$export$5f595addf4e50d58);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $l9kus = parcelRequire("l9kus");

var $d4nKw = parcelRequire("d4nKw");

var $lGVkp = parcelRequire("lGVkp");

var $f9HVI = parcelRequire("f9HVI");

var $2qrUZ = parcelRequire("2qrUZ");

var $6y6Kb = parcelRequire("6y6Kb");
const $c89c918fe8e7675b$export$5f595addf4e50d58 = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, shouldCollapseOnDoubleClick: shouldCollapseOnDoubleClick = true, tooltipContent: tooltipContent })=>{
    const context = (0, $fsvuC.useContext)((0, $6y6Kb.PanelSplitterContext));
    (0, $l9kus.default)(context?.panelId === (0, $d4nKw.sideNavPanelSplitterId), 'SideNavPanelSplitter must be rendered as a child of <SideNav />.');
    const toggleSideNav = (0, $lGVkp.useToggleSideNav)({
        trigger: 'double-click'
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $f9HVI.OnDoubleClickContext).Provider, {
        value: shouldCollapseOnDoubleClick ? toggleSideNav : undefined,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $2qrUZ.PanelSplitter), {
            label: label,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd,
            testId: testId,
            tooltipContent: // Only displaying the tooltip if double click to collapse is enabled.
            // Otherwise, we would be displaying a tooltip with "Double click to collapse", when it actually won't.
            shouldCollapseOnDoubleClick ? tooltipContent : undefined
        })
    });
};
$c89c918fe8e7675b$export$5f595addf4e50d58.displayName = "SideNavPanelSplitter";

});
parcelRegister("f9HVI", function(module, exports) {
$parcel$export(module.exports, "OnDoubleClickContext", () => $5e613960fd3ea478$export$e253efba824eceb);

var $fsvuC = parcelRequire("fsvuC");
const $5e613960fd3ea478$export$e253efba824eceb = /*#__PURE__*/ (0, $fsvuC.createContext)(undefined);

});

parcelRegister("2qrUZ", function(module, exports) {
$parcel$export(module.exports, "PanelSplitter", () => $d245715da7f5c890$export$db67e3f8d3d6da0f);
/* panel-splitter.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $80czl = parcelRequire("80czl");

var $dqdTY = parcelRequire("dqdTY");

var $l9kus = parcelRequire("l9kus");

var $k9FWI = parcelRequire("k9FWI");

var $k3Yn7 = parcelRequire("k3Yn7");

var $lsWhN = parcelRequire("lsWhN");

var $5T6N9 = parcelRequire("5T6N9");

var $gKvs9 = parcelRequire("gKvs9");

var $bo03n = parcelRequire("bo03n");

var $k0iCs = parcelRequire("k0iCs");

var $1A0xB = parcelRequire("1A0xB");

var $am7NR = parcelRequire("am7NR");

var $f4lus = parcelRequire("f4lus");

var $hIKfe = parcelRequire("hIKfe");

var $7WPU3 = parcelRequire("7WPU3");

var $01oqo = parcelRequire("01oqo");

var $d4nKw = parcelRequire("d4nKw");

var $BFYYG = parcelRequire("BFYYG");

var $9EEC1 = parcelRequire("9EEC1");

var $iH0NW = parcelRequire("iH0NW");

var $csVj0 = parcelRequire("csVj0");

var $lBdFx = parcelRequire("lBdFx");

var $6PgcW = parcelRequire("6PgcW");

var $gAEEt = parcelRequire("gAEEt");

var $2b4Dn = parcelRequire("2b4Dn");

var $f9HVI = parcelRequire("f9HVI");

var $6y6Kb = parcelRequire("6y6Kb");

var $ieEsD = parcelRequire("ieEsD");
function $d245715da7f5c890$var$signPanelSplitterDragData(data) {
    return {
        ...data,
        [(0, $ieEsD.panelSplitterDragDataSymbol)]: true
    };
}
const $d245715da7f5c890$var$containerStyles = {
    root: "_2xIroY98eZ _497WNwYbGa _2zndICT6kp _3iDTPbYbGa _1mT5xdWVPG _1ZB6UydnbC _2I62gzdnbC _42Yu6B7dHp _2UeR8bvLZJ",
    positionEnd: "_1OKFqYJg58",
    positionStart: "_3iC0zd1x6F"
};
const $d245715da7f5c890$var$grabAreaStyles = {
    root: "_39xV02vFgp _0jFU0VN91d _1mT5xdWVPG _46hvQmPgdg _03SyCPPgdg _0xmtkoPgdg _0LQT5EPgdg _1UtDYzs4Fm _0KLXruyL8i _3Z9K0wb8VS _3OZqoK0jWM _0qk6IKN8t6 _1kOSYtWkA1 _0ReiIHuudW _25IEJJjTy9 _0clgaMjTy9 _3sFUREYbGa _0CMRbkAwSC",
    rootFinesse: "_25IEJJWkXl _0clgaMWkXl _0CMRbkrzt2"
};
const $d245715da7f5c890$var$lineStyles = {
    root: "_1mT5xdWVPG _3iDTPbvLZJ _39xV024Y4b _0jFU0VN91d _1UtDYzOLYo _0KLXru98eZ _3iC0zdXJux"
};
const $d245715da7f5c890$var$tooltipStyles = {
    root: "_0GTcwRTUhv _39xV02W9qI",
    placedLeft: "_0GTcwRPgdg _2xTnZxTUhv"
};
const $d245715da7f5c890$var$PanelSplitterTooltip = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ children: children, className: className, ...props }, ref)=>{
    const style = (0, $fsvuC.useMemo)(()=>{
        if (!props.style || !props.style.transform) return props.style;
        // We cannot just match against integers safely, as browsers may introduce non-integer values due to scaling
        // In the future we can probably use `CSSStyleValue.parse()` to get the browser to handle parsing for us,
        // but there's no Firefox support yet.
        const [translateX, translateY] = props.style.transform.matchAll(/(?:-|\+)?\d*\.?\d+px/g);
        if (!translateY) // If we can't extract the translateY value we bail out and return the original style
        return props.style;
        /**
     * Adjusts the translate Y to keep the tooltip within the main content area,
     * so that it does not appear over the banner or top navigation.
     */ const newTranslateY = `max(calc(${(0, $d4nKw.contentInsetBlockStart)} + ${"var(--ds-space-100, 8px)"}), ${translateY})`;
        const newTransform = `translate3d(${translateX}, ${newTranslateY}, 0)`;
        return {
            ...props.style,
            transform: newTransform
        };
    }, [
        props.style
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hIKfe.default), {
        ...props,
        ref: ref,
        // Must be statically passed
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $gJ6nT.default)([
            $d245715da7f5c890$var$tooltipStyles.root,
            props.placement === 'left' && $d245715da7f5c890$var$tooltipStyles.placedLeft,
            className
        ]),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        children: children
    });
});
/**
 * A wrapper component that renders a tooltip if the tooltipContent or shortcut is provided.
 */ const $d245715da7f5c890$var$MaybeTooltip = ({ tooltipContent: tooltipContent, shortcut: shortcut, mousePosition: mousePosition, children: children, testId: testId })=>{
    if (tooltipContent) return /*#__PURE__*/ (0, $5chsV.jsx)((0, $f4lus.default), {
        testId: testId,
        content: tooltipContent,
        shortcut: shortcut,
        position: "mouse-y",
        mousePosition: mousePosition,
        isScreenReaderAnnouncementDisabled: true,
        component: $d245715da7f5c890$var$PanelSplitterTooltip,
        shouldAlwaysFadeIn: true,
        shouldRenderToParent: true,
        children: children
    });
    return children;
};
$d245715da7f5c890$var$MaybeTooltip.displayName = "MaybeTooltip";
// Browsers increase an RTL range input's value on ArrowLeft, so the arrow key pointing towards the
// panel's growth side widens it.
const $d245715da7f5c890$var$rangeInputDirs = {
    left: 'rtl',
    right: 'ltr'
};
function $d245715da7f5c890$var$getTextDirection(element) {
    const { direction: direction } = window.getComputedStyle(element);
    return direction === 'rtl' ? 'rtl' : 'ltr';
}
const $d245715da7f5c890$var$PortaledPanelSplitter = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, onResizeStartInternal: onResizeStartInternal, onResizeInternal: onResizeInternal, prepareResize: prepareResize, getResizeBounds: getResizeBounds, panel: panel, portal: portal, resizingCssVar: resizingCssVar, resizingElementRef: resizingElementRef, position: position, tooltipContent: tooltipContent, shortcut: shortcut })=>{
    const splitterRef = (0, $fsvuC.useRef)(null);
    const registerSplitter = (0, $fsvuC.useContext)((0, $BFYYG.LayoutAreaSizingContext))?.registerSplitter;
    const unregisterSplitter = (0, $fsvuC.useRef)(undefined);
    const setSplitterRef = (0, $fsvuC.useCallback)((element)=>{
        unregisterSplitter.current?.();
        splitterRef.current = element;
        unregisterSplitter.current = element && prepareResize ? registerSplitter?.(element) : undefined;
    }, [
        prepareResize,
        registerSplitter
    ]);
    const labelId = (0, $k9FWI.useId)();
    const panelGrowthSide = (0, $fsvuC.useMemo)(()=>(0, $5T6N9.fg)('platform-dst-panel-splitter-resize-direction') ? (0, $iH0NW.getPanelGrowthSide)({
            position: position,
            textDirection: $d245715da7f5c890$var$getTextDirection(panel)
        }) : undefined, [
        position,
        panel
    ]);
    // Separate state used for the input range width to remove the UI's dependency on the "persisted" layout state value being updated
    const [rangeInputValue, setRangeInputValue] = (0, $fsvuC.useState)(panelWidth);
    /**
   * We are using state to store the resize bounds _converted into pixel units_, so that we can update them when the window is resized.
   * Otherwise they can become out of sync with the actual viewport size, and cause a broken experience (inaccurate width percentage)
   * when the user tries to resize using the keyboard.
   */ const [rangeInputBounds, setRangeInputBounds] = (0, $fsvuC.useState)({
        // Using placeholder values here for the initial render. These will be calculated and updated when the range input is focused.
        min: 200,
        max: 500
    });
    const openLayerObserver = (0, $lsWhN.useOpenLayerObserver)({
        isEnabled: !(0, $5T6N9.fg)('platform-dst-top-layer')
    });
    /**
   * This is a temporary workaround to enable the `SideNavPanelSplitter` component
   * to collapse the side nav on double click, without exposing the `onDoubleClick` prop on `PanelSplitter`.
   * Once `PanelSplitter` supports an `onDoubleClick` prop directly, this context can be removed.
   */ const onDoubleClick = (0, $fsvuC.useContext)((0, $f9HVI.OnDoubleClickContext));
    // Storing the initial `clientX` on `mousedown` events, to workaround a bug caused by some browser extensions
    // where the `dragstart` event incorrectly returns `0` for the `clientX` location.
    const initialClientXRef = (0, $fsvuC.useRef)(null);
    // Live allocation changes panelWidth on every frame. Only the legacy path should
    // rebind the drag listeners when this value changes.
    const legacyPanelWidth = (0, $5T6N9.fg)('platform-dst-chat-panel-layout') || onResizeInternal ? undefined : panelWidth;
    (0, $fsvuC.useEffect)(()=>{
        const splitter = splitterRef.current;
        (0, $l9kus.default)(splitter, 'Splitter ref must be set');
        let lastManagedResizeWidth;
        return (0, $k0iCs.combine)((0, $bo03n.blockDraggingToIFrames)({
            element: splitter
        }), /**
     * Capturing the initial `clientX` from the mousedown, before the drag starts.
     *
     * ⚠️ Note: We are not using pragmatic-drag-and-drop's `onDragStart` for this as some browser
     * extensions can cause the client location (e.g. clientX) to incorrectly return 0 during the `dragstart` event.
     *
     * We are also not using pragmatic-drag-and-drop's `onDrag` here as it is throttled, which means
     * fast mouse movements can cause the real first drag event to be missed, causing a different clientX
     * to be captured.
     *
     * I also tried only binding an event listener inside pragmatic-drag-and-drop's `onDragStart`, which seemd to work
     * but did not feel as robust, and might have timing issues as it happens slightly later.
     */ (0, $dqdTY.bind)(splitter, {
            type: 'mousedown',
            listener: (event)=>{
                initialClientXRef.current = event.clientX;
            }
        }), (0, $gKvs9.draggable)({
            element: splitter,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                // We will be moving the line to indicate a drag. We can disable the native drag preview
                (0, $1A0xB.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                // We don't want any native drop animation for when the user does not drop on a drop target. We want the drag to finish immediately
                (0, $am7NR.preventUnhandled).start();
            },
            getInitialData () {
                const initialWidth = (0, $lBdFx.getPixelWidth)(panel);
                /**
         * The drag calculations require the actual computed width of the element
         * For example, if the panel has loaded with a width of 2000px, but the max bound is 1000px and is visually 1000px (due to the CSS `clamp()`),
         * the drag calculations should use the actual width of 1000px, not the width in state of 2000px.
         */ return $d245715da7f5c890$var$signPanelSplitterDragData({
                    panelId: panelId,
                    initialWidth: initialWidth,
                    resizingWidth: `${initialWidth}px`,
                    resizeBounds: getResizeBounds(),
                    // Only computing text direction when we need it, just as the drag is starting.
                    // Recomputing text direction on each new drag in case the text direction
                    // has changed. This is unlikely, but being safe.
                    direction: $d245715da7f5c890$var$getTextDirection(panel)
                });
            },
            onDragStart ({ source: source }) {
                /**
         * ⚠️ Note: We are not using the client locations (e.g. clientX) during `onDragStart`
         * because some browser extensions can cause the event properties to incorrectly return 0.
         */ (0, $l9kus.default)((0, $gAEEt.isPanelSplitterDragData)(source.data));
                const resizeStartData = {
                    initialWidth: source.data.initialWidth
                };
                // The layout allocation system needs to know which area is actively being
                // resized before the first drag update. Committing this synchronously keeps
                // the actively dragged area protected from automatic compression.
                if (onResizeStartInternal) (0, $80czl.flushSync)(()=>onResizeStartInternal(resizeStartData));
                onResizeStart?.(resizeStartData);
                // Close any open layers when the user starts resizing
                // Not gated. Top-layer tooltips (`platform-dst-top-layer-tooltip`) are not known to the observer.
                (0, $7WPU3.requestClosePopovers)();
                openLayerObserver?.closeLayers();
            },
            onDrag ({ location: location, source: source }) {
                /**
         * ⚠️ Note: We are not using the location.initial.input client locations because some browser extensions
         * can cause the client locations (e.g. clientX) in the `dragstart` event to incorrectly return 0.
         */ (0, $l9kus.default)((0, $gAEEt.isPanelSplitterDragData)(source.data));
                const { initialWidth: initialWidth, resizeBounds: resizeBounds, direction: direction } = source.data;
                (0, $l9kus.default)(initialClientXRef.current !== null, 'initialClientX must be set');
                /**
         * How wide the element would be if there were no width constraints,
         * based on the pointer's position.
         */ const targetWidth = (0, $6PgcW.getWidthFromDragLocation)({
                    initialWidth: initialWidth,
                    location: location,
                    // The fallback of 0 won't be used due to the invariant, however we require one to satisfy the type.
                    initialClientX: initialClientXRef.current ?? 0,
                    direction: direction,
                    position: position
                });
                const resizingWidth = `clamp(${resizeBounds.min}, ${targetWidth}px, ${resizeBounds.max})`;
                if (onResizeInternal) {
                    // The allocator needs below-minimum requests for the local-to-chat cascade.
                    const currentBounds = getResizeBounds();
                    const width = Math.max(0, Math.min(targetWidth, prepareResize ? window.innerWidth : (0, $9EEC1.convertResizeBoundToPixels)(currentBounds.max)));
                    if (width !== lastManagedResizeWidth) {
                        lastManagedResizeWidth = width;
                        onResizeInternal(width);
                    }
                } else {
                    panel.style.setProperty(resizingCssVar, resizingWidth);
                    resizingElementRef?.current?.style.setProperty(resizingCssVar, resizingWidth);
                }
                source.data.resizingWidth = resizingWidth;
            },
            async onDrop ({ source: source }) {
                (0, $l9kus.default)((0, $gAEEt.isPanelSplitterDragData)(source.data));
                (0, $am7NR.preventUnhandled).stop();
                if (prepareResize) {
                    if (!await prepareResize() || !panel.isConnected) return;
                }
                // PDD may deliver its final throttled drag update immediately before drop.
                // Commit that update once before measuring; do not persist a previous frame.
                if (onResizeInternal && lastManagedResizeWidth !== undefined) {
                    const width = lastManagedResizeWidth;
                    (0, $80czl.flushSync)(()=>onResizeInternal(width));
                    lastManagedResizeWidth = undefined;
                }
                const finalWidth = (0, $lBdFx.getPixelWidth)(panel);
                // Persist the final preferred width before removing the imperative drag
                // variable, so the rendered width is continuous across pointer release.
                if ((0, $5T6N9.fg)('platform-dst-chat-panel-layout') || onResizeInternal) (0, $80czl.flushSync)(()=>onCompleteResize(finalWidth));
                else onCompleteResize(finalWidth);
                onResizeEnd?.({
                    initialWidth: source.data.initialWidth,
                    finalWidth: finalWidth
                });
                panel.style.removeProperty(resizingCssVar);
                resizingElementRef?.current?.style.removeProperty(resizingCssVar);
            }
        }));
    }, [
        onCompleteResize,
        onResizeStartInternal,
        onResizeInternal,
        prepareResize,
        onResizeStart,
        onResizeEnd,
        panel,
        resizingCssVar,
        resizingElementRef,
        legacyPanelWidth,
        position,
        openLayerObserver,
        panelId,
        getResizeBounds
    ]);
    const onResizeStartStableRef = (0, $k3Yn7.default)(onResizeStart);
    const onResizeEndStableRef = (0, $k3Yn7.default)(onResizeEnd);
    const [keyboardResizeManager] = (0, $fsvuC.useState)(()=>(0, $2b4Dn.createKeyboardResizeManager)({
            onResizeStart: (...args)=>{
                // Close any open layers when the user starts resizing with keyboard
                // Not gated. Top-layer tooltips (`platform-dst-top-layer-tooltip`) are not known to the observer.
                (0, $7WPU3.requestClosePopovers)();
                openLayerObserver?.closeLayers();
                onResizeStartStableRef.current?.(...args);
            },
            onResizeEnd: (...args)=>onResizeEndStableRef.current?.(...args)
        }));
    const focusSequence = (0, $fsvuC.useRef)(0);
    const keyboardBoundsReady = (0, $fsvuC.useRef)(false);
    const pendingKeyboardWidth = (0, $fsvuC.useRef)(null);
    const handleSliderInputChange = (0, $fsvuC.useCallback)(async (event, pendingKey)=>{
        const isManagedResize = onResizeInternal;
        const sequence = focusSequence.current;
        let value = isManagedResize ? parseFloat(event.currentTarget.value) : parseInt(event.currentTarget.value);
        if (prepareResize) {
            if (!await prepareResize() || !panel.isConnected || sequence !== focusSequence.current) return;
        }
        if (isManagedResize) {
            // The available region may have changed since focus, including without a
            // window resize. Use the allocator's current bounds for the public payload.
            const bounds = getResizeBounds();
            const min = (0, $9EEC1.convertResizeBoundToPixels)(bounds.min);
            const max = (0, $9EEC1.convertResizeBoundToPixels)(bounds.max);
            if (pendingKey) {
                // Native range inputs would apply these keys to the placeholder bounds.
                // Preserve the intent until the chunk provides the real bounds instead.
                const current = pendingKeyboardWidth.current ?? (0, $lBdFx.getPixelWidth)(panel);
                const doesArrowRightIncrease = panelGrowthSide ? panelGrowthSide === 'right' : $d245715da7f5c890$var$getTextDirection(panel) === 'ltr';
                const increase = pendingKey === 'ArrowUp' || pendingKey === (doesArrowRightIncrease ? 'ArrowRight' : 'ArrowLeft') || pendingKey === 'PageUp';
                const step = pendingKey.startsWith('Page') ? Math.max(20, (max - min) / 10) : 20;
                value = pendingKey === 'End' ? max : pendingKey === 'Home' ? min : current + (increase ? step : -step);
            }
            value = Math.max(min, Math.min(value, max));
            setRangeInputBounds({
                min: min,
                max: max
            });
        }
        pendingKeyboardWidth.current = value;
        setRangeInputValue(value);
        /**
     * We are intentionally _not_ debouncing `onCompleteResize` as we want it to be called anytime the user changes the range input value.
     * It is an internal-only callback - it's provided by `PanelSplitterProvider`, and used by layout slots to update their layout width state.
     */ onCompleteResize(value);
        keyboardResizeManager.onResize({
            initialWidth: panelWidth,
            finalWidth: value
        });
    }, [
        getResizeBounds,
        onCompleteResize,
        onResizeInternal,
        panelWidth,
        keyboardResizeManager,
        panel,
        prepareResize,
        panelGrowthSide
    ]);
    const handleSliderKeyDown = (0, $fsvuC.useCallback)((event)=>{
        if (prepareResize && !keyboardBoundsReady.current && [
            'Home',
            'End',
            'ArrowLeft',
            'ArrowRight',
            'ArrowUp',
            'ArrowDown',
            'PageUp',
            'PageDown'
        ].includes(event.key)) {
            event.preventDefault();
            handleSliderInputChange(event, event.key);
        }
    }, [
        handleSliderInputChange,
        prepareResize
    ]);
    const resizeEventListenerCleanupFn = (0, $fsvuC.useRef)(null);
    const handleSliderFocus = (0, $fsvuC.useCallback)(async ()=>{
        const sequence = ++focusSequence.current;
        keyboardBoundsReady.current = false;
        pendingKeyboardWidth.current = null;
        if (prepareResize) {
            if (!await prepareResize() || !panel.isConnected || sequence !== focusSequence.current) return;
        }
        /**
     * We are only updating the range input's properties when the element is focused, as a performance optimisation.
     * It isn't necessary to recalculate these values until the element is going to be used.
     */ // Clean up any left over listeners in case `focus` was triggered again without `blur`.
        resizeEventListenerCleanupFn.current?.();
        // Update the range input value to match the current panel width.
        const width = prepareResize ? (0, $lBdFx.getPixelWidth)(panel) : panelWidth;
        pendingKeyboardWidth.current = width;
        setRangeInputValue(width);
        const resizeBounds = getResizeBounds();
        // Update the range input bounds to ensure they are accurate (in case the viewport was previously resized)
        setRangeInputBounds({
            min: (0, $9EEC1.convertResizeBoundToPixels)(resizeBounds.min),
            max: (0, $9EEC1.convertResizeBoundToPixels)(resizeBounds.max)
        });
        keyboardBoundsReady.current = true;
        /**
     * _While the slider element is focused_, add a window resize event listener to update the range input bounds
     * when the window is resized. This is needed to ensure the min and max widths accurately reflect the viewport
     * size - in case they are provided in vw units.
     *
     * This listener is cleaned up when the element is blurred.
     */ resizeEventListenerCleanupFn.current = (0, $dqdTY.bind)(window, {
            type: 'resize',
            listener: function updateState() {
                const resizeBounds = getResizeBounds();
                setRangeInputBounds({
                    min: (0, $9EEC1.convertResizeBoundToPixels)(resizeBounds.min),
                    max: (0, $9EEC1.convertResizeBoundToPixels)(resizeBounds.max)
                });
            }
        });
    }, [
        panelWidth,
        getResizeBounds,
        panel,
        prepareResize
    ]);
    const handleSliderBlur = (0, $fsvuC.useCallback)(()=>{
        focusSequence.current++;
        keyboardBoundsReady.current = false;
        // Remove the resize event listener when the range input is blurred.
        resizeEventListenerCleanupFn.current?.();
    }, []);
    (0, $fsvuC.useEffect)(()=>{
        return function cleanup() {
            // Cleanup the resize event listener when the component is unmounted.
            resizeEventListenerCleanupFn.current?.();
        };
    }, []);
    const ariaValueText = (0, $fsvuC.useMemo)(()=>`${(0, $csVj0.getPercentageWithinPixelBounds)({
            currentWidth: rangeInputValue,
            resizeBounds: rangeInputBounds
        })}% width`, [
        rangeInputValue,
        rangeInputBounds
    ]);
    return /*#__PURE__*/ (0, $80czl.createPortal)(/*#__PURE__*/ (0, $5chsV.jsx)("div", {
        "data-testid": testId ? `${testId}-container` : undefined,
        className: (0, $gJ6nT.default)([
            $d245715da7f5c890$var$containerStyles.root,
            position === 'start' && $d245715da7f5c890$var$containerStyles.positionStart,
            position === 'end' && $d245715da7f5c890$var$containerStyles.positionEnd
        ]),
        children: /*#__PURE__*/ (0, $5chsV.jsx)($d245715da7f5c890$var$MaybeTooltip, {
            tooltipContent: tooltipContent,
            shortcut: shortcut,
            mousePosition: panelGrowthSide ?? 'right',
            testId: testId ? `${testId}-tooltip` : undefined,
            children: /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
                ref: setSplitterRef,
                "data-testid": testId,
                onDoubleClick: onDoubleClick,
                className: (0, $gJ6nT.default)([
                    $d245715da7f5c890$var$grabAreaStyles.root,
                    (0, $5T6N9.fg)('platform-dst-tokens-finesse') && $d245715da7f5c890$var$grabAreaStyles.rootFinesse
                ]),
                children: [
                    /*#__PURE__*/ (0, $5chsV.jsxs)((0, $01oqo.default), {
                        children: [
                            /*#__PURE__*/ (0, $5chsV.jsx)("input", {
                                type: "range",
                                dir: panelGrowthSide ? $d245715da7f5c890$var$rangeInputDirs[panelGrowthSide] : undefined,
                                value: rangeInputValue,
                                step: 20,
                                min: rangeInputBounds.min,
                                max: rangeInputBounds.max,
                                "aria-valuetext": ariaValueText,
                                "aria-labelledby": labelId,
                                onChange: handleSliderInputChange,
                                onKeyDown: prepareResize ? handleSliderKeyDown : undefined,
                                onFocus: handleSliderFocus,
                                onBlur: handleSliderBlur
                            }),
                            /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                                id: labelId,
                                children: label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                        className: (0, $gJ6nT.default)([
                            $d245715da7f5c890$var$lineStyles.root
                        ])
                    })
                ]
            })
        })
    }), portal);
};
$d245715da7f5c890$var$PortaledPanelSplitter.displayName = "PortaledPanelSplitter";
const $d245715da7f5c890$export$db67e3f8d3d6da0f = ({ label: label, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, testId: testId, tooltipContent: tooltipContent })=>{
    const [panel, setPanel] = (0, $fsvuC.useState)(null);
    const [portal, setPortal] = (0, $fsvuC.useState)(null);
    const context = (0, $fsvuC.useContext)((0, $6y6Kb.PanelSplitterContext));
    (0, $l9kus.default)(context, 'Panel splitter context not set');
    const { panelRef: panelRef, portalRef: portalRef, isEnabled: isEnabled, panelId: panelId, panelWidth: panelWidth, onCompleteResize: onCompleteResize, onResizeStartInternal: onResizeStartInternal, onResizeInternal: onResizeInternal, getResizeBounds: getResizeBounds, prepareResize: prepareResize, resizingCssVar: resizingCssVar, resizingElementRef: resizingElementRef, position: position, shortcut: shortcut } = context;
    /**
   * **Explanation**
   *
   * _How React Suspense works_
   *
   * When a component is suspended:
   *
   * - it is _not_ "unmounted" and effects are _not_ cleaned up
   * - refs to react managed elements are cleared
   * - react adds `display:none !important` as an inline style to hide the element
   * - state is preserved
   *
   * When a suspended component is resumed:
   * - `display:none !important` inline style is removed
   * - it will re-render (without the refs set)
   * - refs will be set
   * - `useEffect` will _not_ re-run
   *
   * [More details](https://x.com/alexandereardon/status/1944617494569992440)
   *
   * _What does this mean for the panel splitter?_
   *
   * - The panel splitter renders into content into a react managed element (eg managed by Aside)
   * - When UI is suspended the portal ref is cleared
   * - After a suspense, we will get a render with cleared refs
   * - 🔥 This is problematic if we want to portal into that ref during the render
   *
   * _Approach: initial render_
   *
   * - We cannot portal the panel splitter until after the refs are initially set
   * - Effects run after refs being set. In an effect we set the ref values (which are populated),
   *   trigger a re-render and then portal into the refs.
   *
   * _Approach: suspense_
   *
   * - We put the refs into react `state` after every render
   * - The refs in `state` will not be cleared by suspending as effects are not run, or cleaned up,
   *   when components are suspended / resumed.
   * - After the post suspense render, we can use the `portalRef` (which was captured in an effect)
   *   to continue to portal into.
   *
   * _Why not store `portalRef` in `state` in `<PanelSplitterProvider>`?_
   *
   * - The `portalRef` is set high in the tree, so a re-render will cause a
   *   large amount of components to re-render (eg the whole sidebar)
   * - After a suspense, we would need to do _another_ large re-render to propagate the new refs
   * - With our current approach, any changes to `portalRef` will cause a re-render low in the tree
   *   (just in the `<PanelSplitter>`)
   */ // We want this effect to run after each render (see above)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $fsvuC.useEffect)(()=>{
        // Don't need to do anything
        if (!isEnabled) return;
        // It is safe to access refs in useEffect, even with Suspense
        const panelEl = panelRef.current;
        const portalEl = portalRef.current;
        (0, $l9kus.default)(panelEl, 'panelRef not set');
        (0, $l9kus.default)(portalEl, 'portal element not set');
        // Doing our own check, as this results in fewer re-renders than react
        // (which also does it's own checks to see if a re-render should occur)
        if (panelEl === panel && portalEl === portal) return;
        // If refs don't change, react won't cause infinite loops
        setPanel(panelEl);
        setPortal(portalEl);
    });
    if (!isEnabled) return null;
    if (!portal || !panel) return null;
    return /*#__PURE__*/ (0, $5chsV.jsx)($d245715da7f5c890$var$PortaledPanelSplitter, {
        label: label,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        testId: testId,
        panelId: panelId,
        panel: panel,
        portal: portal,
        panelWidth: panelWidth,
        onCompleteResize: onCompleteResize,
        onResizeStartInternal: onResizeStartInternal,
        onResizeInternal: onResizeInternal,
        prepareResize: prepareResize,
        getResizeBounds: getResizeBounds,
        resizingCssVar: resizingCssVar,
        resizingElementRef: resizingElementRef,
        position: position,
        tooltipContent: tooltipContent,
        shortcut: shortcut
    });
};
$d245715da7f5c890$export$db67e3f8d3d6da0f.displayName = "PanelSplitter";

});
parcelRegister("iH0NW", function(module, exports) {
$parcel$export(module.exports, "getPanelGrowthSide", () => $42c4b6f4eb58801c$export$bfece4a13ba3dfe4);
/**
 * Returns the physical side the panel grows towards when the splitter is dragged away from it.
 *
 * `position: 'end'` grows towards the inline-end, which is the right in left-to-right languages, and
 * `position: 'start'` grows towards the inline-start.
 */ function $42c4b6f4eb58801c$export$bfece4a13ba3dfe4({ position: position, textDirection: textDirection }) {
    const isGrowingTowardsInlineEnd = position === 'end';
    const isInlineEndOnTheRight = textDirection === 'ltr';
    return isGrowingTowardsInlineEnd === isInlineEndOnTheRight ? 'right' : 'left';
}

});

parcelRegister("csVj0", function(module, exports) {
$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $785f80cd7c1a2e4a$export$b5423678cdf09f5);
function $785f80cd7c1a2e4a$export$b5423678cdf09f5({ currentWidth: currentWidth, resizeBounds: resizeBounds }) {
    const resizeRange = resizeBounds.max - resizeBounds.min;
    const widthAsPercentage = (currentWidth - resizeBounds.min) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("lBdFx", function(module, exports) {
$parcel$export(module.exports, "getPixelWidth", () => $74fd127513769894$export$d942790ad00c41f9);
/**
 * Returns the computed width of an element in pixels.
 */ const $74fd127513769894$export$d942790ad00c41f9 = (element)=>{
    // Always returns an integer. Returns 0 if element is hidden / removed.
    return element.offsetWidth;
};

});

parcelRegister("6PgcW", function(module, exports) {
$parcel$export(module.exports, "getWidthFromDragLocation", () => $c06c04bcecbc5833$export$e360234971cb95b8);
const $c06c04bcecbc5833$export$e360234971cb95b8 = ({ initialWidth: initialWidth, location: location, initialClientX: initialClientX, direction: direction, position: position })=>{
    const diffX = location.current.input.clientX - initialClientX;
    // Resize line is positioned at the inline-end (right) of the element.
    // If the direction is left-to-right, the width will increase when the mouse is moved to the right, and vice versa.
    if (position === 'end') return direction === 'ltr' ? initialWidth + diffX : initialWidth - diffX;
    // Resize line is positioned at the inline-start (left) of the element.
    // If the direction is left-to-right, the width will decrease when the mouse is moved to the right, and vice versa.
    return direction === 'ltr' ? initialWidth - diffX : initialWidth + diffX;
};

});

parcelRegister("2b4Dn", function(module, exports) {
$parcel$export(module.exports, "createKeyboardResizeManager", () => $e88fea2ab558f740$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $e88fea2ab558f740$var$resizeCallbackDebounceTimeMs = 500;
function $e88fea2ab558f740$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
	 * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
	 */ function startResizeEndTimer({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            resizingState = {
                type: 'idle'
            };
        }, $e88fea2ab558f740$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: initialWidth,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ initialWidth: initialWidth, finalWidth: finalWidth }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart({
                initialWidth: initialWidth
            });
            startResizeEndTimer({
                initialWidth: initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                initialWidth: resizingState.initialWidth,
                finalWidth: finalWidth
            });
            return;
        }
    }
    return {
        onResize: onResize
    };
}

});




parcelRegister("9Namg", function(module, exports) {
$parcel$export(module.exports, "TopNavEnd", () => $c5d8cf6b246c9eac$export$8b7a38b70a3c9839);
/* top-nav-end.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $4twf9 = parcelRequire("4twf9");

var $86OVn = parcelRequire("86OVn");

var $fE6ce = parcelRequire("fE6ce");

var $hT71o = parcelRequire("hT71o");

var $5T6N9 = parcelRequire("5T6N9");

var $2LKzh = parcelRequire("2LKzh");

var $aIMFz = parcelRequire("aIMFz");

var $d16EQ = parcelRequire("d16EQ");

var $e2VD8 = parcelRequire("e2VD8");

var $58UFo = parcelRequire("58UFo");

var $d4nKw = parcelRequire("d4nKw");
const $c5d8cf6b246c9eac$var$containerStyles = {
    root: "_2j3gqA7LI7 _3iDTPbQ4SZ _37wbyuF05b _4ouGXIUofl _3eQEqqW9qI _15X6MhW9qI _04KkHPBmSS _3tZeuj2Njc _1xHhlhF05b",
    withPersistentItems: "_2mHwu81Y8M _0hPCNLDIqT"
};
const $c5d8cf6b246c9eac$var$listStyles = {
    root: "_2mHwu81Y8M _0hPCNLDIqT _3iDTPbQ4SZ",
    hideOnSmallViewport: "_3iDTPbYbGa _2UeR8bQ4SZ",
    popupContainer: "_4FKVYE2ADO"
};
function $c5d8cf6b246c9eac$export$8b7a38b70a3c9839({ children: children, persistentItems: persistentItems, label: label = 'Actions', showMoreButtonLabel: showMoreButtonLabel = 'Show more' }) {
    const hasPersistentItems = (0, $5T6N9.fg)('platform-dst-chat-panel-layout') && persistentItems != null;
    const [isOpen, setIsOpen] = (0, $fsvuC.useState)(false);
    // Always setting to `false` for the initial render (will flip in an effect for mobile)
    const [isMobile, setIsMobile] = (0, $fsvuC.useState)(false);
    // Note: `query` is a stable value between renders
    const query = (0, $aIMFz.UNSAFE_useMediaQuery)('below.sm', function onChange(event) {
        setIsMobile(event.matches);
        // Any time we shift between mobile and desktop
        // We always close the popup
        setIsOpen(false);
    });
    (0, $86OVn.useLayoutEffect)(()=>{
        // The default is `false`, and desktop will remain as `false` (no re-render).
        // Mobile will flip from `false` to `true`.
        setIsMobile(query?.matches ?? false);
    }, [
        query
    ]);
    // The shared provider also covers the mobile overflow popup itself. Keep the
    // previous content-only namespace coverage when the layout gate is disabled.
    // The observer is not used when the top-layer gate is on, so no provider is needed.
    const actions = (0, $5T6N9.fg)('platform-dst-chat-panel-layout') || (0, $5T6N9.fg)('platform-dst-top-layer') ? children : /*#__PURE__*/ (0, $5chsV.jsx)((0, $hT71o.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $d4nKw.openLayerObserverTopNavEndNamespace),
        children: children
    });
    const content = /*#__PURE__*/ (0, $5chsV.jsxs)("nav", {
        "aria-label": label,
        className: (0, $gJ6nT.default)([
            $c5d8cf6b246c9eac$var$containerStyles.root,
            hasPersistentItems && $c5d8cf6b246c9eac$var$containerStyles.withPersistentItems
        ]),
        children: [
            isMobile ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $2LKzh.Popup), {
                isOpen: isOpen,
                onClose: ()=>setIsOpen(false),
                // Top-layer popups need a role to register as a popup with the layer observer.
                role: (0, $5T6N9.fg)('platform-dst-chat-panel-layout') ? 'dialog' : undefined,
                label: (0, $5T6N9.fg)('platform-dst-chat-panel-layout') ? label : undefined,
                placement: "bottom-start",
                shouldRenderToParent: true,
                content: ()=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $e2VD8.HasCustomThemeContext).Provider, {
                        value: false,
                        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $d16EQ.List), {
                            xcss: (0, $4twf9.cx)($c5d8cf6b246c9eac$var$listStyles.root, $c5d8cf6b246c9eac$var$listStyles.popupContainer),
                            children: actions
                        })
                    }),
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $58UFo.IconButton), {
                        ...triggerProps,
                        label: showMoreButtonLabel,
                        isSelected: isOpen,
                        onClick: ()=>setIsOpen(!isOpen),
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fE6ce))),
                        isTooltipDisabled: false
                    })
            }) : /*#__PURE__*/ (0, $5chsV.jsx)((0, $d16EQ.List), {
                xcss: (0, $4twf9.cx)($c5d8cf6b246c9eac$var$listStyles.root, $c5d8cf6b246c9eac$var$listStyles.hideOnSmallViewport),
                children: actions
            }),
            hasPersistentItems && persistentItems
        ]
    });
    return (0, $5T6N9.fg)('platform-dst-chat-panel-layout') && !(0, $5T6N9.fg)('platform-dst-top-layer') ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $hT71o.OpenLayerObserverNamespaceProvider), {
        namespace: (0, $d4nKw.openLayerObserverTopNavEndNamespace),
        children: content
    }) : content;
}
$c5d8cf6b246c9eac$export$8b7a38b70a3c9839.displayName = "TopNavEnd";

});
parcelRegister("d16EQ", function(module, exports) {
$parcel$export(module.exports, "List", () => $7f1ce0e4bf198342$export$54c2e3dc7acea9f5);
/* list.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
function $7f1ce0e4bf198342$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId,
        children: children
    }));
}
const $7f1ce0e4bf198342$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $fsvuC.forwardRef)($7f1ce0e4bf198342$var$_List);

});


parcelRegister("8O6b1", function(module, exports) {
$parcel$export(module.exports, "TopNavMiddle", () => $b16af41aeeb49a51$export$88836ac6da0f492f);
/* top-nav-middle.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");
parcelRequire("fsvuC");

var $hT71o = parcelRequire("hT71o");

var $5T6N9 = parcelRequire("5T6N9");

var $d4nKw = parcelRequire("d4nKw");
const $b16af41aeeb49a51$var$styles = {
    root: "_2mHwu82ADO _2j3gqAiZR3 _39xV02N91d _0hPCNLDIqT _3iDTPbQ4SZ _37wbyuF05b _2UeR8bgBM8 _3E0AG21EBl _1p7Awjbt8w _4itPyXW9qI _2x7hvAF05b"
};
function $b16af41aeeb49a51$export$88836ac6da0f492f({ children: children }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            $b16af41aeeb49a51$var$styles.root
        ]),
        children: (0, $5T6N9.fg)('platform-dst-top-layer') ? children : /*#__PURE__*/ (0, $5chsV.jsx)((0, $hT71o.OpenLayerObserverNamespaceProvider), {
            namespace: (0, $d4nKw.openLayerObserverTopNavMiddleNamespace),
            children: children
        })
    });
}
$b16af41aeeb49a51$export$88836ac6da0f492f.displayName = "TopNavMiddle";

});

parcelRegister("aGfnr", function(module, exports) {
$parcel$export(module.exports, "TopNavStart", () => $7ee0fd2c7dc30f91$export$4c15269b98c5129);
/* top-nav-start.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $f26MV = parcelRequire("f26MV");
/**
 * Styles for the TopNavStart element.
 */ const $7ee0fd2c7dc30f91$var$innerStyles = {
    root: "_2mHwu81Y8M _2j3gqA7dHp _0jFU0VN91d _0hPCNLDIqT _3iDTPbQ4SZ _15X6MhW9qI _04KkHPBmSS _3tZeuj2Njc"
};
function $7ee0fd2c7dc30f91$export$4c15269b98c5129({ children: children, testId: testId, sideNavToggleButton: sideNavToggleButton }) {
    const ref = (0, $fsvuC.useContext)((0, $f26MV.TopNavStartAttachRef));
    const elementRef = (0, $fsvuC.useRef)(null);
    // FIXME: unsafe pattern with Suspense, should use callback ref / store in state
    // Should handle the underlying HTMLElement changing without a remount
    (0, $fsvuC.useEffect)(()=>{
        ref(elementRef.current);
    }, [
        elementRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
        ref: elementRef,
        "data-testid": testId,
        className: (0, $gJ6nT.default)([
            $7ee0fd2c7dc30f91$var$innerStyles.root
        ]),
        children: [
            sideNavToggleButton,
            children
        ]
    });
}
$7ee0fd2c7dc30f91$export$4c15269b98c5129.displayName = "TopNavStart";

});

parcelRegister("iguLq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b7ce0838881bb0eb6f29b86e8b3a459>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d4c195b483e44d6b$var$_react = $d4c195b483e44d6b$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $d4c195b483e44d6b$var$_iconNew = $d4c195b483e44d6b$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $d4c195b483e44d6b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/editions
 * Usage guidance:
 * Reserved for representing premium features in upsell experiences. The Editions gem icon has officially replaced the sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d4c195b483e44d6b$var$EditionsIcon = (props)=>/*#__PURE__*/ $d4c195b483e44d6b$var$_react.default.createElement($d4c195b483e44d6b$var$_iconNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.75 1 .096.006a.75.75 0 0 1 .54.347l2.5 4a.75.75 0 0 1-.066.883l-7.25 8.5a.75.75 0 0 1-1.14 0l-7.25-8.5a.75.75 0 0 1-.066-.883l2.5-4 .056-.079A.75.75 0 0 1 3.25 1zM8 11.813 9.719 6.5H6.28zm-1.873-.914L4.704 6.5H2.375zm3.745 0L13.625 6.5h-2.33zM11.302 5h2.596l-1.563-2.5H10.52zM6.27 5h3.46l-.782-2.5H7.052zM2.103 5h2.595l.781-2.5H3.665z"/>`
    }, props));
$d4c195b483e44d6b$var$EditionsIcon.displayName = 'EditionsIcon';
var $d4c195b483e44d6b$var$_default = module.exports.default = $d4c195b483e44d6b$var$EditionsIcon;

});

parcelRegister("hLA8z", function(module, exports) {
$parcel$export(module.exports, "Button", () => $13e2392174f496da$export$353f5b6fc5456de1);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $76zfX = parcelRequire("76zfX");

var $e2VD8 = parcelRequire("e2VD8");

var $bdRgs = parcelRequire("bdRgs");
const $13e2392174f496da$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $e2VD8.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $bdRgs.ThemedButton) : (0, $76zfX.default);
    return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("bdRgs", function(module, exports) {
$parcel$export(module.exports, "ThemedButton", () => $6a24a82942d8e0da$export$f67fb575035cc7d0);
/* themed-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $jQC6P = parcelRequire("jQC6P");

var $gCNxI = parcelRequire("gCNxI");
const $6a24a82942d8e0da$var$textButtonStyles = {
    iconBefore: "_26BoRwdnbC",
    text: "_1kk5Tkf7mX"
};
const $6a24a82942d8e0da$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $gCNxI.ThemedPressable), {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                className: (0, $gJ6nT.default)([
                    $6a24a82942d8e0da$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $jQC6P.default), {
                    icon: IconBefore
                })
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                className: (0, $gJ6nT.default)([
                    $6a24a82942d8e0da$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
});

});


parcelRegister("j8AQW", function(module, exports) {
$parcel$export(module.exports, "Hide", () => $1e1366f3963ace65$export$bed28288a051538);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $h2YWL = parcelRequire("h2YWL");

var $hgZMM = parcelRequire("hgZMM");

var $femIf = parcelRequire("femIf");

var $9Uvr6 = parcelRequire("9Uvr6");
const $1e1366f3963ace65$var$hideAboveQueries = (0, $femIf.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $1e1366f3963ace65$var$hideBelowQueries = (0, $9Uvr6.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $1e1366f3963ace65$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $hgZMM.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $h2YWL.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $1e1366f3963ace65$var$hideAboveQueries[above],
            below && $1e1366f3963ace65$var$hideBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
$1e1366f3963ace65$export$bed28288a051538.displayName = "Hide";

});
parcelRegister("femIf", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $812df2e94c99e267$export$918f8818cfbbeb2c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $h2YWL = parcelRequire("h2YWL");

var $76mlK = parcelRequire("76mlK");

var $jwhvu = parcelRequire("jwhvu");
const $812df2e94c99e267$export$918f8818cfbbeb2c = (input)=>{
    return (0, $76mlK.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $h2YWL.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $jwhvu.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};

});
parcelRegister("76mlK", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_CONFIG", () => $dd17047f423b8398$export$e5ee4fe8b989fd09);
$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $dd17047f423b8398$export$2d293d9871c38e91);
const $dd17047f423b8398$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $dd17047f423b8398$export$2d293d9871c38e91 = Object.keys($dd17047f423b8398$export$e5ee4fe8b989fd09);
const $dd17047f423b8398$export$b7ed752a57b4177b = $dd17047f423b8398$export$2d293d9871c38e91[0];

});

parcelRegister("jwhvu", function(module, exports) {
$parcel$export(module.exports, "media", () => $69a2424aabd7ed54$export$987d49ffe1b0900f);
const $69a2424aabd7ed54$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});


parcelRegister("9Uvr6", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $1cf44c4b210175bd$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $h2YWL = parcelRequire("h2YWL");

var $76mlK = parcelRequire("76mlK");

var $er85K = parcelRequire("er85K");
const $1cf44c4b210175bd$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $76mlK.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $h2YWL.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $er85K.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("er85K", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_media", () => $0b02a049e9fe7c0d$export$c881183ca713c214);

var $jwhvu = parcelRequire("jwhvu");
const $0b02a049e9fe7c0d$export$c881183ca713c214 = (0, $jwhvu.media);

});



parcelRegister("fjOL2", function(module, exports) {
$parcel$export(module.exports, "Show", () => $96cd5d21f065505d$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $h2YWL = parcelRequire("h2YWL");

var $hgZMM = parcelRequire("hgZMM");

var $femIf = parcelRequire("femIf");

var $9Uvr6 = parcelRequire("9Uvr6");
function $96cd5d21f065505d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $96cd5d21f065505d$var$showAboveQueries = (0, $femIf.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $96cd5d21f065505d$var$showBelowQueries = (0, $9Uvr6.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $96cd5d21f065505d$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $96cd5d21f065505d$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $hgZMM.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $h2YWL.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $96cd5d21f065505d$var$defaultHiddenStyles,
            above && $96cd5d21f065505d$var$showAboveQueries[above],
            below && $96cd5d21f065505d$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
$96cd5d21f065505d$export$f6a3d19be20f5819.displayName = "Show";

});

parcelRegister("esR3B", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $37105d532699afc0$export$49e55ae2c03d6045);

var $fsvuC = parcelRequire("fsvuC");

var $dqdTY = parcelRequire("dqdTY");

var $86OVn = parcelRequire("86OVn");

var $er85K = parcelRequire("er85K");
const $37105d532699afc0$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $er85K.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $er85K.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $er85K.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $er85K.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $er85K.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $er85K.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $er85K.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $er85K.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $er85K.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $er85K.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $er85K.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $37105d532699afc0$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $fsvuC.useRef)(listener);
    (0, $fsvuC.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $37105d532699afc0$var$queries[queryString];
    (0, $86OVn.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $dqdTY.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};
$37105d532699afc0$export$49e55ae2c03d6045.displayName = "UNSAFE_useMediaQuery";

});

parcelRegister("Nncc3", function(module, exports) {
$parcel$export(module.exports, "ModalContextProvider", () => $979ac43320d9ad8e$export$7c9538f5f3c365e9);

var $fsvuC = parcelRequire("fsvuC");

var $fLAte = parcelRequire("fLAte");

var $biJr6 = parcelRequire("biJr6");
const $979ac43320d9ad8e$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $fsvuC.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $fsvuC.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
$979ac43320d9ad8e$var$RenderModal.displayName = "RenderModal";
function $979ac43320d9ad8e$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $fsvuC.useRef)(1);
    const [modals, setModals] = (0, $fsvuC.useState)([]);
    const modalContext = (0, $fsvuC.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $biJr6.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $fLAte.default), null, modals.map((modal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($979ac43320d9ad8e$var$RenderModal, {
            key: modal.key,
            modal: modal
        }))));
}
$979ac43320d9ad8e$export$7c9538f5f3c365e9.displayName = "ModalContextProvider";

});
parcelRegister("biJr6", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $ef64ce11d7644313$export$ab57792b9b6974a6);

var $fsvuC = parcelRequire("fsvuC");
const $ef64ce11d7644313$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $fsvuC.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-points/modal-context-provider';");
    }
});

});


parcelRegister("BbxEd", function(module, exports) {
$parcel$export(module.exports, "ModalTrigger", () => $67c0e0d792b55b28$export$fb10b32cfe19f1e);

var $fsvuC = parcelRequire("fsvuC");

var $jWJ9H = parcelRequire("jWJ9H");

var $iNT4o = parcelRequire("iNT4o");

var $8V6dQ = parcelRequire("8V6dQ");

var $2PNUx = parcelRequire("2PNUx");

var $5T6N9 = parcelRequire("5T6N9");

var $bc4oC = parcelRequire("bc4oC");

var $85Ele = parcelRequire("85Ele");

var $7z61P = parcelRequire("7z61P");

var $bGf4T = parcelRequire("bGf4T");

var $biJr6 = parcelRequire("biJr6");

var $wZyN2 = parcelRequire("wZyN2");

var $5w7nx = parcelRequire("5w7nx");

var $6ztSZ = parcelRequire("6ztSZ");

var $k9MLR = parcelRequire("k9MLR");
const $67c0e0d792b55b28$var$emptyEntryPointParams = {};
const $67c0e0d792b55b28$var$emptyEntryPointProps = {};
function $67c0e0d792b55b28$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, errorFallback: ErrorFallbackComponent, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, onRequestClose: onRequestClose, source: source, preloadOnFocus: preloadOnFocus = true, loadingText: loadingText, errorTitle: errorTitle, errorText: errorText, errorCloseText: errorCloseText }) {
    (0, $jWJ9H.di)((0, $iNT4o.loadEntryPoint));
    const { openModal: openModal } = (0, $fsvuC.useContext)((0, $biJr6.ModalContext));
    const environmentProvider = (0, $bGf4T.useRelayEnvironmentProvider)();
    const { GlobalModalErrorFallback: GlobalModalErrorFallback } = (0, $bc4oC.useEntryPointConfig)();
    const ModalErrorFallback = ErrorFallbackComponent ?? GlobalModalErrorFallback;
    const modalRef = (0, $fsvuC.useRef)(null);
    const { onContentReady: onContentReady, resetContentReady: resetContentReady, waitForContentReady: waitForContentReady } = (0, $wZyN2.useContentReadySignal)();
    const { id: id, packageName: packageName, teamName: teamName } = source ?? {};
    const metricName = (0, $fsvuC.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $fsvuC.useCallback)(()=>(0, $iNT4o.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $67c0e0d792b55b28$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $fsvuC.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            resetContentReady();
            const requestClose = (request)=>{
                if (onRequestClose?.(request.event) === false) return;
                entryPointProps?.onClose?.(request.entryPointCloseArgument);
                closeModal();
                dispose();
            };
            const onInternalClose = (extraInformation)=>{
                requestClose({
                    entryPointCloseArgument: extraInformation
                });
            };
            const onUserInteractionClose = (event)=>{
                requestClose({
                    event: event,
                    entryPointCloseArgument: event
                });
            };
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $7z61P.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement(ModalErrorFallback, {
                        error: error,
                        id: id ?? metricName,
                        teamName: teamName,
                        packageName: packageName,
                        closeModal: onInternalClose,
                        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $5w7nx.ErrorFallback), {
                            error: error,
                            closeModal: onInternalClose,
                            errorTitle: errorTitle,
                            title: title,
                            errorText: errorText,
                            errorCloseText: errorCloseText
                        })
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                },
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement(Fallback, {
                    onClose: onInternalClose
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $k9MLR.Loading), {
                    title: title,
                    loadingText: loadingText
                }),
                id: metricName,
                onContentReady: onContentReady,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $67c0e0d792b55b28$var$emptyEntryPointProps,
                    onClose: onInternalClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return(// eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $2PNUx.default), {
                ...modalProps,
                UNSAFE__disableInitialAutoFocus: (0, $5T6N9.fg)('platform_dst-automated_focus'),
                ref: modalRef,
                onClose: onUserInteractionClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress
            }, container, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $6ztSZ.FocusInsideOnLoad), {
                entryPointReference: entryPointReference,
                autoFocusRef: modalProps?.autoFocus,
                modalRef: modalRef,
                waitForContentReady: waitForContentReady
            })));
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        id,
        packageName,
        teamName,
        entryPointProps,
        ModalErrorFallback,
        onError,
        onRequestClose,
        loadingText,
        errorTitle,
        errorText,
        errorCloseText,
        onContentReady,
        resetContentReady,
        waitForContentReady
    ]);
    const triggerRef = (0, $85Ele.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $8V6dQ.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef,
        'aria-haspopup': 'dialog'
    });
}
$67c0e0d792b55b28$export$fb10b32cfe19f1e.displayName = "ModalTrigger";

});
parcelRegister("wZyN2", function(module, exports) {
$parcel$export(module.exports, "useContentReadySignal", () => $e5b6e57ad072b221$export$16e5184805aaf31a);

var $fsvuC = parcelRequire("fsvuC");
function $e5b6e57ad072b221$export$16e5184805aaf31a() {
    const isContentReadyRef = (0, $fsvuC.useRef)(false);
    const onContentReadyRef = (0, $fsvuC.useRef)(null);
    const resetContentReady = (0, $fsvuC.useCallback)(()=>{
        isContentReadyRef.current = false;
        onContentReadyRef.current = null;
    }, []);
    const onContentReady = (0, $fsvuC.useCallback)(()=>{
        isContentReadyRef.current = true;
        const callback = onContentReadyRef.current;
        onContentReadyRef.current = null;
        callback?.();
    }, []);
    const waitForContentReady = (0, $fsvuC.useCallback)((callback)=>{
        if (isContentReadyRef.current) {
            callback();
            return ()=>{};
        }
        onContentReadyRef.current = callback;
        return ()=>{
            if (onContentReadyRef.current === callback) onContentReadyRef.current = null;
        };
    }, []);
    return {
        onContentReady: onContentReady,
        resetContentReady: resetContentReady,
        waitForContentReady: waitForContentReady
    };
}

});

parcelRegister("5w7nx", function(module, exports) {
$parcel$export(module.exports, "ErrorFallback", () => $bd4bfc63418b19e9$export$8a7ad05c3ee0c78a);

var $fsvuC = parcelRequire("fsvuC");

var $76zfX = parcelRequire("76zfX");

var $dJ6LB = parcelRequire("dJ6LB");

var $e6Xis = parcelRequire("e6Xis");

var $brBog = parcelRequire("brBog");

var $clYgZ = parcelRequire("clYgZ");

var $kBK9z = parcelRequire("kBK9z");
const $bd4bfc63418b19e9$var$defaultErrorTitle = "Couldn't load dialog content";
const $bd4bfc63418b19e9$var$defaultErrorText = 'Something went wrong while loading the dialog content. Dismiss to go back';
const $bd4bfc63418b19e9$var$defaultCloseLabel = 'Close';
const $bd4bfc63418b19e9$export$8a7ad05c3ee0c78a = ({ error: _, closeModal: closeModal, errorTitle: errorTitle, title: title, errorText: errorText = $bd4bfc63418b19e9$var$defaultErrorText, errorCloseText: errorCloseText = $bd4bfc63418b19e9$var$defaultCloseLabel })=>{
    const modalTitle = errorTitle ?? title ?? $bd4bfc63418b19e9$var$defaultErrorTitle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $brBog.default), {
        hasCloseButton: true,
        closeButtonLabel: errorCloseText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $clYgZ.default), {
        appearance: "danger"
    }, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $dJ6LB.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $kBK9z.Text), {
        as: "p"
    }, errorText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $e6Xis.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $76zfX.default), {
        appearance: "primary",
        onClick: closeModal
    }, errorCloseText)));
};
$bd4bfc63418b19e9$export$8a7ad05c3ee0c78a.displayName = "ErrorFallback";

});

parcelRegister("6ztSZ", function(module, exports) {
$parcel$export(module.exports, "FocusInsideOnLoad", () => $5c2645944fc19c56$export$eb58c1f6b41ee511);

var $fsvuC = parcelRequire("fsvuC");

var $5T6N9 = parcelRequire("5T6N9");

var $eVUS8 = parcelRequire("eVUS8");

var $7JsUS = parcelRequire("7JsUS");

var $b5GX6 = parcelRequire("b5GX6");
function $5c2645944fc19c56$var$FocusInsideOnLoadInner({ autoFocusRef: autoFocusRef, modalRef: modalRef, waitForContentReady: waitForContentReady }) {
    (0, $fsvuC.useEffect)(()=>{
        const modalElement = modalRef.current;
        if (!modalElement) return;
        const focusContent = ()=>{
            if ((0, $5T6N9.fg)('platform_dst-automated_focus')) {
                const result = (0, $eVUS8.applyInitialFocus)({
                    container: modalElement,
                    // Modal Dialog permits a ref whose current value is `undefined`; the
                    // shared focus contract treats that the same as an unset ref.
                    initialFocusRef: autoFocusRef,
                    role: 'dialog'
                });
                if (!result.applied) modalElement.focus();
                return;
            }
            // If ref provided, use that first. Else find first focusable element or
            // container if not exists
            if (autoFocusRef?.current) {
                autoFocusRef.current.focus();
                return;
            }
            const firstFocusable = (0, $7JsUS.getFirstFocusable)({
                container: modalElement
            });
            if (firstFocusable) {
                firstFocusable.focus();
                return;
            }
            modalElement.focus();
        };
        if (!(0, $5T6N9.fg)('platform_dst-trigger-focus-after-content')) {
            focusContent();
            return;
        }
        return waitForContentReady(focusContent);
    }, [
        autoFocusRef,
        modalRef,
        waitForContentReady
    ]);
    return null;
}
$5c2645944fc19c56$var$FocusInsideOnLoadInner.displayName = "FocusInsideOnLoadInner";
function $5c2645944fc19c56$export$eb58c1f6b41ee511({ entryPointReference: entryPointReference, autoFocusRef: autoFocusRef, modalRef: modalRef, waitForContentReady: waitForContentReady }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $b5GX6.WaitForEntryPointLoad), {
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($5c2645944fc19c56$var$FocusInsideOnLoadInner, {
        autoFocusRef: autoFocusRef,
        modalRef: modalRef,
        waitForContentReady: waitForContentReady
    }));
}
$5c2645944fc19c56$export$eb58c1f6b41ee511.displayName = "FocusInsideOnLoad";

});
parcelRegister("b5GX6", function(module, exports) {
$parcel$export(module.exports, "WaitForEntryPointLoad", () => $8cca82d85ee319e3$export$ed96a854f3831b66);

var $fsvuC = parcelRequire("fsvuC");

var $jY9mG = parcelRequire("jY9mG");

var $iqo7S = parcelRequire("iqo7S");
function $8cca82d85ee319e3$var$SuspendUntilLoaded({ entryPointReference: entryPointReference, children: children }) {
    // The result is intentionally unused — this call exists purely to gate
    // the mount of children on the load completing.
    entryPointReference.getComponent();
    return children;
}
function $8cca82d85ee319e3$export$ed96a854f3831b66({ entryPointReference: entryPointReference, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $jY9mG.ErrorBoundary), {
        fallbackRender: ()=>children,
        onError: (0, $iqo7S.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($8cca82d85ee319e3$var$SuspendUntilLoaded, {
        entryPointReference: entryPointReference
    }, children)));
}
$8cca82d85ee319e3$export$ed96a854f3831b66.displayName = "WaitForEntryPointLoad";

});


parcelRegister("k9MLR", function(module, exports) {
$parcel$export(module.exports, "Loading", () => $fad84e1379a13d37$export$669f6ea7d267feaf);

var $fsvuC = parcelRequire("fsvuC");

var $dJ6LB = parcelRequire("dJ6LB");

var $e6Xis = parcelRequire("e6Xis");

var $brBog = parcelRequire("brBog");

var $clYgZ = parcelRequire("clYgZ");

var $dAp3w = parcelRequire("dAp3w");
const $fad84e1379a13d37$export$669f6ea7d267feaf = ({ loadingText: loadingText, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $brBog.default), {
        hasCloseButton: true
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $clYgZ.default), null, title) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $dJ6LB.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $dAp3w.LoadingContent), {
        loadingText: loadingText ?? 'Loading dialog content...',
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $e6Xis.default), null));
$fad84e1379a13d37$export$669f6ea7d267feaf.displayName = "Loading";

});
parcelRegister("dAp3w", function(module, exports) {
$parcel$export(module.exports, "LoadingContent", () => $178705649e1331e1$export$4ab3512e4872e6ff);

var $fsvuC = parcelRequire("fsvuC");

var $1APHY = parcelRequire("1APHY");

var $kBK9z = parcelRequire("kBK9z");

var $k403E = parcelRequire("k403E");
const $178705649e1331e1$export$4ab3512e4872e6ff = ({ loadingText: loadingText, size: size })=>{
    const stackSpace = size === 'large' ? 'space.400' : 'space.200';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $1APHY.Stack), {
        space: stackSpace,
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $k403E.default), {
        size: size,
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $kBK9z.Text), {
        color: "color.text.subtle"
    }, loadingText));
};
$178705649e1331e1$export$4ab3512e4872e6ff.displayName = "LoadingContent";

});



parcelRegister("ccgVY", function(module, exports) {
$parcel$export(module.exports, "LinkButton", () => $4fe37d77421f3faf$export$29d11c0fe2fc51d8);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $eBNGe = parcelRequire("eBNGe");

var $e2VD8 = parcelRequire("e2VD8");

var $jzjAM = parcelRequire("jzjAM");
const $4fe37d77421f3faf$export$29d11c0fe2fc51d8 = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $e2VD8.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $jzjAM.ThemedLinkButton) : (0, $eBNGe.default);
    return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("jzjAM", function(module, exports) {
$parcel$export(module.exports, "ThemedLinkButton", () => $77d0dec036ff4aba$export$b0b5aeed52623827);
/* themed-link-button.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");
parcelRequire("fsvuC");

var $buELT = parcelRequire("buELT");

var $l8owV = parcelRequire("l8owV");
const $77d0dec036ff4aba$var$textButtonStyles = {
    iconBefore: "_26BoRwdnbC",
    text: "_1kk5Tkf7mX"
};
function $77d0dec036ff4aba$var$ThemedLinkButtonFn({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $5chsV.jsxs)((0, $l8owV.ThemedAnchor), {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                className: (0, $gJ6nT.default)([
                    $77d0dec036ff4aba$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                className: (0, $gJ6nT.default)([
                    $77d0dec036ff4aba$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    }));
}
$77d0dec036ff4aba$var$ThemedLinkButtonFn.displayName = "ThemedLinkButtonFn";
const $77d0dec036ff4aba$export$b0b5aeed52623827 = (0, $buELT.default)($77d0dec036ff4aba$var$ThemedLinkButtonFn);

});
parcelRegister("l8owV", function(module, exports) {
$parcel$export(module.exports, "ThemedAnchor", () => $ff5610f53c4eacad$export$1b69d1a78614cc52);
/* themed-anchor.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $4twf9 = parcelRequire("4twf9");

var $buELT = parcelRequire("buELT");

var $5hZWH = parcelRequire("5hZWH");

var $l413Q = parcelRequire("l413Q");
const $ff5610f53c4eacad$var$styles = {
    root: "_2mHwu8gVvo _2sNsIgmnOE _0bjKvDKTcp _23rrnHyKLB _00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _4c065UPgdg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VymQ6 _1mT5xdRAKS _3WzCGiyL8i _32C2rkyL8i _0DCa9DyL8i _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8 _3sFUREiSCN",
    border: "_2Gfj6iOLYo _0EnhYgPgdg _4lwhQT6wH8 _0dpm39NvrM _0GBAIrogpp _2WYcYGWVPG",
    selected: "_2uo31fhe06 _1UtDYzysOt _0z8nYC0GCl _10n1R5ysOt _2nTuUYysOt _30zrXRUQDy _0clgaMysOt _1gxogc4k8R _0CMRbkysOt",
    disabled: "_2uo31ftHCb _1UtDYzn3Ip _0z8nYCs4Fm _10n1R5n3Ip _2nTuUYn3Ip _30zrXRtHCb _0clgaMn3Ip _1gxogctHCb _0CMRbkn3Ip"
};
const $ff5610f53c4eacad$var$appearanceStyles = {
    default: "_2uo31fGfro _1UtDYz98eZ _0z8nYCQMmr _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    subtle: "_2uo31fGfro _1UtDYz98eZ _10n1R598eZ _2nTuUY98eZ _30zrXRJxD8 _0clgaM98eZ _1gxogcK3Oy _0CMRbk98eZ",
    primary: "_2uo31fxjIo _1UtDYzwGpT _10n1R5wGpT _2nTuUYwGpT _30zrXR2rJx _0clgaMwGpT _1gxogcHVA2 _0CMRbkwGpT"
};
const $ff5610f53c4eacad$var$shapeStyles = {
    default: "_2Y7lL48HPE",
    square: "_2Y7lL4Pgdg _39xV02ymQ6 _26BoRwdnbC"
};
function $ff5610f53c4eacad$var$ThemedAnchorFn({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5hZWH.Anchor), {
        ...(0, $l413Q.getPrimitiveSpreadProps)(props),
        ref: ref,
        /**
   * We are using some style values that are outside of the strict
   * `@atlaskit/css` types.
   */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $4twf9.cx)($ff5610f53c4eacad$var$styles.root, $ff5610f53c4eacad$var$shapeStyles[shape], hasBorder && $ff5610f53c4eacad$var$styles.border, $ff5610f53c4eacad$var$appearanceStyles[appearance], isSelected && $ff5610f53c4eacad$var$styles.selected, isDisabled && $ff5610f53c4eacad$var$styles.disabled)
    });
}
$ff5610f53c4eacad$var$ThemedAnchorFn.displayName = "ThemedAnchorFn";
const $ff5610f53c4eacad$export$1b69d1a78614cc52 = (0, $buELT.default)($ff5610f53c4eacad$var$ThemedAnchorFn);

});



parcelRegister("8IGY1", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $016a3c9577ba121f$export$6da5aa77c402ba0f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b9c55c8ffa026c174f3b8612196e48f7>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $hBUvp = parcelRequire("hBUvp");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $016a3c9577ba121f$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
</svg>
`;
const $016a3c9577ba121f$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>
</svg>
`;
function $016a3c9577ba121f$export$6da5aa77c402ba0f({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Customer Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hBUvp.IconWrapper), {
        svg: $016a3c9577ba121f$var$svg,
        customThemeSvg: $016a3c9577ba121f$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$016a3c9577ba121f$export$6da5aa77c402ba0f.displayName = "CustomerServiceManagementIcon";

});

parcelRegister("b3RE8", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $774f2d4e694569b8$export$3c6158790f5e01c4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::018e1283e27acb8e799a70f211bb080a>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $hBUvp = parcelRequire("hBUvp");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $774f2d4e694569b8$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
</svg>
`;
const $774f2d4e694569b8$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
</svg>
`;
function $774f2d4e694569b8$export$3c6158790f5e01c4({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hBUvp.IconWrapper), {
        svg: $774f2d4e694569b8$var$svg,
        customThemeSvg: $774f2d4e694569b8$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$774f2d4e694569b8$export$3c6158790f5e01c4.displayName = "JiraServiceManagementIcon";

});

parcelRegister("jDgWP", function(module, exports) {
$parcel$export(module.exports, "PopupTrigger", () => $36716ada163ca52f$export$95d4acdbab2fc6ef);

var $fsvuC = parcelRequire("fsvuC");

var $iNT4o = parcelRequire("iNT4o");

var $3NfiF = parcelRequire("3NfiF");

var $5T6N9 = parcelRequire("5T6N9");

var $2LKzh = parcelRequire("2LKzh");

var $eVUS8 = parcelRequire("eVUS8");

var $85Ele = parcelRequire("85Ele");

var $7z61P = parcelRequire("7z61P");

var $bGf4T = parcelRequire("bGf4T");

var $9J9d6 = parcelRequire("9J9d6");

var $9owtR = parcelRequire("9owtR");

var $wZyN2 = parcelRequire("wZyN2");

var $cMNF8 = parcelRequire("cMNF8");

var $lNLPs = parcelRequire("lNLPs");


var $kkY33 = parcelRequire("kkY33");

var $l6w1c = parcelRequire("l6w1c");

var $d0bFx = parcelRequire("d0bFx");

var $d3K7S = parcelRequire("d3K7S");

var $2WCkQ = parcelRequire("2WCkQ");

var $asQ3r = parcelRequire("asQ3r");
const $36716ada163ca52f$var$emptyEntryPointParams = {};
const $36716ada163ca52f$var$emptyEntryPointProps = {};
const $36716ada163ca52f$var$FallbackComponent = ({ fallback: fallback, loadingText: loadingText, onMount: onMount, onUnmount: onUnmount, onFocusStateChange: onFocusStateChange, shouldFocus: shouldFocus, role: role })=>{
    const ref = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        if (shouldFocus) {
            if ((0, $5T6N9.fg)('platform_dst-automated_focus')) {
                const container = ref.current?.parentElement;
                if (container && (0, $d3K7S.isFocusMovingRole)({
                    role: role
                })) (0, $eVUS8.applyInitialFocus)({
                    container: container,
                    initialFocusRef: ref,
                    role: role
                });
            } else ref.current?.focus();
        }
        onMount();
        return ()=>onUnmount();
    }, [
        onMount,
        onUnmount,
        shouldFocus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement("span", {
        ref: ref,
        tabIndex: shouldFocus ? -1 : undefined,
        "data-testid": "popup-trigger-loading",
        onBlur: ()=>onFocusStateChange(false),
        onFocus: ()=>onFocusStateChange(true)
    }, fallback || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $2WCkQ.Loading), {
        loadingText: loadingText
    }));
};
$36716ada163ca52f$var$FallbackComponent.displayName = "FallbackComponent";
/**
 * Whether the popup's own initial focus target should be forwarded to the
 * entry point and used to restore focus.
 *
 * Both gates are always read, rather than short-circuited, so that each gate
 * is accessed regardless of the other gate's value.
 */ function $36716ada163ca52f$var$isInitialFocusForwardingEnabled() {
    const isAutomatedFocusEnabled = (0, $5T6N9.fg)('platform_dst-automated_focus');
    const isInitialFocusRefEnabled = (0, $5T6N9.fg)('platform_dst-popup-trigger-initial-focus-ref');
    return isAutomatedFocusEnabled || isInitialFocusRefEnabled;
}
function $36716ada163ca52f$export$95d4acdbab2fc6ef({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, errorText: errorText, errorTitle: errorTitle, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, onClose: onClose, onPopupOpen: onPopupOpen, preloadOnFocus: preloadOnFocus = true, autoFocus: autoFocus, loadingText: loadingText = 'Loading popup...', loadingCompleteText: loadingCompleteText = 'Loading is complete.', shouldCloseOnItemClick: shouldCloseOnItemClick = false, ...popupProps }) {
    const environmentProvider = (0, $bGf4T.useRelayEnvironmentProvider)();
    const id = (0, $fsvuC.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const [isOpen, setIsOpen] = (0, $fsvuC.useState)(false);
    const [content, setContent] = (0, $fsvuC.useState)(null);
    const { statusText: statusText, announce: announce, cancelPendingAnnouncement: cancelPendingAnnouncement, resetStatus: resetStatus } = (0, $cMNF8.useStatusAnnouncement)();
    const isOpenRef = (0, $fsvuC.useRef)(false);
    const hasErrorRef = (0, $fsvuC.useRef)(false);
    const triggerFocusRef = (0, $fsvuC.useRef)(null);
    const updateRef = (0, $fsvuC.useRef)(null);
    const setInitialFocusRef = (0, $fsvuC.useRef)(null);
    const initialFocusRef = (0, $fsvuC.useRef)(null);
    const shouldTransferFocusRef = (0, $fsvuC.useRef)(false);
    const handleError = (0, $fsvuC.useCallback)((props)=>{
        if (isOpenRef.current) {
            hasErrorRef.current = true;
            resetStatus();
            announce({
                text: errorText ?? (0, $531256d3fe3ee2a2$export$73e31d6dbeb74c41),
                clearAfter: 5000
            });
        }
        onError?.(props);
    }, [
        announce,
        errorText,
        onError,
        resetStatus
    ]);
    const handleOpen = (0, $fsvuC.useCallback)(()=>{
        isOpenRef.current = true;
        setIsOpen(true);
        // Notify at activation time, before popup content is queued for rendering. The native
        // opening listener can commit state before the trigger's React onClick runs.
        onPopupOpen?.();
    }, [
        onPopupOpen
    ]);
    const handleClose = (0, $fsvuC.useCallback)((event, currentLevel)=>{
        isOpenRef.current = false;
        setIsOpen(false);
        if ($36716ada163ca52f$var$isInitialFocusForwardingEnabled() && popupProps.shouldReturnFocus !== false && event?.type === 'keydown' && 'key' in event && (event.key === 'Escape' || event.key === 'Esc')) setTimeout(()=>{
            if (document.activeElement === document.body) triggerFocusRef.current?.focus();
        }, 0);
        resetStatus();
        onClose?.(event, currentLevel);
    }, [
        onClose,
        popupProps.shouldReturnFocus,
        resetStatus,
        triggerFocusRef
    ]);
    // Content that closes the popup from its own item handler has already closed it by the time
    // this runs, so it must not report a second close.
    const handleItemClick = (0, $fsvuC.useCallback)((event)=>{
        if (isOpenRef.current) handleClose(event);
    }, [
        handleClose
    ]);
    const triggerCloseRef = (0, $asQ3r.useClickToCloseRef)({
        isOpen: isOpen,
        handleClose: handleClose
    });
    const { onContentReady: onContentReady, resetContentReady: resetContentReady, waitForContentReady: waitForContentReady } = (0, $wZyN2.useContentReadySignal)();
    const load = (0, $fsvuC.useCallback)(()=>(0, $iNT4o.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $36716ada163ca52f$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const popupSetInitialFocusRef = (0, $fsvuC.useRef)(null);
    const handleSetInitialFocusRef = (0, $fsvuC.useCallback)((el)=>{
        initialFocusRef.current = el;
        popupSetInitialFocusRef.current?.(el);
    }, []);
    const onLoad = (0, $fsvuC.useCallback)(({ reference: entryPointReference })=>{
        // Use the rendered open state: the separate close listener may already have
        // reset isOpenRef on this click. Reading that ref would reopen the popup.
        if (isOpen) return;
        resetContentReady();
        hasErrorRef.current = false;
        shouldTransferFocusRef.current = false;
        handleOpen();
        const entryPointContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $7z61P.InternalEntryPointContainer), {
            id: id,
            onContentReady: onContentReady,
            entryPointReference: entryPointReference,
            fallback: // when the fallback is unmounted we want to trigger an update to the popup position
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($36716ada163ca52f$var$FallbackComponent, {
                fallback: fallback,
                loadingText: loadingText,
                onMount: ()=>{
                    announce({
                        text: loadingText,
                        delay: 100
                    });
                },
                onUnmount: ()=>{
                    if (!hasErrorRef.current) {
                        const wasPending = cancelPendingAnnouncement();
                        if (!wasPending && isOpenRef.current) announce({
                            text: loadingCompleteText,
                            clearAfter: 5000
                        });
                    }
                    return updateRef.current?.();
                },
                onFocusStateChange: (wasFocused)=>{
                    shouldTransferFocusRef.current = wasFocused;
                },
                shouldFocus: autoFocus !== false,
                role: popupProps.role
            }),
            errorFallback: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $kkY33.FocusErrorExperience), {
                    role: popupProps.role,
                    shouldFocus: autoFocus !== false,
                    shouldTransferFocusRef: shouldTransferFocusRef,
                    triggerRef: triggerFocusRef
                }, errorFallback ? errorFallback(props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $9J9d6.ErrorContent), {
                    title: errorTitle,
                    errorText: errorText ?? (0, $531256d3fe3ee2a2$export$73e31d6dbeb74c41)
                })),
            runtimeProps: {
                ...entryPointProps ?? $36716ada163ca52f$var$emptyEntryPointProps,
                onContentResized: ()=>{
                    updateRef.current?.();
                },
                onClose: handleClose,
                ...$36716ada163ca52f$var$isInitialFocusForwardingEnabled() ? {
                    setInitialFocusRef: handleSetInitialFocusRef
                } : {}
            },
            onError: handleError,
            forcedError: forcedReportErrorUFO
        });
        setContent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment, null, shouldCloseOnItemClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $lNLPs.CloseOnItemClick), {
            onItemClick: handleItemClick
        }, entryPointContainer) : entryPointContainer, autoFocus !== false && ((0, $5T6N9.fg)('platform_dst-popup-trigger-focus-container') && !(0, $5T6N9.fg)('platform_dst-automated_focus') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $d0bFx.FocusOnContainerOnLoad), {
            entryPointReference: entryPointReference,
            setInitialFocusRef: setInitialFocusRef,
            waitForContentReady: waitForContentReady
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $l6w1c.FocusInsideOnLoad), {
            entryPointReference: entryPointReference,
            initialFocusRef: initialFocusRef,
            role: popupProps.role,
            setInitialFocusRef: setInitialFocusRef,
            shouldTransferFocusRef: shouldTransferFocusRef,
            triggerRef: triggerFocusRef,
            waitForContentReady: waitForContentReady
        }))));
    }, [
        setContent,
        id,
        isOpen,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        errorText,
        errorTitle,
        handleOpen,
        handleError,
        announce,
        cancelPendingAnnouncement,
        handleClose,
        handleSetInitialFocusRef,
        autoFocus,
        loadingCompleteText,
        loadingText,
        onContentReady,
        resetContentReady,
        shouldCloseOnItemClick,
        waitForContentReady,
        handleItemClick,
        popupProps.role
    ]);
    const triggerRef = (0, $85Ele.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const popupTrigger = (0, $fsvuC.useCallback)((triggerProps)=>{
        const mergedRef = (0, $3NfiF.mergeRefs)([
            triggerRef,
            triggerProps.ref,
            triggerCloseRef,
            triggerFocusRef
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef
        });
    }, [
        trigger,
        triggerRef,
        triggerCloseRef,
        triggerFocusRef
    ]);
    const popupContent = (0, $fsvuC.useCallback)(({ update: update, setInitialFocusRef: setInitialFocusRef })=>{
        updateRef.current = update;
        if ($36716ada163ca52f$var$isInitialFocusForwardingEnabled()) popupSetInitialFocusRef.current = setInitialFocusRef;
        return content;
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $2LKzh.Popup), {
        ...popupProps,
        autoFocus: autoFocus,
        UNSAFE__disableInitialAutoFocus: (0, $5T6N9.fg)('platform_dst-automated_focus'),
        isOpen: isOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        // Run time passes the setter for every role; the types hide it. Goes at the flag cleanup.
        content: popupContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $9owtR.StatusAnnouncement), null, statusText));
}
$36716ada163ca52f$export$95d4acdbab2fc6ef.displayName = "PopupTrigger";

});
parcelRegister("9J9d6", function(module, exports) {
$parcel$export(module.exports, "ErrorContent", () => $15df98f4f00cd211$export$a9f602ed820d9782);
/* error-content.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fsvuC = parcelRequire("fsvuC");

var $gcAhT = parcelRequire("gcAhT");

var $6Pb6R = parcelRequire("6Pb6R");

var $8C8EQ = parcelRequire("8C8EQ");

var $1APHY = parcelRequire("1APHY");

var $kBK9z = parcelRequire("kBK9z");
const $15df98f4f00cd211$var$styles = {
    errorContainer: "_4ouGXIoaux _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
};
function $15df98f4f00cd211$export$a9f602ed820d9782({ errorText: errorText, title: title }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $8C8EQ.Flex), {
        justifyContent: "center",
        xcss: $15df98f4f00cd211$var$styles.errorContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $1APHY.Stack), {
        space: "space.200"
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $8C8EQ.Flex), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Pb6R))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $gcAhT.default), {
        size: "small",
        as: "h2"
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $kBK9z.Text), {
        as: "p"
    }, errorText)));
}
$15df98f4f00cd211$export$a9f602ed820d9782.displayName = "ErrorContent";

});

parcelRegister("9owtR", function(module, exports) {
$parcel$export(module.exports, "StatusAnnouncement", () => $aadd364167cc2f8d$export$1144e05dc01c8ac);
/* status-announcement.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fsvuC = parcelRequire("fsvuC");

var $fpjto = parcelRequire("fpjto");

var $01oqo = parcelRequire("01oqo");
const $aadd364167cc2f8d$var$styles = {
    container: "_1mT5xdy1CL _2I62gzdnbC _3iC0zddnbC _39xV02dnbC _0jFU0VdnbC _1pp6NdYbGa"
};
function $aadd364167cc2f8d$export$1144e05dc01c8ac({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $fpjto.Box), {
        xcss: $aadd364167cc2f8d$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $01oqo.default), {
        role: "status"
    }, children));
}
$aadd364167cc2f8d$export$1144e05dc01c8ac.displayName = "StatusAnnouncement";

});

parcelRegister("cMNF8", function(module, exports) {
$parcel$export(module.exports, "useStatusAnnouncement", () => $7e130c247555d4a7$export$f2e04a9fdd1a3236);

var $fsvuC = parcelRequire("fsvuC");
function $7e130c247555d4a7$export$f2e04a9fdd1a3236() {
    const [statusText, setStatusText] = (0, $fsvuC.useState)('');
    const announceTimeout = (0, $fsvuC.useRef)(null);
    const clearTimeoutRef = (0, $fsvuC.useRef)(null);
    const cancelPendingAnnouncement = (0, $fsvuC.useCallback)(()=>{
        if (announceTimeout.current === null) return false;
        clearTimeout(announceTimeout.current);
        announceTimeout.current = null;
        return true;
    }, []);
    const cancelClear = (0, $fsvuC.useCallback)(()=>{
        if (clearTimeoutRef.current !== null) {
            clearTimeout(clearTimeoutRef.current);
            clearTimeoutRef.current = null;
        }
    }, []);
    const resetStatus = (0, $fsvuC.useCallback)(()=>{
        cancelPendingAnnouncement();
        cancelClear();
        setStatusText('');
    }, [
        cancelPendingAnnouncement,
        cancelClear
    ]);
    const announce = (0, $fsvuC.useCallback)(({ text: text, delay: delay = 0, clearAfter: clearAfter })=>{
        cancelPendingAnnouncement();
        cancelClear();
        const publish = ()=>{
            announceTimeout.current = null;
            setStatusText(text);
            if (clearAfter !== undefined) clearTimeoutRef.current = setTimeout(()=>{
                setStatusText('');
                clearTimeoutRef.current = null;
            }, clearAfter);
        };
        if (delay === 0) publish();
        else announceTimeout.current = setTimeout(publish, delay);
    }, [
        cancelPendingAnnouncement,
        cancelClear
    ]);
    (0, $fsvuC.useEffect)(()=>()=>{
            cancelPendingAnnouncement();
            cancelClear();
        }, [
        cancelPendingAnnouncement,
        cancelClear
    ]);
    return {
        statusText: statusText,
        announce: announce,
        cancelPendingAnnouncement: cancelPendingAnnouncement,
        resetStatus: resetStatus
    };
}

});

parcelRegister("lNLPs", function(module, exports) {
$parcel$export(module.exports, "CloseOnItemClick", () => $858da304d830e1cf$export$f18d42803ecfe229);
/* close-on-item-click.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $dqdTY = parcelRequire("dqdTY");
const $858da304d830e1cf$var$styles = {
    root: "_3iDTPbcK7c"
};
const $858da304d830e1cf$var$nativeItemSelector = 'a[href], button';
const $858da304d830e1cf$var$itemSelector = `${$858da304d830e1cf$var$nativeItemSelector}, [role="menuitem"]`;
/**
 * Items that keep the popup open: they are unavailable, they open or expand something the user
 * still needs the popup for, or they toggle a selection the user may change several times.
 */ const $858da304d830e1cf$var$keepsPopupOpenSelector = [
    '[aria-disabled="true"]',
    '[aria-expanded]',
    '[aria-haspopup]:not([aria-haspopup="false"])',
    '[role="menuitemcheckbox"]',
    '[role="menuitemradio"]'
].join(', ');
// The surfaces ADS layers render: the legacy popup wrapper, top-layer popovers, and dialogs.
const $858da304d830e1cf$var$layerSelector = '[data-ds--level], [popover], dialog, [role="dialog"]';
/**
 * Returns the item in the popup's own layer that the event activated, unless the item keeps the
 * popup open.
 */ function $858da304d830e1cf$var$getClosingItem(boundary, event) {
    // Modifier clicks open links in a new tab or window, so the user is still here.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return null;
    if (!(event.target instanceof Element)) return null;
    const item = event.target.closest($858da304d830e1cf$var$itemSelector);
    // Containment is checked in the DOM, so a layer the content opens in a portal — a modal, say —
    // does not count as the content. A layer it opens inline is inside the boundary, so the item
    // must also share the boundary's nearest layer.
    if (!item || !boundary.contains(item) || item.closest($858da304d830e1cf$var$layerSelector) !== boundary.closest($858da304d830e1cf$var$layerSelector) || item.matches($858da304d830e1cf$var$keepsPopupOpenSelector)) return null;
    return item;
}
function $858da304d830e1cf$export$f18d42803ecfe229({ children: children, onItemClick: onItemClick }) {
    const boundaryRef = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        const boundary = boundaryRef.current;
        if (!boundary) return;
        // Listening on the document in the bubble phase runs after React has dispatched the event to
        // the item, which it does from its root container. An item that stops propagation keeps the
        // popup open.
        return (0, $dqdTY.bindAll)(boundary.ownerDocument, [
            {
                type: 'click',
                listener: (event)=>{
                    if ($858da304d830e1cf$var$getClosingItem(boundary, event)) onItemClick(event);
                }
            },
            {
                // Enter on a link or button dispatches a click, which the listener above handles. No
                // click follows when the item handles Enter itself and prevents the default, as router
                // links do, or when the item is not a native link or button.
                type: 'keydown',
                listener: (event)=>{
                    if (event.key !== 'Enter' || event.repeat) return;
                    const item = $858da304d830e1cf$var$getClosingItem(boundary, event);
                    if (item && (event.defaultPrevented || !item.matches($858da304d830e1cf$var$nativeItemSelector))) onItemClick(event);
                }
            }
        ]);
    }, [
        onItemClick
    ]);
    return /*#__PURE__*/ $fsvuC.createElement("div", {
        ref: boundaryRef,
        className: (0, $gJ6nT.default)([
            $858da304d830e1cf$var$styles.root
        ])
    }, children);
}
$858da304d830e1cf$export$f18d42803ecfe229.displayName = "CloseOnItemClick";

});

const $531256d3fe3ee2a2$export$73e31d6dbeb74c41 = 'Something went wrong while loading the popup content.';

parcelRegister("kkY33", function(module, exports) {
$parcel$export(module.exports, "FocusErrorExperience", () => $c4cec7f7ad301054$export$3b3dbedadc5a6ab9);

var $fsvuC = parcelRequire("fsvuC");

var $5T6N9 = parcelRequire("5T6N9");

var $eVUS8 = parcelRequire("eVUS8");

var $b1A11 = parcelRequire("b1A11");
function $c4cec7f7ad301054$export$3b3dbedadc5a6ab9({ children: children, role: role, shouldFocus: shouldFocus, shouldTransferFocusRef: shouldTransferFocusRef, triggerRef: triggerRef }) {
    const ref = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        if (!shouldFocus || !(0, $5T6N9.fg)('platform_dst-automated_focus')) return;
        const container = ref.current?.parentElement;
        if (!container || !(0, $b1A11.shouldMoveFocus)({
            container: container,
            role: role,
            shouldTransferFocusRef: shouldTransferFocusRef,
            triggerRef: triggerRef
        })) return;
        const result = (0, $eVUS8.applyInitialFocus)({
            container: container,
            role: role
        });
        if (!result.applied) (0, $eVUS8.applyInitialFocus)({
            container: container,
            initialFocusRef: ref,
            role: role
        });
    }, [
        role,
        shouldFocus,
        shouldTransferFocusRef,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement("span", {
        ref: ref,
        tabIndex: shouldFocus ? -1 : undefined
    }, children);
}
$c4cec7f7ad301054$export$3b3dbedadc5a6ab9.displayName = "FocusErrorExperience";

});
parcelRegister("b1A11", function(module, exports) {
$parcel$export(module.exports, "shouldMoveFocus", () => $4c6bb2df25f444f0$export$9c43340be6393b15);

var $d3K7S = parcelRequire("d3K7S");
function $4c6bb2df25f444f0$export$9c43340be6393b15({ container: container, role: role, shouldTransferFocusRef: shouldTransferFocusRef, triggerRef: triggerRef }) {
    if (!(0, $d3K7S.isFocusMovingRole)({
        role: role
    })) return false;
    const activeElement = container.ownerDocument.activeElement;
    return shouldTransferFocusRef.current || container.contains(activeElement) || activeElement === triggerRef.current;
}

});
parcelRegister("d3K7S", function(module, exports) {
$parcel$export(module.exports, "isFocusMovingRole", () => $f469f3779fa6d41d$export$f52dd3ecbda3822c);
function $f469f3779fa6d41d$export$f52dd3ecbda3822c({ role: role }) {
    return role === 'dialog' || role === 'alertdialog' || role === 'menu' || role === 'listbox';
}

});



parcelRegister("l6w1c", function(module, exports) {
$parcel$export(module.exports, "FocusInsideOnLoad", () => $7d0d55dd080d4409$export$eb58c1f6b41ee511);

var $fsvuC = parcelRequire("fsvuC");

var $5T6N9 = parcelRequire("5T6N9");

var $eVUS8 = parcelRequire("eVUS8");

var $7JsUS = parcelRequire("7JsUS");

var $5q4rR = parcelRequire("5q4rR");

var $b1A11 = parcelRequire("b1A11");
function $7d0d55dd080d4409$export$eb58c1f6b41ee511({ entryPointReference: entryPointReference, initialFocusRef: initialFocusRef, role: role, setInitialFocusRef: setInitialFocusRef, shouldTransferFocusRef: shouldTransferFocusRef, triggerRef: triggerRef, waitForContentReady: waitForContentReady }) {
    const handleLoad = (0, $fsvuC.useCallback)((container)=>{
        if ((0, $5T6N9.fg)('platform_dst-automated_focus')) {
            const initialFocusTarget = initialFocusRef.current;
            const hasInitialFocusTarget = initialFocusTarget !== null && container.contains(initialFocusTarget);
            if (!hasInitialFocusTarget && !(0, $b1A11.shouldMoveFocus)({
                container: container,
                role: role,
                shouldTransferFocusRef: shouldTransferFocusRef,
                triggerRef: triggerRef
            })) return;
            if (hasInitialFocusTarget) {
                // An entry point explicitly selected this target. Unlike the role-based
                // defaults below, it must take precedence even for roles such as
                // `tooltip` that do not otherwise move focus.
                initialFocusTarget.focus();
                return;
            }
            const result = (0, $eVUS8.applyInitialFocus)({
                container: container,
                role: role
            });
            if (!result.applied) {
                container.tabIndex = -1;
                (0, $eVUS8.applyInitialFocus)({
                    container: container,
                    initialFocusRef: {
                        current: container
                    },
                    role: role
                });
            }
            return;
        }
        // Focus the first focusable element of the loaded experience, or the
        // popup itself when the experience has nothing focusable in it.
        const target = (0, $7JsUS.getFirstFocusable)({
            container: container
        }) ?? container;
        // The popup focuses its initial target once, when it opens. If that has
        // not happened yet — because the entry point was already loaded — this
        // makes the popup focus the target instead of itself, avoiding focus
        // moving twice.
        setInitialFocusRef.current?.(target);
        target.focus();
    }, [
        initialFocusRef,
        role,
        setInitialFocusRef,
        shouldTransferFocusRef,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $5q4rR.FocusOnLoad), {
        entryPointReference: entryPointReference,
        onLoad: handleLoad,
        waitForContentReady: waitForContentReady
    });
}
$7d0d55dd080d4409$export$eb58c1f6b41ee511.displayName = "FocusInsideOnLoad";

});
parcelRegister("5q4rR", function(module, exports) {
$parcel$export(module.exports, "FocusOnLoad", () => $84e9edc44fd7bd88$export$192b96059b53397f);

var $fsvuC = parcelRequire("fsvuC");

var $5T6N9 = parcelRequire("5T6N9");

var $b5GX6 = parcelRequire("b5GX6");
function $84e9edc44fd7bd88$var$FocusOnLoadInner({ onLoad: onLoad, waitForContentReady: waitForContentReady }) {
    const anchorRef = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        // `Popup` does not expose a ref to the element wrapping its content, so
        // it is resolved through this anchor, which renders as a sibling of the
        // loaded experience inside that element.
        const container = anchorRef.current?.parentElement;
        if (!container) return;
        const focusContent = ()=>onLoad(container);
        if (!(0, $5T6N9.fg)('platform_dst-trigger-focus-after-content')) {
            focusContent();
            return;
        }
        return waitForContentReady(focusContent);
    }, [
        onLoad,
        waitForContentReady
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement("span", {
        ref: anchorRef,
        hidden: true
    });
}
$84e9edc44fd7bd88$var$FocusOnLoadInner.displayName = "FocusOnLoadInner";
function $84e9edc44fd7bd88$export$192b96059b53397f({ entryPointReference: entryPointReference, onLoad: onLoad, waitForContentReady: waitForContentReady }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $b5GX6.WaitForEntryPointLoad), {
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement($84e9edc44fd7bd88$var$FocusOnLoadInner, {
        onLoad: onLoad,
        waitForContentReady: waitForContentReady
    }));
}
$84e9edc44fd7bd88$export$192b96059b53397f.displayName = "FocusOnLoad";

});


parcelRegister("d0bFx", function(module, exports) {
$parcel$export(module.exports, "FocusOnContainerOnLoad", () => $92cfe536c973988c$export$82324a1aa77ecbcc);

var $fsvuC = parcelRequire("fsvuC");

var $5q4rR = parcelRequire("5q4rR");
function $92cfe536c973988c$export$82324a1aa77ecbcc({ entryPointReference: entryPointReference, setInitialFocusRef: setInitialFocusRef, waitForContentReady: waitForContentReady }) {
    const handleLoad = (0, $fsvuC.useCallback)((container)=>{
        setInitialFocusRef.current?.(container);
        container.focus();
    }, [
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $5q4rR.FocusOnLoad), {
        entryPointReference: entryPointReference,
        onLoad: handleLoad,
        waitForContentReady: waitForContentReady
    });
}
$92cfe536c973988c$export$82324a1aa77ecbcc.displayName = "FocusOnContainerOnLoad";

});

parcelRegister("2WCkQ", function(module, exports) {
$parcel$export(module.exports, "Loading", () => $2aeeb65e6dfa78b3$export$669f6ea7d267feaf);

var $fsvuC = parcelRequire("fsvuC");

var $kxfZ1 = parcelRequire("kxfZ1");

var $gJeXl = parcelRequire("gJeXl");

var $dAp3w = parcelRequire("dAp3w");
const $2aeeb65e6dfa78b3$var$spinnerContainerStyles = (0, $gJeXl.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
function $2aeeb65e6dfa78b3$export$669f6ea7d267feaf({ loadingText: loadingText }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $kxfZ1.Box), {
        xcss: $2aeeb65e6dfa78b3$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $dAp3w.LoadingContent), {
        loadingText: loadingText ?? 'Loading popup...',
        size: "small"
    }));
}
$2aeeb65e6dfa78b3$export$669f6ea7d267feaf.displayName = "Loading";

});

parcelRegister("asQ3r", function(module, exports) {
$parcel$export(module.exports, "useClickToCloseRef", () => $a6dd30beb04bb20e$export$46ec6629f411921d);

var $fsvuC = parcelRequire("fsvuC");
function $a6dd30beb04bb20e$export$46ec6629f411921d({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const clickListener = ()=>{
            if (isOpen) handleClose(null);
        };
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('click', clickListener);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            el.removeEventListener('click', clickListener);
        };
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
}

});


parcelRegister("Bj17K", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", () => $926358163dbd421b$export$8d789f76fde3e05);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::30c7e77d0c70a3a1f66632de11893604>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $hBUvp = parcelRequire("hBUvp");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $926358163dbd421b$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
function $926358163dbd421b$export$8d789f76fde3e05({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hBUvp.IconWrapper), {
        svg: $926358163dbd421b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$926358163dbd421b$export$8d789f76fde3e05.displayName = "LoomIcon";

});

parcelRegister("lM93g", function(module, exports) {
$parcel$export(module.exports, "generateTheme", () => $c09c98899d94f474$export$2e4ecffaca289a18);

var $idYQe = parcelRequire("idYQe");

var $77WmF = parcelRequire("77WmF");

var $atIPC = parcelRequire("atIPC");

var $1IEsU = parcelRequire("1IEsU");

var $6ySQ3 = parcelRequire("6ySQ3");

var $idfwM = parcelRequire("idfwM");
const $c09c98899d94f474$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $c09c98899d94f474$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $c09c98899d94f474$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $idfwM.hexToRGBA)(backgroundColor, 0.65) : (0, $6ySQ3.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $1IEsU.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $1IEsU.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $idfwM.hexToRGBA)(backgroundColor, 0.8) : (0, $6ySQ3.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $1IEsU.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $6ySQ3.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $1IEsU.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $6ySQ3.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $1IEsU.getBoxShadow)('transparent')
        }
    };
};
const $c09c98899d94f474$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $atIPC.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $c09c98899d94f474$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $atIPC.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $idYQe.DEFAULT_THEME_NAME)) return 0, $77WmF.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $c09c98899d94f474$var$generateButtonCSSStates($c09c98899d94f474$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $c09c98899d94f474$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $c09c98899d94f474$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $idfwM.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $idfwM.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $idfwM.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $1IEsU.getBoxShadow)((0, $idfwM.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $6ySQ3.getContrastColor)(0.1, $c09c98899d94f474$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};

});
parcelRegister("idYQe", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $19fe887583892de8$export$2491e13b198e597d);
$parcel$export(module.exports, "default", () => $19fe887583892de8$export$2e2bcd8739ae039);
const $19fe887583892de8$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $19fe887583892de8$var$defaultThemeCopy = JSON.parse(JSON.stringify($19fe887583892de8$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$19fe887583892de8$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$19fe887583892de8$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $19fe887583892de8$export$2491e13b198e597d = 'atlassian';
var $19fe887583892de8$export$2e2bcd8739ae039 = $19fe887583892de8$var$defaultTheme;

});

parcelRegister("77WmF", function(module, exports) {
$parcel$export(module.exports, "defaultThemeBrandRefresh", () => $3b253b5e8c026229$export$77823bc9863eaa03);

var $idYQe = parcelRequire("idYQe");
const $3b253b5e8c026229$var$defaultThemeCopy = JSON.parse(JSON.stringify((0, $idYQe.default)));
const $3b253b5e8c026229$export$77823bc9863eaa03 = $3b253b5e8c026229$var$defaultThemeCopy;

});

parcelRegister("atIPC", function(module, exports) {
$parcel$export(module.exports, "generateTextColor", () => $ba947b4922e4a4d3$export$10a10e7cd1193377);

var $479gE = parcelRequire("479gE");

var $8FBPD = parcelRequire("8FBPD");
const $ba947b4922e4a4d3$export$10a10e7cd1193377 = (color)=>{
    const converted = (0, $8FBPD.convertHexShorthand)(color);
    return (0, $479gE.default).contrastRatio(converted).hex;
};

});
parcelRegister("8FBPD", function(module, exports) {
$parcel$export(module.exports, "convertHexShorthand", () => $3a271f0de19801ef$export$db8d2130677f868c);
const $3a271f0de19801ef$var$hex = '[a-z0-9]';
const $3a271f0de19801ef$var$shortHandHexColorPattern = new RegExp(`#(${$3a271f0de19801ef$var$hex})(${$3a271f0de19801ef$var$hex})(${$3a271f0de19801ef$var$hex})`, 'i');
const $3a271f0de19801ef$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $3a271f0de19801ef$var$isShortHexColor = (color)=>color && color.length === 4;
const $3a271f0de19801ef$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$3a271f0de19801ef$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $3a271f0de19801ef$var$completeTriplet = (colors)=>`#${$3a271f0de19801ef$var$repeat(colors[1], 6)}`;
const $3a271f0de19801ef$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $3a271f0de19801ef$export$db8d2130677f868c = (color)=>{
    if ($3a271f0de19801ef$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($3a271f0de19801ef$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($3a271f0de19801ef$var$isTriplet(colors)) return $3a271f0de19801ef$var$completeTriplet(colors);
            else return $3a271f0de19801ef$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};

});


parcelRegister("1IEsU", function(module, exports) {
$parcel$export(module.exports, "getBoxShadow", () => $bdff393aff4ce250$export$bba5a971afe05444);
const $bdff393aff4ce250$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;

});

parcelRegister("6ySQ3", function(module, exports) {
$parcel$export(module.exports, "getContrastColor", () => $ce50fee3aafc17ec$export$77a1051494882576);

var $479gE = parcelRequire("479gE");

var $idfwM = parcelRequire("idfwM");
const $ce50fee3aafc17ec$export$77a1051494882576 = (contrastValue, opacityValue, color)=>(0, $idfwM.hexToRGBA)((0, $479gE.default).contrast(contrastValue, color).hex, opacityValue);

});
parcelRegister("idfwM", function(module, exports) {
$parcel$export(module.exports, "hexToRGBA", () => $a5329f3394cb0327$export$7229be6d7219ee6a);

var $479gE = parcelRequire("479gE");
const $a5329f3394cb0327$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $479gE.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};

});



parcelRegister("YIBUv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aff96bcfcadf44a79300107c56beac1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b68356b3f69919e$var$_react = $0b68356b3f69919e$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $0b68356b3f69919e$var$_iconNew = $0b68356b3f69919e$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $0b68356b3f69919e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsGraph".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-graph
 * Usage guidance:
 * Reserved for representing Assets graph
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b68356b3f69919e$var$AssetsGraphIcon = (props)=>/*#__PURE__*/ $0b68356b3f69919e$var$_react.default.createElement($0b68356b3f69919e$var$_iconNew.default, Object.assign({
        name: "AssetsGraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.78 4.28-1.833 1.832a3.5 3.5 0 0 1 0 3.774l1.833 1.834-1.06 1.06-1.833-1.833a3.5 3.5 0 0 1-3.775 0L4.28 12.78l-1.06-1.06 1.832-1.834a3.5 3.5 0 0 1 0-3.774L3.22 4.28l1.06-1.06 1.832 1.832a3.5 3.5 0 0 1 3.775 0l1.833-1.833zM9.414 6.586a2 2 0 1 0-2.828 2.827 2 2 0 0 0 2.828-2.827"/><path fill="currentcolor" d="M11.73.73a2.5 2.5 0 1 1 3.54 3.54A2.5 2.5 0 0 1 11.73.73m2.48 1.06A1 1 0 1 0 12.8 3.2a1 1 0 0 0 1.41-1.41m-2.48 9.94a2.5 2.5 0 1 1 3.54 3.54 2.5 2.5 0 0 1-3.54-3.53m2.48 1.06a1 1 0 1 0-1.41 1.42 1 1 0 0 0 1.41-1.41M.73.73a2.5 2.5 0 1 1 3.54 3.54A2.5 2.5 0 0 1 .73.73m2.48 1.06A1 1 0 1 0 1.8 3.21 1 1 0 0 0 3.21 1.8M.73 11.73a2.5 2.5 0 1 1 3.54 3.54 2.5 2.5 0 0 1-3.54-3.53m2.48 1.06a1 1 0 1 0-1.41 1.42 1 1 0 0 0 1.41-1.41"/>`
    }, props));
$0b68356b3f69919e$var$AssetsGraphIcon.displayName = 'AssetsGraphIcon';
var $0b68356b3f69919e$var$_default = module.exports.default = $0b68356b3f69919e$var$AssetsGraphIcon;

});

parcelRegister("eFDWt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::630f7862dea052120b01b06315f58212>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aae3e0b5caa1c9b1$var$_react = $aae3e0b5caa1c9b1$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $aae3e0b5caa1c9b1$var$_iconNew = $aae3e0b5caa1c9b1$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $aae3e0b5caa1c9b1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/spaces
 * Usage guidance:
 * Reserved for use for Jira Projects for now. This will replace the Jira rocket.
 * 
 * More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aae3e0b5caa1c9b1$var$SpacesIcon = (props)=>/*#__PURE__*/ $aae3e0b5caa1c9b1$var$_react.default.createElement($aae3e0b5caa1c9b1$var$_iconNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.497A5.98 5.98 0 0 1 11 13.196a5.98 5.98 0 0 1-4.608.584 29.4 29.4 0 0 0 3.858-1.882 29.4 29.4 0 0 0 3.559-2.401"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.424 2.308-.447.377-.013.751.017 1.083.126.338.111.678.32.888.685.354.613.152 1.296-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.396c-.444.413-.954.837-1.517 1.263a29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.581c-.65.275-1.272.505-1.85.683h-.003q-.28.087-.548.158c-.783.206-1.511.318-2.116.288-.505-.024-1.114-.161-1.49-.63l-.052-.068-.07-.11-.07-.138a1.6 1.6 0 0 1-.078-.973c.071-.342.231-.68.431-1 .35-.56.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.5a6 6 0 0 0-.698.878c-.147.235-.213.407-.236.516l-.004.046c.048.022.155.056.37.066.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34a4.5 4.5 0 0 0 1.24 2.396C5.986 10.743 7.347 10.11 8.75 9.3s2.63-1.673 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36c-.306.01-.68.066-1.111.165q.233.306.432.648.196.341.342.695c.394-.424.665-.789.816-1.081.098-.192.121-.302.127-.355l-.041-.018c-.106-.035-.288-.063-.565-.054" clip-rule="evenodd"/>`
    }, props));
$aae3e0b5caa1c9b1$var$SpacesIcon.displayName = 'SpacesIcon';
var $aae3e0b5caa1c9b1$var$_default = module.exports.default = $aae3e0b5caa1c9b1$var$SpacesIcon;

});

parcelRegister("enE1l", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bbe3107b8dcb4caf83567322ed86022>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a78241f6f5f7d0ff$var$_react = $a78241f6f5f7d0ff$var$_interopRequireDefault((parcelRequire("fsvuC")));

var $a78241f6f5f7d0ff$var$_iconNew = $a78241f6f5f7d0ff$var$_interopRequireDefault((parcelRequire("kXb4n")));
function $a78241f6f5f7d0ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sunset".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/sunset
 * Usage guidance:
 * Farewell feed in hello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a78241f6f5f7d0ff$var$SunsetIcon = (props)=>/*#__PURE__*/ $a78241f6f5f7d0ff$var$_react.default.createElement($a78241f6f5f7d0ff$var$_iconNew.default, Object.assign({
        name: "SunsetIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v2h-1.5V1zm3 2.845 1.414-1.415 1.06 1.061-1.413 1.414zm-8.586 1.07L1.75 3.5l1.06-1.06 1.415 1.414zM8 6a3 3 0 0 0-3 3H3.5a4.5 4.5 0 0 1 9 0H11a3 3 0 0 0-3-3M2 9H0V7.5h2zm14 0h-2V7.5h2zm-1 3H1v-1.5h14zm-4.5 1.5V15h-5v-1.5z" clip-rule="evenodd"/>`
    }, props));
$a78241f6f5f7d0ff$var$SunsetIcon.displayName = 'SunsetIcon';
var $a78241f6f5f7d0ff$var$_default = module.exports.default = $a78241f6f5f7d0ff$var$SunsetIcon;

});

parcelRegister("1Q2wC", function(module, exports) {
$parcel$export(module.exports, "GoalsIcon", () => $8533a16995ad639e$export$9eb74917ea768ed4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c4362ec97402bb58da4aa4719b522f90>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $hBUvp = parcelRequire("hBUvp");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $8533a16995ad639e$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
function $8533a16995ad639e$export$9eb74917ea768ed4({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hBUvp.IconWrapper), {
        svg: $8533a16995ad639e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$8533a16995ad639e$export$9eb74917ea768ed4.displayName = "GoalsIcon";

});

parcelRegister("9TP9j", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", () => $23fe4644514b32be$export$eeccc49dc7a12d9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97b6247692aeac56aeb21bd6a8750acc>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $hBUvp = parcelRequire("hBUvp");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $23fe4644514b32be$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848"/>
</svg>
`;
function $23fe4644514b32be$export$eeccc49dc7a12d9f({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Opsgenie', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hBUvp.IconWrapper), {
        svg: $23fe4644514b32be$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$23fe4644514b32be$export$eeccc49dc7a12d9f.displayName = "OpsgenieIcon";

});

parcelRegister("6WPWg", function(module, exports) {
$parcel$export(module.exports, "ProjectsIcon", () => $f1fec5559ffa617c$export$5ed3e1bb3b04fc02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8862141676163c22cf5b4279aef2ba3>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $hBUvp = parcelRequire("hBUvp");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $f1fec5559ffa617c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>
</svg>
`;
function $f1fec5559ffa617c$export$5ed3e1bb3b04fc02({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hBUvp.IconWrapper), {
        svg: $f1fec5559ffa617c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$f1fec5559ffa617c$export$5ed3e1bb3b04fc02.displayName = "ProjectsIcon";

});

parcelRegister("fciUC", function(module, exports) {
$parcel$export(module.exports, "TeamsIcon", () => $0dc6f02688d7d65f$export$1bcbc9c337da86da);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f5210074a380dcd268126674dc826a2>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $hBUvp = parcelRequire("hBUvp");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $0dc6f02688d7d65f$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>
</svg>
`;
function $0dc6f02688d7d65f$export$1bcbc9c337da86da({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Teams', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hBUvp.IconWrapper), {
        svg: $0dc6f02688d7d65f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$0dc6f02688d7d65f$export$1bcbc9c337da86da.displayName = "TeamsIcon";

});

parcelRegister("e8auh", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $9bae792bef25e0f9$export$21bfbeb62fdcce8d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29e2c6af008db660c9f38b0bce4ff4cc>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $hBUvp = parcelRequire("hBUvp");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $9bae792bef25e0f9$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
</svg>
`;
const $9bae792bef25e0f9$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
</svg>
`;
function $9bae792bef25e0f9$export$21bfbeb62fdcce8d({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $hBUvp.IconWrapper), {
        svg: $9bae792bef25e0f9$var$svg,
        customThemeSvg: $9bae792bef25e0f9$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}
$9bae792bef25e0f9$export$21bfbeb62fdcce8d.displayName = "JiraProductDiscoveryIcon";

});

parcelRegister("dQcY8", function(module, exports) {
$parcel$export(module.exports, "useOverflowStatus", () => $23bd3db4deb30539$export$3fcfc71fab3314f2);

var $fsvuC = parcelRequire("fsvuC");

var $qYv1I = parcelRequire("qYv1I");
const $23bd3db4deb30539$export$3fcfc71fab3314f2 = ()=>(0, $fsvuC.useContext)((0, $qYv1I.OverflowContext));

});
parcelRegister("qYv1I", function(module, exports) {
$parcel$export(module.exports, "OverflowContext", () => $da1926255bafadd1$export$79f16dd643143c25);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $fsvuC = parcelRequire("fsvuC");

var $iqo7S = parcelRequire("iqo7S");
const $da1926255bafadd1$export$79f16dd643143c25 = /*#__PURE__*/ (0, $fsvuC.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $iqo7S.default),
    closeOverflowMenu: (0, $iqo7S.default)
});

});


parcelRegister("loekp", function(module, exports) {
$parcel$export(module.exports, "AppSwitcher", () => $6aaf9d589a301cfd$export$9923361bd43fa030);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $4Cn0v = parcelRequire("4Cn0v");

var $5T6N9 = parcelRequire("5T6N9");

var $58UFo = parcelRequire("58UFo");
const $6aaf9d589a301cfd$var$toggleButtonTooltipOptions = {
    // We're disabling pointer events on the tooltip to prevent it from blocking mouse events, so that the side nav flyout stays open
    // when moving the mouse from the top bar to the side nav.
    ignoreTooltipPointerEvents: true
};
const $6aaf9d589a301cfd$export$9923361bd43fa030 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, interactionName: interactionName, isSelected: isSelected, testId: testId, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const pickedAppSwitcherIcon = (0, $5T6N9.fg)('platform_dst_ads_appswitcher_improvements') ? icon ?? (0, (/*@__PURE__*/$parcel$interopDefault($4Cn0v))) : (0, (/*@__PURE__*/$parcel$interopDefault($4Cn0v)));
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $58UFo.IconButton), {
        ref: ref,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        icon: pickedAppSwitcherIcon,
        label: label,
        appearance: "subtle",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        interactionName: interactionName,
        isTooltipDisabled: false,
        tooltip: $6aaf9d589a301cfd$var$toggleButtonTooltipOptions,
        isSelected: isSelected,
        testId: testId
    });
});

});

parcelRegister("28qzj", function(module, exports) {
$parcel$export(module.exports, "SpotlightPrimaryLink", () => $0ffae6dffc4977d9$export$82ba9bc832fb64);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $2YOL2 = parcelRequire("2YOL2");

var $5hZWH = parcelRequire("5hZWH");

var $kBK9z = parcelRequire("kBK9z");
const $0ffae6dffc4977d9$var$styles = {
    root: "_0bjKvDKxmn _24h04i2Njc _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYze5R3",
    outline: "_00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _3hxITi6wH8 _2V7sgONvrM _3vBAKHFIvx _2Y7lL4gVvo _0KLXrugozt _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _1eOmH6kTlo _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8 _3gzVzLVbka",
    primary: "_00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _3hxITi6wH8 _2V7sgONvrM _3vBAKHJrlu _2Y7lL4gVvo _0KLXruDM2k _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _1eOmH6hmrj _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8 _3gzVzLczkD"
};
const $0ffae6dffc4977d9$export$82ba9bc832fb64 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, appearance: appearance = 'outline', href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $5hZWH.Anchor), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: (0, $2YOL2.cx)($0ffae6dffc4977d9$var$styles.root, $0ffae6dffc4977d9$var$styles[appearance]),
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightPrimaryLink",
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kBK9z.Text), {
            as: "span",
            children: children
        })
    }));

});

parcelRegister("1Vak6", function(module, exports) {
$parcel$export(module.exports, "SpotlightSecondaryLink", () => $d036283bcac9533f$export$797d360648cfd970);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $5hZWH = parcelRequire("5hZWH");

var $kBK9z = parcelRequire("kBK9z");
const $d036283bcac9533f$var$styles = {
    root: "_0bjKvDKxmn _00uqCYyL8i _3xtjKNYbGa _0H9qDF6wH8 _2Y7lL4gVvo _4c065UFQfX _24h04i2Njc _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYze5R3 _0KLXrugozt _0DCa9DyL8i _3932vvYbGa _02cRtH6wH8 _1eOmH6kTlo _3WzCGiyL8i _0NqVRtYbGa _3BKYwu6wH8 _3gzVzLVbka"
};
const $d036283bcac9533f$export$797d360648cfd970 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $5hZWH.Anchor), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $d036283bcac9533f$var$styles.root,
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightSecondaryLink",
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kBK9z.Text), {
            as: "span",
            children: children
        })
    }));

});

parcelRegister("aeuCx", function(module, exports) {
$parcel$export(module.exports, "Aside", () => $009dae0f28d7de4f$export$ac3bdfe4cb17f64e);
/* aside.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $822dj = parcelRequire("822dj");

var $5T6N9 = parcelRequire("5T6N9");

var $4ZPLN = parcelRequire("4ZPLN");

var $d4nKw = parcelRequire("d4nKw");

var $cSKcF = parcelRequire("cSKcF");

var $f0Dt1 = parcelRequire("f0Dt1");

var $llimD = parcelRequire("llimD");

var $lYppp = parcelRequire("lYppp");

var $e3hSW = parcelRequire("e3hSW");

var $7RD7t = parcelRequire("7RD7t");
const $009dae0f28d7de4f$var$panelSplitterResizingVar = '--n_asdRsz';
/**
 * The bounds for Aside and Panel are purposely set to support the current usage in Jira.
 *
 * Jira sets the slot's width to `0px` when there is no active content to display in it.
 *   - This means the min width needs to support `0px`.
 * The Conversation Assistant component in Jira (rendered in a nav3 RightSidebar, or a nav4 Aside) has a custom resizing
 * implementation, which has a maximum width of `50vw`.
 *   - This means the max width needs to support `50vw`.
 *
 * This is not the final implementation and will be updated once Jira's usage has been fixed.
 * Ticket to track this is: https://jplat.atlassian.net/browse/BLU-3951
 *
 * We're using two different bounds for each slot here, to support the `0px` min width when programatically set using the
 * `defaultWidth` prop, and another one that is used when resizing the slots which has a sensible min width.
 */ const $009dae0f28d7de4f$var$asideWidthSlotBounds = {
    min: '0px',
    max: '50vw'
};
const $009dae0f28d7de4f$var$asideWidthResizeBounds = {
    min: '120px',
    max: '50vw'
};
function $009dae0f28d7de4f$var$getResizeBounds() {
    return $009dae0f28d7de4f$var$asideWidthResizeBounds;
}
const $009dae0f28d7de4f$var$styles = {
    root: "_1xC2CJjgYz _24h04i2Njc _1mT5xdRAKS _15X6Mhduac _1xHhlhF05b",
    inner: "_4bt5LAIZbP _2WAcuGIZbP _2I62gzgiHs _0jFU0VN91d _2MwU8rlOMI _2DiRUzHE3j"
};
const $009dae0f28d7de4f$var$fallbackDefaultWidth = 330;
function $009dae0f28d7de4f$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, defaultWidth: defaultWidthProp = $009dae0f28d7de4f$var$fallbackDefaultWidth, label: label = 'Aside', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $fsvuC.useContext)((0, $f0Dt1.DangerouslyHoistSlotSizes));
    const id = (0, $lYppp.useLayoutId)({
        providedId: providedId
    });
    const defaultWidth = (0, $7RD7t.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $009dae0f28d7de4f$var$fallbackDefaultWidth,
        slotName: 'Aside'
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   *
   * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
   */ (0, $4ZPLN.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0 || (0, $5T6N9.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const ref = (0, $fsvuC.useRef)(null);
    const [width, setWidth] = (0, $fsvuC.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const previousWidthProp = (0, $822dj.default)(defaultWidth);
    /**
   * Updates the width state based on changes to `defaultWidth`.
   * This is temporary and needed to support the current usage in Jira, and will be removed once it is no longer needed.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $fsvuC.useEffect)(()=>{
        setWidth(defaultWidth);
    }, [
        defaultWidth
    ]);
    // Putting the warning in a separate effect to avoid adding `previousWidthProp` as an effect dependency when updating width.
    (0, $fsvuC.useEffect)(()=>{}, [
        defaultWidth,
        previousWidthProp
    ]);
    const asideVariableWidth = `clamp(${$009dae0f28d7de4f$var$asideWidthSlotBounds.min}, ${width}px, ${$009dae0f28d7de4f$var$asideWidthSlotBounds.max})`;
    (0, $e3hSW.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes,
        panelId: (0, $d4nKw.asidePanelSplitterId),
        cssVar: $009dae0f28d7de4f$var$panelSplitterResizingVar
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)("aside", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        className: (0, $gJ6nT.default)([
            $009dae0f28d7de4f$var$styles.root,
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            [(0, $d4nKw.asideVar)]: asideVariableWidth
        },
        "data-testid": testId,
        ref: ref,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $cSKcF.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $d4nKw.UNSAFE_asideLayoutVar),
                value: "0px",
                mediaQuery: '@media (min-width: 64rem)',
                responsiveValue: `var(${$009dae0f28d7de4f$var$panelSplitterResizingVar}, ${asideVariableWidth})`
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $llimD.PanelSplitterProvider), {
                panelId: (0, $d4nKw.asidePanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: $009dae0f28d7de4f$var$getResizeBounds,
                resizingCssVar: $009dae0f28d7de4f$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    "data-testid": testId ? `${testId}--inner` : undefined,
                    className: (0, $gJ6nT.default)([
                        $009dae0f28d7de4f$var$styles.inner
                    ]),
                    children: children
                })
            })
        ]
    });
}
$009dae0f28d7de4f$export$ac3bdfe4cb17f64e.displayName = "Aside";

});

parcelRegister("cP2dN", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $6fe66a297255ba5b$export$3b4e64e77073e307);
/* banner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $5T6N9 = parcelRequire("5T6N9");

var $4ZPLN = parcelRequire("4ZPLN");

var $d4nKw = parcelRequire("d4nKw");

var $cSKcF = parcelRequire("cSKcF");

var $5EVfh = parcelRequire("5EVfh");

var $f0Dt1 = parcelRequire("f0Dt1");

var $lYppp = parcelRequire("lYppp");
const $6fe66a297255ba5b$var$styles = {
    root: "_1xC2CJweDq _4bt5LAnQyn _2WAcuGnQyn _0jFU0V9QlX _2I62gzdnbC _1mT5xdHE3j _42Yu6B8OLE"
};
function $6fe66a297255ba5b$export$3b4e64e77073e307({ children: children, xcss: xcss, height: // 48px has been chosen to align with the height of the Banner component from `@atlaskit/banner`.
height = 48, skipLinkLabel: skipLinkLabel = 'Banner', testId: testId, id: providedId }) {
    const dangerouslyHoistSlotSizes = (0, $fsvuC.useContext)((0, $f0Dt1.DangerouslyHoistSlotSizes));
    const id = (0, $lYppp.useLayoutId)({
        providedId: providedId
    });
    /**
   * Don't show the skip link if the slot has 0 height.
   *
   * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
   */ (0, $4ZPLN.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: height === 0 || (0, $5T6N9.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)("div", {
        id: id,
        "data-layout-slot": true,
        className: (0, $gJ6nT.default)([
            $6fe66a297255ba5b$var$styles.root,
            xcss
        ]),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $5EVfh.HoistCssVarToLocalGrid), {
                variableName: (0, $d4nKw.bannerMountedVar),
                value: height
            }),
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $cSKcF.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $d4nKw.UNSAFE_bannerVar),
                value: height
            }),
            children
        ]
    });
}
$6fe66a297255ba5b$export$3b4e64e77073e307.displayName = "Banner";

});
parcelRegister("5EVfh", function(module, exports) {
$parcel$export(module.exports, "HoistCssVarToLocalGrid", () => $12bf5a86a333284a$export$cfa3cd08d675e56e);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $oprSU = parcelRequire("oprSU");
const $12bf5a86a333284a$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>/*#__PURE__*/ (0, $5chsV.jsx)("style", {
        children: `#${(0, $oprSU.gridRootId)} { ${variableName}: ${value}px }`
    });
$12bf5a86a333284a$export$cfa3cd08d675e56e.displayName = "HoistCssVarToLocalGrid";

});


parcelRegister("36LDQ", function(module, exports) {
$parcel$export(module.exports, "Main", () => $72f7d51eacb9336b$export$861edd1ccea2f746);
/* main.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $5T6N9 = parcelRequire("5T6N9");

var $6OcmT = parcelRequire("6OcmT");

var $d4nKw = parcelRequire("d4nKw");

var $jfjDK = parcelRequire("jfjDK");

var $oprSU = parcelRequire("oprSU");

var $lYppp = parcelRequire("lYppp");

var $lWbRc = parcelRequire("lWbRc");
const $72f7d51eacb9336b$var$contentInsetBlockStartStatic = `calc(var(--n_bnrM, 0px) + var(--n_tNvM, 0px))`;
const $72f7d51eacb9336b$var$contentHeightWhenFixedStatic = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tNvM, 0px))`;
const $72f7d51eacb9336b$var$mainElementStyles = {
    root: "_1xC2CJOQJL _4bt5LAIZbP _2WAcuGIZbP _2YgrGrP0S5 _2I62gzgiHs _0jFU0VlOMI _0zToRPIZbP _1M50CAIZbP _2DiRUzHE3j"
};
function $72f7d51eacb9336b$export$861edd1ccea2f746({ children: children, xcss: xcss, skipLinkLabel: skipLinkLabel = (0, $5T6N9.fg)('platform_dst_nav4_skip_link_a11y_1') ? 'Main content' : 'Main Content', testId: testId, id: providedId, minWidth: minWidth = (0, $d4nKw.defaultMainMinWidth) }) {
    const id = (0, $lYppp.useLayoutId)({
        providedId: providedId
    });
    (0, $lWbRc.useLayoutMainSizing)(minWidth);
    (0, $6OcmT.useSkipLink)(id, skipLinkLabel);
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $fsvuC.Fragment), {
        children: [
            (0, $5T6N9.fg)('platform-dst-chat-panel-layout') && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
            /*#__PURE__*/ (0, $5chsV.jsx)("style", {
                children: `#${(0, $oprSU.gridRootId)}, #${(0, $oprSU.gridRootFitId)} { ${(0, $d4nKw.mainMinimumWidthVar)}: ${minWidth}px; }`
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                id: id,
                "data-layout-slot": true,
                className: (0, $gJ6nT.default)([
                    $72f7d51eacb9336b$var$mainElementStyles.root,
                    xcss
                ]),
                role: "main",
                "data-testid": testId,
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $jfjDK.MainMinWidthContext).Provider, {
                    value: (0, $5T6N9.fg)('platform-dst-chat-panel-layout') ? minWidth : (0, $d4nKw.defaultMainMinWidth),
                    children: children
                })
            })
        ]
    });
}
$72f7d51eacb9336b$export$861edd1ccea2f746.displayName = "Main";

});
parcelRegister("6OcmT", function(module, exports) {
$parcel$export(module.exports, "useSkipLink", () => $740700e8d97052e2$export$89d9323301efc7d6);

var $4ZPLN = parcelRequire("4ZPLN");
const $740700e8d97052e2$export$89d9323301efc7d6 = (/**
	 * The unique ID for the skip link.
	 * You can use the `useSkipLinkId` hook to generate a unique ID.
	 */ id, /**
	 * The label for the skip link.
	 */ label, /**
	 * You can optionally set the position of the skip link in the list of skip links.
	 * Positions are zero-indexed.
	 */ listIndex)=>{
    (0, $4ZPLN.useSkipLinkInternal)({
        id: id,
        label: label,
        listIndex: listIndex
    });
};

});

parcelRegister("jfjDK", function(module, exports) {
$parcel$export(module.exports, "MainMinWidthContext", () => $16f5ac7e241fb329$export$b23e6ffeb0d132c8);

var $fsvuC = parcelRequire("fsvuC");

var $d4nKw = parcelRequire("d4nKw");
const $16f5ac7e241fb329$export$b23e6ffeb0d132c8 = /*#__PURE__*/ (0, $fsvuC.createContext)((0, $d4nKw.defaultMainMinWidth));

});

parcelRegister("lWbRc", function(module, exports) {
$parcel$export(module.exports, "useLayoutMainSizing", () => $9296ae474d78f9a8$export$da289e07ef5e0a12);

var $fsvuC = parcelRequire("fsvuC");

var $BFYYG = parcelRequire("BFYYG");
function $9296ae474d78f9a8$export$da289e07ef5e0a12(minWidth) {
    const context = (0, $fsvuC.useContext)((0, $BFYYG.LayoutAreaSizingContext));
    const setMainMinWidth = context?.setMainMinWidth;
    (0, $fsvuC.useEffect)(()=>setMainMinWidth?.(minWidth), [
        minWidth,
        setMainMinWidth
    ]);
}

});


parcelRegister("iIZNz", function(module, exports) {
$parcel$export(module.exports, "Panel", () => $0a08598ec4df119f$export$2ddb90ad54e5f587);
/* panel.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $1cXpO = parcelRequire("1cXpO");

var $bX1gK = parcelRequire("bX1gK");

var $c4Atc = parcelRequire("c4Atc");

var $7U5Xt = parcelRequire("7U5Xt");

var $5T6N9 = parcelRequire("5T6N9");

var $4ZPLN = parcelRequire("4ZPLN");

var $d4nKw = parcelRequire("d4nKw");

var $cSKcF = parcelRequire("cSKcF");

var $f0Dt1 = parcelRequire("f0Dt1");

var $llimD = parcelRequire("llimD");

var $6a1tO = parcelRequire("6a1tO");

var $lYppp = parcelRequire("lYppp");

var $e3hSW = parcelRequire("e3hSW");

var $7RD7t = parcelRequire("7RD7t");
const $0a08598ec4df119f$var$panelSplitterResizingVar = '--n_pnlRsz';
const $0a08598ec4df119f$var$fallbackDefaultWidth = 365;
/**
 * We typically use the `defaultWidth` as the minimum resizing width,
 * but for large default widths we fallback to a standard value.
 *
 * This standard value of `400px` is to align with the Global Preview Panels.
 */ const $0a08598ec4df119f$var$fallbackResizeMinWidth = 400;
const $0a08598ec4df119f$var$styles = {
    root: "_1xC2CJ39pk _2p6ht9F05b _24h04i2Njc _42Yu6B7dHp _0jFU0VlOMI _1mT5xdHE3j _2I62gzgiHs _0KLXruoI2d _39xV02mSzM _2EWYUbwuPN _0hAebtlfZc _3gynorcCME _0E5nkyIZbP",
    border: "_2YmqfPYbGa _2OUyjtGk8v _4uZkDnOeNX _1RYJRxYbGa",
    scrollContainer: "_4bt5LAIZbP _2WAcuGIZbP _0jFU0VN91d",
    hidden: "_3iDTPbYbGa",
    entering: "_1jZhRJ3mzc _2qDx9m7CF6 _03Q0eexlqh _4xtBsMCT93 _4tikTSThaV _3JI830y1CL _2nUT5xdEse",
    exiting: "_1jZhRJiZOe _2qDx9m7CF6 _03Q0eexlqh _4xtBsMouYb _4tikTSThaV _0LZf8iy1CL _2nUT5xcfkA",
    contentEntering: "_2fBhteeOAp",
    contentExiting: "_2fBhtezSOH",
    contentChangeContainer: "_0jFU0VN91d"
};
const $0a08598ec4df119f$var$PanelContentMotion = ({ children: children })=>{
    const { state: state, ref: ref } = (0, $bX1gK.useMotion)();
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: ref,
        className: (0, $gJ6nT.default)([
            $0a08598ec4df119f$var$styles.contentChangeContainer,
            state === 'entering' && $0a08598ec4df119f$var$styles.contentEntering,
            state === 'exiting' && $0a08598ec4df119f$var$styles.contentExiting
        ]),
        children: children
    });
};
$0a08598ec4df119f$var$PanelContentMotion.displayName = "PanelContentMotion";
function $0a08598ec4df119f$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidthProp = $0a08598ec4df119f$var$fallbackDefaultWidth, label: label = 'Panel', skipLinkLabel: skipLinkLabel = label, testId: testId, id: providedId, xcss: xcss, hasBorder: hasBorder = true, maxWidth: maxWidth, contentKey: contentKey }) {
    const dangerouslyHoistSlotSizes = (0, $fsvuC.useContext)((0, $f0Dt1.DangerouslyHoistSlotSizes));
    const id = (0, $lYppp.useLayoutId)({
        providedId: providedId
    });
    const isMotionUpliftEnabled = (0, $5T6N9.fg)('platform-dst-motion-uplift-panel');
    const isContentMotionEnabled = (0, $5T6N9.fg)('platform-dst-motion-uplift-panel-content');
    const prevContentKeyRef = (0, $fsvuC.useRef)(contentKey);
    (0, $fsvuC.useEffect)(()=>{
        if (isContentMotionEnabled && contentKey !== undefined) prevContentKeyRef.current = contentKey;
    }, [
        contentKey,
        isContentMotionEnabled
    ]);
    const defaultWidth = (0, $7RD7t.useSafeDefaultWidth)({
        defaultWidthProp: defaultWidthProp,
        fallbackDefaultWidth: $0a08598ec4df119f$var$fallbackDefaultWidth,
        slotName: 'Panel'
    });
    // useMotion is applied only when the `platform-dst-motion-uplift-panel` gate is enabled.
    const { state: state, ref: motionRef, reanimate: reanimate } = (0, $bX1gK.useMotion)({
        onFinish: (state)=>{
            if (state === 'exiting' && defaultWidthRef.current === 0) // Set width to 0 as animation is complete
            setWidth(0);
        },
        initialState: defaultWidth === 0 ? 'hidden' : undefined
    });
    /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   *
   * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
   */ (0, $4ZPLN.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: defaultWidth === 0 || (0, $5T6N9.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const ref = (0, $fsvuC.useRef)(null);
    const [width, setWidth] = (0, $fsvuC.useState)(defaultWidth);
    // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
    const defaultWidthRef = (0, $fsvuC.useRef)(defaultWidth);
    // `mergeRefs` returns a new callback ref on every call, and combined with a new array literal
    // this would cause React to detach/re-attach the ref on every render. Memoise it so the merged
    // ref is stable across renders.
    const mergedRef = (0, $fsvuC.useMemo)(()=>isMotionUpliftEnabled ? (0, $1cXpO.default)([
            ref,
            motionRef
        ]) : ref, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isMotionUpliftEnabled,
        motionRef
    ]);
    /**
   * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
   * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
   * https://jplat.atlassian.net/browse/BLU-3951
   */ (0, $fsvuC.useEffect)(()=>{
        if (defaultWidthRef.current === defaultWidth) return;
        if (isMotionUpliftEnabled) {
            if (defaultWidth === 0) {
                reanimate((0, $7U5Xt.Reanimate).exit);
                defaultWidthRef.current = defaultWidth;
                // Set width to 0 once the exit animation is complete
                return;
            } else if (defaultWidthRef.current === 0) reanimate((0, $7U5Xt.Reanimate).enter);
        }
        defaultWidthRef.current = defaultWidth;
        setWidth(defaultWidth);
    }, [
        defaultWidth,
        isMotionUpliftEnabled,
        reanimate
    ]);
    const sideNavRef = (0, $6a1tO.useSideNavRef)();
    /**
   * The minimum width that the panel can be resized to by the user.
   *
   * We only use the `defaultWidth` up to a point to avoid huge panels.
   */ const minWidth = Math.min(defaultWidth, $0a08598ec4df119f$var$fallbackResizeMinWidth);
    /**
   * Returns the bounds for resizing, evaluated lazily when needed.
   *
   * Defined separately to the slot bounds because the resizing bounds need to be resolvable to a pixel value,
   * and the panel's slot bounds use a complex CSS expression.
   */ const getResizeBounds = (0, $fsvuC.useCallback)(()=>{
        const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0;
        /**
     * By default the panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
     *
     * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
     *
     * Consumers can opt in to a larger maximum via the `maxWidth` prop.
     */ const defaultMaxWidth = `${Math.round((window.innerWidth - sideNavWidth) / 2)}px`;
        return {
            min: `${minWidth}px`,
            max: maxWidth ?? defaultMaxWidth
        };
    }, [
        maxWidth,
        minWidth,
        sideNavRef
    ]);
    const panelWidthSlotBounds = {
        min: `${minWidth}px`,
        // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
        // Consumers can opt in to a larger maximum via the `maxWidth` prop.
        max: maxWidth ?? `round(nearest, calc((100vw - var(${0, $d4nKw.sideNavLiveWidthVar}, 0px)) / 2), 1px)`
    };
    const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
    (0, $e3hSW.useResizingWidthCssVarOnRootElement)({
        isEnabled: dangerouslyHoistSlotSizes,
        cssVar: $0a08598ec4df119f$var$panelSplitterResizingVar,
        panelId: (0, $d4nKw.panelPanelSplitterId)
    });
    return /*#__PURE__*/ (0, $5chsV.jsxs)("section", {
        id: id,
        "data-layout-slot": true,
        "aria-label": label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gJ6nT.default)([
            $0a08598ec4df119f$var$styles.root,
            isMotionUpliftEnabled && state === 'hidden' && $0a08598ec4df119f$var$styles.hidden,
            isMotionUpliftEnabled && state === 'entering' && $0a08598ec4df119f$var$styles.entering,
            isMotionUpliftEnabled && state === 'exiting' && $0a08598ec4df119f$var$styles.exiting,
            !isMotionUpliftEnabled && defaultWidth === 0 && $0a08598ec4df119f$var$styles.hidden,
            hasBorder && $0a08598ec4df119f$var$styles.border,
            xcss
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            [(0, $d4nKw.panelVar)]: panelVariableWidth,
            '--minWidth': `${minWidth}px`
        },
        "data-testid": testId,
        ref: mergedRef,
        children: [
            dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
            // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
            // When they aren't needed anymore we can delete them wholesale.
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $cSKcF.DangerouslyHoistCssVarToDocumentRoot), {
                variableName: (0, $d4nKw.UNSAFE_panelLayoutVar),
                value: "0px",
                mediaQuery: '@media (min-width: 90rem)',
                responsiveValue: `var(${$0a08598ec4df119f$var$panelSplitterResizingVar}, ${panelVariableWidth})`
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)((0, $llimD.PanelSplitterProvider), {
                panelId: (0, $d4nKw.panelPanelSplitterId),
                panelRef: ref,
                panelWidth: width,
                onCompleteResize: setWidth,
                getResizeBounds: getResizeBounds,
                resizingCssVar: $0a08598ec4df119f$var$panelSplitterResizingVar,
                position: "start",
                children: /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    className: (0, $gJ6nT.default)([
                        $0a08598ec4df119f$var$styles.scrollContainer,
                        isMotionUpliftEnabled && state === 'entering' && $0a08598ec4df119f$var$styles.contentEntering,
                        isMotionUpliftEnabled && state === 'exiting' && $0a08598ec4df119f$var$styles.contentExiting
                    ]),
                    children: isContentMotionEnabled ? /*#__PURE__*/ (0, $5chsV.jsx)((0, $c4Atc.default), {
                        exitThenEnter: contentKey !== undefined,
                        children: /*#__PURE__*/ (0, $5chsV.jsx)($0a08598ec4df119f$var$PanelContentMotion, {
                            children: children
                        }, contentKey === undefined ? prevContentKeyRef.current : contentKey)
                    }) : children
                })
            })
        ]
    });
}
$0a08598ec4df119f$export$2ddb90ad54e5f587.displayName = "Panel";

});

parcelRegister("4DvwY", function(module, exports) {
$parcel$export(module.exports, "TopNav", () => $3bf4d9dc2eca4f16$export$41d0d88a6b0e456f);
/* top-nav.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $3cTN3 = parcelRequire("3cTN3");

var $5T6N9 = parcelRequire("5T6N9");

var $4ZPLN = parcelRequire("4ZPLN");

var $e2VD8 = parcelRequire("e2VD8");

var $dHe0X = parcelRequire("dHe0X");

var $byM5Y = parcelRequire("byM5Y");

var $i1pXz = parcelRequire("i1pXz");

var $d4nKw = parcelRequire("d4nKw");

var $cSKcF = parcelRequire("cSKcF");

var $5EVfh = parcelRequire("5EVfh");

var $f0Dt1 = parcelRequire("f0Dt1");

var $lYppp = parcelRequire("lYppp");
/**
 * Styles for the container for the top nav items.
 *
 * The background and border are applied to a different element for z-indexing reasons:
 *
 * - The items sit above the expanded side nav
 * - The background sits below the expanded side nav
 */ const $3bf4d9dc2eca4f16$var$styles = {
    root: "_1xC2CJ8ySg _2mHwu82ADO _2Y7lL48HPE _2R4pr3OeNX _3iDTPbgBM8 _2iEGP292QF _0hPCNLDIqT _0KLXrulfZc _24h04i2Njc _0jFU0VmTzZ _2I62gza2UD _1mT5xdHE3j _42Yu6B8OLE _0RYKppcK7c _3E0AG2ifeC"
};
/**
 * The top nav layout area. It will display at the top of the screen, below the banner if one is present.
 */ function $3bf4d9dc2eca4f16$var$TopNavOld({ children: children, xcss: xcss, height: heightProp, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, customTheme: customThemeConfig }) {
    const dangerouslyHoistSlotSizes = (0, $fsvuC.useContext)((0, $f0Dt1.DangerouslyHoistSlotSizes));
    const id = (0, $lYppp.useLayoutId)({
        providedId: providedId
    });
    (0, $4ZPLN.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: (0, $5T6N9.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const height = heightProp ?? ((0, $5T6N9.fg)('platform_dst_ads_appswitcher_improvements') ? 56 : 48);
    const customTheme = (0, $byM5Y.useCustomTheme)(customThemeConfig);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $e2VD8.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)("header", {
            id: id,
            "data-layout-slot": true,
            className: (0, $gJ6nT.default)([
                $3bf4d9dc2eca4f16$var$styles.root,
                xcss
            ]),
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: customTheme.isEnabled ? customTheme.style : undefined,
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $5EVfh.HoistCssVarToLocalGrid), {
                    variableName: (0, $d4nKw.topNavMountedVar),
                    value: height
                }),
                dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                // When they aren't needed anymore we can delete them wholesale.
                /*#__PURE__*/ (0, $5chsV.jsx)((0, $cSKcF.DangerouslyHoistCssVarToDocumentRoot), {
                    variableName: (0, $d4nKw.UNSAFE_topNavVar),
                    value: height
                }),
                children
            ]
        })
    });
}
$3bf4d9dc2eca4f16$var$TopNavOld.displayName = "TopNavOld";
/**
 * The top nav layout area. It will display at the top of the screen, below the banner if one is present.
 */ function $3bf4d9dc2eca4f16$var$TopNavNew({ children: children, xcss: xcss, height: heightProp, skipLinkLabel: skipLinkLabel = 'Top Bar', testId: testId, id: providedId, customTheme: customThemeConfig }) {
    const dangerouslyHoistSlotSizes = (0, $fsvuC.useContext)((0, $f0Dt1.DangerouslyHoistSlotSizes));
    const id = (0, $lYppp.useLayoutId)({
        providedId: providedId
    });
    (0, $4ZPLN.useSkipLinkInternal)({
        id: id,
        label: skipLinkLabel,
        isHidden: (0, $5T6N9.fg)('platform_dst_nav4_skip_link_a11y_1')
    });
    const height = heightProp ?? ((0, $5T6N9.fg)('platform_dst_ads_appswitcher_improvements') ? 56 : 48);
    const customTheme = (0, $i1pXz.useCustomThemeNew)(customThemeConfig);
    const hasDefaultBackground = customTheme.isEnabled ? customTheme.hasDefaultBackground : true;
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $e2VD8.HasCustomThemeContext).Provider, {
        value: customTheme.isEnabled,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $dHe0X.HasDefaultBackgroundColorContext).Provider, {
            value: hasDefaultBackground,
            children: /*#__PURE__*/ (0, $5chsV.jsxs)("header", {
                id: id,
                "data-layout-slot": true,
                className: (0, $gJ6nT.default)([
                    $3bf4d9dc2eca4f16$var$styles.root,
                    xcss
                ]),
                "data-testid": testId,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: customTheme.isEnabled ? customTheme.style : undefined,
                children: [
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $5EVfh.HoistCssVarToLocalGrid), {
                        variableName: (0, $d4nKw.topNavMountedVar),
                        value: height
                    }),
                    dangerouslyHoistSlotSizes && // ------ START UNSAFE STYLES ------
                    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
                    // When they aren't needed anymore we can delete them wholesale.
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $cSKcF.DangerouslyHoistCssVarToDocumentRoot), {
                        variableName: (0, $d4nKw.UNSAFE_topNavVar),
                        value: height
                    }),
                    children
                ]
            })
        })
    });
}
$3bf4d9dc2eca4f16$var$TopNavNew.displayName = "TopNavNew";
const $3bf4d9dc2eca4f16$export$41d0d88a6b0e456f = (0, $3cTN3.componentWithFG)('platform_dst_nav4_custom_theming_fhs_1', $3bf4d9dc2eca4f16$var$TopNavNew, $3bf4d9dc2eca4f16$var$TopNavOld);

});
parcelRegister("dHe0X", function(module, exports) {
$parcel$export(module.exports, "HasDefaultBackgroundColorContext", () => $dc6dac2feb9078db$export$e4314fea1a98d918);

var $fsvuC = parcelRequire("fsvuC");
const $dc6dac2feb9078db$export$e4314fea1a98d918 = /*#__PURE__*/ (0, $fsvuC.createContext)(true);

});

parcelRegister("byM5Y", function(module, exports) {
$parcel$export(module.exports, "useCustomTheme", () => $61786836cfd96684$export$c0c5f5b297b77726);

var $fsvuC = parcelRequire("fsvuC");

var $iCoFe = parcelRequire("iCoFe");
function $61786836cfd96684$export$c0c5f5b297b77726(theme) {
    const value = (0, $fsvuC.useMemo)(()=>{
        if (!theme?.backgroundColor || !theme?.highlightColor) return {
            isEnabled: false
        };
        /**
			 * Re-creating the `theme` object from it's pieces.
			 *
			 * _Technically_ we could just use `theme`, but that would involve an eslint opt out
			 * as we would be leveraging a value (`theme`) not in the dependency array.
			 *
			 * The current approach is the most correct™️ and avoids foot guns.
			 * We are only using values in the effect that are defined in the dependency array 🙌
			 */ const value = {
            backgroundColor: theme.backgroundColor,
            highlightColor: theme.highlightColor
        };
        const style = (0, $iCoFe.getCustomThemeStyles)(value);
        if (!style) // Either the `backgroundColor` or `highlightColor` could not be parsed
        return {
            isEnabled: false
        };
        return {
            isEnabled: true,
            style: style
        };
    }, // Using individual properties as keys for improved memoization.
    // Now this effect will only run if the values change rather than
    // the reference to the object (which might be new on every call)
    [
        theme?.backgroundColor,
        theme?.highlightColor
    ]);
    return value;
}

});
parcelRegister("iCoFe", function(module, exports) {
$parcel$export(module.exports, "getCustomThemeStyles", () => $6fc23c53c9a6a406$export$3986d75fe2da3239);

var $h1nyb = parcelRequire("h1nyb");

var $5Tw5T = parcelRequire("5Tw5T");

var $1D6wy = parcelRequire("1D6wy");

var $fzfIC = parcelRequire("fzfIC");

var $kaQmU = parcelRequire("kaQmU");

var $lKK5h = parcelRequire("lKK5h");
function $6fc23c53c9a6a406$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $6fc23c53c9a6a406$var$toRGBAString({ r: r, g: g, b: b, a: a }) {
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// Using raw hex codes because custom colors break out of the tokens model
// We will need to invert the colors based on backgroundColor independently of the app's color mode (dark/light)
// Values here are not final
const $6fc23c53c9a6a406$var$buttonStyles = {
    light: {
        ['--ds-top-bar-button-background']: 'transparent',
        ['--ds-top-bar-button-background-hovered']: (0, $fzfIC.palette).Neutral200A,
        ['--ds-top-bar-button-background-pressed']: (0, $fzfIC.palette).Neutral300A,
        ['--ds-top-bar-button-border']: (0, $fzfIC.palette).Neutral300A,
        ['--ds-top-bar-button-selected-background']: (0, $fzfIC.palette).Neutral300A,
        ['--ds-top-bar-button-selected-background-hovered']: (0, $fzfIC.palette).Neutral400A,
        ['--ds-top-bar-button-selected-background-pressed']: (0, $fzfIC.palette).Neutral500A,
        ['--ds-top-bar-button-disabled-text']: (0, $fzfIC.palette).Neutral400A,
        ['--ds-top-bar-button-disabled-background']: (0, $fzfIC.palette).Neutral100A
    },
    dark: {
        ['--ds-top-bar-button-background']: 'transparent',
        ['--ds-top-bar-button-background-hovered']: (0, $fzfIC.palette).DarkNeutral200A,
        ['--ds-top-bar-button-background-pressed']: (0, $fzfIC.palette).DarkNeutral300A,
        ['--ds-top-bar-button-border']: (0, $fzfIC.palette).DarkNeutral300A,
        ['--ds-top-bar-button-selected-background']: (0, $fzfIC.palette).DarkNeutral300A,
        ['--ds-top-bar-button-selected-background-hovered']: (0, $fzfIC.palette).DarkNeutral400A,
        ['--ds-top-bar-button-selected-background-pressed']: (0, $fzfIC.palette).DarkNeutral500A,
        ['--ds-top-bar-button-disabled-text']: (0, $fzfIC.palette).DarkNeutral400A,
        ['--ds-top-bar-button-disabled-background']: (0, $fzfIC.palette).DarkNeutral100A
    }
};
const $6fc23c53c9a6a406$var$logoStyles = {
    light: {
        ['--ds-top-bar-logo-icon']: (0, $fzfIC.palette).DarkNeutral0,
        ['--ds-top-bar-logo-text']: (0, $fzfIC.palette).DarkNeutral0
    },
    dark: {
        [(0, $h1nyb.themedLogoIcon)]: (0, $fzfIC.palette).Neutral0,
        [(0, $h1nyb.themedLogoText)]: (0, $fzfIC.palette).Neutral0
    }
};
function $6fc23c53c9a6a406$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
    const backgroundRgb = typeof backgroundColor === 'string' ? (0, $1D6wy.parseHex)(backgroundColor) : backgroundColor;
    const highlightRgb = typeof highlightColor === 'string' ? (0, $1D6wy.parseHex)(highlightColor) : highlightColor;
    if (!backgroundRgb || !highlightRgb) return null;
    const textColor = (0, $5Tw5T.getTextColor)(backgroundRgb);
    const colorMode = (0, $5Tw5T.getColorMode)(backgroundRgb);
    const highlightTextColor = (0, $5Tw5T.getTextColor)(highlightRgb);
    return {
        backgroundColor: $6fc23c53c9a6a406$var$toRGBString(backgroundRgb),
        color: textColor.hex,
        ...$6fc23c53c9a6a406$var$buttonStyles[colorMode],
        ...$6fc23c53c9a6a406$var$logoStyles[colorMode],
        ...$6fc23c53c9a6a406$var$getSelectedStyles({
            backgroundColor: backgroundRgb,
            colorMode: colorMode
        }),
        /**
		 * Search colors are the same as Nav 3
		 */ [(0, $lKK5h.themedSearchBorder)]: $6fc23c53c9a6a406$var$toRGBAString({
            ...textColor.rgb,
            a: 0.5
        }),
        [(0, $lKK5h.themedSearchBorderFocused)]: $6fc23c53c9a6a406$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        /**
		 * Primary button colors are the same as Nav 3,
		 * except the text color which can sometimes differ because we're
		 * now following WCAG
		 */ ['--ds-top-bar-button-primary-background']: $6fc23c53c9a6a406$var$toRGBString(highlightRgb),
        ['--ds-top-bar-button-primary-background-hovered']: $6fc23c53c9a6a406$var$toRGBAString({
            ...highlightRgb,
            a: 0.8
        }),
        ['--ds-top-bar-button-primary-background-pressed']: $6fc23c53c9a6a406$var$toRGBAString({
            ...highlightRgb,
            a: 0.65
        }),
        ['--ds-top-bar-button-primary-text']: highlightTextColor.hex
    };
}
/**
 * Precomputed RGBA values for the selected backgrounds
 */ const $6fc23c53c9a6a406$var$selectedBackgroundRGBA = {
    light: (0, $kaQmU.paletteRgba).Neutral300A,
    dark: (0, $kaQmU.paletteRgba).DarkNeutral300A
};
function $6fc23c53c9a6a406$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
    /**
	 * The background color of the selected button in its default state.
	 *
	 * We are referring to this as a foreground color because it is semi-transparent,
	 * so is not the actual color displayed when the button is on top of a background color.
	 */ const foregroundColor = $6fc23c53c9a6a406$var$selectedBackgroundRGBA[colorMode];
    /**
	 * The blended color seen when the selected background is over the top bar.
	 */ const blendedBackground = (0, $5Tw5T.simpleAlphaComposite)({
        background: backgroundColor,
        foreground: foregroundColor
    });
    return {
        ['--ds-top-bar-button-selected-text']: (0, $5Tw5T.getTextColor)(blendedBackground).hex,
        // Border colors are chosen to match the text, while remaining in the palette
        ['--ds-top-bar-button-selected-border']: (0, $5Tw5T.isLight)(blendedBackground) ? (0, $fzfIC.palette).Neutral1100 : (0, $fzfIC.palette).DarkNeutral1100
    };
}

});
parcelRegister("h1nyb", function(module, exports) {
$parcel$export(module.exports, "themedLogoIcon", () => $4d23b7c9703ad1e8$export$24328117f1132113);
$parcel$export(module.exports, "themedLogoText", () => $4d23b7c9703ad1e8$export$91b0830f8f4ab279);
$parcel$export(module.exports, "LogoRenderer", () => $4d23b7c9703ad1e8$export$35e88bd9b061a3a4);
/* logo-renderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $e2VD8 = parcelRequire("e2VD8");
const $4d23b7c9703ad1e8$export$24328117f1132113 = '--ds-top-bar-logo-icon';
const $4d23b7c9703ad1e8$export$91b0830f8f4ab279 = '--ds-top-bar-logo-text';
function $4d23b7c9703ad1e8$export$35e88bd9b061a3a4({ logoOrIcon: LogoOrIcon }) {
    const hasCustomTheme = (0, $e2VD8.useHasCustomTheme)();
    if (hasCustomTheme) return /*#__PURE__*/ (0, $5chsV.jsx)(LogoOrIcon, {
        label: "",
        size: "small",
        iconColor: `var(${$4d23b7c9703ad1e8$export$24328117f1132113})`,
        textColor: `var(${$4d23b7c9703ad1e8$export$91b0830f8f4ab279})`
    });
    return /*#__PURE__*/ (0, $5chsV.jsx)(LogoOrIcon, {
        size: "small",
        label: "",
        appearance: "brand"
    });
}
$4d23b7c9703ad1e8$export$35e88bd9b061a3a4.displayName = "LogoRenderer";

});

parcelRegister("5Tw5T", function(module, exports) {
$parcel$export(module.exports, "isLight", () => $23ece66c222259c4$export$44af652f4cca9039);
$parcel$export(module.exports, "getColorMode", () => $23ece66c222259c4$export$5573a5bab3e074b5);
$parcel$export(module.exports, "getTextColor", () => $23ece66c222259c4$export$5357fe757c335c0d);
$parcel$export(module.exports, "simpleAlphaComposite", () => $23ece66c222259c4$export$e5e64c30bee1469b);
/**
 * Removes sRGB gamma correction from the provided channel.
 * The resulting linear channel directly corresponds to subpixel intensity.
 *
 * Expects a normalized sRGB value (between 0 and 1)
 *
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $23ece66c222259c4$var$linearizeRGBChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
}
/**
 * This formula is derived from WCAG2 guidelines:
 * https://www.w3.org/WAI/WCAG22/Techniques/general/G18.html#tests
 */ function $23ece66c222259c4$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
    /**
	 * Normalized sRGB - each channel is between 0 and 1
	 */ const normal = {
        r: r / 255,
        g: g / 255,
        b: b / 255
    };
    /**
	 * linear RGB - the gamma correction of sRGB is removed and
	 * the channels correspond directly to subpixel intensity
	 */ const linear = {
        r: $23ece66c222259c4$var$linearizeRGBChannel(normal.r),
        g: $23ece66c222259c4$var$linearizeRGBChannel(normal.g),
        b: $23ece66c222259c4$var$linearizeRGBChannel(normal.b)
    };
    // For linear RGB, the relative luminance of a color is defined as:
    const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
    return L;
}
/**
 * This is the intersection point for W3C contrast ratio against:
 *
 * 1. black
 * 2. white
 *
 * In other words, the background luminance for which W3C contrast is equal
 * for both white and black text.
 *
 * Using a precomputed flip point means we can save a lot of calculations.
 *
 * This is only the theoretical flip point, and we can adjust it as needed.
 */ const $23ece66c222259c4$var$flipLuminance = 0.179129;
function $23ece66c222259c4$export$44af652f4cca9039(color) {
    return $23ece66c222259c4$var$relativeLuminanceW3C(color) >= $23ece66c222259c4$var$flipLuminance;
}
function $23ece66c222259c4$export$5573a5bab3e074b5(backgroundColor) {
    if ($23ece66c222259c4$var$relativeLuminanceW3C(backgroundColor) >= $23ece66c222259c4$var$flipLuminance) return 'light';
    return 'dark';
}
const $23ece66c222259c4$var$textColor = {
    light: {
        hex: '#000',
        rgb: {
            r: 0,
            g: 0,
            b: 0
        }
    },
    dark: {
        hex: '#FFF',
        rgb: {
            r: 255,
            g: 255,
            b: 255
        }
    }
};
function $23ece66c222259c4$export$5357fe757c335c0d(backgroundColor) {
    const colorMode = $23ece66c222259c4$export$5573a5bab3e074b5(backgroundColor);
    return $23ece66c222259c4$var$textColor[colorMode];
}
function $23ece66c222259c4$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
    return {
        r: foreground.a * foreground.r + background.r * (1 - foreground.a),
        g: foreground.a * foreground.g + background.g * (1 - foreground.a),
        b: foreground.a * foreground.b + background.b * (1 - foreground.a)
    };
}

});

parcelRegister("1D6wy", function(module, exports) {
$parcel$export(module.exports, "parseHex", () => $0ea412edcf434dd6$export$103711ef09c6edec);
// valid hex color (optional alpha channel) - 3, 4, 6, or 8 digits after the #
const $0ea412edcf434dd6$var$isValidHex = (hex)=>// Not using `([a-f0-9]{3,4}){1,2}` because that allows 7 digits which is invalid
    /^#(([a-f0-9]{3,4})|([a-f0-9][a-f0-9]){3,4})$/i.test(hex);
function $0ea412edcf434dd6$export$103711ef09c6edec(color) {
    if (!$0ea412edcf434dd6$var$isValidHex(color)) return null;
    let channels;
    if (color.length <= 5) // Hex code is shorthand - RGB channels are one digit
    channels = {
        r: color[1].repeat(2),
        g: color[2].repeat(2),
        b: color[3].repeat(2)
    };
    else // Hex code is longhand - RGB channels are two digits
    channels = {
        r: color.slice(1, 3),
        g: color.slice(3, 5),
        b: color.slice(5, 7)
    };
    return {
        r: parseInt(channels.r, 16),
        g: parseInt(channels.g, 16),
        b: parseInt(channels.b, 16)
    };
}

});

parcelRegister("fzfIC", function(module, exports) {
$parcel$export(module.exports, "palette", () => $6063bad036dfd923$export$eaad8caa32d2521d);
const $6063bad036dfd923$export$eaad8caa32d2521d = {
    'DarkNeutral-100': '#111213',
    'DarkNeutral-100A': '#01040475',
    DarkNeutral0: '#18191A',
    DarkNeutral100: '#1F1F21',
    DarkNeutral100A: '#BDBDBD0A',
    DarkNeutral200: '#242528',
    DarkNeutral200A: '#CECED912',
    DarkNeutral250: '#2B2C2F',
    DarkNeutral250A: '#D9DAE71A',
    DarkNeutral300: '#303134',
    DarkNeutral300A: '#E3E4F21F',
    DarkNeutral350: '#3D3F43',
    DarkNeutral350A: '#E8EDFD2E',
    DarkNeutral400: '#4B4D51',
    DarkNeutral400A: '#E5E9F640',
    DarkNeutral500: '#63666B',
    DarkNeutral500A: '#E9F0FB5C',
    DarkNeutral600: '#7E8188',
    DarkNeutral700: '#96999E',
    DarkNeutral800: '#A9ABAF',
    DarkNeutral900: '#BFC1C4',
    DarkNeutral1000: '#CECFD2',
    DarkNeutral1100: '#E2E3E4',
    Neutral0: '#FFFFFF',
    Neutral100: '#F8F8F8',
    Neutral100A: '#17171708',
    Neutral200: '#F0F1F2',
    Neutral200A: '#0515240F',
    Neutral300: '#DDDEE1',
    Neutral300A: '#0B120E24',
    Neutral400: '#B7B9BE',
    Neutral400A: '#080F214A',
    Neutral500: '#8C8F97',
    Neutral500A: '#050C1F75',
    Neutral600: '#7D818A',
    Neutral700: '#6B6E76',
    Neutral800: '#505258',
    Neutral900: '#3B3D42',
    Neutral1000: '#292A2E',
    Neutral1100: '#1E1F21'
};

});

parcelRegister("kaQmU", function(module, exports) {
$parcel$export(module.exports, "paletteRgba", () => $d3bff3dbe629cda8$export$c9b84419dae66a82);
const $d3bff3dbe629cda8$export$c9b84419dae66a82 = {
    DarkNeutral300A: {
        r: 0xe3,
        g: 0xe4,
        b: 0xf2,
        a: 0x1f / 255
    },
    Neutral300A: {
        r: 0x0b,
        g: 0x12,
        b: 0x0e,
        a: 0x24 / 255
    }
};

});

parcelRegister("lKK5h", function(module, exports) {
$parcel$export(module.exports, "themedSearchBorder", () => $4acfd1831a89ba5c$export$ae6fbf5ba3a7a784);
$parcel$export(module.exports, "themedSearchBorderFocused", () => $4acfd1831a89ba5c$export$ee42b8430f4c19bd);
$parcel$export(module.exports, "useLegacySearchTheme", () => $4acfd1831a89ba5c$export$18a29b1ed2212823);

var $e2VD8 = parcelRequire("e2VD8");
const $4acfd1831a89ba5c$export$ae6fbf5ba3a7a784 = '--ds-top-bar-search-border';
const $4acfd1831a89ba5c$export$ee42b8430f4c19bd = '--ds-top-bar-search-border-focused';
/**
 * Theme object intended for use with Search Platform components while transitioning to nav4.
 *
 * This is for backwards compatibility with the legacy theming API that was designed for nav3.
 *
 * As nav4 matures we will ideally evolve the theming solution inside Search Platform,
 * at which point this legacy theme object will not be needed.
 */ const $4acfd1831a89ba5c$var$legacySearchTheme = {
    default: {
        backgroundColor: 'transparent',
        color: 'currentColor',
        borderColor: `var(${$4acfd1831a89ba5c$export$ae6fbf5ba3a7a784})`
    },
    focus: {
        /**
     * When expanded the input ignores the custom theme,
     * except for its border which is derived from the highlight color.
     */ color: "var(--ds-text, #292A2E)",
        backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
        borderColor: `var(${$4acfd1831a89ba5c$export$ee42b8430f4c19bd})`,
        boxShadow: `inset 0px 0px 0px 1px var(${$4acfd1831a89ba5c$export$ee42b8430f4c19bd})`
    },
    hover: {
        /**
     * This is not actually used for the search bar input (at least by the Search Platform components).
     *
     * Instead it's used as the hover background color for a close button when on mobile.
     */ backgroundColor: `var(--ds-top-bar-button-background-hovered)`
    }
};
function $4acfd1831a89ba5c$export$18a29b1ed2212823() {
    const hasCustomTheme = (0, $e2VD8.useHasCustomTheme)();
    if (hasCustomTheme) return $4acfd1831a89ba5c$var$legacySearchTheme;
    return undefined;
}

});



parcelRegister("i1pXz", function(module, exports) {
$parcel$export(module.exports, "useCustomThemeNew", () => $6b0275c67b888354$export$92ae7a8762fba89e);

var $fsvuC = parcelRequire("fsvuC");

var $iZfz5 = parcelRequire("iZfz5");

var $gE4pd = parcelRequire("gE4pd");

var $1D6wy = parcelRequire("1D6wy");

var $byM5Y = parcelRequire("byM5Y");
function $6b0275c67b888354$var$toRGBString({ r: r, g: g, b: b }) {
    return `rgb(${r}, ${g}, ${b})`;
}
function $6b0275c67b888354$export$92ae7a8762fba89e(theme) {
    const value = (0, $byM5Y.useCustomTheme)(theme);
    /**
   * We use the color mode to determine the default background color for the top nav.
   * We need to use the hook because the user could change their color mode preference.
   */ const colorMode = (0, $iZfz5.useColorMode)();
    const hasDefaultBackground = (0, $fsvuC.useMemo)(()=>{
        if (!value.isEnabled) return true;
        const defaultBackground = (0, $1D6wy.parseHex)((0, $gE4pd.getTokenValue)('elevation.surface', colorMode === 'light' ? '#FFFFFF' : '#1F1F21'));
        return defaultBackground ? value.style.backgroundColor === $6b0275c67b888354$var$toRGBString(defaultBackground) : true;
    }, [
        value,
        colorMode
    ]);
    if (value.isEnabled) return {
        ...value,
        hasDefaultBackground: hasDefaultBackground
    };
    return value;
}

});


parcelRegister("c4mJX", function(module, exports) {
$parcel$export(module.exports, "PrimaryButton", () => $c64234adddf9e1dc$export$ac16a6a04d9b7c84);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $h2YWL = parcelRequire("h2YWL");

var $kE3M8 = parcelRequire("kE3M8");

var $f4lus = parcelRequire("f4lus");

var $805Ft = parcelRequire("805Ft");

var $3oNr8 = parcelRequire("3oNr8");
function $c64234adddf9e1dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c64234adddf9e1dc$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $c64234adddf9e1dc$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $c64234adddf9e1dc$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $c64234adddf9e1dc$var$buttonNoOpStyle = {
    name: "zvio0b",
    styles: "--noop:1"
};
const $c64234adddf9e1dc$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $h2YWL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$c64234adddf9e1dc$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$c64234adddf9e1dc$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-radius-xsmall, 1px)",
        borderStartStartRadius: "var(--ds-radius-xsmall, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $c64234adddf9e1dc$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, shortcut: shortcut, ...rest } = props;
    const themeFromContext = (0, $805Ft.useTheme)();
    const button = /*#__PURE__*/ (0, $h2YWL.jsx)("div", {
        style: {
            [$c64234adddf9e1dc$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$c64234adddf9e1dc$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $c64234adddf9e1dc$var$buttonBaseStyles,
            isHighlighted && $c64234adddf9e1dc$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $h2YWL.jsx)((0, $kE3M8.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $3oNr8.getPrimaryButtonTheme)(themeFromContext),
        css: [
            $c64234adddf9e1dc$var$buttonNoOpStyle
        ],
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $h2YWL.jsx)((0, $f4lus.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        shortcut: shortcut
    }, button);
    return button;
});

});
parcelRegister("805Ft", function(module, exports) {
$parcel$export(module.exports, "useTheme", () => $8da5b86ae6878167$export$93d4e7f90805808f);

var $fsvuC = parcelRequire("fsvuC");

var $lu5qt = parcelRequire("lu5qt");
const $8da5b86ae6878167$export$93d4e7f90805808f = ()=>(0, $fsvuC.useContext)((0, $lu5qt.ThemeContext));

});
parcelRegister("lu5qt", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $95ad77bcc966803f$export$2c657da244d00bd6);

var $fsvuC = parcelRequire("fsvuC");

var $6cUKt = parcelRequire("6cUKt");
const $95ad77bcc966803f$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $fsvuC.createContext)((0, $6cUKt.defaultTheme));

});
parcelRegister("6cUKt", function(module, exports) {
$parcel$export(module.exports, "defaultTheme", () => $dd41b18571f16d50$export$164de7ab8df77ef0);

var $53hvY = parcelRequire("53hvY");
const $dd41b18571f16d50$export$164de7ab8df77ef0 = (0, $53hvY.atlassianTheme);

});
parcelRegister("53hvY", function(module, exports) {
$parcel$export(module.exports, "atlassianTheme", () => $ed7ce1cb38b5deef$export$eeee8619e1b91cb0);

var $idYQe = parcelRequire("idYQe");

var $lM93g = parcelRequire("lM93g");
const $ed7ce1cb38b5deef$export$eeee8619e1b91cb0 = (0, $lM93g.generateTheme)({
    name: (0, $idYQe.DEFAULT_THEME_NAME),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});

});




parcelRegister("3oNr8", function(module, exports) {
$parcel$export(module.exports, "getPrimaryButtonTheme", () => $86e25c704d52089c$export$14dd6915caf431fe);
const $86e25c704d52089c$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});


parcelRegister("d6Fbm", function(module, exports) {
$parcel$export(module.exports, "usePanelManager", () => $d6941cd8ef627820$export$3946869e2f4977e4);

var $lCNAN = parcelRequire("lCNAN");

var $lSgFO = parcelRequire("lSgFO");
function $d6941cd8ef627820$export$3946869e2f4977e4() {
    const manager = (0, $lCNAN.usePanelActionsInternal)();
    const state = (0, $lSgFO.usePanelStateInternal)();
    return {
        state: state,
        manager: manager
    };
}

});
parcelRegister("lCNAN", function(module, exports) {
$parcel$export(module.exports, "PanelProvider", () => $abf9e80f737bcd23$export$e7dba2ce3ae71ca);
$parcel$export(module.exports, "usePanelActionsInternal", () => $abf9e80f737bcd23$export$5f6762d4d1cd693d);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $5fMcq = parcelRequire("5fMcq");
const $abf9e80f737bcd23$export$18d6b45fa585ca8a = /*#__PURE__*/ (0, $fsvuC.createContext)(null);
/**
 * Pure reducer function handling panel, preloaded entry point, and requested-width state transitions.
 *
 * LayoutWithPanel mirrors its requested width here. To apply provider width changes to an
 * already-mounted layout, connect its panelWidth and onPanelWidthChange props to the provider.
 */ function $abf9e80f737bcd23$var$panelReducer(state, action) {
    switch(action.type){
        case 'PANEL_OPEN':
            {
                const { instanceId: instanceId, panelContent: panelContent, params: params } = action.payload;
                const newPanel = {
                    instanceId: instanceId,
                    panelContent: panelContent,
                    params: params || {}
                };
                return {
                    ...state,
                    activePanel: newPanel
                };
            }
        case 'PANEL_OPEN_ENTRYPOINT':
            {
                const { instanceId: instanceId, entryPoint: entryPoint, params: params, entryPointReference: entryPointReference } = action.payload;
                const newPanel = {
                    instanceId: instanceId,
                    entryPoint: entryPoint,
                    params: params || {},
                    entryPointReference: entryPointReference
                };
                return {
                    ...state,
                    activePanel: newPanel
                };
            }
        case 'PANEL_CLOSE':
            {
                const { instanceId: instanceId } = action.payload;
                // A delayed close from replaced content must not close the new panel.
                if (state.activePanel?.instanceId !== instanceId) return state;
                return {
                    ...state,
                    activePanel: null
                };
            }
        case 'PANEL_SAVE_ENTRYPOINT':
            {
                const { instanceId: instanceId, entryPointReference: entryPointReference } = action.payload;
                const filtered = state.preloadedPanels.filter((p)=>p.instanceId !== instanceId);
                return {
                    ...state,
                    preloadedPanels: [
                        ...filtered,
                        {
                            instanceId: instanceId,
                            entryPointReference: entryPointReference
                        }
                    ]
                };
            }
        case 'PANEL_SET_WIDTH':
            {
                const { width: width } = action.payload;
                if (state.panelWidth === width) return state;
                return {
                    ...state,
                    panelWidth: width
                };
            }
        default:
            return state;
    }
}
function $abf9e80f737bcd23$export$e7dba2ce3ae71ca({ children: children, initialState: initialState }) {
    const [state, dispatch] = (0, $fsvuC.useReducer)($abf9e80f737bcd23$var$panelReducer, {
        activePanel: null,
        preloadedPanels: [],
        ...initialState
    });
    // Create stable manager object with memoization
    // This object reference never changes, so ManagerContext consumers never re-render
    const manager = (0, $fsvuC.useMemo)(()=>{
        return {
            /**
			 * Opens a panel with either an entry point or React content.
			 * Always replaces the active panel, including when the instance ID is unchanged.
			 *
			 * **Note:** This is a low-level API. For most use cases, prefer using the `Trigger` component,
			 * which handles entry point loading and ID generation automatically.
			 *
			 * **ID Generation:** The instanceId must be provided. For best practices, use the `Trigger`
			 * component's instanceId (either provided or auto-generated) rather than generating IDs
			 * at the manager level. This keeps ID management co-located with the trigger.
			 *
			 * @param options - Instance ID, optional params, and either entryPoint (with an optional
			 * preloaded entryPointReference) or panelContent.
			 */ openPanel: (options)=>{
                const { instanceId: instanceId, params: params } = options;
                if (options.entryPoint !== undefined) dispatch({
                    type: 'PANEL_OPEN_ENTRYPOINT',
                    payload: {
                        instanceId: instanceId,
                        params: params,
                        entryPoint: options.entryPoint,
                        entryPointReference: options.entryPointReference
                    }
                });
                else dispatch({
                    type: 'PANEL_OPEN',
                    payload: {
                        instanceId: instanceId,
                        params: params,
                        panelContent: options.panelContent
                    }
                });
            },
            closePanel: (instanceId)=>{
                dispatch({
                    type: 'PANEL_CLOSE',
                    payload: {
                        instanceId: instanceId
                    }
                });
            },
            /**
			 * Saves a preloaded EntryPoint reference for a given panel instance.
			 * Useful for mixing Trigger and programmatic panel opening.
			 *
			 * @param instanceId - Unique identifier for this panel instance
			 * @param entryPointReference - Preloaded EntryPoint reference
			 */ saveEntryPointReference: (instanceId, entryPointReference)=>{
                dispatch({
                    type: 'PANEL_SAVE_ENTRYPOINT',
                    payload: {
                        instanceId: instanceId,
                        entryPointReference: entryPointReference
                    }
                });
            },
            setPanelWidth: (width)=>{
                dispatch({
                    type: 'PANEL_SET_WIDTH',
                    payload: {
                        width: width
                    }
                });
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $5chsV.jsx)($abf9e80f737bcd23$export$18d6b45fa585ca8a.Provider, {
        value: manager,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $5fMcq.StateContext).Provider, {
            value: state,
            children: children
        })
    });
}
$abf9e80f737bcd23$export$e7dba2ce3ae71ca.displayName = "PanelProvider";
function $abf9e80f737bcd23$export$5f6762d4d1cd693d() {
    const manager = (0, $fsvuC.useContext)($abf9e80f737bcd23$export$18d6b45fa585ca8a);
    if (!manager) throw new Error("usePanelActionsInternal must be used within a <PanelProvider>. Wrap your app with: <PanelProvider><App /></PanelProvider>");
    return manager;
}

});
parcelRegister("5fMcq", function(module, exports) {
$parcel$export(module.exports, "StateContext", () => $97dd7e08f59aa00e$export$437ae3f50102760d);

var $fsvuC = parcelRequire("fsvuC");
const $97dd7e08f59aa00e$export$437ae3f50102760d = /*#__PURE__*/ (0, $fsvuC.createContext)(null);

});


parcelRegister("lSgFO", function(module, exports) {
$parcel$export(module.exports, "usePanelStateInternal", () => $71558c1349e79f5a$export$3fff25b77d81bf59);

var $fsvuC = parcelRequire("fsvuC");

var $5fMcq = parcelRequire("5fMcq");
function $71558c1349e79f5a$export$3fff25b77d81bf59() {
    const state = (0, $fsvuC.useContext)((0, $5fMcq.StateContext));
    if (!state) throw new Error("usePanelStateInternal must be used within a <PanelProvider>. Wrap your app with: <PanelProvider><App /></PanelProvider>");
    return state;
}

});


parcelRegister("eoNDS", function(module, exports) {
$parcel$export(module.exports, "Help", () => $112b0898a83ec9a9$export$1be7516c0280bee8);
/**
 * @jsxRuntime classic
 */ 
var $fsvuC = parcelRequire("fsvuC");

var $c2Y7c = parcelRequire("c2Y7c");

var $iOOpv = parcelRequire("iOOpv");

var $iI0AP = parcelRequire("iI0AP");
const $112b0898a83ec9a9$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $112b0898a83ec9a9$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(function Help({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, isListItem: isListItem, badge: badge, shortcut: shortcut }, ref) {
    const sharedProps = {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2Y7c))),
        label: label,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        isSelected: isSelected,
        testId: testId,
        interactionName: interactionName,
        ref: ref,
        shortcut: shortcut
    };
    if (!badge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $iI0AP.EndItem), {
        ...sharedProps,
        isListItem: isListItem
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $iOOpv.BadgeContainer), {
        id: $112b0898a83ec9a9$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fsvuC))).createElement((0, $iI0AP.EndItem), {
        ...sharedProps,
        // We explicitly set the EndItem to not be a list item,
        // because the BadgeContainer already has a list item role (if `isListItem` is true)
        isListItem: false
    }));
});

});
parcelRegister("iOOpv", function(module, exports) {
$parcel$export(module.exports, "BadgeContainer", () => $96b6db237b50e10e$export$f710265eb5a003da);
/* badge-container.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $96b6db237b50e10e$var$styles = {
    root: "_1mT5xdRAKS _3iDTPbQ4SZ",
    badgeContainer: "_1mT5xdWVPG _1ANEUSLRg7 _2I62gz5UaJ _3iC0zd8HPE _1pp6NdYbGa"
};
const $96b6db237b50e10e$export$f710265eb5a003da = ({ children: children, id: badgeId, badge: Badge, isListItem: isListItem = true })=>/*#__PURE__*/ (0, $5chsV.jsxs)("div", {
        role: isListItem ? 'listitem' : undefined,
        className: (0, $gJ6nT.default)([
            $96b6db237b50e10e$var$styles.root
        ]),
        children: [
            children,
            /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                id: badgeId,
                "aria-hidden": true,
                className: (0, $gJ6nT.default)([
                    $96b6db237b50e10e$var$styles.badgeContainer
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)(Badge, {})
            })
        ]
    });
$96b6db237b50e10e$export$f710265eb5a003da.displayName = "BadgeContainer";

});

parcelRegister("iI0AP", function(module, exports) {
$parcel$export(module.exports, "EndItem", () => $cb95833ddfe327df$export$b3477e90773be2d0);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $2lWJX = parcelRequire("2lWJX");

var $58UFo = parcelRequire("58UFo");
const $cb95833ddfe327df$export$b3477e90773be2d0 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ label: label, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem = true, shortcut: shortcut }, forwardedRef)=>{
    const Wrapper = isListItem ? (0, $2lWJX.ListItem) : (0, $fsvuC.Fragment);
    return /*#__PURE__*/ (0, $5chsV.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $58UFo.IconButton), {
            ref: forwardedRef,
            icon: icon,
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            appearance: "subtle",
            isSelected: isSelected,
            isTooltipDisabled: false,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            // Only creating object when shortcut is provided
            tooltip: shortcut ? {
                shortcut: shortcut
            } : undefined
        })
    });
});

});
parcelRegister("2lWJX", function(module, exports) {
$parcel$export(module.exports, "ListItem", () => $b59d0bd21a153ef2$export$a7b06bfba60a8a78);
/* list-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");
function $b59d0bd21a153ef2$var$_ListItem({ children: children, testId: testId, xcss: xcss }, ref) {
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        role: "listitem",
        ref: ref,
        className: xcss,
        "data-testid": testId,
        children: children
    });
}
const $b59d0bd21a153ef2$export$a7b06bfba60a8a78 = /*#__PURE__*/ (0, $fsvuC.forwardRef)($b59d0bd21a153ef2$var$_ListItem);

});



parcelRegister("82jWl", function(module, exports) {
$parcel$export(module.exports, "Notifications", () => $85d0b9e328187bed$export$36ba2f559d49a8f6);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $byNe2 = parcelRequire("byNe2");

var $iOOpv = parcelRequire("iOOpv");

var $iI0AP = parcelRequire("iI0AP");
const $85d0b9e328187bed$var$NOTIFICATIONS_BADGE_ID = 'atlassian-navigation-notification-count';
const $85d0b9e328187bed$export$36ba2f559d49a8f6 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(function Notifications({ label: label, onClick: onClick, onMouseEnter: onMouseEnter, isSelected: isSelected, testId: testId, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, isListItem: isListItem, badge: badge, shortcut: shortcut }, ref) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $iOOpv.BadgeContainer), {
        id: $85d0b9e328187bed$var$NOTIFICATIONS_BADGE_ID,
        badge: badge,
        // We only need to set the list item role on the top level element (BadgeContainer)
        isListItem: isListItem,
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $iI0AP.EndItem), {
            label: label,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            isSelected: isSelected,
            testId: testId,
            interactionName: interactionName,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHasPopup,
            ref: ref,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($byNe2))),
            // We explicitly set the EndItem to not be a list item,
            // because the BadgeContainer already has a list item role (if `isListItem` is true)
            isListItem: false,
            shortcut: shortcut
        })
    });
});

});

parcelRegister("9hOw3", function(module, exports) {
$parcel$export(module.exports, "AppLogo", () => $d1eb14860a64c1ca$export$113a612889e1565d);
/* app-logo.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $4twf9 = parcelRequire("4twf9");

var $5T6N9 = parcelRequire("5T6N9");

var $5hZWH = parcelRequire("5hZWH");

var $9EEzo = parcelRequire("9EEzo");

var $kBK9z = parcelRequire("kBK9z");

var $f4lus = parcelRequire("f4lus");

var $e2VD8 = parcelRequire("e2VD8");

var $h1nyb = parcelRequire("h1nyb");
const $d1eb14860a64c1ca$var$anchorStyles = {
    root: "_0bjKvD8fU6 _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VUofl _3YEZNOdnbC _0GTcwR1Y8M _4kLJBnyL8i _0mJftuYbGa _1vb6Qj6wH8 _4vhRtvOLYo",
    interactionStates: "_1eOmH6o126 _3gzVzLJovG",
    interactionStatesCustomTheming: "_1eOmH6JxD8 _3gzVzL8abp"
};
const $d1eb14860a64c1ca$var$logoWrapperStyles = {
    root: "_2Y7lL41Y8M"
};
const $d1eb14860a64c1ca$var$iconContainerStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _1EqgXloWWg _0NUa3roWWg"
};
const $d1eb14860a64c1ca$var$logoTextStyles = {
    root: "_39xV02W9qI _1EqgXlsz7G _20VacPYbGa _03SyCPFQfX _3iDTPbYbGa _0aFT5vbt8w _37wbyuDIqT _2rc81eQ4SZ"
};
const $d1eb14860a64c1ca$var$secondaryNameStyles = {
    root: "_43nrzTLl21"
};
function $d1eb14860a64c1ca$var$isTextClamped(element) {
    // Checking for vertical height rather than horizontal height.
    // When text is "clamped", it's technically being clamped vertically! 🤯
    return element.scrollHeight > element.clientHeight;
}
const $d1eb14860a64c1ca$export$113a612889e1565d = ({ name: name, label: label, secondaryName: secondaryName, href: href, icon: icon, onClick: onClick })=>{
    const ref = (0, $fsvuC.useRef)(null);
    const nameRef = (0, $fsvuC.useRef)(null);
    const hasCustomTheme = (0, $e2VD8.useHasCustomTheme)();
    const showSecondaryName = Boolean(secondaryName) && (0, $5T6N9.fg)('platform_dst_ads_appswitcher_improvements');
    /**
   * Show the tooltip if the name is truncated
   */ const canTooltipAppear = (0, $fsvuC.useCallback)(()=>{
        const text = nameRef.current;
        return Boolean(text && $d1eb14860a64c1ca$var$isTextClamped(text));
    }, []);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $5hZWH.Anchor), {
        ref: ref,
        "aria-label": label,
        href: href,
        // @ts-expect-error - non-standard values for `borderRadius` and the custom theming interaction states
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $4twf9.cx)($d1eb14860a64c1ca$var$anchorStyles.root, hasCustomTheme ? $d1eb14860a64c1ca$var$anchorStyles.interactionStatesCustomTheming : $d1eb14860a64c1ca$var$anchorStyles.interactionStates),
        onClick: onClick,
        children: /*#__PURE__*/ (0, $5chsV.jsxs)((0, $9EEzo.Inline), {
            space: "space.075",
            alignBlock: "center",
            xcss: $d1eb14860a64c1ca$var$logoWrapperStyles.root,
            children: [
                /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                    className: (0, $gJ6nT.default)([
                        $d1eb14860a64c1ca$var$iconContainerStyles.root
                    ]),
                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $h1nyb.LogoRenderer), {
                        logoOrIcon: icon
                    })
                }),
                /*#__PURE__*/ (0, $5chsV.jsxs)("span", {
                    className: (0, $gJ6nT.default)([
                        $d1eb14860a64c1ca$var$logoTextStyles.root
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $5chsV.jsx)((0, $f4lus.default), {
                            content: name,
                            position: "bottom",
                            ignoreTooltipPointerEvents: true,
                            hideTooltipOnMouseDown: true,
                            // We don't need a duplicate hidden element containing tooltip content
                            // as the content of the tooltip matches what is rendered in the nav item.
                            isScreenReaderAnnouncementDisabled: true,
                            canAppear: canTooltipAppear,
                            children: (tooltipProps)=>/*#__PURE__*/ (0, $5chsV.jsx)("span", {
                                    ...tooltipProps,
                                    children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kBK9z.Text), {
                                        "aria-hidden": true,
                                        color: "inherit",
                                        weight: "semibold",
                                        maxLines: 1,
                                        ref: nameRef,
                                        children: name
                                    })
                                })
                        }),
                        showSecondaryName && /*#__PURE__*/ (0, $5chsV.jsx)("span", {
                            className: (0, $gJ6nT.default)([
                                $d1eb14860a64c1ca$var$secondaryNameStyles.root
                            ]),
                            children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $kBK9z.Text), {
                                "aria-hidden": true,
                                color: "color.text.subtlest",
                                weight: "regular",
                                maxLines: 1,
                                size: "small",
                                children: secondaryName
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$d1eb14860a64c1ca$export$113a612889e1565d.displayName = "AppLogo";

});

parcelRegister("cPLhu", function(module, exports) {
$parcel$export(module.exports, "CustomLogo", () => $3a9ec39047fcab09$export$4156d88e9ccc616b);
/* custom-logo.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $gJ6nT = parcelRequire("gJ6nT");

var $fsvuC = parcelRequire("fsvuC");

var $4twf9 = parcelRequire("4twf9");

var $5hZWH = parcelRequire("5hZWH");

var $e2VD8 = parcelRequire("e2VD8");

var $h1nyb = parcelRequire("h1nyb");
const $3a9ec39047fcab09$var$anchorStyles = {
    root: "_0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _0jFU0VUofl",
    customLogoBorderRadius: "_0bjKvD8fU6",
    newMargin: "_0GTcwR1Y8M",
    newInteractionStates: "_1eOmH6o126 _3gzVzLJovG",
    newInteractionStatesCustomTheming: "_1eOmH6JxD8 _3gzVzL8abp"
};
const $3a9ec39047fcab09$var$sharedIconOrLogoContainerStyles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _2Y7lL41Y8M _0LETLXoWWg _1PTmduOLYo _3G0Ib8gIor"
};
const $3a9ec39047fcab09$var$iconContainerStyles = {
    root: "_3iDTPbQ4SZ _1EqgXloWWg _24h04iyL8i _2rc81eYbGa"
};
const $3a9ec39047fcab09$var$logoContainerStyles = {
    root: "_3iDTPbYbGa _1EqgXlsz7G _24h04iyL8i _2rc81eQ4SZ"
};
const $3a9ec39047fcab09$export$4156d88e9ccc616b = ({ href: href, logo: logo, icon: icon, onClick: onClick, label: label })=>{
    const ref = (0, $fsvuC.useRef)(null);
    (0, $fsvuC.useEffect)(()=>{
        return;
    }, []);
    const hasCustomTheme = (0, $e2VD8.useHasCustomTheme)();
    return /*#__PURE__*/ (0, $5chsV.jsxs)((0, $5hZWH.Anchor), {
        ref: ref,
        "aria-label": label,
        href: href,
        // @ts-expect-error - non-standard values for `borderRadius` and the custom theming interaction states
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $4twf9.cx)($3a9ec39047fcab09$var$anchorStyles.root, $3a9ec39047fcab09$var$anchorStyles.customLogoBorderRadius, $3a9ec39047fcab09$var$anchorStyles.newMargin, hasCustomTheme ? $3a9ec39047fcab09$var$anchorStyles.newInteractionStatesCustomTheming : $3a9ec39047fcab09$var$anchorStyles.newInteractionStates),
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                className: (0, $gJ6nT.default)([
                    $3a9ec39047fcab09$var$sharedIconOrLogoContainerStyles.root,
                    $3a9ec39047fcab09$var$iconContainerStyles.root
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $h1nyb.LogoRenderer), {
                    logoOrIcon: icon
                })
            }),
            /*#__PURE__*/ (0, $5chsV.jsx)("div", {
                className: (0, $gJ6nT.default)([
                    $3a9ec39047fcab09$var$sharedIconOrLogoContainerStyles.root,
                    $3a9ec39047fcab09$var$logoContainerStyles.root
                ]),
                children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $h1nyb.LogoRenderer), {
                    logoOrIcon: logo
                })
            })
        ]
    });
};
$3a9ec39047fcab09$export$4156d88e9ccc616b.displayName = "CustomLogo";

});

parcelRegister("iQ1Tn", function(module, exports) {
$parcel$export(module.exports, "CustomTitle", () => $b6bd921b96786f6d$export$9ccddf7ee2a0e24e);
/* custom-title.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");

var $e2VD8 = parcelRequire("e2VD8");
const $b6bd921b96786f6d$var$styles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _1ANEUSLRg7 _1EqgXlgZxp _39HuIbz8Lp _0LQT5E1Y8M _03SyCP2ADO _3iDTPbYbGa _2rc81eQ4SZ",
    subtleText: "_1UtDYzZpcK"
};
const $b6bd921b96786f6d$export$9ccddf7ee2a0e24e = /*#__PURE__*/ (0, $fsvuC.forwardRef)(function CustomTitle({ children: children, testId: testId }, ref) {
    const hasCustomTheme = (0, $e2VD8.useHasCustomTheme)();
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        ref: ref,
        "data-testid": testId,
        className: (0, $gJ6nT.default)([
            $b6bd921b96786f6d$var$styles.root,
            !hasCustomTheme && $b6bd921b96786f6d$var$styles.subtleText
        ]),
        children: children
    });
});

});

parcelRegister("3SNIp", function(module, exports) {
$parcel$export(module.exports, "LogIn", () => $7145c9102b24ee7f$export$88195aaac9f90319);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $dM6XP = parcelRequire("dM6XP");

var $2lWJX = parcelRequire("2lWJX");

var $4pd5D = parcelRequire("4pd5D");
const $7145c9102b24ee7f$export$88195aaac9f90319 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, interactionName: interactionName, href: href, label: label }, ref)=>/**
		 * This component doesn't use `EndItem` internally because it renders a
		 * `LinkIconButton` instead of an `IconButton`.
		 *
		 * We could make another abstraction, but this is the only top navigation item
		 * that renders a link.
		 */ /*#__PURE__*/ (0, $5chsV.jsx)((0, $2lWJX.ListItem), {
        children: /*#__PURE__*/ (0, $5chsV.jsx)((0, $4pd5D.LinkIconButton), {
            ref: ref,
            label: label,
            href: href,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            testId: testId,
            interactionName: interactionName,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dM6XP))),
            appearance: "subtle",
            isTooltipDisabled: false
        })
    }));

});
parcelRegister("4pd5D", function(module, exports) {
$parcel$export(module.exports, "LinkIconButton", () => $a92ffee81b5a302f$export$edad7fca51b767e1);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $7ircd = parcelRequire("7ircd");

var $e2VD8 = parcelRequire("e2VD8");

var $by0Yc = parcelRequire("by0Yc");
const $a92ffee81b5a302f$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $e2VD8.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $by0Yc.ThemedLinkIconButton) : (0, $7ircd.default);
    return /*#__PURE__*/ (0, $5chsV.jsx)(Component, {
        ref: ref,
        ...props
    });
});

});
parcelRegister("by0Yc", function(module, exports) {
$parcel$export(module.exports, "ThemedLinkIconButton", () => $c452d8264b99b6dc$export$a1ab08e79d264ec8);

var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $buELT = parcelRequire("buELT");

var $1cXpO = parcelRequire("1cXpO");

var $f4lus = parcelRequire("f4lus");

var $01oqo = parcelRequire("01oqo");

var $l8owV = parcelRequire("l8owV");
function $c452d8264b99b6dc$var$ThemedLinkIconButtonFn({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $f4lus.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
				 * The `aria-describedby` from `triggerProps` is intentionally not passed down,
				 * because it would cause double announcements with the `VisuallyHidden` label.
				 *
				 * The `@atlaskit/button` IconButton uses the same approach.
				 */ /*#__PURE__*/ (0, $5chsV.jsxs)((0, $l8owV.ThemedAnchor), {
                ...props,
                shape: "square",
                ref: (0, $1cXpO.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $5chsV.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $5chsV.jsx)((0, $01oqo.default), {
                        children: label
                    })
                ]
            })
    });
}
$c452d8264b99b6dc$var$ThemedLinkIconButtonFn.displayName = "ThemedLinkIconButtonFn";
const $c452d8264b99b6dc$export$a1ab08e79d264ec8 = (0, $buELT.default)($c452d8264b99b6dc$var$ThemedLinkIconButtonFn);

});



parcelRegister("aCXqs", function(module, exports) {
$parcel$export(module.exports, "Profile", () => $1e3cd01b0feb8eb7$export$5120f2d0b8d4cab8);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $aCTVG = parcelRequire("aCTVG");

var $iI0AP = parcelRequire("iI0AP");
const $1e3cd01b0feb8eb7$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $fsvuC.forwardRef)(({ src: src, ...props }, ref)=>{
    const ProfileAvatar = (0, $fsvuC.useCallback)(()=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $aCTVG.default), {
            appearance: "circle",
            src: src,
            size: "small"
        }), [
        src
    ]);
    return /*#__PURE__*/ (0, $5chsV.jsx)((0, $iI0AP.EndItem), {
        ...props,
        ref: ref,
        icon: ProfileAvatar
    });
});

});

parcelRegister("dAGma", function(module, exports) {
$parcel$export(module.exports, "Settings", () => $be962f546bfadacf$export$c72f6eaae7b9adff);

var $5chsV = parcelRequire("5chsV");

var $fsvuC = parcelRequire("fsvuC");

var $hQpu3 = parcelRequire("hQpu3");

var $iI0AP = parcelRequire("iI0AP");
const $be962f546bfadacf$export$c72f6eaae7b9adff = /*#__PURE__*/ (0, $fsvuC.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $5chsV.jsx)((0, $iI0AP.EndItem), {
        ...props,
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQpu3)))
    }));

});

parcelRegister("juR3N", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f46f30eab313f6$export$2e2bcd8739ae039);
/* skeleton-heading-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $5chsV = parcelRequire("5chsV");
parcelRequire("fsvuC");

var $gJ6nT = parcelRequire("gJ6nT");
const $36f46f30eab313f6$var$styles = {
    skeleton: "_4c065UPgdg _2Y7lL45zaO _2Gfj6iQEt6 _4Gb5FivLZJ _2jfUf9r1As _47eTBt2ADO _3wEj0XGsB2 _0GBAIrogpp",
    customWidth: "_2jfUf9yRC6"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-item.tsx
 *
 * Please update both.
 */ const $36f46f30eab313f6$var$shimmerKeyframes = null;
/**
 * These styles are defined using `css` rather than `cssMap` as there is a
 * bug when using `cssMap` that causes a build failure due to the use of keyframes.
 */ const $36f46f30eab313f6$var$shimmerStyles = null;
/**
 * __Skeleton heading item__
 *
 * A skeleton heading item is used in place of a heading item when its contents it not ready.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $36f46f30eab313f6$var$SkeletonHeadingItem = ({ isShimmering: isShimmering = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $5chsV.jsx)("div", {
        className: (0, $gJ6nT.default)([
            $36f46f30eab313f6$var$styles.skeleton,
            width && $36f46f30eab313f6$var$styles.customWidth,
            isShimmering && "",
            isShimmering && "_21qtfOkSs3 _0160FKkSs3 _1nw4qxfONH _1iAcE9fONH _2VLDZtSHWH _0YTlblSHWH _30VpOT55dm _2ofBtg55dm _2WuqwLHVQb _2lXp1JHVQb _3wEj0XGsB2 _4diMdqGsB2",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-ds--menu--skeleton-heading-item": true,
        "data-testid": testId
    });
};
$36f46f30eab313f6$var$SkeletonHeadingItem.displayName = "SkeletonHeadingItem";
var $36f46f30eab313f6$export$2e2bcd8739ae039 = $36f46f30eab313f6$var$SkeletonHeadingItem;

});

const $5b20f9eca5080b27$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $5b20f9eca5080b27$export$f005e2e9f707cb5f = 'commercial';
const $5b20f9eca5080b27$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $5b20f9eca5080b27$export$a739cd5aac835909 = 'stg';
const $5b20f9eca5080b27$export$42dd0cdd351a4a9 = 'prod';
const $5b20f9eca5080b27$export$404582bc18fe4d9e = 'dev';

// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $2beb1c5a9011e8fc$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $f924aeb8b4d03d56$export$7d0a15ee70427305 = 2147483647;

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $58ff2e19b0510997$export$fd3d00026297c0ad = 'text/plain';

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $0ff3806a414665e6$export$4c44a460f123106 = 'text/uri-list';

/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $2e2e8445b88fdb4c$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

const $e9181d8bc9d96b1b$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $e9181d8bc9d96b1b$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $e9181d8bc9d96b1b$export$13f57c02915787b3 = 'atlaskit-portal';

/**
 * @deprecated Top-layer surfaces do not fire portal events. To know when a top-layer surface opens
 * or closes, listen for the native `toggle` and `close` events.
 */ const $2842d286e8760d3e$export$ed5835cc67e87f72 = 'akPortalMount';
const $2842d286e8760d3e$export$80816bd900e5bd00 = 'akPortalUnmount';

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

/* eslint-disable jira/filename-case */ const $eb8cfa569eede1a9$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $eb8cfa569eede1a9$export$e9c56aa3b027d98f = 'jira-customer-service';
const $eb8cfa569eede1a9$export$1346c9aa3cbb477d = 'jira-software';
const $eb8cfa569eede1a9$export$202f50ee62667e32 = 'jira-product-discovery';
const $eb8cfa569eede1a9$export$db515c8cec1e6f79 = 'jira-core';
const $eb8cfa569eede1a9$export$c811f21c9ad05dc2 = 'confluence';
const $eb8cfa569eede1a9$export$961148c98d198270 = 'opsgenie';
const $eb8cfa569eede1a9$export$a310f85340477585 = 'assets';
const $eb8cfa569eede1a9$export$d5e9b613bc4c47f = 'compass';

const $9924ccd0a7eb3f48$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $9924ccd0a7eb3f48$export$f005e2e9f707cb5f = 'commercial';
const $9924ccd0a7eb3f48$export$17b81a3d6c98013c = 'isolated-cloud';
const $9924ccd0a7eb3f48$export$a739cd5aac835909 = 'staging';
const $9924ccd0a7eb3f48$export$42dd0cdd351a4a9 = 'prod';
const $9924ccd0a7eb3f48$export$404582bc18fe4d9e = 'dev';
const $9924ccd0a7eb3f48$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $9924ccd0a7eb3f48$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $9924ccd0a7eb3f48$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $9924ccd0a7eb3f48$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $9924ccd0a7eb3f48$export$b61e047ddcc35726 = 'GCP';
const $9924ccd0a7eb3f48$export$1baf17f3e645a2b2 = 'AWS';

/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */ // this is autogenerated file, see scripts/version-update.js
const $2604faf4ecb0fc27$export$a4ad2735b021c132 = '1.9.1';

const $8d44ad6280d93004$export$42f4885608027d0c = 'non_boolean';

const $402a0cf753e25867$export$790b3707cd7b148f = 'network';
const $402a0cf753e25867$export$31e3351e7cd6ef5 = 'memory';
const $402a0cf753e25867$export$1f09aaaa930516f = 'disk';

const $ef5fca219fe79279$export$3f072f06b90c3985 = 'navigation';

const $f8a69c6d37cb4ab8$export$d6830277b06edd6 = 'normal';
const $f8a69c6d37cb4ab8$export$1eee5ddc4f6d41c5 = 400;

// Gate off keepAlive. UCT refresh window:
// https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $e15c9062f5fd0542$export$8b012b965402e06a = 580000;
const $e15c9062f5fd0542$export$68a6a6cccbaf5f06 = 30000;
const $e15c9062f5fd0542$export$6fe3216720bb7a79 = 15000;
const $e15c9062f5fd0542$export$e5f3cb8ab5223cd4 = 15000;
const $e15c9062f5fd0542$export$bf6cd96e19b2987f = 100;
const $e15c9062f5fd0542$export$bcf3b302e1a0ba63 = 30000;
const $e15c9062f5fd0542$export$74f911c394187993 = 4430;
const $e15c9062f5fd0542$export$5d72de7e544ab20f = 300000;
const $e15c9062f5fd0542$export$a5991d6597d2d0f8 = 15000;
const $e15c9062f5fd0542$export$6a0c27ebdbd1f0ed = 240;
const $e15c9062f5fd0542$export$3f57674185473b5d = 5000;
const $e15c9062f5fd0542$export$1ad8434180c5936c = 300000;

const $35a4dea637e0d056$export$81189edc9b923717 = 1;

const $d06951238cc95036$export$cf090d5281b5ae06 = 10000;
const $d06951238cc95036$export$8575e30be0feb909 = 30000;

// temp solution until we can get it automated
const $6b756b851d60bfdf$export$2295b861f318254a = '0.1.5';

const $790d54a7af2f6d42$export$d8b468db8a225bc9 = 250;

const $7b7d6f3fbc64b228$export$e5a5b1df38d9e289 = 4;

const $15eb290b41e9ce25$export$838dd406eb10ebcd = '-';

const $0b9d8b9516247b3c$export$ef65d694be8f5484 = 'OwnerMark___';

const $9f5054f87e3e2d3a$export$5e28bf885ebebfa6 = '[browser-storage-controls]';
const $9f5054f87e3e2d3a$export$aeb1f5aa1188ce28 = 5000; // min gap between sends of the same action
const $9f5054f87e3e2d3a$export$ee3d07c2528881e2 = 10; // hard cap per action per page load

/* eslint-disable jira/filename-case */ const $d0b0f317b4f60123$export$881d135f98d8d7d0 = 100;
const $d0b0f317b4f60123$export$9ab5bdcb8a1d6c34 = false;
const $d0b0f317b4f60123$export$f267d0e9ab3eb265 = false;
const $d0b0f317b4f60123$export$12c1dc38ea1692da = 0;
const $d0b0f317b4f60123$export$34932e325e1234b3 = false;

const $f9196309764c88eb$export$98a7370239de6730 = 86400000;

// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $69c4eea1f1404581$export$338a9f6c7a1f02b0 = 'text/html';

// ACT Event types
// AdControlDropdownMenu
const $ccaff9c1e22335c3$export$17ff257e1f6e39f5 = 'AD_CONTROL_DROP_DOWN_MENU_OPENED';
const $ccaff9c1e22335c3$export$7fc09cf740f33ed4 = 'AD_CONTROL_DROP_DOWN_MENU_CLOSED';
const $ccaff9c1e22335c3$export$e33200507ac1d20a = 'DISMISS_STARTED';
const $ccaff9c1e22335c3$export$103f41d1f3bf374e = 'DISMISS_SUCCEEDED';
const $ccaff9c1e22335c3$export$6d3088110036f124 = 'DISMISS_FAILED';
const $ccaff9c1e22335c3$export$5595c6967e83d351 = 'REASONS_BUTTON_CLICKED';
const $ccaff9c1e22335c3$export$ff50ad60f08a4bc0 = 'REASONS_MODAL_SHOWN';
const $ccaff9c1e22335c3$export$6bd2d8eacca15ce1 = 'REASONS_MODAL_DISMISSED';
const $ccaff9c1e22335c3$export$5c5fc6956b7600ea = 'FLAG_DISMISSED';

// same types defined in analytics-web-client but avoid creating dependency with that
const $ddd31af8f515fa50$export$a1562d08625f5d7e = 'ui';
const $ddd31af8f515fa50$export$947dac6c72b26f81 = 'track';
const $ddd31af8f515fa50$export$f1d537d508d2945a = 'screen';
const $ddd31af8f515fa50$export$12346a674644c156 = 'operational';
const $ddd31af8f515fa50$export$b055de0e665cb20c = 'unknown';

/* eslint-disable jira/filename-case */ const $8f860a533cc71fca$export$ff39ebd4bb12b718 = 201;
const $8f860a533cc71fca$export$3288b14b6745c572 = 204;
const $8f860a533cc71fca$export$9de493bcd9b1d977 = 400;
const $8f860a533cc71fca$export$67d19e9a991baa07 = 401;
const $8f860a533cc71fca$export$a3269a3914b007e3 = 403;
const $8f860a533cc71fca$export$8bca792d963eb0ef = 404;
const $8f860a533cc71fca$export$4a3cb39801694eee = 407;
const $8f860a533cc71fca$export$fa405bbf47d510e2 = 408;
const $8f860a533cc71fca$export$c09e7ea0fc79f34f = 409;
const $8f860a533cc71fca$export$5244030134e99 = 412;
const $8f860a533cc71fca$export$f90ac1df0b60853d = 413;
const $8f860a533cc71fca$export$a447d0a965e16776 = 422;
const $8f860a533cc71fca$export$3b48aba8957000cd = 426;
const $8f860a533cc71fca$export$6763168a631449a2 = 429;
const $8f860a533cc71fca$export$e813cd7045fcc98d = 500;
const $8f860a533cc71fca$export$2ce38d41a306034e = 502;
const $8f860a533cc71fca$export$974c37534b0191b1 = 503;
const $8f860a533cc71fca$export$5400e8dddac3fcf3 = 504;

const $132a6a261f02ebf7$export$52483b87432059f1 = 'jiraEditionAwarenessForStandardToPremium';

const $55bf78281c651395$export$83e119fb36bc846a = 'jira.user.theme.standard-to-premium-ea-pill.dismissed';

const $28bd25a9b2071a0a$export$9d760aa8e6fb3b65 = 'jira.user.theme.premium-ea-pill.dismissed';

/* eslint-disable jira/filename-case */ const $f0e9a194674bc930$export$b5a308a17bc991f3 = 'projectKey';
const $f0e9a194674bc930$export$929d50f83189406c = 'boardId';
const $f0e9a194674bc930$export$da6f46390e1a426f = 'projectId';

/* eslint-disable jira/filename-case */ const $3b258ee19859baa5$export$2bd315ece9f68967 = 'v4';

/* eslint-disable jira/filename-case */ const $192a2eeaa0a1dbf6$export$2ee9e5a3556c1e43 = 'sidebar';
const $192a2eeaa0a1dbf6$export$793ed84f5e13fedc = 'top';
const $192a2eeaa0a1dbf6$export$f1c9dd0f5207dd5e = 'tab';
const $192a2eeaa0a1dbf6$export$b83d0ee9325a2d0a = 'projectTitle';

/* eslint-disable jira/filename-case */ // TopNav or sidebar
const $fad9173ee481d7de$export$17ff3f7e02c6ac22 = 'global';
const $fad9173ee481d7de$export$33d8c916a600c5e9 = 'container';

/* eslint-disable jira/filename-case */ const $6b2913942bd90807$export$6dd9406e478a1fe2 = 'navigationItem';
const $6b2913942bd90807$export$b887e88d8d0739f6 = 'button';
const $6b2913942bd90807$export$64fed82162bd367 = 'dropdownItem';
const $6b2913942bd90807$export$b0a8b257f1f878a2 = 'searchInput';

const $5bdb53f12f87b5a8$export$cb2f616a76599e00 = 'APP_SWITCHER';

const $b435b412b2dfd147$export$b8b9d90f9e5bd72b = '@jira/navigation-apps__atlassian-navigation';
const $b435b412b2dfd147$export$4766f0c4b6fe35dc = 'TOP_LEVEL';
const $b435b412b2dfd147$export$9934c8d98fd9e572 = 'atlassianSwitcher';

const $98fd96abde9f3719$export$3364800d9d60baf9 = 'localStorage';

const $a911def61a058b00$export$45e63649edff1e2a = 'ASSETS';
const $a911def61a058b00$export$eb7589a4ee50c678 = 'tenantless';

const $11c0f1bd3f72e082$export$c2c502a6524b22c7 = 'com.atlassian.jira.modules.servicemanagement.status-pages-entity:status-pages-entity-field-cftype';

const $110b74e2943f9928$export$e26f00bd90899835 = 'success';
const $110b74e2943f9928$export$edb46161045fece7 = 'error';

/**
 * CSS variables that mirror the legacy `@atlaskit/page-layout` CSS custom properties.
 *
 * These are provided for consumers that previously relied on the `@atlaskit/page-layout`
 * CSS variables and need to reference them when using the navigation system.
 */ const $266ff4fb0e8e331a$export$f963aecf2d4465bd = 'var(--leftPanelWidth, 0px)';
const $266ff4fb0e8e331a$export$750459958906793 = 'var(--rightPanelWidth, 0px)';
const $266ff4fb0e8e331a$export$f897e1ed9f8ed251 = 'var(--leftSidebarWidth, 0px)';
const $266ff4fb0e8e331a$export$b44ab66843c05a69 = 'var(--rightSidebarWidth, 0px)';
const $266ff4fb0e8e331a$export$aeff86a16f13529 = 'var(--topNavigationHeight, 0px)';
const $266ff4fb0e8e331a$export$ed7cc0d417ee89e = 'var(--bannerHeight, 0px)';

/**
 * Statsig experiment for the extension context bridge; both Host and Client self-gate on its
 * boolean `isEnabled` parameter. Call sites inline this value rather than importing it, since the
 * experiment runtime takes a static literal; tests resolve the experiment through this constant so
 * the two cannot drift apart.
 *
 * Read here **without** logging exposure. Host mounts at the root of every page of an opted-in
 * product, so an exposure-firing read would count product page loads rather than extension users.
 * The extension owns the single exposure call, at the point the user is on a page the bridge can
 * act on.
 */ const $cc43f8d8bb5fab5b$export$db198c33f2e37660 = 'rovo-ext_context_bridge_exp';
const $cc43f8d8bb5fab5b$export$e21ac689710817ff = '__rovoExtContextBridge';
const $cc43f8d8bb5fab5b$export$d47ad6b1eb76b6f0 = 'to-extension';
const $cc43f8d8bb5fab5b$export$220cfa2a744655be = 'to-product';
const $cc43f8d8bb5fab5b$export$5c12543a8c31403d = 'rovo-extension-bridge';
const $cc43f8d8bb5fab5b$export$a99341a6988edb30 = 'request-context';

// temp solution until we can get it automated
const $ddd67f40feddf208$export$2295b861f318254a = '0.1.5';

const $161c8cfa8193bed5$export$d8b468db8a225bc9 = 250;

const $c0bb806f19dcd148$export$e0744546db5b6189 = 'rovo_chat_sites_source_filter';

const $9ef461ad64e3bd90$export$49522921ba2a21c2 = 'JSMGROWTH-524';

const $5ec2d6bdfb6ca03e$export$28f711f8dbb6b7b5 = 'grw-524_jsm_jpd_rovo_sidekick_killswitch';

const $3051eed5ed84753d$export$e21b200f8af41884 = 'jsm-contextual-suggestions';

const $2f484f18f15917a9$export$bda3888b7ddd2020 = 'rovoQuickActions';

const $19d831e177a0f7bb$export$e4679b831656578d = 60;

/* eslint-disable jira/filename-case */ const $1771eb0e641090af$export$53d41ff2666118e1 = 'agility-backlog';
const $1771eb0e641090af$export$7552fe2669628499 = 'bitbucket-issue';
const $1771eb0e641090af$export$41a718da0a8636f4 = 'connect-issue';
const $1771eb0e641090af$export$cebf0bc8b2ccaf57 = 'core-issue';
const $1771eb0e641090af$export$f154708d773ba5a0 = 'jira-board';
const $1771eb0e641090af$export$5e91e17726e54450 = 'jiraCalendar';
const $1771eb0e641090af$export$2dac1950892123f5 = 'jiraTimeline';
const $1771eb0e641090af$export$82540942fb014b0a = 'business-calendar';
const $1771eb0e641090af$export$7ca28938a07e0c33 = 'business-list';
const $1771eb0e641090af$export$f6cf06aaaeb58a54 = 'business-timeline';
const $1771eb0e641090af$export$b2c0462ff17aa26e = 'business-board';
const $1771eb0e641090af$export$a607850ebccd28ac = 'business-approvals';
const $1771eb0e641090af$export$1da6cede3561048f = 'business-files';
const $1771eb0e641090af$export$b19f949fb9713614 = 'full-issue';
const $1771eb0e641090af$export$c3899e01aa51a88e = 'jsm-full-issue';
const $1771eb0e641090af$export$a5132300c5214280 = 'embed-issue';
const $1771eb0e641090af$export$36d32bfbadaf29fb = 'work-item-view';
const $1771eb0e641090af$export$710114090a811b37 = 'global-issue-navigator-issue';
const $1771eb0e641090af$export$ce88447986394f2d = 'mobile-issue';
const $1771eb0e641090af$export$6a90d9196d330040 = 'project-issue-navigator';
const $1771eb0e641090af$export$2247c9059c171db1 = 'roadmap-issue';
const $1771eb0e641090af$export$cd16d39c55c569d0 = 'simple-software-board';
const $1771eb0e641090af$export$f72626bf0d75dfad = 'software-backlog-issue';
const $1771eb0e641090af$export$778b4609e784cb27 = 'software-deployments-issue';
const $1771eb0e641090af$export$5b73d694a6048002 = 'version-detail-issue';
const $1771eb0e641090af$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $1771eb0e641090af$export$21b5b7189add7861 = 'software-incidents-issue';
const $1771eb0e641090af$export$9c5d81b901471b27 = 'software-issue';
const $1771eb0e641090af$export$1735f6ad917dc411 = 'change-calendar';
const $1771eb0e641090af$export$7063ee6d0035a982 = 'queues-issue-view';
const $1771eb0e641090af$export$e3ab9da1dcf8e2ba = 'live-chat-issue-view';
const $1771eb0e641090af$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $1771eb0e641090af$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $1771eb0e641090af$export$14a8072f422804fd = 'issue-navigator-next';
const $1771eb0e641090af$export$cd2e8394c029507b = 'issue-navigator-detail-view';
const $1771eb0e641090af$export$9dac02c804d7acd8 = 'classic-software-board';
const $1771eb0e641090af$export$d6a617b7cd271a10 = 'jira-home-recommended';
const $1771eb0e641090af$export$49d57bef9ac2550b = 'global-issue-create';
const $1771eb0e641090af$export$9aea6bdc77a1b448 = 'csm-live-conversation-issue-view';
const $1771eb0e641090af$export$887083471231a492 = 'ham-work-items';
const $1771eb0e641090af$export$5dc6e9f73f201b75 = 'sam-work-items';
const $1771eb0e641090af$export$74b1da58ccd0577f = 'agents-watchtower';

/* eslint-disable jira/filename-case */ const $74cc6705a5fdb0de$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!, $shouldIncludeBetaAiFeatures: Boolean!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	}

	jira_isRovoLLMEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
	jira_isBetaAiFeaturesEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence") @include(if: $shouldIncludeBetaAiFeatures)
	jira_rovoEnablementStatus(cloudId: $cloudId)@optIn(to: "JiraRovoEnablementStatus") {
		isRovoEntitlementEnabledForTenant
		isRovoAiFeaturesEnabledInAnyJiraProducts {
			isEnabled
			disabledReason
		}
		rovoAiFeaturesEnabledJiraProducts
	}
}
`;

const $1056e2b7e19aa4e0$export$f4208f01301e1342 = 'HELP';

/* eslint-disable jira/filename-case */ const $2b56b53c34bc2033$export$c43c7444da662fa1 = '1';
const $2b56b53c34bc2033$export$e99efa3985fa3c26 = 'helpPanel';
const $2b56b53c34bc2033$export$23aa6670f346c214 = 368;

/* eslint-disable jira/filename-case */ const $a250aea31dc76f65$export$53f45136e435c2fd = 'help_button_ui_state';

const $863aeee714b20c92$export$2ce650757fdac12a = 'NOTIFICATIONS';

/* eslint-disable jira/filename-case */ const $71a8d80581e45c48$export$e0226a83abddbd07 = 'check-notifications';

/* eslint-disable jira/filename-case */ const $8dfb0c8c68d6c8c9$export$14c62ba6f49b806f = 9;

const $e973804fadfc5d87$export$3a54edb6ba4daa82 = 'TOP_NAV';
const $e973804fadfc5d87$export$2ee9e5a3556c1e43 = 'SIDEBAR';

const $8ce4c0417f34b437$export$b98e411ae80c806f = '/';

const $eb044bb12d0b1d65$export$c1b33b1e65f8bd62 = 'SEARCH';

const $ba3615aabbc9caed$export$eeb0307e2964e28d = "var(--ds-text, #292A2E)";

const $73820dc7daa419bb$export$7168c0a11fb9ab29 = "var(--ds-text-subtlest, #6B6E76)";

const $bd344c6c2142b1d3$export$4ac85ff259fe4fce = "var(--ds-background-neutral-subtle-hovered, #0515240F)";

const $98d257b803724cde$export$271fb8b1437b1d62 = "var(--ds-link-visited, #803FA5)";

const $57a8d3ee2467d6bc$export$1b6b909295618bea = 'SETTINGS';


$parcel$global.rlb("5h6rP")
//# sourceMappingURL=shared~atlassian-navigation~atlaskit~ar.b27d9759.js.map
